window.slate = window.slate || {}, window.theme = window.theme || {}; /*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */
(function(e, t21) {
  "use strict";
  typeof module == "object" && typeof module.exports == "object" ? module.exports = e.document ? t21(e, !0) : function(e2) {
    if (!e2.document) throw new Error("jQuery requires a window with a document");
    return t21(e2)
  } : t21(e)
})(typeof window < "u" ? window : this, function(C, e) {
  "use strict";
  var t21 = [],
      r = Object.getPrototypeOf,
      s = t21.slice,
      g = t21.flat ? function(e2) {
        return t21.flat.call(e2)
      } : function(e2) {
        return t21.concat.apply([], e2)
      },
      u = t21.push,
      i = t21.indexOf,
      n = {},
      o = n.toString,
      v = n.hasOwnProperty,
      a = v.toString,
      l = a.call(Object),
      y = {},
      m = function(e2) {
        return typeof e2 == "function" && typeof e2.nodeType != "number"
      },
      x = function(e2) {
        return e2 != null && e2 === e2.window
      },
      E = C.document,
      c = {
        type: !0,
        src: !0,
        nonce: !0,
        noModule: !0
      };

  function b(e2, t22, n2) {
    var r2, i2, o2 = (n2 = n2 || E).createElement("script");
    if (o2.text = e2, t22)
      for (r2 in c)(i2 = t22[r2] || t22.getAttribute && t22.getAttribute(r2)) && o2.setAttribute(r2, i2);
    n2.head.appendChild(o2).parentNode.removeChild(o2)
  }

  function w(e2) {
    return e2 == null ? e2 + "" : typeof e2 == "object" || typeof e2 == "function" ? n[o.call(e2)] || "object" : typeof e2
  }
  var f = "3.5.1",
      S = function(e2, t22) {
        return new S.fn.init(e2, t22)
      };

  function p(e2) {
    var t22 = !!e2 && "length" in e2 && e2.length,
        n2 = w(e2);
    return !m(e2) && !x(e2) && (n2 === "array" || t22 === 0 || typeof t22 == "number" && 0 < t22 && t22 - 1 in e2)
  }
  S.fn = S.prototype = {
    jquery: f,
    constructor: S,
    length: 0,
    toArray: function() {
      return s.call(this)
    },
    get: function(e2) {
      return e2 == null ? s.call(this) : e2 < 0 ? this[e2 + this.length] : this[e2]
    },
    pushStack: function(e2) {
      var t22 = S.merge(this.constructor(), e2);
      return t22.prevObject = this, t22
    },
    each: function(e2) {
      return S.each(this, e2)
    },
    map: function(n2) {
      return this.pushStack(S.map(this, function(e2, t22) {
        return n2.call(e2, t22, e2)
      }))
    },
    slice: function() {
      return this.pushStack(s.apply(this, arguments))
    },
    first: function() {
      return this.eq(0)
    },
    last: function() {
      return this.eq(-1)
    },
    even: function() {
      return this.pushStack(S.grep(this, function(e2, t22) {
        return (t22 + 1) % 2
      }))
    },
    odd: function() {
      return this.pushStack(S.grep(this, function(e2, t22) {
        return t22 % 2
      }))
    },
    eq: function(e2) {
      var t22 = this.length,
          n2 = +e2 + (e2 < 0 ? t22 : 0);
      return this.pushStack(0 <= n2 && n2 < t22 ? [this[n2]] : [])
    },
    end: function() {
      return this.prevObject || this.constructor()
    },
    push: u,
    sort: t21.sort,
    splice: t21.splice
  }, S.extend = S.fn.extend = function() {
    var e2, t22, n2, r2, i2, o2, a2 = arguments[0] || {},
        s2 = 1,
        u2 = arguments.length,
        l2 = !1;
    for (typeof a2 == "boolean" && (l2 = a2, a2 = arguments[s2] || {}, s2++), typeof a2 == "object" || m(a2) || (a2 = {}), s2 === u2 && (a2 = this, s2--); s2 < u2; s2++)
      if ((e2 = arguments[s2]) != null)
        for (t22 in e2) r2 = e2[t22], t22 !== "__proto__" && a2 !== r2 && (l2 && r2 && (S.isPlainObject(r2) || (i2 = Array.isArray(r2))) ? (n2 = a2[t22], o2 = i2 && !Array.isArray(n2) ? [] : i2 || S.isPlainObject(n2) ? n2 : {}, i2 = !1, a2[t22] = S.extend(l2, o2, r2)) : r2 !== void 0 && (a2[t22] = r2));
    return a2
  }, S.extend({
    expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""),
    isReady: !0,
    error: function(e2) {
      throw new Error(e2)
    },
    noop: function() {},
    isPlainObject: function(e2) {
      var t22, n2;
      return !(!e2 || o.call(e2) !== "[object Object]") && (!(t22 = r(e2)) || typeof(n2 = v.call(t22, "constructor") && t22.constructor) == "function" && a.call(n2) === l)
    },
    isEmptyObject: function(e2) {
      var t22;
      for (t22 in e2) return !1;
      return !0
    },
    globalEval: function(e2, t22, n2) {
      b(e2, {
        nonce: t22 && t22.nonce
      }, n2)
    },
    each: function(e2, t22) {
      var n2, r2 = 0;
      if (p(e2))
        for (n2 = e2.length; r2 < n2 && t22.call(e2[r2], r2, e2[r2]) !== !1; r2++);
      else
        for (r2 in e2)
          if (t22.call(e2[r2], r2, e2[r2]) === !1) break;
      return e2
    },
    makeArray: function(e2, t22) {
      var n2 = t22 || [];
      return e2 != null && (p(Object(e2)) ? S.merge(n2, typeof e2 == "string" ? [e2] : e2) : u.call(n2, e2)), n2
    },
    inArray: function(e2, t22, n2) {
      return t22 == null ? -1 : i.call(t22, e2, n2)
    },
    merge: function(e2, t22) {
      for (var n2 = +t22.length, r2 = 0, i2 = e2.length; r2 < n2; r2++) e2[i2++] = t22[r2];
      return e2.length = i2, e2
    },
    grep: function(e2, t22, n2) {
      for (var r2 = [], i2 = 0, o2 = e2.length, a2 = !n2; i2 < o2; i2++) !t22(e2[i2], i2) !== a2 && r2.push(e2[i2]);
      return r2
    },
    map: function(e2, t22, n2) {
      var r2, i2, o2 = 0,
          a2 = [];
      if (p(e2))
        for (r2 = e2.length; o2 < r2; o2++)(i2 = t22(e2[o2], o2, n2)) != null && a2.push(i2);
      else
        for (o2 in e2)(i2 = t22(e2[o2], o2, n2)) != null && a2.push(i2);
      return g(a2)
    },
    guid: 1,
    support: y
  }), typeof Symbol == "function" && (S.fn[Symbol.iterator] = t21[Symbol.iterator]), S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e2, t22) {
    n["[object " + t22 + "]"] = t22.toLowerCase()
  });
  var d = function(n2) {
    var e2, d2, b2, o2, i2, h2, f2, g2, w2, u2, l2, T2, C2, a2, E2, v2, s2, c2, y2, S2 = "sizzle" + 1 * new Date,
        p2 = n2.document,
        k2 = 0,
        r2 = 0,
        m2 = ue2(),
        x2 = ue2(),
        A2 = ue2(),
        N2 = ue2(),
        D2 = function(e3, t23) {
          return e3 === t23 && (l2 = !0), 0
        },
        j2 = {}.hasOwnProperty,
        t22 = [],
        q2 = t22.pop,
        L2 = t22.push,
        H2 = t22.push,
        O2 = t22.slice,
        P2 = function(e3, t23) {
          for (var n3 = 0, r3 = e3.length; n3 < r3; n3++)
            if (e3[n3] === t23) return n3;
          return -1
        },
        R2 = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        M2 = "[\\x20\\t\\r\\n\\f]",
        I2 = "(?:\\\\[\\da-fA-F]{1,6}" + M2 + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
        W2 = "\\[" + M2 + "*(" + I2 + ")(?:" + M2 + "*([*^$|!~]?=)" + M2 + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + I2 + "))|)" + M2 + "*\\]",
        F2 = ":(" + I2 + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + W2 + ")*)|.*)\\)|)",
        B2 = new RegExp(M2 + "+", "g"),
        $3 = new RegExp("^" + M2 + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M2 + "+$", "g"),
        _3 = new RegExp("^" + M2 + "*," + M2 + "*"),
        z2 = new RegExp("^" + M2 + "*([>+~]|" + M2 + ")" + M2 + "*"),
        U2 = new RegExp(M2 + "|>"),
        X2 = new RegExp(F2),
        V2 = new RegExp("^" + I2 + "$"),
        G2 = {
          ID: new RegExp("^#(" + I2 + ")"),
          CLASS: new RegExp("^\\.(" + I2 + ")"),
          TAG: new RegExp("^(" + I2 + "|[*])"),
          ATTR: new RegExp("^" + W2),
          PSEUDO: new RegExp("^" + F2),
          CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M2 + "*(even|odd|(([+-]|)(\\d*)n|)" + M2 + "*(?:([+-]|)" + M2 + "*(\\d+)|))" + M2 + "*\\)|)", "i"),
          bool: new RegExp("^(?:" + R2 + ")$", "i"),
          needsContext: new RegExp("^" + M2 + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M2 + "*((?:-\\d)?\\d*)" + M2 + "*\\)|)(?=[^-]|$)", "i")
        },
        Y2 = /HTML$/i,
        Q2 = /^(?:input|select|textarea|button)$/i,
        J2 = /^h\d$/i,
        K2 = /^[^{]+\{\s*\[native \w/,
        Z2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ee2 = /[+~]/,
        te2 = new RegExp("\\\\[\\da-fA-F]{1,6}" + M2 + "?|\\\\([^\\r\\n\\f])", "g"),
        ne2 = function(e3, t23) {
          var n3 = "0x" + e3.slice(1) - 65536;
          return t23 || (n3 < 0 ? String.fromCharCode(n3 + 65536) : String.fromCharCode(n3 >> 10 | 55296, 1023 & n3 | 56320))
        },
        re2 = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        ie2 = function(e3, t23) {
          return t23 ? e3 === "\0" ? "\uFFFD" : e3.slice(0, -1) + "\\" + e3.charCodeAt(e3.length - 1).toString(16) + " " : "\\" + e3
        },
        oe2 = function() {
          T2()
        },
        ae2 = be2(function(e3) {
          return e3.disabled === !0 && e3.nodeName.toLowerCase() === "fieldset"
        }, {
          dir: "parentNode",
          next: "legend"
        });
    try {
      H2.apply(t22 = O2.call(p2.childNodes), p2.childNodes), t22[p2.childNodes.length].nodeType
    } catch {
      H2 = {
        apply: t22.length ? function(e4, t23) {
          L2.apply(e4, O2.call(t23))
        } : function(e4, t23) {
          for (var n3 = e4.length, r3 = 0; e4[n3++] = t23[r3++];);
          e4.length = n3 - 1
        }
      }
    }

    function se2(t23, e3, n3, r3) {
      var i3, o3, a3, s3, u3, l3, c3, f3 = e3 && e3.ownerDocument,
          p3 = e3 ? e3.nodeType : 9;
      if (n3 = n3 || [], typeof t23 != "string" || !t23 || p3 !== 1 && p3 !== 9 && p3 !== 11) return n3;
      if (!r3 && (T2(e3), e3 = e3 || C2, E2)) {
        if (p3 !== 11 && (u3 = Z2.exec(t23)))
          if (i3 = u3[1]) {
            if (p3 === 9) {
              if (!(a3 = e3.getElementById(i3))) return n3;
              if (a3.id === i3) return n3.push(a3), n3
            } else if (f3 && (a3 = f3.getElementById(i3)) && y2(e3, a3) && a3.id === i3) return n3.push(a3), n3
          } else {
            if (u3[2]) return H2.apply(n3, e3.getElementsByTagName(t23)), n3;
            if ((i3 = u3[3]) && d2.getElementsByClassName && e3.getElementsByClassName) return H2.apply(n3, e3.getElementsByClassName(i3)), n3
          } if (d2.qsa && !N2[t23 + " "] && (!v2 || !v2.test(t23)) && (p3 !== 1 || e3.nodeName.toLowerCase() !== "object")) {
          if (c3 = t23, f3 = e3, p3 === 1 && (U2.test(t23) || z2.test(t23))) {
            for ((f3 = ee2.test(t23) && ye2(e3.parentNode) || e3) === e3 && d2.scope || ((s3 = e3.getAttribute("id")) ? s3 = s3.replace(re2, ie2) : e3.setAttribute("id", s3 = S2)), o3 = (l3 = h2(t23)).length; o3--;) l3[o3] = (s3 ? "#" + s3 : ":scope") + " " + xe2(l3[o3]);
            c3 = l3.join(",")
          }
          try {
            return H2.apply(n3, f3.querySelectorAll(c3)), n3
          } catch {
            N2(t23, !0)
          } finally {
            s3 === S2 && e3.removeAttribute("id")
          }
        }
      }
      return g2(t23.replace($3, "$1"), e3, n3, r3)
    }

    function ue2() {
      var r3 = [];
      return function e3(t23, n3) {
        return r3.push(t23 + " ") > b2.cacheLength && delete e3[r3.shift()], e3[t23 + " "] = n3
      }
    }

    function le2(e3) {
      return e3[S2] = !0, e3
    }

    function ce2(e3) {
      var t23 = C2.createElement("fieldset");
      try {
        return !!e3(t23)
      } catch {
        return !1
      } finally {
        t23.parentNode && t23.parentNode.removeChild(t23), t23 = null
      }
    }

    function fe2(e3, t23) {
      for (var n3 = e3.split("|"), r3 = n3.length; r3--;) b2.attrHandle[n3[r3]] = t23
    }

    function pe2(e3, t23) {
      var n3 = t23 && e3,
          r3 = n3 && e3.nodeType === 1 && t23.nodeType === 1 && e3.sourceIndex - t23.sourceIndex;
      if (r3) return r3;
      if (n3) {
        for (; n3 = n3.nextSibling;)
          if (n3 === t23) return -1
      }
      return e3 ? 1 : -1
    }

    function de2(t23) {
      return function(e3) {
        return e3.nodeName.toLowerCase() === "input" && e3.type === t23
      }
    }

    function he2(n3) {
      return function(e3) {
        var t23 = e3.nodeName.toLowerCase();
        return (t23 === "input" || t23 === "button") && e3.type === n3
      }
    }

    function ge2(t23) {
      return function(e3) {
        return "form" in e3 ? e3.parentNode && e3.disabled === !1 ? "label" in e3 ? "label" in e3.parentNode ? e3.parentNode.disabled === t23 : e3.disabled === t23 : e3.isDisabled === t23 || e3.isDisabled !== !t23 && ae2(e3) === t23 : e3.disabled === t23 : "label" in e3 && e3.disabled === t23
      }
    }

    function ve2(a3) {
      return le2(function(o3) {
        return o3 = +o3, le2(function(e3, t23) {
          for (var n3, r3 = a3([], e3.length, o3), i3 = r3.length; i3--;) e3[n3 = r3[i3]] && (e3[n3] = !(t23[n3] = e3[n3]))
        })
      })
    }

    function ye2(e3) {
      return e3 && typeof e3.getElementsByTagName < "u" && e3
    }
    for (e2 in d2 = se2.support = {}, i2 = se2.isXML = function(e3) {
      var t23 = e3.namespaceURI,
          n3 = (e3.ownerDocument || e3).documentElement;
      return !Y2.test(t23 || n3 && n3.nodeName || "HTML")
    }, T2 = se2.setDocument = function(e3) {
      var t23, n3, r3 = e3 ? e3.ownerDocument || e3 : p2;
      return r3 != C2 && r3.nodeType === 9 && r3.documentElement && (a2 = (C2 = r3).documentElement, E2 = !i2(C2), p2 != C2 && (n3 = C2.defaultView) && n3.top !== n3 && (n3.addEventListener ? n3.addEventListener("unload", oe2, !1) : n3.attachEvent && n3.attachEvent("onunload", oe2)), d2.scope = ce2(function(e4) {
        return a2.appendChild(e4).appendChild(C2.createElement("div")), typeof e4.querySelectorAll < "u" && !e4.querySelectorAll(":scope fieldset div").length
      }), d2.attributes = ce2(function(e4) {
        return e4.className = "i", !e4.getAttribute("className")
      }), d2.getElementsByTagName = ce2(function(e4) {
        return e4.appendChild(C2.createComment("")), !e4.getElementsByTagName("*").length
      }), d2.getElementsByClassName = K2.test(C2.getElementsByClassName), d2.getById = ce2(function(e4) {
        return a2.appendChild(e4).id = S2, !C2.getElementsByName || !C2.getElementsByName(S2).length
      }), d2.getById ? (b2.filter.ID = function(e4) {
        var t24 = e4.replace(te2, ne2);
        return function(e5) {
          return e5.getAttribute("id") === t24
        }
      }, b2.find.ID = function(e4, t24) {
        if (typeof t24.getElementById < "u" && E2) {
          var n4 = t24.getElementById(e4);
          return n4 ? [n4] : []
        }
      }) : (b2.filter.ID = function(e4) {
        var n4 = e4.replace(te2, ne2);
        return function(e5) {
          var t24 = typeof e5.getAttributeNode < "u" && e5.getAttributeNode("id");
          return t24 && t24.value === n4
        }
      }, b2.find.ID = function(e4, t24) {
        if (typeof t24.getElementById < "u" && E2) {
          var n4, r4, i3, o3 = t24.getElementById(e4);
          if (o3) {
            if ((n4 = o3.getAttributeNode("id")) && n4.value === e4) return [o3];
            for (i3 = t24.getElementsByName(e4), r4 = 0; o3 = i3[r4++];)
              if ((n4 = o3.getAttributeNode("id")) && n4.value === e4) return [o3]
          }
          return []
        }
      }), b2.find.TAG = d2.getElementsByTagName ? function(e4, t24) {
        return typeof t24.getElementsByTagName < "u" ? t24.getElementsByTagName(e4) : d2.qsa ? t24.querySelectorAll(e4) : void 0
      } : function(e4, t24) {
        var n4, r4 = [],
            i3 = 0,
            o3 = t24.getElementsByTagName(e4);
        if (e4 === "*") {
          for (; n4 = o3[i3++];) n4.nodeType === 1 && r4.push(n4);
          return r4
        }
        return o3
      }, b2.find.CLASS = d2.getElementsByClassName && function(e4, t24) {
        if (typeof t24.getElementsByClassName < "u" && E2) return t24.getElementsByClassName(e4)
      }, s2 = [], v2 = [], (d2.qsa = K2.test(C2.querySelectorAll)) && (ce2(function(e4) {
        var t24;
        a2.appendChild(e4).innerHTML = "<a id='" + S2 + "'></a><select id='" + S2 + "-\r\\' msallowcapture=''><option selected=''></option></select>", e4.querySelectorAll("[msallowcapture^='']").length && v2.push("[*^$]=" + M2 + `*(?:''|"")`), e4.querySelectorAll("[selected]").length || v2.push("\\[" + M2 + "*(?:value|" + R2 + ")"), e4.querySelectorAll("[id~=" + S2 + "-]").length || v2.push("~="), (t24 = C2.createElement("input")).setAttribute("name", ""), e4.appendChild(t24), e4.querySelectorAll("[name='']").length || v2.push("\\[" + M2 + "*name" + M2 + "*=" + M2 + `*(?:''|"")`), e4.querySelectorAll(":checked").length || v2.push(":checked"), e4.querySelectorAll("a#" + S2 + "+*").length || v2.push(".#.+[+~]"), e4.querySelectorAll("\\\f"), v2.push("[\\r\\n\\f]")
      }), ce2(function(e4) {
        e4.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
        var t24 = C2.createElement("input");
        t24.setAttribute("type", "hidden"), e4.appendChild(t24).setAttribute("name", "D"), e4.querySelectorAll("[name=d]").length && v2.push("name" + M2 + "*[*^$|!~]?="), e4.querySelectorAll(":enabled").length !== 2 && v2.push(":enabled", ":disabled"), a2.appendChild(e4).disabled = !0, e4.querySelectorAll(":disabled").length !== 2 && v2.push(":enabled", ":disabled"), e4.querySelectorAll("*,:x"), v2.push(",.*:")
      })), (d2.matchesSelector = K2.test(c2 = a2.matches || a2.webkitMatchesSelector || a2.mozMatchesSelector || a2.oMatchesSelector || a2.msMatchesSelector)) && ce2(function(e4) {
        d2.disconnectedMatch = c2.call(e4, "*"), c2.call(e4, "[s!='']:x"), s2.push("!=", F2)
      }), v2 = v2.length && new RegExp(v2.join("|")), s2 = s2.length && new RegExp(s2.join("|")), t23 = K2.test(a2.compareDocumentPosition), y2 = t23 || K2.test(a2.contains) ? function(e4, t24) {
        var n4 = e4.nodeType === 9 ? e4.documentElement : e4,
            r4 = t24 && t24.parentNode;
        return e4 === r4 || !(!r4 || r4.nodeType !== 1 || !(n4.contains ? n4.contains(r4) : e4.compareDocumentPosition && 16 & e4.compareDocumentPosition(r4)))
      } : function(e4, t24) {
        if (t24) {
          for (; t24 = t24.parentNode;)
            if (t24 === e4) return !0
        }
        return !1
      }, D2 = t23 ? function(e4, t24) {
        if (e4 === t24) return l2 = !0, 0;
        var n4 = !e4.compareDocumentPosition - !t24.compareDocumentPosition;
        return n4 || (1 & (n4 = (e4.ownerDocument || e4) == (t24.ownerDocument || t24) ? e4.compareDocumentPosition(t24) : 1) || !d2.sortDetached && t24.compareDocumentPosition(e4) === n4 ? e4 == C2 || e4.ownerDocument == p2 && y2(p2, e4) ? -1 : t24 == C2 || t24.ownerDocument == p2 && y2(p2, t24) ? 1 : u2 ? P2(u2, e4) - P2(u2, t24) : 0 : 4 & n4 ? -1 : 1)
      } : function(e4, t24) {
        if (e4 === t24) return l2 = !0, 0;
        var n4, r4 = 0,
            i3 = e4.parentNode,
            o3 = t24.parentNode,
            a3 = [e4],
            s3 = [t24];
        if (!i3 || !o3) return e4 == C2 ? -1 : t24 == C2 ? 1 : i3 ? -1 : o3 ? 1 : u2 ? P2(u2, e4) - P2(u2, t24) : 0;
        if (i3 === o3) return pe2(e4, t24);
        for (n4 = e4; n4 = n4.parentNode;) a3.unshift(n4);
        for (n4 = t24; n4 = n4.parentNode;) s3.unshift(n4);
        for (; a3[r4] === s3[r4];) r4++;
        return r4 ? pe2(a3[r4], s3[r4]) : a3[r4] == p2 ? -1 : s3[r4] == p2 ? 1 : 0
      }), C2
    }, se2.matches = function(e3, t23) {
      return se2(e3, null, null, t23)
    }, se2.matchesSelector = function(e3, t23) {
      if (T2(e3), d2.matchesSelector && E2 && !N2[t23 + " "] && (!s2 || !s2.test(t23)) && (!v2 || !v2.test(t23))) try {
        var n3 = c2.call(e3, t23);
        if (n3 || d2.disconnectedMatch || e3.document && e3.document.nodeType !== 11) return n3
      } catch {
        N2(t23, !0)
      }
      return 0 < se2(t23, C2, null, [e3]).length
    }, se2.contains = function(e3, t23) {
      return (e3.ownerDocument || e3) != C2 && T2(e3), y2(e3, t23)
    }, se2.attr = function(e3, t23) {
      (e3.ownerDocument || e3) != C2 && T2(e3);
      var n3 = b2.attrHandle[t23.toLowerCase()],
          r3 = n3 && j2.call(b2.attrHandle, t23.toLowerCase()) ? n3(e3, t23, !E2) : void 0;
      return r3 !== void 0 ? r3 : d2.attributes || !E2 ? e3.getAttribute(t23) : (r3 = e3.getAttributeNode(t23)) && r3.specified ? r3.value : null
    }, se2.escape = function(e3) {
      return (e3 + "").replace(re2, ie2)
    }, se2.error = function(e3) {
      throw new Error("Syntax error, unrecognized expression: " + e3)
    }, se2.uniqueSort = function(e3) {
      var t23, n3 = [],
          r3 = 0,
          i3 = 0;
      if (l2 = !d2.detectDuplicates, u2 = !d2.sortStable && e3.slice(0), e3.sort(D2), l2) {
        for (; t23 = e3[i3++];) t23 === e3[i3] && (r3 = n3.push(i3));
        for (; r3--;) e3.splice(n3[r3], 1)
      }
      return u2 = null, e3
    }, o2 = se2.getText = function(e3) {
      var t23, n3 = "",
          r3 = 0,
          i3 = e3.nodeType;
      if (i3) {
        if (i3 === 1 || i3 === 9 || i3 === 11) {
          if (typeof e3.textContent == "string") return e3.textContent;
          for (e3 = e3.firstChild; e3; e3 = e3.nextSibling) n3 += o2(e3)
        } else if (i3 === 3 || i3 === 4) return e3.nodeValue
      } else
        for (; t23 = e3[r3++];) n3 += o2(t23);
      return n3
    }, (b2 = se2.selectors = {
      cacheLength: 50,
      createPseudo: le2,
      match: G2,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: !0
        },
        " ": {
          dir: "parentNode"
        },
        "+": {
          dir: "previousSibling",
          first: !0
        },
        "~": {
          dir: "previousSibling"
        }
      },
      preFilter: {
        ATTR: function(e3) {
          return e3[1] = e3[1].replace(te2, ne2), e3[3] = (e3[3] || e3[4] || e3[5] || "").replace(te2, ne2), e3[2] === "~=" && (e3[3] = " " + e3[3] + " "), e3.slice(0, 4)
        },
        CHILD: function(e3) {
          return e3[1] = e3[1].toLowerCase(), e3[1].slice(0, 3) === "nth" ? (e3[3] || se2.error(e3[0]), e3[4] = +(e3[4] ? e3[5] + (e3[6] || 1) : 2 * (e3[3] === "even" || e3[3] === "odd")), e3[5] = +(e3[7] + e3[8] || e3[3] === "odd")) : e3[3] && se2.error(e3[0]), e3
        },
        PSEUDO: function(e3) {
          var t23, n3 = !e3[6] && e3[2];
          return G2.CHILD.test(e3[0]) ? null : (e3[3] ? e3[2] = e3[4] || e3[5] || "" : n3 && X2.test(n3) && (t23 = h2(n3, !0)) && (t23 = n3.indexOf(")", n3.length - t23) - n3.length) && (e3[0] = e3[0].slice(0, t23), e3[2] = n3.slice(0, t23)), e3.slice(0, 3))
        }
      },
      filter: {
        TAG: function(e3) {
          var t23 = e3.replace(te2, ne2).toLowerCase();
          return e3 === "*" ? function() {
            return !0
          } : function(e4) {
            return e4.nodeName && e4.nodeName.toLowerCase() === t23
          }
        },
        CLASS: function(e3) {
          var t23 = m2[e3 + " "];
          return t23 || (t23 = new RegExp("(^|" + M2 + ")" + e3 + "(" + M2 + "|$)")) && m2(e3, function(e4) {
            return t23.test(typeof e4.className == "string" && e4.className || typeof e4.getAttribute < "u" && e4.getAttribute("class") || "")
          })
        },
        ATTR: function(n3, r3, i3) {
          return function(e3) {
            var t23 = se2.attr(e3, n3);
            return t23 == null ? r3 === "!=" : !r3 || (t23 += "", r3 === "=" ? t23 === i3 : r3 === "!=" ? t23 !== i3 : r3 === "^=" ? i3 && t23.indexOf(i3) === 0 : r3 === "*=" ? i3 && -1 < t23.indexOf(i3) : r3 === "$=" ? i3 && t23.slice(-i3.length) === i3 : r3 === "~=" ? -1 < (" " + t23.replace(B2, " ") + " ").indexOf(i3) : r3 === "|=" && (t23 === i3 || t23.slice(0, i3.length + 1) === i3 + "-"))
          }
        },
        CHILD: function(h3, e3, t23, g3, v3) {
          var y3 = h3.slice(0, 3) !== "nth",
              m3 = h3.slice(-4) !== "last",
              x3 = e3 === "of-type";
          return g3 === 1 && v3 === 0 ? function(e4) {
            return !!e4.parentNode
          } : function(e4, t24, n3) {
            var r3, i3, o3, a3, s3, u3, l3 = y3 !== m3 ? "nextSibling" : "previousSibling",
                c3 = e4.parentNode,
                f3 = x3 && e4.nodeName.toLowerCase(),
                p3 = !n3 && !x3,
                d3 = !1;
            if (c3) {
              if (y3) {
                for (; l3;) {
                  for (a3 = e4; a3 = a3[l3];)
                    if (x3 ? a3.nodeName.toLowerCase() === f3 : a3.nodeType === 1) return !1;
                  u3 = l3 = h3 === "only" && !u3 && "nextSibling"
                }
                return !0
              }
              if (u3 = [m3 ? c3.firstChild : c3.lastChild], m3 && p3) {
                for (d3 = (s3 = (r3 = (i3 = (o3 = (a3 = c3)[S2] || (a3[S2] = {}))[a3.uniqueID] || (o3[a3.uniqueID] = {}))[h3] || [])[0] === k2 && r3[1]) && r3[2], a3 = s3 && c3.childNodes[s3]; a3 = ++s3 && a3 && a3[l3] || (d3 = s3 = 0) || u3.pop();)
                  if (a3.nodeType === 1 && ++d3 && a3 === e4) {
                    i3[h3] = [k2, s3, d3];
                    break
                  }
              } else if (p3 && (d3 = s3 = (r3 = (i3 = (o3 = (a3 = e4)[S2] || (a3[S2] = {}))[a3.uniqueID] || (o3[a3.uniqueID] = {}))[h3] || [])[0] === k2 && r3[1]), d3 === !1)
                for (;
                    (a3 = ++s3 && a3 && a3[l3] || (d3 = s3 = 0) || u3.pop()) && !((x3 ? a3.nodeName.toLowerCase() === f3 : a3.nodeType === 1) && ++d3 && (p3 && ((i3 = (o3 = a3[S2] || (a3[S2] = {}))[a3.uniqueID] || (o3[a3.uniqueID] = {}))[h3] = [k2, d3]), a3 === e4)););
              return (d3 -= v3) === g3 || d3 % g3 == 0 && 0 <= d3 / g3
            }
          }
        },
        PSEUDO: function(e3, o3) {
          var t23, a3 = b2.pseudos[e3] || b2.setFilters[e3.toLowerCase()] || se2.error("unsupported pseudo: " + e3);
          return a3[S2] ? a3(o3) : 1 < a3.length ? (t23 = [e3, e3, "", o3], b2.setFilters.hasOwnProperty(e3.toLowerCase()) ? le2(function(e4, t24) {
            for (var n3, r3 = a3(e4, o3), i3 = r3.length; i3--;) e4[n3 = P2(e4, r3[i3])] = !(t24[n3] = r3[i3])
          }) : function(e4) {
            return a3(e4, 0, t23)
          }) : a3
        }
      },
      pseudos: {
        not: le2(function(e3) {
          var r3 = [],
              i3 = [],
              s3 = f2(e3.replace($3, "$1"));
          return s3[S2] ? le2(function(e4, t23, n3, r4) {
            for (var i4, o3 = s3(e4, null, r4, []), a3 = e4.length; a3--;)(i4 = o3[a3]) && (e4[a3] = !(t23[a3] = i4))
          }) : function(e4, t23, n3) {
            return r3[0] = e4, s3(r3, null, n3, i3), r3[0] = null, !i3.pop()
          }
        }),
        has: le2(function(t23) {
          return function(e3) {
            return 0 < se2(t23, e3).length
          }
        }),
        contains: le2(function(t23) {
          return t23 = t23.replace(te2, ne2),
              function(e3) {
                return -1 < (e3.textContent || o2(e3)).indexOf(t23)
              }
        }),
        lang: le2(function(n3) {
          return V2.test(n3 || "") || se2.error("unsupported lang: " + n3), n3 = n3.replace(te2, ne2).toLowerCase(),
              function(e3) {
                var t23;
                do
                  if (t23 = E2 ? e3.lang : e3.getAttribute("xml:lang") || e3.getAttribute("lang")) return (t23 = t23.toLowerCase()) === n3 || t23.indexOf(n3 + "-") === 0; while ((e3 = e3.parentNode) && e3.nodeType === 1);
                return !1
              }
        }),
        target: function(e3) {
          var t23 = n2.location && n2.location.hash;
          return t23 && t23.slice(1) === e3.id
        },
        root: function(e3) {
          return e3 === a2
        },
        focus: function(e3) {
          return e3 === C2.activeElement && (!C2.hasFocus || C2.hasFocus()) && !!(e3.type || e3.href || ~e3.tabIndex)
        },
        enabled: ge2(!1),
        disabled: ge2(!0),
        checked: function(e3) {
          var t23 = e3.nodeName.toLowerCase();
          return t23 === "input" && !!e3.checked || t23 === "option" && !!e3.selected
        },
        selected: function(e3) {
          return e3.parentNode && e3.parentNode.selectedIndex, e3.selected === !0
        },
        empty: function(e3) {
          for (e3 = e3.firstChild; e3; e3 = e3.nextSibling)
            if (e3.nodeType < 6) return !1;
          return !0
        },
        parent: function(e3) {
          return !b2.pseudos.empty(e3)
        },
        header: function(e3) {
          return J2.test(e3.nodeName)
        },
        input: function(e3) {
          return Q2.test(e3.nodeName)
        },
        button: function(e3) {
          var t23 = e3.nodeName.toLowerCase();
          return t23 === "input" && e3.type === "button" || t23 === "button"
        },
        text: function(e3) {
          var t23;
          return e3.nodeName.toLowerCase() === "input" && e3.type === "text" && ((t23 = e3.getAttribute("type")) == null || t23.toLowerCase() === "text")
        },
        first: ve2(function() {
          return [0]
        }),
        last: ve2(function(e3, t23) {
          return [t23 - 1]
        }),
        eq: ve2(function(e3, t23, n3) {
          return [n3 < 0 ? n3 + t23 : n3]
        }),
        even: ve2(function(e3, t23) {
          for (var n3 = 0; n3 < t23; n3 += 2) e3.push(n3);
          return e3
        }),
        odd: ve2(function(e3, t23) {
          for (var n3 = 1; n3 < t23; n3 += 2) e3.push(n3);
          return e3
        }),
        lt: ve2(function(e3, t23, n3) {
          for (var r3 = n3 < 0 ? n3 + t23 : t23 < n3 ? t23 : n3; 0 <= --r3;) e3.push(r3);
          return e3
        }),
        gt: ve2(function(e3, t23, n3) {
          for (var r3 = n3 < 0 ? n3 + t23 : n3; ++r3 < t23;) e3.push(r3);
          return e3
        })
      }
    }).pseudos.nth = b2.pseudos.eq, {
      radio: !0,
      checkbox: !0,
      file: !0,
      password: !0,
      image: !0
    }) b2.pseudos[e2] = de2(e2);
    for (e2 in {
      submit: !0,
      reset: !0
    }) b2.pseudos[e2] = he2(e2);

    function me2() {}

    function xe2(e3) {
      for (var t23 = 0, n3 = e3.length, r3 = ""; t23 < n3; t23++) r3 += e3[t23].value;
      return r3
    }

    function be2(s3, e3, t23) {
      var u3 = e3.dir,
          l3 = e3.next,
          c3 = l3 || u3,
          f3 = t23 && c3 === "parentNode",
          p3 = r2++;
      return e3.first ? function(e4, t24, n3) {
        for (; e4 = e4[u3];)
          if (e4.nodeType === 1 || f3) return s3(e4, t24, n3);
        return !1
      } : function(e4, t24, n3) {
        var r3, i3, o3, a3 = [k2, p3];
        if (n3) {
          for (; e4 = e4[u3];)
            if ((e4.nodeType === 1 || f3) && s3(e4, t24, n3)) return !0
        } else
          for (; e4 = e4[u3];)
            if (e4.nodeType === 1 || f3)
              if (i3 = (o3 = e4[S2] || (e4[S2] = {}))[e4.uniqueID] || (o3[e4.uniqueID] = {}), l3 && l3 === e4.nodeName.toLowerCase()) e4 = e4[u3] || e4;
              else {
                if ((r3 = i3[c3]) && r3[0] === k2 && r3[1] === p3) return a3[2] = r3[2];
                if ((i3[c3] = a3)[2] = s3(e4, t24, n3)) return !0
              } return !1
      }
    }

    function we2(i3) {
      return 1 < i3.length ? function(e3, t23, n3) {
        for (var r3 = i3.length; r3--;)
          if (!i3[r3](e3, t23, n3)) return !1;
        return !0
      } : i3[0]
    }

    function Te2(e3, t23, n3, r3, i3) {
      for (var o3, a3 = [], s3 = 0, u3 = e3.length, l3 = t23 != null; s3 < u3; s3++)(o3 = e3[s3]) && (n3 && !n3(o3, r3, i3) || (a3.push(o3), l3 && t23.push(s3)));
      return a3
    }

    function Ce2(d3, h3, g3, v3, y3, e3) {
      return v3 && !v3[S2] && (v3 = Ce2(v3)), y3 && !y3[S2] && (y3 = Ce2(y3, e3)), le2(function(e4, t23, n3, r3) {
        var i3, o3, a3, s3 = [],
            u3 = [],
            l3 = t23.length,
            c3 = e4 || function(e5, t24, n4) {
              for (var r4 = 0, i4 = t24.length; r4 < i4; r4++) se2(e5, t24[r4], n4);
              return n4
            }(h3 || "*", n3.nodeType ? [n3] : n3, []),
            f3 = !d3 || !e4 && h3 ? c3 : Te2(c3, s3, d3, n3, r3),
            p3 = g3 ? y3 || (e4 ? d3 : l3 || v3) ? [] : t23 : f3;
        if (g3 && g3(f3, p3, n3, r3), v3)
          for (i3 = Te2(p3, u3), v3(i3, [], n3, r3), o3 = i3.length; o3--;)(a3 = i3[o3]) && (p3[u3[o3]] = !(f3[u3[o3]] = a3));
        if (e4) {
          if (y3 || d3) {
            if (y3) {
              for (i3 = [], o3 = p3.length; o3--;)(a3 = p3[o3]) && i3.push(f3[o3] = a3);
              y3(null, p3 = [], i3, r3)
            }
            for (o3 = p3.length; o3--;)(a3 = p3[o3]) && -1 < (i3 = y3 ? P2(e4, a3) : s3[o3]) && (e4[i3] = !(t23[i3] = a3))
          }
        } else p3 = Te2(p3 === t23 ? p3.splice(l3, p3.length) : p3), y3 ? y3(null, t23, p3, r3) : H2.apply(t23, p3)
      })
    }

    function Ee2(e3) {
      for (var i3, t23, n3, r3 = e3.length, o3 = b2.relative[e3[0].type], a3 = o3 || b2.relative[" "], s3 = o3 ? 1 : 0, u3 = be2(function(e4) {
        return e4 === i3
      }, a3, !0), l3 = be2(function(e4) {
        return -1 < P2(i3, e4)
      }, a3, !0), c3 = [function(e4, t24, n4) {
        var r4 = !o3 && (n4 || t24 !== w2) || ((i3 = t24).nodeType ? u3(e4, t24, n4) : l3(e4, t24, n4));
        return i3 = null, r4
      }]; s3 < r3; s3++)
        if (t23 = b2.relative[e3[s3].type]) c3 = [be2(we2(c3), t23)];
        else {
          if ((t23 = b2.filter[e3[s3].type].apply(null, e3[s3].matches))[S2]) {
            for (n3 = ++s3; n3 < r3 && !b2.relative[e3[n3].type]; n3++);
            return Ce2(1 < s3 && we2(c3), 1 < s3 && xe2(e3.slice(0, s3 - 1).concat({
              value: e3[s3 - 2].type === " " ? "*" : ""
            })).replace($3, "$1"), t23, s3 < n3 && Ee2(e3.slice(s3, n3)), n3 < r3 && Ee2(e3 = e3.slice(n3)), n3 < r3 && xe2(e3))
          }
          c3.push(t23)
        } return we2(c3)
    }
    return me2.prototype = b2.filters = b2.pseudos, b2.setFilters = new me2, h2 = se2.tokenize = function(e3, t23) {
      var n3, r3, i3, o3, a3, s3, u3, l3 = x2[e3 + " "];
      if (l3) return t23 ? 0 : l3.slice(0);
      for (a3 = e3, s3 = [], u3 = b2.preFilter; a3;) {
        for (o3 in n3 && !(r3 = _3.exec(a3)) || (r3 && (a3 = a3.slice(r3[0].length) || a3), s3.push(i3 = [])), n3 = !1, (r3 = z2.exec(a3)) && (n3 = r3.shift(), i3.push({
          value: n3,
          type: r3[0].replace($3, " ")
        }), a3 = a3.slice(n3.length)), b2.filter) !(r3 = G2[o3].exec(a3)) || u3[o3] && !(r3 = u3[o3](r3)) || (n3 = r3.shift(), i3.push({
          value: n3,
          type: o3,
          matches: r3
        }), a3 = a3.slice(n3.length));
        if (!n3) break
      }
      return t23 ? a3.length : a3 ? se2.error(e3) : x2(e3, s3).slice(0)
    }, f2 = se2.compile = function(e3, t23) {
      var n3, v3, y3, m3, x3, r3, i3 = [],
          o3 = [],
          a3 = A2[e3 + " "];
      if (!a3) {
        for (t23 || (t23 = h2(e3)), n3 = t23.length; n3--;)(a3 = Ee2(t23[n3]))[S2] ? i3.push(a3) : o3.push(a3);
        (a3 = A2(e3, (v3 = o3, m3 = 0 < (y3 = i3).length, x3 = 0 < v3.length, r3 = function(e4, t24, n4, r4, i4) {
          var o4, a4, s3, u3 = 0,
              l3 = "0",
              c3 = e4 && [],
              f3 = [],
              p3 = w2,
              d3 = e4 || x3 && b2.find.TAG("*", i4),
              h3 = k2 += p3 == null ? 1 : Math.random() || .1,
              g3 = d3.length;
          for (i4 && (w2 = t24 == C2 || t24 || i4); l3 !== g3 && (o4 = d3[l3]) != null; l3++) {
            if (x3 && o4) {
              for (a4 = 0, t24 || o4.ownerDocument == C2 || (T2(o4), n4 = !E2); s3 = v3[a4++];)
                if (s3(o4, t24 || C2, n4)) {
                  r4.push(o4);
                  break
                } i4 && (k2 = h3)
            }
            m3 && ((o4 = !s3 && o4) && u3--, e4 && c3.push(o4))
          }
          if (u3 += l3, m3 && l3 !== u3) {
            for (a4 = 0; s3 = y3[a4++];) s3(c3, f3, t24, n4);
            if (e4) {
              if (0 < u3)
                for (; l3--;) c3[l3] || f3[l3] || (f3[l3] = q2.call(r4));
              f3 = Te2(f3)
            }
            H2.apply(r4, f3), i4 && !e4 && 0 < f3.length && 1 < u3 + y3.length && se2.uniqueSort(r4)
          }
          return i4 && (k2 = h3, w2 = p3), c3
        }, m3 ? le2(r3) : r3))).selector = e3
      }
      return a3
    }, g2 = se2.select = function(e3, t23, n3, r3) {
      var i3, o3, a3, s3, u3, l3 = typeof e3 == "function" && e3,
          c3 = !r3 && h2(e3 = l3.selector || e3);
      if (n3 = n3 || [], c3.length === 1) {
        if (2 < (o3 = c3[0] = c3[0].slice(0)).length && (a3 = o3[0]).type === "ID" && t23.nodeType === 9 && E2 && b2.relative[o3[1].type]) {
          if (!(t23 = (b2.find.ID(a3.matches[0].replace(te2, ne2), t23) || [])[0])) return n3;
          l3 && (t23 = t23.parentNode), e3 = e3.slice(o3.shift().value.length)
        }
        for (i3 = G2.needsContext.test(e3) ? 0 : o3.length; i3-- && (a3 = o3[i3], !b2.relative[s3 = a3.type]);)
          if ((u3 = b2.find[s3]) && (r3 = u3(a3.matches[0].replace(te2, ne2), ee2.test(o3[0].type) && ye2(t23.parentNode) || t23))) {
            if (o3.splice(i3, 1), !(e3 = r3.length && xe2(o3))) return H2.apply(n3, r3), n3;
            break
          }
      }
      return (l3 || f2(e3, c3))(r3, t23, !E2, n3, !t23 || ee2.test(e3) && ye2(t23.parentNode) || t23), n3
    }, d2.sortStable = S2.split("").sort(D2).join("") === S2, d2.detectDuplicates = !!l2, T2(), d2.sortDetached = ce2(function(e3) {
      return 1 & e3.compareDocumentPosition(C2.createElement("fieldset"))
    }), ce2(function(e3) {
      return e3.innerHTML = "<a href='#'></a>", e3.firstChild.getAttribute("href") === "#"
    }) || fe2("type|href|height|width", function(e3, t23, n3) {
      if (!n3) return e3.getAttribute(t23, t23.toLowerCase() === "type" ? 1 : 2)
    }), d2.attributes && ce2(function(e3) {
      return e3.innerHTML = "<input/>", e3.firstChild.setAttribute("value", ""), e3.firstChild.getAttribute("value") === ""
    }) || fe2("value", function(e3, t23, n3) {
      if (!n3 && e3.nodeName.toLowerCase() === "input") return e3.defaultValue
    }), ce2(function(e3) {
      return e3.getAttribute("disabled") == null
    }) || fe2(R2, function(e3, t23, n3) {
      var r3;
      if (!n3) return e3[t23] === !0 ? t23.toLowerCase() : (r3 = e3.getAttributeNode(t23)) && r3.specified ? r3.value : null
    }), se2
  }(C);
  S.find = d, S.expr = d.selectors, S.expr[":"] = S.expr.pseudos, S.uniqueSort = S.unique = d.uniqueSort, S.text = d.getText, S.isXMLDoc = d.isXML, S.contains = d.contains, S.escapeSelector = d.escape;
  var h = function(e2, t22, n2) {
        for (var r2 = [], i2 = n2 !== void 0;
             (e2 = e2[t22]) && e2.nodeType !== 9;)
          if (e2.nodeType === 1) {
            if (i2 && S(e2).is(n2)) break;
            r2.push(e2)
          } return r2
      },
      T = function(e2, t22) {
        for (var n2 = []; e2; e2 = e2.nextSibling) e2.nodeType === 1 && e2 !== t22 && n2.push(e2);
        return n2
      },
      k = S.expr.match.needsContext;

  function A(e2, t22) {
    return e2.nodeName && e2.nodeName.toLowerCase() === t22.toLowerCase()
  }
  var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

  function D(e2, n2, r2) {
    return m(n2) ? S.grep(e2, function(e3, t22) {
      return !!n2.call(e3, t22, e3) !== r2
    }) : n2.nodeType ? S.grep(e2, function(e3) {
      return e3 === n2 !== r2
    }) : typeof n2 != "string" ? S.grep(e2, function(e3) {
      return -1 < i.call(n2, e3) !== r2
    }) : S.filter(n2, e2, r2)
  }
  S.filter = function(e2, t22, n2) {
    var r2 = t22[0];
    return n2 && (e2 = ":not(" + e2 + ")"), t22.length === 1 && r2.nodeType === 1 ? S.find.matchesSelector(r2, e2) ? [r2] : [] : S.find.matches(e2, S.grep(t22, function(e3) {
      return e3.nodeType === 1
    }))
  }, S.fn.extend({
    find: function(e2) {
      var t22, n2, r2 = this.length,
          i2 = this;
      if (typeof e2 != "string") return this.pushStack(S(e2).filter(function() {
        for (t22 = 0; t22 < r2; t22++)
          if (S.contains(i2[t22], this)) return !0
      }));
      for (n2 = this.pushStack([]), t22 = 0; t22 < r2; t22++) S.find(e2, i2[t22], n2);
      return 1 < r2 ? S.uniqueSort(n2) : n2
    },
    filter: function(e2) {
      return this.pushStack(D(this, e2 || [], !1))
    },
    not: function(e2) {
      return this.pushStack(D(this, e2 || [], !0))
    },
    is: function(e2) {
      return !!D(this, typeof e2 == "string" && k.test(e2) ? S(e2) : e2 || [], !1).length
    }
  });
  var j, q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  (S.fn.init = function(e2, t22, n2) {
    var r2, i2;
    if (!e2) return this;
    if (n2 = n2 || j, typeof e2 == "string") {
      if (!(r2 = e2[0] === "<" && e2[e2.length - 1] === ">" && 3 <= e2.length ? [null, e2, null] : q.exec(e2)) || !r2[1] && t22) return !t22 || t22.jquery ? (t22 || n2).find(e2) : this.constructor(t22).find(e2);
      if (r2[1]) {
        if (t22 = t22 instanceof S ? t22[0] : t22, S.merge(this, S.parseHTML(r2[1], t22 && t22.nodeType ? t22.ownerDocument || t22 : E, !0)), N.test(r2[1]) && S.isPlainObject(t22))
          for (r2 in t22) m(this[r2]) ? this[r2](t22[r2]) : this.attr(r2, t22[r2]);
        return this
      }
      return (i2 = E.getElementById(r2[2])) && (this[0] = i2, this.length = 1), this
    }
    return e2.nodeType ? (this[0] = e2, this.length = 1, this) : m(e2) ? n2.ready !== void 0 ? n2.ready(e2) : e2(S) : S.makeArray(e2, this)
  }).prototype = S.fn, j = S(E);
  var L = /^(?:parents|prev(?:Until|All))/,
      H = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
      };

  function O(e2, t22) {
    for (;
        (e2 = e2[t22]) && e2.nodeType !== 1;);
    return e2
  }
  S.fn.extend({
    has: function(e2) {
      var t22 = S(e2, this),
          n2 = t22.length;
      return this.filter(function() {
        for (var e3 = 0; e3 < n2; e3++)
          if (S.contains(this, t22[e3])) return !0
      })
    },
    closest: function(e2, t22) {
      var n2, r2 = 0,
          i2 = this.length,
          o2 = [],
          a2 = typeof e2 != "string" && S(e2);
      if (!k.test(e2)) {
        for (; r2 < i2; r2++)
          for (n2 = this[r2]; n2 && n2 !== t22; n2 = n2.parentNode)
            if (n2.nodeType < 11 && (a2 ? -1 < a2.index(n2) : n2.nodeType === 1 && S.find.matchesSelector(n2, e2))) {
              o2.push(n2);
              break
            }
      }
      return this.pushStack(1 < o2.length ? S.uniqueSort(o2) : o2)
    },
    index: function(e2) {
      return e2 ? typeof e2 == "string" ? i.call(S(e2), this[0]) : i.call(this, e2.jquery ? e2[0] : e2) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
    },
    add: function(e2, t22) {
      return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e2, t22))))
    },
    addBack: function(e2) {
      return this.add(e2 == null ? this.prevObject : this.prevObject.filter(e2))
    }
  }), S.each({
    parent: function(e2) {
      var t22 = e2.parentNode;
      return t22 && t22.nodeType !== 11 ? t22 : null
    },
    parents: function(e2) {
      return h(e2, "parentNode")
    },
    parentsUntil: function(e2, t22, n2) {
      return h(e2, "parentNode", n2)
    },
    next: function(e2) {
      return O(e2, "nextSibling")
    },
    prev: function(e2) {
      return O(e2, "previousSibling")
    },
    nextAll: function(e2) {
      return h(e2, "nextSibling")
    },
    prevAll: function(e2) {
      return h(e2, "previousSibling")
    },
    nextUntil: function(e2, t22, n2) {
      return h(e2, "nextSibling", n2)
    },
    prevUntil: function(e2, t22, n2) {
      return h(e2, "previousSibling", n2)
    },
    siblings: function(e2) {
      return T((e2.parentNode || {}).firstChild, e2)
    },
    children: function(e2) {
      return T(e2.firstChild)
    },
    contents: function(e2) {
      return e2.contentDocument != null && r(e2.contentDocument) ? e2.contentDocument : (A(e2, "template") && (e2 = e2.content || e2), S.merge([], e2.childNodes))
    }
  }, function(r2, i2) {
    S.fn[r2] = function(e2, t22) {
      var n2 = S.map(this, i2, e2);
      return r2.slice(-5) !== "Until" && (t22 = e2), t22 && typeof t22 == "string" && (n2 = S.filter(t22, n2)), 1 < this.length && (H[r2] || S.uniqueSort(n2), L.test(r2) && n2.reverse()), this.pushStack(n2)
    }
  });
  var P = /[^\x20\t\r\n\f]+/g;

  function R(e2) {
    return e2
  }

  function M(e2) {
    throw e2
  }

  function I(e2, t22, n2, r2) {
    var i2;
    try {
      e2 && m(i2 = e2.promise) ? i2.call(e2).done(t22).fail(n2) : e2 && m(i2 = e2.then) ? i2.call(e2, t22, n2) : t22.apply(void 0, [e2].slice(r2))
    } catch (e3) {
      n2.apply(void 0, [e3])
    }
  }
  S.Callbacks = function(r2) {
    var e2, n2;
    r2 = typeof r2 == "string" ? (e2 = r2, n2 = {}, S.each(e2.match(P) || [], function(e3, t23) {
      n2[t23] = !0
    }), n2) : S.extend({}, r2);
    var i2, t22, o2, a2, s2 = [],
        u2 = [],
        l2 = -1,
        c2 = function() {
          for (a2 = a2 || r2.once, o2 = i2 = !0; u2.length; l2 = -1)
            for (t22 = u2.shift(); ++l2 < s2.length;) s2[l2].apply(t22[0], t22[1]) === !1 && r2.stopOnFalse && (l2 = s2.length, t22 = !1);
          r2.memory || (t22 = !1), i2 = !1, a2 && (s2 = t22 ? [] : "")
        },
        f2 = {
          add: function() {
            return s2 && (t22 && !i2 && (l2 = s2.length - 1, u2.push(t22)), function n3(e3) {
              S.each(e3, function(e4, t23) {
                m(t23) ? r2.unique && f2.has(t23) || s2.push(t23) : t23 && t23.length && w(t23) !== "string" && n3(t23)
              })
            }(arguments), t22 && !i2 && c2()), this
          },
          remove: function() {
            return S.each(arguments, function(e3, t23) {
              for (var n3; - 1 < (n3 = S.inArray(t23, s2, n3));) s2.splice(n3, 1), n3 <= l2 && l2--
            }), this
          },
          has: function(e3) {
            return e3 ? -1 < S.inArray(e3, s2) : 0 < s2.length
          },
          empty: function() {
            return s2 && (s2 = []), this
          },
          disable: function() {
            return a2 = u2 = [], s2 = t22 = "", this
          },
          disabled: function() {
            return !s2
          },
          lock: function() {
            return a2 = u2 = [], t22 || i2 || (s2 = t22 = ""), this
          },
          locked: function() {
            return !!a2
          },
          fireWith: function(e3, t23) {
            return a2 || (t23 = [e3, (t23 = t23 || []).slice ? t23.slice() : t23], u2.push(t23), i2 || c2()), this
          },
          fire: function() {
            return f2.fireWith(this, arguments), this
          },
          fired: function() {
            return !!o2
          }
        };
    return f2
  }, S.extend({
    Deferred: function(e2) {
      var o2 = [
            ["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2],
            ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"],
            ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"]
          ],
          i2 = "pending",
          a2 = {
            state: function() {
              return i2
            },
            always: function() {
              return s2.done(arguments).fail(arguments), this
            },
            catch: function(e3) {
              return a2.then(null, e3)
            },
            pipe: function() {
              var i3 = arguments;
              return S.Deferred(function(r2) {
                S.each(o2, function(e3, t22) {
                  var n2 = m(i3[t22[4]]) && i3[t22[4]];
                  s2[t22[1]](function() {
                    var e4 = n2 && n2.apply(this, arguments);
                    e4 && m(e4.promise) ? e4.promise().progress(r2.notify).done(r2.resolve).fail(r2.reject) : r2[t22[0] + "With"](this, n2 ? [e4] : arguments)
                  })
                }), i3 = null
              }).promise()
            },
            then: function(t22, n2, r2) {
              var u2 = 0;

              function l2(i3, o3, a3, s3) {
                return function() {
                  var n3 = this,
                      r3 = arguments,
                      e3 = function() {
                        var e4, t24;
                        if (!(i3 < u2)) {
                          if ((e4 = a3.apply(n3, r3)) === o3.promise()) throw new TypeError("Thenable self-resolution");
                          t24 = e4 && (typeof e4 == "object" || typeof e4 == "function") && e4.then, m(t24) ? s3 ? t24.call(e4, l2(u2, o3, R, s3), l2(u2, o3, M, s3)) : (u2++, t24.call(e4, l2(u2, o3, R, s3), l2(u2, o3, M, s3), l2(u2, o3, R, o3.notifyWith))) : (a3 !== R && (n3 = void 0, r3 = [e4]), (s3 || o3.resolveWith)(n3, r3))
                        }
                      },
                      t23 = s3 ? e3 : function() {
                        try {
                          e3()
                        } catch (e4) {
                          S.Deferred.exceptionHook && S.Deferred.exceptionHook(e4, t23.stackTrace), u2 <= i3 + 1 && (a3 !== M && (n3 = void 0, r3 = [e4]), o3.rejectWith(n3, r3))
                        }
                      };
                  i3 ? t23() : (S.Deferred.getStackHook && (t23.stackTrace = S.Deferred.getStackHook()), C.setTimeout(t23))
                }
              }
              return S.Deferred(function(e3) {
                o2[0][3].add(l2(0, e3, m(r2) ? r2 : R, e3.notifyWith)), o2[1][3].add(l2(0, e3, m(t22) ? t22 : R)), o2[2][3].add(l2(0, e3, m(n2) ? n2 : M))
              }).promise()
            },
            promise: function(e3) {
              return e3 != null ? S.extend(e3, a2) : a2
            }
          },
          s2 = {};
      return S.each(o2, function(e3, t22) {
        var n2 = t22[2],
            r2 = t22[5];
        a2[t22[1]] = n2.add, r2 && n2.add(function() {
          i2 = r2
        }, o2[3 - e3][2].disable, o2[3 - e3][3].disable, o2[0][2].lock, o2[0][3].lock), n2.add(t22[3].fire), s2[t22[0]] = function() {
          return s2[t22[0] + "With"](this === s2 ? void 0 : this, arguments), this
        }, s2[t22[0] + "With"] = n2.fireWith
      }), a2.promise(s2), e2 && e2.call(s2, s2), s2
    },
    when: function(e2) {
      var n2 = arguments.length,
          t22 = n2,
          r2 = Array(t22),
          i2 = s.call(arguments),
          o2 = S.Deferred(),
          a2 = function(t23) {
            return function(e3) {
              r2[t23] = this, i2[t23] = 1 < arguments.length ? s.call(arguments) : e3, --n2 || o2.resolveWith(r2, i2)
            }
          };
      if (n2 <= 1 && (I(e2, o2.done(a2(t22)).resolve, o2.reject, !n2), o2.state() === "pending" || m(i2[t22] && i2[t22].then))) return o2.then();
      for (; t22--;) I(i2[t22], a2(t22), o2.reject);
      return o2.promise()
    }
  });
  var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  S.Deferred.exceptionHook = function(e2, t22) {
    C.console && C.console.warn && e2 && W.test(e2.name) && C.console.warn("jQuery.Deferred exception: " + e2.message, e2.stack, t22)
  }, S.readyException = function(e2) {
    C.setTimeout(function() {
      throw e2
    })
  };
  var F = S.Deferred();

  function B() {
    E.removeEventListener("DOMContentLoaded", B), C.removeEventListener("load", B), S.ready()
  }
  S.fn.ready = function(e2) {
    return F.then(e2).catch(function(e3) {
      S.readyException(e3)
    }), this
  }, S.extend({
    isReady: !1,
    readyWait: 1,
    ready: function(e2) {
      (e2 === !0 ? --S.readyWait : S.isReady) || (S.isReady = !0) !== e2 && 0 < --S.readyWait || F.resolveWith(E, [S])
    }
  }), S.ready.then = F.then, E.readyState === "complete" || E.readyState !== "loading" && !E.documentElement.doScroll ? C.setTimeout(S.ready) : (E.addEventListener("DOMContentLoaded", B), C.addEventListener("load", B));
  var $2 = function(e2, t22, n2, r2, i2, o2, a2) {
        var s2 = 0,
            u2 = e2.length,
            l2 = n2 == null;
        if (w(n2) === "object")
          for (s2 in i2 = !0, n2) $2(e2, t22, s2, n2[s2], !0, o2, a2);
        else if (r2 !== void 0 && (i2 = !0, m(r2) || (a2 = !0), l2 && (a2 ? (t22.call(e2, r2), t22 = null) : (l2 = t22, t22 = function(e3, t23, n3) {
          return l2.call(S(e3), n3)
        })), t22))
          for (; s2 < u2; s2++) t22(e2[s2], n2, a2 ? r2 : r2.call(e2[s2], s2, t22(e2[s2], n2)));
        return i2 ? e2 : l2 ? t22.call(e2) : u2 ? t22(e2[0], n2) : o2
      },
      _2 = /^-ms-/,
      z = /-([a-z])/g;

  function U(e2, t22) {
    return t22.toUpperCase()
  }

  function X(e2) {
    return e2.replace(_2, "ms-").replace(z, U)
  }
  var V = function(e2) {
    return e2.nodeType === 1 || e2.nodeType === 9 || !+e2.nodeType
  };

  function G() {
    this.expando = S.expando + G.uid++
  }
  G.uid = 1, G.prototype = {
    cache: function(e2) {
      var t22 = e2[this.expando];
      return t22 || (t22 = {}, V(e2) && (e2.nodeType ? e2[this.expando] = t22 : Object.defineProperty(e2, this.expando, {
        value: t22,
        configurable: !0
      }))), t22
    },
    set: function(e2, t22, n2) {
      var r2, i2 = this.cache(e2);
      if (typeof t22 == "string") i2[X(t22)] = n2;
      else
        for (r2 in t22) i2[X(r2)] = t22[r2];
      return i2
    },
    get: function(e2, t22) {
      return t22 === void 0 ? this.cache(e2) : e2[this.expando] && e2[this.expando][X(t22)]
    },
    access: function(e2, t22, n2) {
      return t22 === void 0 || t22 && typeof t22 == "string" && n2 === void 0 ? this.get(e2, t22) : (this.set(e2, t22, n2), n2 !== void 0 ? n2 : t22)
    },
    remove: function(e2, t22) {
      var n2, r2 = e2[this.expando];
      if (r2 !== void 0) {
        if (t22 !== void 0)
          for (n2 = (t22 = Array.isArray(t22) ? t22.map(X) : (t22 = X(t22)) in r2 ? [t22] : t22.match(P) || []).length; n2--;) delete r2[t22[n2]];
        (t22 === void 0 || S.isEmptyObject(r2)) && (e2.nodeType ? e2[this.expando] = void 0 : delete e2[this.expando])
      }
    },
    hasData: function(e2) {
      var t22 = e2[this.expando];
      return t22 !== void 0 && !S.isEmptyObject(t22)
    }
  };
  var Y = new G,
      Q = new G,
      J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      K = /[A-Z]/g;

  function Z(e2, t22, n2) {
    var r2, i2;
    if (n2 === void 0 && e2.nodeType === 1)
      if (r2 = "data-" + t22.replace(K, "-$&").toLowerCase(), typeof(n2 = e2.getAttribute(r2)) == "string") {
        try {
          n2 = (i2 = n2) === "true" || i2 !== "false" && (i2 === "null" ? null : i2 === +i2 + "" ? +i2 : J.test(i2) ? JSON.parse(i2) : i2)
        } catch {}
        Q.set(e2, t22, n2)
      } else n2 = void 0;
    return n2
  }
  S.extend({
    hasData: function(e2) {
      return Q.hasData(e2) || Y.hasData(e2)
    },
    data: function(e2, t22, n2) {
      return Q.access(e2, t22, n2)
    },
    removeData: function(e2, t22) {
      Q.remove(e2, t22)
    },
    _data: function(e2, t22, n2) {
      return Y.access(e2, t22, n2)
    },
    _removeData: function(e2, t22) {
      Y.remove(e2, t22)
    }
  }), S.fn.extend({
    data: function(n2, e2) {
      var t22, r2, i2, o2 = this[0],
          a2 = o2 && o2.attributes;
      if (n2 === void 0) {
        if (this.length && (i2 = Q.get(o2), o2.nodeType === 1 && !Y.get(o2, "hasDataAttrs"))) {
          for (t22 = a2.length; t22--;) a2[t22] && (r2 = a2[t22].name).indexOf("data-") === 0 && (r2 = X(r2.slice(5)), Z(o2, r2, i2[r2]));
          Y.set(o2, "hasDataAttrs", !0)
        }
        return i2
      }
      return typeof n2 == "object" ? this.each(function() {
        Q.set(this, n2)
      }) : $2(this, function(e3) {
        var t23;
        if (o2 && e3 === void 0) return (t23 = Q.get(o2, n2)) !== void 0 || (t23 = Z(o2, n2)) !== void 0 ? t23 : void 0;
        this.each(function() {
          Q.set(this, n2, e3)
        })
      }, null, e2, 1 < arguments.length, null, !0)
    },
    removeData: function(e2) {
      return this.each(function() {
        Q.remove(this, e2)
      })
    }
  }), S.extend({
    queue: function(e2, t22, n2) {
      var r2;
      if (e2) return t22 = (t22 || "fx") + "queue", r2 = Y.get(e2, t22), n2 && (!r2 || Array.isArray(n2) ? r2 = Y.access(e2, t22, S.makeArray(n2)) : r2.push(n2)), r2 || []
    },
    dequeue: function(e2, t22) {
      t22 = t22 || "fx";
      var n2 = S.queue(e2, t22),
          r2 = n2.length,
          i2 = n2.shift(),
          o2 = S._queueHooks(e2, t22);
      i2 === "inprogress" && (i2 = n2.shift(), r2--), i2 && (t22 === "fx" && n2.unshift("inprogress"), delete o2.stop, i2.call(e2, function() {
        S.dequeue(e2, t22)
      }, o2)), !r2 && o2 && o2.empty.fire()
    },
    _queueHooks: function(e2, t22) {
      var n2 = t22 + "queueHooks";
      return Y.get(e2, n2) || Y.access(e2, n2, {
        empty: S.Callbacks("once memory").add(function() {
          Y.remove(e2, [t22 + "queue", n2])
        })
      })
    }
  }), S.fn.extend({
    queue: function(t22, n2) {
      var e2 = 2;
      return typeof t22 != "string" && (n2 = t22, t22 = "fx", e2--), arguments.length < e2 ? S.queue(this[0], t22) : n2 === void 0 ? this : this.each(function() {
        var e3 = S.queue(this, t22, n2);
        S._queueHooks(this, t22), t22 === "fx" && e3[0] !== "inprogress" && S.dequeue(this, t22)
      })
    },
    dequeue: function(e2) {
      return this.each(function() {
        S.dequeue(this, e2)
      })
    },
    clearQueue: function(e2) {
      return this.queue(e2 || "fx", [])
    },
    promise: function(e2, t22) {
      var n2, r2 = 1,
          i2 = S.Deferred(),
          o2 = this,
          a2 = this.length,
          s2 = function() {
            --r2 || i2.resolveWith(o2, [o2])
          };
      for (typeof e2 != "string" && (t22 = e2, e2 = void 0), e2 = e2 || "fx"; a2--;)(n2 = Y.get(o2[a2], e2 + "queueHooks")) && n2.empty && (r2++, n2.empty.add(s2));
      return s2(), i2.promise(t22)
    }
  });
  var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
      ne = ["Top", "Right", "Bottom", "Left"],
      re = E.documentElement,
      ie = function(e2) {
        return S.contains(e2.ownerDocument, e2)
      },
      oe = {
        composed: !0
      };
  re.getRootNode && (ie = function(e2) {
    return S.contains(e2.ownerDocument, e2) || e2.getRootNode(oe) === e2.ownerDocument
  });
  var ae = function(e2, t22) {
    return (e2 = t22 || e2).style.display === "none" || e2.style.display === "" && ie(e2) && S.css(e2, "display") === "none"
  };

  function se(e2, t22, n2, r2) {
    var i2, o2, a2 = 20,
        s2 = r2 ? function() {
          return r2.cur()
        } : function() {
          return S.css(e2, t22, "")
        },
        u2 = s2(),
        l2 = n2 && n2[3] || (S.cssNumber[t22] ? "" : "px"),
        c2 = e2.nodeType && (S.cssNumber[t22] || l2 !== "px" && +u2) && te.exec(S.css(e2, t22));
    if (c2 && c2[3] !== l2) {
      for (u2 /= 2, l2 = l2 || c2[3], c2 = +u2 || 1; a2--;) S.style(e2, t22, c2 + l2), (1 - o2) * (1 - (o2 = s2() / u2 || .5)) <= 0 && (a2 = 0), c2 /= o2;
      c2 *= 2, S.style(e2, t22, c2 + l2), n2 = n2 || []
    }
    return n2 && (c2 = +c2 || +u2 || 0, i2 = n2[1] ? c2 + (n2[1] + 1) * n2[2] : +n2[2], r2 && (r2.unit = l2, r2.start = c2, r2.end = i2)), i2
  }
  var ue = {};

  function le(e2, t22) {
    for (var n2, r2, i2, o2, a2, s2, u2, l2 = [], c2 = 0, f2 = e2.length; c2 < f2; c2++)(r2 = e2[c2]).style && (n2 = r2.style.display, t22 ? (n2 === "none" && (l2[c2] = Y.get(r2, "display") || null, l2[c2] || (r2.style.display = "")), r2.style.display === "" && ae(r2) && (l2[c2] = (u2 = a2 = o2 = void 0, a2 = (i2 = r2).ownerDocument, s2 = i2.nodeName, (u2 = ue[s2]) || (o2 = a2.body.appendChild(a2.createElement(s2)), u2 = S.css(o2, "display"), o2.parentNode.removeChild(o2), u2 === "none" && (u2 = "block"), ue[s2] = u2)))) : n2 !== "none" && (l2[c2] = "none", Y.set(r2, "display", n2)));
    for (c2 = 0; c2 < f2; c2++) l2[c2] != null && (e2[c2].style.display = l2[c2]);
    return e2
  }
  S.fn.extend({
    show: function() {
      return le(this, !0)
    },
    hide: function() {
      return le(this)
    },
    toggle: function(e2) {
      return typeof e2 == "boolean" ? e2 ? this.show() : this.hide() : this.each(function() {
        ae(this) ? S(this).show() : S(this).hide()
      })
    }
  });
  var ce, fe, pe = /^(?:checkbox|radio)$/i,
      de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
      he = /^$|^module$|\/(?:java|ecma)script/i;
  ce = E.createDocumentFragment().appendChild(E.createElement("div")), (fe = E.createElement("input")).setAttribute("type", "radio"), fe.setAttribute("checked", "checked"), fe.setAttribute("name", "t"), ce.appendChild(fe), y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked, ce.innerHTML = "<textarea>x</textarea>", y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue, ce.innerHTML = "<option></option>", y.option = !!ce.lastChild;
  var ge = {
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };

  function ve(e2, t22) {
    var n2;
    return n2 = typeof e2.getElementsByTagName < "u" ? e2.getElementsByTagName(t22 || "*") : typeof e2.querySelectorAll < "u" ? e2.querySelectorAll(t22 || "*") : [], t22 === void 0 || t22 && A(e2, t22) ? S.merge([e2], n2) : n2
  }

  function ye(e2, t22) {
    for (var n2 = 0, r2 = e2.length; n2 < r2; n2++) Y.set(e2[n2], "globalEval", !t22 || Y.get(t22[n2], "globalEval"))
  }
  ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead, ge.th = ge.td, y.option || (ge.optgroup = ge.option = [1, "<select multiple='multiple'>", "</select>"]);
  var me = /<|&#?\w+;/;

  function xe(e2, t22, n2, r2, i2) {
    for (var o2, a2, s2, u2, l2, c2, f2 = t22.createDocumentFragment(), p2 = [], d2 = 0, h2 = e2.length; d2 < h2; d2++)
      if ((o2 = e2[d2]) || o2 === 0)
        if (w(o2) === "object") S.merge(p2, o2.nodeType ? [o2] : o2);
        else if (me.test(o2)) {
          for (a2 = a2 || f2.appendChild(t22.createElement("div")), s2 = (de.exec(o2) || ["", ""])[1].toLowerCase(), u2 = ge[s2] || ge._default, a2.innerHTML = u2[1] + S.htmlPrefilter(o2) + u2[2], c2 = u2[0]; c2--;) a2 = a2.lastChild;
          S.merge(p2, a2.childNodes), (a2 = f2.firstChild).textContent = ""
        } else p2.push(t22.createTextNode(o2));
    for (f2.textContent = "", d2 = 0; o2 = p2[d2++];)
      if (r2 && -1 < S.inArray(o2, r2)) i2 && i2.push(o2);
      else if (l2 = ie(o2), a2 = ve(f2.appendChild(o2), "script"), l2 && ye(a2), n2)
        for (c2 = 0; o2 = a2[c2++];) he.test(o2.type || "") && n2.push(o2);
    return f2
  }
  var be = /^key/,
      we = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Te = /^([^.]*)(?:\.(.+)|)/;

  function Ce() {
    return !0
  }

  function Ee() {
    return !1
  }

  function Se(e2, t22) {
    return e2 === function() {
      try {
        return E.activeElement
      } catch {}
    }() == (t22 === "focus")
  }

  function ke(e2, t22, n2, r2, i2, o2) {
    var a2, s2;
    if (typeof t22 == "object") {
      for (s2 in typeof n2 != "string" && (r2 = r2 || n2, n2 = void 0), t22) ke(e2, s2, n2, r2, t22[s2], o2);
      return e2
    }
    if (r2 == null && i2 == null ? (i2 = n2, r2 = n2 = void 0) : i2 == null && (typeof n2 == "string" ? (i2 = r2, r2 = void 0) : (i2 = r2, r2 = n2, n2 = void 0)), i2 === !1) i2 = Ee;
    else if (!i2) return e2;
    return o2 === 1 && (a2 = i2, (i2 = function(e3) {
      return S().off(e3), a2.apply(this, arguments)
    }).guid = a2.guid || (a2.guid = S.guid++)), e2.each(function() {
      S.event.add(this, t22, i2, r2, n2)
    })
  }

  function Ae(e2, i2, o2) {
    o2 ? (Y.set(e2, i2, !1), S.event.add(e2, i2, {
      namespace: !1,
      handler: function(e3) {
        var t22, n2, r2 = Y.get(this, i2);
        if (1 & e3.isTrigger && this[i2]) {
          if (r2.length)(S.event.special[i2] || {}).delegateType && e3.stopPropagation();
          else if (r2 = s.call(arguments), Y.set(this, i2, r2), t22 = o2(this, i2), this[i2](), r2 !== (n2 = Y.get(this, i2)) || t22 ? Y.set(this, i2, !1) : n2 = {}, r2 !== n2) return e3.stopImmediatePropagation(), e3.preventDefault(), n2.value
        } else r2.length && (Y.set(this, i2, {
          value: S.event.trigger(S.extend(r2[0], S.Event.prototype), r2.slice(1), this)
        }), e3.stopImmediatePropagation())
      }
    })) : Y.get(e2, i2) === void 0 && S.event.add(e2, i2, Ce)
  }
  S.event = {
    global: {},
    add: function(t22, e2, n2, r2, i2) {
      var o2, a2, s2, u2, l2, c2, f2, p2, d2, h2, g2, v2 = Y.get(t22);
      if (V(t22))
        for (n2.handler && (n2 = (o2 = n2).handler, i2 = o2.selector), i2 && S.find.matchesSelector(re, i2), n2.guid || (n2.guid = S.guid++), (u2 = v2.events) || (u2 = v2.events = Object.create(null)), (a2 = v2.handle) || (a2 = v2.handle = function(e3) {
          return typeof S < "u" && S.event.triggered !== e3.type ? S.event.dispatch.apply(t22, arguments) : void 0
        }), l2 = (e2 = (e2 || "").match(P) || [""]).length; l2--;) d2 = g2 = (s2 = Te.exec(e2[l2]) || [])[1], h2 = (s2[2] || "").split(".").sort(), d2 && (f2 = S.event.special[d2] || {}, d2 = (i2 ? f2.delegateType : f2.bindType) || d2, f2 = S.event.special[d2] || {}, c2 = S.extend({
          type: d2,
          origType: g2,
          data: r2,
          handler: n2,
          guid: n2.guid,
          selector: i2,
          needsContext: i2 && S.expr.match.needsContext.test(i2),
          namespace: h2.join(".")
        }, o2), (p2 = u2[d2]) || ((p2 = u2[d2] = []).delegateCount = 0, f2.setup && f2.setup.call(t22, r2, h2, a2) !== !1 || t22.addEventListener && t22.addEventListener(d2, a2)), f2.add && (f2.add.call(t22, c2), c2.handler.guid || (c2.handler.guid = n2.guid)), i2 ? p2.splice(p2.delegateCount++, 0, c2) : p2.push(c2), S.event.global[d2] = !0)
    },
    remove: function(e2, t22, n2, r2, i2) {
      var o2, a2, s2, u2, l2, c2, f2, p2, d2, h2, g2, v2 = Y.hasData(e2) && Y.get(e2);
      if (v2 && (u2 = v2.events)) {
        for (l2 = (t22 = (t22 || "").match(P) || [""]).length; l2--;)
          if (d2 = g2 = (s2 = Te.exec(t22[l2]) || [])[1], h2 = (s2[2] || "").split(".").sort(), d2) {
            for (f2 = S.event.special[d2] || {}, p2 = u2[d2 = (r2 ? f2.delegateType : f2.bindType) || d2] || [], s2 = s2[2] && new RegExp("(^|\\.)" + h2.join("\\.(?:.*\\.|)") + "(\\.|$)"), a2 = o2 = p2.length; o2--;) c2 = p2[o2], !i2 && g2 !== c2.origType || n2 && n2.guid !== c2.guid || s2 && !s2.test(c2.namespace) || r2 && r2 !== c2.selector && (r2 !== "**" || !c2.selector) || (p2.splice(o2, 1), c2.selector && p2.delegateCount--, f2.remove && f2.remove.call(e2, c2));
            a2 && !p2.length && (f2.teardown && f2.teardown.call(e2, h2, v2.handle) !== !1 || S.removeEvent(e2, d2, v2.handle), delete u2[d2])
          } else
            for (d2 in u2) S.event.remove(e2, d2 + t22[l2], n2, r2, !0);
        S.isEmptyObject(u2) && Y.remove(e2, "handle events")
      }
    },
    dispatch: function(e2) {
      var t22, n2, r2, i2, o2, a2, s2 = new Array(arguments.length),
          u2 = S.event.fix(e2),
          l2 = (Y.get(this, "events") || Object.create(null))[u2.type] || [],
          c2 = S.event.special[u2.type] || {};
      for (s2[0] = u2, t22 = 1; t22 < arguments.length; t22++) s2[t22] = arguments[t22];
      if (u2.delegateTarget = this, !c2.preDispatch || c2.preDispatch.call(this, u2) !== !1) {
        for (a2 = S.event.handlers.call(this, u2, l2), t22 = 0;
             (i2 = a2[t22++]) && !u2.isPropagationStopped();)
          for (u2.currentTarget = i2.elem, n2 = 0;
               (o2 = i2.handlers[n2++]) && !u2.isImmediatePropagationStopped();) u2.rnamespace && o2.namespace !== !1 && !u2.rnamespace.test(o2.namespace) || (u2.handleObj = o2, u2.data = o2.data, (r2 = ((S.event.special[o2.origType] || {}).handle || o2.handler).apply(i2.elem, s2)) !== void 0 && (u2.result = r2) === !1 && (u2.preventDefault(), u2.stopPropagation()));
        return c2.postDispatch && c2.postDispatch.call(this, u2), u2.result
      }
    },
    handlers: function(e2, t22) {
      var n2, r2, i2, o2, a2, s2 = [],
          u2 = t22.delegateCount,
          l2 = e2.target;
      if (u2 && l2.nodeType && !(e2.type === "click" && 1 <= e2.button)) {
        for (; l2 !== this; l2 = l2.parentNode || this)
          if (l2.nodeType === 1 && (e2.type !== "click" || l2.disabled !== !0)) {
            for (o2 = [], a2 = {}, n2 = 0; n2 < u2; n2++) a2[i2 = (r2 = t22[n2]).selector + " "] === void 0 && (a2[i2] = r2.needsContext ? -1 < S(i2, this).index(l2) : S.find(i2, this, null, [l2]).length), a2[i2] && o2.push(r2);
            o2.length && s2.push({
              elem: l2,
              handlers: o2
            })
          }
      }
      return l2 = this, u2 < t22.length && s2.push({
        elem: l2,
        handlers: t22.slice(u2)
      }), s2
    },
    addProp: function(t22, e2) {
      Object.defineProperty(S.Event.prototype, t22, {
        enumerable: !0,
        configurable: !0,
        get: m(e2) ? function() {
          if (this.originalEvent) return e2(this.originalEvent)
        } : function() {
          if (this.originalEvent) return this.originalEvent[t22]
        },
        set: function(e3) {
          Object.defineProperty(this, t22, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e3
          })
        }
      })
    },
    fix: function(e2) {
      return e2[S.expando] ? e2 : new S.Event(e2)
    },
    special: {
      load: {
        noBubble: !0
      },
      click: {
        setup: function(e2) {
          var t22 = this || e2;
          return pe.test(t22.type) && t22.click && A(t22, "input") && Ae(t22, "click", Ce), !1
        },
        trigger: function(e2) {
          var t22 = this || e2;
          return pe.test(t22.type) && t22.click && A(t22, "input") && Ae(t22, "click"), !0
        },
        _default: function(e2) {
          var t22 = e2.target;
          return pe.test(t22.type) && t22.click && A(t22, "input") && Y.get(t22, "click") || A(t22, "a")
        }
      },
      beforeunload: {
        postDispatch: function(e2) {
          e2.result !== void 0 && e2.originalEvent && (e2.originalEvent.returnValue = e2.result)
        }
      }
    }
  }, S.removeEvent = function(e2, t22, n2) {
    e2.removeEventListener && e2.removeEventListener(t22, n2)
  }, S.Event = function(e2, t22) {
    if (!(this instanceof S.Event)) return new S.Event(e2, t22);
    e2 && e2.type ? (this.originalEvent = e2, this.type = e2.type, this.isDefaultPrevented = e2.defaultPrevented || e2.defaultPrevented === void 0 && e2.returnValue === !1 ? Ce : Ee, this.target = e2.target && e2.target.nodeType === 3 ? e2.target.parentNode : e2.target, this.currentTarget = e2.currentTarget, this.relatedTarget = e2.relatedTarget) : this.type = e2, t22 && S.extend(this, t22), this.timeStamp = e2 && e2.timeStamp || Date.now(), this[S.expando] = !0
  }, S.Event.prototype = {
    constructor: S.Event,
    isDefaultPrevented: Ee,
    isPropagationStopped: Ee,
    isImmediatePropagationStopped: Ee,
    isSimulated: !1,
    preventDefault: function() {
      var e2 = this.originalEvent;
      this.isDefaultPrevented = Ce, e2 && !this.isSimulated && e2.preventDefault()
    },
    stopPropagation: function() {
      var e2 = this.originalEvent;
      this.isPropagationStopped = Ce, e2 && !this.isSimulated && e2.stopPropagation()
    },
    stopImmediatePropagation: function() {
      var e2 = this.originalEvent;
      this.isImmediatePropagationStopped = Ce, e2 && !this.isSimulated && e2.stopImmediatePropagation(), this.stopPropagation()
    }
  }, S.each({
    altKey: !0,
    bubbles: !0,
    cancelable: !0,
    changedTouches: !0,
    ctrlKey: !0,
    detail: !0,
    eventPhase: !0,
    metaKey: !0,
    pageX: !0,
    pageY: !0,
    shiftKey: !0,
    view: !0,
    char: !0,
    code: !0,
    charCode: !0,
    key: !0,
    keyCode: !0,
    button: !0,
    buttons: !0,
    clientX: !0,
    clientY: !0,
    offsetX: !0,
    offsetY: !0,
    pointerId: !0,
    pointerType: !0,
    screenX: !0,
    screenY: !0,
    targetTouches: !0,
    toElement: !0,
    touches: !0,
    which: function(e2) {
      var t22 = e2.button;
      return e2.which == null && be.test(e2.type) ? e2.charCode != null ? e2.charCode : e2.keyCode : !e2.which && t22 !== void 0 && we.test(e2.type) ? 1 & t22 ? 1 : 2 & t22 ? 3 : 4 & t22 ? 2 : 0 : e2.which
    }
  }, S.event.addProp), S.each({
    focus: "focusin",
    blur: "focusout"
  }, function(e2, t22) {
    S.event.special[e2] = {
      setup: function() {
        return Ae(this, e2, Se), !1
      },
      trigger: function() {
        return Ae(this, e2), !0
      },
      delegateType: t22
    }
  }), S.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function(e2, i2) {
    S.event.special[e2] = {
      delegateType: i2,
      bindType: i2,
      handle: function(e3) {
        var t22, n2 = e3.relatedTarget,
            r2 = e3.handleObj;
        return n2 && (n2 === this || S.contains(this, n2)) || (e3.type = r2.origType, t22 = r2.handler.apply(this, arguments), e3.type = i2), t22
      }
    }
  }), S.fn.extend({
    on: function(e2, t22, n2, r2) {
      return ke(this, e2, t22, n2, r2)
    },
    one: function(e2, t22, n2, r2) {
      return ke(this, e2, t22, n2, r2, 1)
    },
    off: function(e2, t22, n2) {
      var r2, i2;
      if (e2 && e2.preventDefault && e2.handleObj) return r2 = e2.handleObj, S(e2.delegateTarget).off(r2.namespace ? r2.origType + "." + r2.namespace : r2.origType, r2.selector, r2.handler), this;
      if (typeof e2 == "object") {
        for (i2 in e2) this.off(i2, t22, e2[i2]);
        return this
      }
      return t22 !== !1 && typeof t22 != "function" || (n2 = t22, t22 = void 0), n2 === !1 && (n2 = Ee), this.each(function() {
        S.event.remove(this, e2, n2, t22)
      })
    }
  });
  var Ne = /<script|<style|<link/i,
      De = /checked\s*(?:[^=]|=\s*.checked.)/i,
      je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

  function qe(e2, t22) {
    return A(e2, "table") && A(t22.nodeType !== 11 ? t22 : t22.firstChild, "tr") && S(e2).children("tbody")[0] || e2
  }

  function Le(e2) {
    return e2.type = (e2.getAttribute("type") !== null) + "/" + e2.type, e2
  }

  function He(e2) {
    return (e2.type || "").slice(0, 5) === "true/" ? e2.type = e2.type.slice(5) : e2.removeAttribute("type"), e2
  }

  function Oe(e2, t22) {
    var n2, r2, i2, o2, a2, s2;
    if (t22.nodeType === 1) {
      if (Y.hasData(e2) && (s2 = Y.get(e2).events))
        for (i2 in Y.remove(t22, "handle events"), s2)
          for (n2 = 0, r2 = s2[i2].length; n2 < r2; n2++) S.event.add(t22, i2, s2[i2][n2]);
      Q.hasData(e2) && (o2 = Q.access(e2), a2 = S.extend({}, o2), Q.set(t22, a2))
    }
  }

  function Pe(n2, r2, i2, o2) {
    r2 = g(r2);
    var e2, t22, a2, s2, u2, l2, c2 = 0,
        f2 = n2.length,
        p2 = f2 - 1,
        d2 = r2[0],
        h2 = m(d2);
    if (h2 || 1 < f2 && typeof d2 == "string" && !y.checkClone && De.test(d2)) return n2.each(function(e3) {
      var t23 = n2.eq(e3);
      h2 && (r2[0] = d2.call(this, e3, t23.html())), Pe(t23, r2, i2, o2)
    });
    if (f2 && (t22 = (e2 = xe(r2, n2[0].ownerDocument, !1, n2, o2)).firstChild, e2.childNodes.length === 1 && (e2 = t22), t22 || o2)) {
      for (s2 = (a2 = S.map(ve(e2, "script"), Le)).length; c2 < f2; c2++) u2 = e2, c2 !== p2 && (u2 = S.clone(u2, !0, !0), s2 && S.merge(a2, ve(u2, "script"))), i2.call(n2[c2], u2, c2);
      if (s2)
        for (l2 = a2[a2.length - 1].ownerDocument, S.map(a2, He), c2 = 0; c2 < s2; c2++) u2 = a2[c2], he.test(u2.type || "") && !Y.access(u2, "globalEval") && S.contains(l2, u2) && (u2.src && (u2.type || "").toLowerCase() !== "module" ? S._evalUrl && !u2.noModule && S._evalUrl(u2.src, {
          nonce: u2.nonce || u2.getAttribute("nonce")
        }, l2) : b(u2.textContent.replace(je, ""), u2, l2))
    }
    return n2
  }

  function Re(e2, t22, n2) {
    for (var r2, i2 = t22 ? S.filter(t22, e2) : e2, o2 = 0;
         (r2 = i2[o2]) != null; o2++) n2 || r2.nodeType !== 1 || S.cleanData(ve(r2)), r2.parentNode && (n2 && ie(r2) && ye(ve(r2, "script")), r2.parentNode.removeChild(r2));
    return e2
  }
  S.extend({
    htmlPrefilter: function(e2) {
      return e2
    },
    clone: function(e2, t22, n2) {
      var r2, i2, o2, a2, s2, u2, l2, c2 = e2.cloneNode(!0),
          f2 = ie(e2);
      if (!(y.noCloneChecked || e2.nodeType !== 1 && e2.nodeType !== 11 || S.isXMLDoc(e2)))
        for (a2 = ve(c2), r2 = 0, i2 = (o2 = ve(e2)).length; r2 < i2; r2++) s2 = o2[r2], u2 = a2[r2], (l2 = u2.nodeName.toLowerCase()) === "input" && pe.test(s2.type) ? u2.checked = s2.checked : l2 !== "input" && l2 !== "textarea" || (u2.defaultValue = s2.defaultValue);
      if (t22)
        if (n2)
          for (o2 = o2 || ve(e2), a2 = a2 || ve(c2), r2 = 0, i2 = o2.length; r2 < i2; r2++) Oe(o2[r2], a2[r2]);
        else Oe(e2, c2);
      return 0 < (a2 = ve(c2, "script")).length && ye(a2, !f2 && ve(e2, "script")), c2
    },
    cleanData: function(e2) {
      for (var t22, n2, r2, i2 = S.event.special, o2 = 0;
           (n2 = e2[o2]) !== void 0; o2++)
        if (V(n2)) {
          if (t22 = n2[Y.expando]) {
            if (t22.events)
              for (r2 in t22.events) i2[r2] ? S.event.remove(n2, r2) : S.removeEvent(n2, r2, t22.handle);
            n2[Y.expando] = void 0
          }
          n2[Q.expando] && (n2[Q.expando] = void 0)
        }
    }
  }), S.fn.extend({
    detach: function(e2) {
      return Re(this, e2, !0)
    },
    remove: function(e2) {
      return Re(this, e2)
    },
    text: function(e2) {
      return $2(this, function(e3) {
        return e3 === void 0 ? S.text(this) : this.empty().each(function() {
          this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9 || (this.textContent = e3)
        })
      }, null, e2, arguments.length)
    },
    append: function() {
      return Pe(this, arguments, function(e2) {
        this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9 || qe(this, e2).appendChild(e2)
      })
    },
    prepend: function() {
      return Pe(this, arguments, function(e2) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var t22 = qe(this, e2);
          t22.insertBefore(e2, t22.firstChild)
        }
      })
    },
    before: function() {
      return Pe(this, arguments, function(e2) {
        this.parentNode && this.parentNode.insertBefore(e2, this)
      })
    },
    after: function() {
      return Pe(this, arguments, function(e2) {
        this.parentNode && this.parentNode.insertBefore(e2, this.nextSibling)
      })
    },
    empty: function() {
      for (var e2, t22 = 0;
           (e2 = this[t22]) != null; t22++) e2.nodeType === 1 && (S.cleanData(ve(e2, !1)), e2.textContent = "");
      return this
    },
    clone: function(e2, t22) {
      return e2 = e2 != null && e2, t22 = t22 ?? e2, this.map(function() {
        return S.clone(this, e2, t22)
      })
    },
    html: function(e2) {
      return $2(this, function(e3) {
        var t22 = this[0] || {},
            n2 = 0,
            r2 = this.length;
        if (e3 === void 0 && t22.nodeType === 1) return t22.innerHTML;
        if (typeof e3 == "string" && !Ne.test(e3) && !ge[(de.exec(e3) || ["", ""])[1].toLowerCase()]) {
          e3 = S.htmlPrefilter(e3);
          try {
            for (; n2 < r2; n2++)(t22 = this[n2] || {}).nodeType === 1 && (S.cleanData(ve(t22, !1)), t22.innerHTML = e3);
            t22 = 0
          } catch {}
        }
        t22 && this.empty().append(e3)
      }, null, e2, arguments.length)
    },
    replaceWith: function() {
      var n2 = [];
      return Pe(this, arguments, function(e2) {
        var t22 = this.parentNode;
        S.inArray(this, n2) < 0 && (S.cleanData(ve(this)), t22 && t22.replaceChild(e2, this))
      }, n2)
    }
  }), S.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function(e2, a2) {
    S.fn[e2] = function(e3) {
      for (var t22, n2 = [], r2 = S(e3), i2 = r2.length - 1, o2 = 0; o2 <= i2; o2++) t22 = o2 === i2 ? this : this.clone(!0), S(r2[o2])[a2](t22), u.apply(n2, t22.get());
      return this.pushStack(n2)
    }
  });
  var Me = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
      Ie = function(e2) {
        var t22 = e2.ownerDocument.defaultView;
        return t22 && t22.opener || (t22 = C), t22.getComputedStyle(e2)
      },
      We = function(e2, t22, n2) {
        var r2, i2, o2 = {};
        for (i2 in t22) o2[i2] = e2.style[i2], e2.style[i2] = t22[i2];
        for (i2 in r2 = n2.call(e2), t22) e2.style[i2] = o2[i2];
        return r2
      },
      Fe = new RegExp(ne.join("|"), "i");

  function Be(e2, t22, n2) {
    var r2, i2, o2, a2, s2 = e2.style;
    return (n2 = n2 || Ie(e2)) && ((a2 = n2.getPropertyValue(t22) || n2[t22]) !== "" || ie(e2) || (a2 = S.style(e2, t22)), !y.pixelBoxStyles() && Me.test(a2) && Fe.test(t22) && (r2 = s2.width, i2 = s2.minWidth, o2 = s2.maxWidth, s2.minWidth = s2.maxWidth = s2.width = a2, a2 = n2.width, s2.width = r2, s2.minWidth = i2, s2.maxWidth = o2)), a2 !== void 0 ? a2 + "" : a2
  }

  function $e(e2, t22) {
    return {
      get: function() {
        if (!e2()) return (this.get = t22).apply(this, arguments);
        delete this.get
      }
    }
  }(function() {
    function e2() {
      if (l2) {
        u2.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", l2.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", re.appendChild(u2).appendChild(l2);
        var e3 = C.getComputedStyle(l2);
        n2 = e3.top !== "1%", s2 = t22(e3.marginLeft) === 12, l2.style.right = "60%", o2 = t22(e3.right) === 36, r2 = t22(e3.width) === 36, l2.style.position = "absolute", i2 = t22(l2.offsetWidth / 3) === 12, re.removeChild(u2), l2 = null
      }
    }

    function t22(e3) {
      return Math.round(parseFloat(e3))
    }
    var n2, r2, i2, o2, a2, s2, u2 = E.createElement("div"),
        l2 = E.createElement("div");
    l2.style && (l2.style.backgroundClip = "content-box", l2.cloneNode(!0).style.backgroundClip = "", y.clearCloneStyle = l2.style.backgroundClip === "content-box", S.extend(y, {
      boxSizingReliable: function() {
        return e2(), r2
      },
      pixelBoxStyles: function() {
        return e2(), o2
      },
      pixelPosition: function() {
        return e2(), n2
      },
      reliableMarginLeft: function() {
        return e2(), s2
      },
      scrollboxSize: function() {
        return e2(), i2
      },
      reliableTrDimensions: function() {
        var e3, t23, n3, r3;
        return a2 == null && (e3 = E.createElement("table"), t23 = E.createElement("tr"), n3 = E.createElement("div"), e3.style.cssText = "position:absolute;left:-11111px", t23.style.height = "1px", n3.style.height = "9px", re.appendChild(e3).appendChild(t23).appendChild(n3), r3 = C.getComputedStyle(t23), a2 = 3 < parseInt(r3.height), re.removeChild(e3)), a2
      }
    }))
  })();
  var _e = ["Webkit", "Moz", "ms"],
      ze = E.createElement("div").style,
      Ue = {};

  function Xe(e2) {
    var t22 = S.cssProps[e2] || Ue[e2];
    return t22 || (e2 in ze ? e2 : Ue[e2] = function(e3) {
      for (var t23 = e3[0].toUpperCase() + e3.slice(1), n2 = _e.length; n2--;)
        if ((e3 = _e[n2] + t23) in ze) return e3
    }(e2) || e2)
  }
  var Ve = /^(none|table(?!-c[ea]).+)/,
      Ge = /^--/,
      Ye = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
      Qe = {
        letterSpacing: "0",
        fontWeight: "400"
      };

  function Je(e2, t22, n2) {
    var r2 = te.exec(t22);
    return r2 ? Math.max(0, r2[2] - (n2 || 0)) + (r2[3] || "px") : t22
  }

  function Ke(e2, t22, n2, r2, i2, o2) {
    var a2 = t22 === "width" ? 1 : 0,
        s2 = 0,
        u2 = 0;
    if (n2 === (r2 ? "border" : "content")) return 0;
    for (; a2 < 4; a2 += 2) n2 === "margin" && (u2 += S.css(e2, n2 + ne[a2], !0, i2)), r2 ? (n2 === "content" && (u2 -= S.css(e2, "padding" + ne[a2], !0, i2)), n2 !== "margin" && (u2 -= S.css(e2, "border" + ne[a2] + "Width", !0, i2))) : (u2 += S.css(e2, "padding" + ne[a2], !0, i2), n2 !== "padding" ? u2 += S.css(e2, "border" + ne[a2] + "Width", !0, i2) : s2 += S.css(e2, "border" + ne[a2] + "Width", !0, i2));
    return !r2 && 0 <= o2 && (u2 += Math.max(0, Math.ceil(e2["offset" + t22[0].toUpperCase() + t22.slice(1)] - o2 - u2 - s2 - .5)) || 0), u2
  }

  function Ze(e2, t22, n2) {
    var r2 = Ie(e2),
        i2 = (!y.boxSizingReliable() || n2) && S.css(e2, "boxSizing", !1, r2) === "border-box",
        o2 = i2,
        a2 = Be(e2, t22, r2),
        s2 = "offset" + t22[0].toUpperCase() + t22.slice(1);
    if (Me.test(a2)) {
      if (!n2) return a2;
      a2 = "auto"
    }
    return (!y.boxSizingReliable() && i2 || !y.reliableTrDimensions() && A(e2, "tr") || a2 === "auto" || !parseFloat(a2) && S.css(e2, "display", !1, r2) === "inline") && e2.getClientRects().length && (i2 = S.css(e2, "boxSizing", !1, r2) === "border-box", (o2 = s2 in e2) && (a2 = e2[s2])), (a2 = parseFloat(a2) || 0) + Ke(e2, t22, n2 || (i2 ? "border" : "content"), o2, r2, a2) + "px"
  }

  function et(e2, t22, n2, r2, i2) {
    return new et.prototype.init(e2, t22, n2, r2, i2)
  }
  S.extend({
    cssHooks: {
      opacity: {
        get: function(e2, t22) {
          if (t22) {
            var n2 = Be(e2, "opacity");
            return n2 === "" ? "1" : n2
          }
        }
      }
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: {},
    style: function(e2, t22, n2, r2) {
      if (e2 && e2.nodeType !== 3 && e2.nodeType !== 8 && e2.style) {
        var i2, o2, a2, s2 = X(t22),
            u2 = Ge.test(t22),
            l2 = e2.style;
        if (u2 || (t22 = Xe(s2)), a2 = S.cssHooks[t22] || S.cssHooks[s2], n2 === void 0) return a2 && "get" in a2 && (i2 = a2.get(e2, !1, r2)) !== void 0 ? i2 : l2[t22];
        (o2 = typeof n2) == "string" && (i2 = te.exec(n2)) && i2[1] && (n2 = se(e2, t22, i2), o2 = "number"), n2 != null && n2 == n2 && (o2 !== "number" || u2 || (n2 += i2 && i2[3] || (S.cssNumber[s2] ? "" : "px")), y.clearCloneStyle || n2 !== "" || t22.indexOf("background") !== 0 || (l2[t22] = "inherit"), a2 && "set" in a2 && (n2 = a2.set(e2, n2, r2)) === void 0 || (u2 ? l2.setProperty(t22, n2) : l2[t22] = n2))
      }
    },
    css: function(e2, t22, n2, r2) {
      var i2, o2, a2, s2 = X(t22);
      return Ge.test(t22) || (t22 = Xe(s2)), (a2 = S.cssHooks[t22] || S.cssHooks[s2]) && "get" in a2 && (i2 = a2.get(e2, !0, n2)), i2 === void 0 && (i2 = Be(e2, t22, r2)), i2 === "normal" && t22 in Qe && (i2 = Qe[t22]), n2 === "" || n2 ? (o2 = parseFloat(i2), n2 === !0 || isFinite(o2) ? o2 || 0 : i2) : i2
    }
  }), S.each(["height", "width"], function(e2, u2) {
    S.cssHooks[u2] = {
      get: function(e3, t22, n2) {
        if (t22) return !Ve.test(S.css(e3, "display")) || e3.getClientRects().length && e3.getBoundingClientRect().width ? Ze(e3, u2, n2) : We(e3, Ye, function() {
          return Ze(e3, u2, n2)
        })
      },
      set: function(e3, t22, n2) {
        var r2, i2 = Ie(e3),
            o2 = !y.scrollboxSize() && i2.position === "absolute",
            a2 = (o2 || n2) && S.css(e3, "boxSizing", !1, i2) === "border-box",
            s2 = n2 ? Ke(e3, u2, n2, a2, i2) : 0;
        return a2 && o2 && (s2 -= Math.ceil(e3["offset" + u2[0].toUpperCase() + u2.slice(1)] - parseFloat(i2[u2]) - Ke(e3, u2, "border", !1, i2) - .5)), s2 && (r2 = te.exec(t22)) && (r2[3] || "px") !== "px" && (e3.style[u2] = t22, t22 = S.css(e3, u2)), Je(0, t22, s2)
      }
    }
  }), S.cssHooks.marginLeft = $e(y.reliableMarginLeft, function(e2, t22) {
    if (t22) return (parseFloat(Be(e2, "marginLeft")) || e2.getBoundingClientRect().left - We(e2, {
      marginLeft: 0
    }, function() {
      return e2.getBoundingClientRect().left
    })) + "px"
  }), S.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function(i2, o2) {
    S.cssHooks[i2 + o2] = {
      expand: function(e2) {
        for (var t22 = 0, n2 = {}, r2 = typeof e2 == "string" ? e2.split(" ") : [e2]; t22 < 4; t22++) n2[i2 + ne[t22] + o2] = r2[t22] || r2[t22 - 2] || r2[0];
        return n2
      }
    }, i2 !== "margin" && (S.cssHooks[i2 + o2].set = Je)
  }), S.fn.extend({
    css: function(e2, t22) {
      return $2(this, function(e3, t23, n2) {
        var r2, i2, o2 = {},
            a2 = 0;
        if (Array.isArray(t23)) {
          for (r2 = Ie(e3), i2 = t23.length; a2 < i2; a2++) o2[t23[a2]] = S.css(e3, t23[a2], !1, r2);
          return o2
        }
        return n2 !== void 0 ? S.style(e3, t23, n2) : S.css(e3, t23)
      }, e2, t22, 1 < arguments.length)
    }
  }), ((S.Tween = et).prototype = {
    constructor: et,
    init: function(e2, t22, n2, r2, i2, o2) {
      this.elem = e2, this.prop = n2, this.easing = i2 || S.easing._default, this.options = t22, this.start = this.now = this.cur(), this.end = r2, this.unit = o2 || (S.cssNumber[n2] ? "" : "px")
    },
    cur: function() {
      var e2 = et.propHooks[this.prop];
      return e2 && e2.get ? e2.get(this) : et.propHooks._default.get(this)
    },
    run: function(e2) {
      var t22, n2 = et.propHooks[this.prop];
      return this.options.duration ? this.pos = t22 = S.easing[this.easing](e2, this.options.duration * e2, 0, 1, this.options.duration) : this.pos = t22 = e2, this.now = (this.end - this.start) * t22 + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n2 && n2.set ? n2.set(this) : et.propHooks._default.set(this), this
    }
  }).init.prototype = et.prototype, (et.propHooks = {
    _default: {
      get: function(e2) {
        var t22;
        return e2.elem.nodeType !== 1 || e2.elem[e2.prop] != null && e2.elem.style[e2.prop] == null ? e2.elem[e2.prop] : (t22 = S.css(e2.elem, e2.prop, "")) && t22 !== "auto" ? t22 : 0
      },
      set: function(e2) {
        S.fx.step[e2.prop] ? S.fx.step[e2.prop](e2) : e2.elem.nodeType !== 1 || !S.cssHooks[e2.prop] && e2.elem.style[Xe(e2.prop)] == null ? e2.elem[e2.prop] = e2.now : S.style(e2.elem, e2.prop, e2.now + e2.unit)
      }
    }
  }).scrollTop = et.propHooks.scrollLeft = {
    set: function(e2) {
      e2.elem.nodeType && e2.elem.parentNode && (e2.elem[e2.prop] = e2.now)
    }
  }, S.easing = {
    linear: function(e2) {
      return e2
    },
    swing: function(e2) {
      return .5 - Math.cos(e2 * Math.PI) / 2
    },
    _default: "swing"
  }, S.fx = et.prototype.init, S.fx.step = {};
  var tt, nt, rt, it, ot = /^(?:toggle|show|hide)$/,
      at = /queueHooks$/;

  function st() {
    nt && (E.hidden === !1 && C.requestAnimationFrame ? C.requestAnimationFrame(st) : C.setTimeout(st, S.fx.interval), S.fx.tick())
  }

  function ut() {
    return C.setTimeout(function() {
      tt = void 0
    }), tt = Date.now()
  }

  function lt(e2, t22) {
    var n2, r2 = 0,
        i2 = {
          height: e2
        };
    for (t22 = t22 ? 1 : 0; r2 < 4; r2 += 2 - t22) i2["margin" + (n2 = ne[r2])] = i2["padding" + n2] = e2;
    return t22 && (i2.opacity = i2.width = e2), i2
  }

  function ct(e2, t22, n2) {
    for (var r2, i2 = (ft.tweeners[t22] || []).concat(ft.tweeners["*"]), o2 = 0, a2 = i2.length; o2 < a2; o2++)
      if (r2 = i2[o2].call(n2, t22, e2)) return r2
  }

  function ft(o2, e2, t22) {
    var n2, a2, r2 = 0,
        i2 = ft.prefilters.length,
        s2 = S.Deferred().always(function() {
          delete u2.elem
        }),
        u2 = function() {
          if (a2) return !1;
          for (var e3 = tt || ut(), t23 = Math.max(0, l2.startTime + l2.duration - e3), n3 = 1 - (t23 / l2.duration || 0), r3 = 0, i3 = l2.tweens.length; r3 < i3; r3++) l2.tweens[r3].run(n3);
          return s2.notifyWith(o2, [l2, n3, t23]), n3 < 1 && i3 ? t23 : (i3 || s2.notifyWith(o2, [l2, 1, 0]), s2.resolveWith(o2, [l2]), !1)
        },
        l2 = s2.promise({
          elem: o2,
          props: S.extend({}, e2),
          opts: S.extend(!0, {
            specialEasing: {},
            easing: S.easing._default
          }, t22),
          originalProperties: e2,
          originalOptions: t22,
          startTime: tt || ut(),
          duration: t22.duration,
          tweens: [],
          createTween: function(e3, t23) {
            var n3 = S.Tween(o2, l2.opts, e3, t23, l2.opts.specialEasing[e3] || l2.opts.easing);
            return l2.tweens.push(n3), n3
          },
          stop: function(e3) {
            var t23 = 0,
                n3 = e3 ? l2.tweens.length : 0;
            if (a2) return this;
            for (a2 = !0; t23 < n3; t23++) l2.tweens[t23].run(1);
            return e3 ? (s2.notifyWith(o2, [l2, 1, 0]), s2.resolveWith(o2, [l2, e3])) : s2.rejectWith(o2, [l2, e3]), this
          }
        }),
        c2 = l2.props;
    for (! function(e3, t23) {
      var n3, r3, i3, o3, a3;
      for (n3 in e3)
        if (i3 = t23[r3 = X(n3)], o3 = e3[n3], Array.isArray(o3) && (i3 = o3[1], o3 = e3[n3] = o3[0]), n3 !== r3 && (e3[r3] = o3, delete e3[n3]), (a3 = S.cssHooks[r3]) && "expand" in a3)
          for (n3 in o3 = a3.expand(o3), delete e3[r3], o3) n3 in e3 || (e3[n3] = o3[n3], t23[n3] = i3);
        else t23[r3] = i3
    }(c2, l2.opts.specialEasing); r2 < i2; r2++)
      if (n2 = ft.prefilters[r2].call(l2, o2, c2, l2.opts)) return m(n2.stop) && (S._queueHooks(l2.elem, l2.opts.queue).stop = n2.stop.bind(n2)), n2;
    return S.map(c2, ct, l2), m(l2.opts.start) && l2.opts.start.call(o2, l2), l2.progress(l2.opts.progress).done(l2.opts.done, l2.opts.complete).fail(l2.opts.fail).always(l2.opts.always), S.fx.timer(S.extend(u2, {
      elem: o2,
      anim: l2,
      queue: l2.opts.queue
    })), l2
  }
  S.Animation = S.extend(ft, {
    tweeners: {
      "*": [function(e2, t22) {
        var n2 = this.createTween(e2, t22);
        return se(n2.elem, e2, te.exec(t22), n2), n2
      }]
    },
    tweener: function(e2, t22) {
      m(e2) ? (t22 = e2, e2 = ["*"]) : e2 = e2.match(P);
      for (var n2, r2 = 0, i2 = e2.length; r2 < i2; r2++) n2 = e2[r2], ft.tweeners[n2] = ft.tweeners[n2] || [], ft.tweeners[n2].unshift(t22)
    },
    prefilters: [function(e2, t22, n2) {
      var r2, i2, o2, a2, s2, u2, l2, c2, f2 = "width" in t22 || "height" in t22,
          p2 = this,
          d2 = {},
          h2 = e2.style,
          g2 = e2.nodeType && ae(e2),
          v2 = Y.get(e2, "fxshow");
      for (r2 in n2.queue || ((a2 = S._queueHooks(e2, "fx")).unqueued == null && (a2.unqueued = 0, s2 = a2.empty.fire, a2.empty.fire = function() {
        a2.unqueued || s2()
      }), a2.unqueued++, p2.always(function() {
        p2.always(function() {
          a2.unqueued--, S.queue(e2, "fx").length || a2.empty.fire()
        })
      })), t22)
        if (i2 = t22[r2], ot.test(i2)) {
          if (delete t22[r2], o2 = o2 || i2 === "toggle", i2 === (g2 ? "hide" : "show")) {
            if (i2 !== "show" || !v2 || v2[r2] === void 0) continue;
            g2 = !0
          }
          d2[r2] = v2 && v2[r2] || S.style(e2, r2)
        } if ((u2 = !S.isEmptyObject(t22)) || !S.isEmptyObject(d2))
        for (r2 in f2 && e2.nodeType === 1 && (n2.overflow = [h2.overflow, h2.overflowX, h2.overflowY], (l2 = v2 && v2.display) == null && (l2 = Y.get(e2, "display")), (c2 = S.css(e2, "display")) === "none" && (l2 ? c2 = l2 : (le([e2], !0), l2 = e2.style.display || l2, c2 = S.css(e2, "display"), le([e2]))), (c2 === "inline" || c2 === "inline-block" && l2 != null) && S.css(e2, "float") === "none" && (u2 || (p2.done(function() {
          h2.display = l2
        }), l2 == null && (c2 = h2.display, l2 = c2 === "none" ? "" : c2)), h2.display = "inline-block")), n2.overflow && (h2.overflow = "hidden", p2.always(function() {
          h2.overflow = n2.overflow[0], h2.overflowX = n2.overflow[1], h2.overflowY = n2.overflow[2]
        })), u2 = !1, d2) u2 || (v2 ? "hidden" in v2 && (g2 = v2.hidden) : v2 = Y.access(e2, "fxshow", {
          display: l2
        }), o2 && (v2.hidden = !g2), g2 && le([e2], !0), p2.done(function() {
          for (r2 in g2 || le([e2]), Y.remove(e2, "fxshow"), d2) S.style(e2, r2, d2[r2])
        })), u2 = ct(g2 ? v2[r2] : 0, r2, p2), r2 in v2 || (v2[r2] = u2.start, g2 && (u2.end = u2.start, u2.start = 0))
    }],
    prefilter: function(e2, t22) {
      t22 ? ft.prefilters.unshift(e2) : ft.prefilters.push(e2)
    }
  }), S.speed = function(e2, t22, n2) {
    var r2 = e2 && typeof e2 == "object" ? S.extend({}, e2) : {
      complete: n2 || !n2 && t22 || m(e2) && e2,
      duration: e2,
      easing: n2 && t22 || t22 && !m(t22) && t22
    };
    return S.fx.off ? r2.duration = 0 : typeof r2.duration != "number" && (r2.duration in S.fx.speeds ? r2.duration = S.fx.speeds[r2.duration] : r2.duration = S.fx.speeds._default), r2.queue != null && r2.queue !== !0 || (r2.queue = "fx"), r2.old = r2.complete, r2.complete = function() {
      m(r2.old) && r2.old.call(this), r2.queue && S.dequeue(this, r2.queue)
    }, r2
  }, S.fn.extend({
    fadeTo: function(e2, t22, n2, r2) {
      return this.filter(ae).css("opacity", 0).show().end().animate({
        opacity: t22
      }, e2, n2, r2)
    },
    animate: function(t22, e2, n2, r2) {
      var i2 = S.isEmptyObject(t22),
          o2 = S.speed(e2, n2, r2),
          a2 = function() {
            var e3 = ft(this, S.extend({}, t22), o2);
            (i2 || Y.get(this, "finish")) && e3.stop(!0)
          };
      return a2.finish = a2, i2 || o2.queue === !1 ? this.each(a2) : this.queue(o2.queue, a2)
    },
    stop: function(i2, e2, o2) {
      var a2 = function(e3) {
        var t22 = e3.stop;
        delete e3.stop, t22(o2)
      };
      return typeof i2 != "string" && (o2 = e2, e2 = i2, i2 = void 0), e2 && this.queue(i2 || "fx", []), this.each(function() {
        var e3 = !0,
            t22 = i2 != null && i2 + "queueHooks",
            n2 = S.timers,
            r2 = Y.get(this);
        if (t22) r2[t22] && r2[t22].stop && a2(r2[t22]);
        else
          for (t22 in r2) r2[t22] && r2[t22].stop && at.test(t22) && a2(r2[t22]);
        for (t22 = n2.length; t22--;) n2[t22].elem !== this || i2 != null && n2[t22].queue !== i2 || (n2[t22].anim.stop(o2), e3 = !1, n2.splice(t22, 1));
        !e3 && o2 || S.dequeue(this, i2)
      })
    },
    finish: function(a2) {
      return a2 !== !1 && (a2 = a2 || "fx"), this.each(function() {
        var e2, t22 = Y.get(this),
            n2 = t22[a2 + "queue"],
            r2 = t22[a2 + "queueHooks"],
            i2 = S.timers,
            o2 = n2 ? n2.length : 0;
        for (t22.finish = !0, S.queue(this, a2, []), r2 && r2.stop && r2.stop.call(this, !0), e2 = i2.length; e2--;) i2[e2].elem === this && i2[e2].queue === a2 && (i2[e2].anim.stop(!0), i2.splice(e2, 1));
        for (e2 = 0; e2 < o2; e2++) n2[e2] && n2[e2].finish && n2[e2].finish.call(this);
        delete t22.finish
      })
    }
  }), S.each(["toggle", "show", "hide"], function(e2, r2) {
    var i2 = S.fn[r2];
    S.fn[r2] = function(e3, t22, n2) {
      return e3 == null || typeof e3 == "boolean" ? i2.apply(this, arguments) : this.animate(lt(r2, !0), e3, t22, n2)
    }
  }), S.each({
    slideDown: lt("show"),
    slideUp: lt("hide"),
    slideToggle: lt("toggle"),
    fadeIn: {
      opacity: "show"
    },
    fadeOut: {
      opacity: "hide"
    },
    fadeToggle: {
      opacity: "toggle"
    }
  }, function(e2, r2) {
    S.fn[e2] = function(e3, t22, n2) {
      return this.animate(r2, e3, t22, n2)
    }
  }), S.timers = [], S.fx.tick = function() {
    var e2, t22 = 0,
        n2 = S.timers;
    for (tt = Date.now(); t22 < n2.length; t22++)(e2 = n2[t22])() || n2[t22] !== e2 || n2.splice(t22--, 1);
    n2.length || S.fx.stop(), tt = void 0
  }, S.fx.timer = function(e2) {
    S.timers.push(e2), S.fx.start()
  }, S.fx.interval = 13, S.fx.start = function() {
    nt || (nt = !0, st())
  }, S.fx.stop = function() {
    nt = null
  }, S.fx.speeds = {
    slow: 600,
    fast: 200,
    _default: 400
  }, S.fn.delay = function(r2, e2) {
    return r2 = S.fx && S.fx.speeds[r2] || r2, e2 = e2 || "fx", this.queue(e2, function(e3, t22) {
      var n2 = C.setTimeout(e3, r2);
      t22.stop = function() {
        C.clearTimeout(n2)
      }
    })
  }, rt = E.createElement("input"), it = E.createElement("select").appendChild(E.createElement("option")), rt.type = "checkbox", y.checkOn = rt.value !== "", y.optSelected = it.selected, (rt = E.createElement("input")).value = "t", rt.type = "radio", y.radioValue = rt.value === "t";
  var pt, dt = S.expr.attrHandle;
  S.fn.extend({
    attr: function(e2, t22) {
      return $2(this, S.attr, e2, t22, 1 < arguments.length)
    },
    removeAttr: function(e2) {
      return this.each(function() {
        S.removeAttr(this, e2)
      })
    }
  }), S.extend({
    attr: function(e2, t22, n2) {
      var r2, i2, o2 = e2.nodeType;
      if (o2 !== 3 && o2 !== 8 && o2 !== 2) return typeof e2.getAttribute > "u" ? S.prop(e2, t22, n2) : (o2 === 1 && S.isXMLDoc(e2) || (i2 = S.attrHooks[t22.toLowerCase()] || (S.expr.match.bool.test(t22) ? pt : void 0)), n2 !== void 0 ? n2 === null ? void S.removeAttr(e2, t22) : i2 && "set" in i2 && (r2 = i2.set(e2, n2, t22)) !== void 0 ? r2 : (e2.setAttribute(t22, n2 + ""), n2) : i2 && "get" in i2 && (r2 = i2.get(e2, t22)) !== null ? r2 : (r2 = S.find.attr(e2, t22)) == null ? void 0 : r2)
    },
    attrHooks: {
      type: {
        set: function(e2, t22) {
          if (!y.radioValue && t22 === "radio" && A(e2, "input")) {
            var n2 = e2.value;
            return e2.setAttribute("type", t22), n2 && (e2.value = n2), t22
          }
        }
      }
    },
    removeAttr: function(e2, t22) {
      var n2, r2 = 0,
          i2 = t22 && t22.match(P);
      if (i2 && e2.nodeType === 1)
        for (; n2 = i2[r2++];) e2.removeAttribute(n2)
    }
  }), pt = {
    set: function(e2, t22, n2) {
      return t22 === !1 ? S.removeAttr(e2, n2) : e2.setAttribute(n2, n2), n2
    }
  }, S.each(S.expr.match.bool.source.match(/\w+/g), function(e2, t22) {
    var a2 = dt[t22] || S.find.attr;
    dt[t22] = function(e3, t23, n2) {
      var r2, i2, o2 = t23.toLowerCase();
      return n2 || (i2 = dt[o2], dt[o2] = r2, r2 = a2(e3, t23, n2) != null ? o2 : null, dt[o2] = i2), r2
    }
  });
  var ht = /^(?:input|select|textarea|button)$/i,
      gt = /^(?:a|area)$/i;

  function vt(e2) {
    return (e2.match(P) || []).join(" ")
  }

  function yt(e2) {
    return e2.getAttribute && e2.getAttribute("class") || ""
  }

  function mt(e2) {
    return Array.isArray(e2) ? e2 : typeof e2 == "string" && e2.match(P) || []
  }
  S.fn.extend({
    prop: function(e2, t22) {
      return $2(this, S.prop, e2, t22, 1 < arguments.length)
    },
    removeProp: function(e2) {
      return this.each(function() {
        delete this[S.propFix[e2] || e2]
      })
    }
  }), S.extend({
    prop: function(e2, t22, n2) {
      var r2, i2, o2 = e2.nodeType;
      if (o2 !== 3 && o2 !== 8 && o2 !== 2) return o2 === 1 && S.isXMLDoc(e2) || (t22 = S.propFix[t22] || t22, i2 = S.propHooks[t22]), n2 !== void 0 ? i2 && "set" in i2 && (r2 = i2.set(e2, n2, t22)) !== void 0 ? r2 : e2[t22] = n2 : i2 && "get" in i2 && (r2 = i2.get(e2, t22)) !== null ? r2 : e2[t22]
    },
    propHooks: {
      tabIndex: {
        get: function(e2) {
          var t22 = S.find.attr(e2, "tabindex");
          return t22 ? parseInt(t22, 10) : ht.test(e2.nodeName) || gt.test(e2.nodeName) && e2.href ? 0 : -1
        }
      }
    },
    propFix: {
      for: "htmlFor",
      class: "className"
    }
  }), y.optSelected || (S.propHooks.selected = {
    get: function(e2) {
      var t22 = e2.parentNode;
      return t22 && t22.parentNode && t22.parentNode.selectedIndex, null
    },
    set: function(e2) {
      var t22 = e2.parentNode;
      t22 && (t22.selectedIndex, t22.parentNode && t22.parentNode.selectedIndex)
    }
  }), S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
    S.propFix[this.toLowerCase()] = this
  }), S.fn.extend({
    addClass: function(t22) {
      var e2, n2, r2, i2, o2, a2, s2, u2 = 0;
      if (m(t22)) return this.each(function(e3) {
        S(this).addClass(t22.call(this, e3, yt(this)))
      });
      if ((e2 = mt(t22)).length) {
        for (; n2 = this[u2++];)
          if (i2 = yt(n2), r2 = n2.nodeType === 1 && " " + vt(i2) + " ") {
            for (a2 = 0; o2 = e2[a2++];) r2.indexOf(" " + o2 + " ") < 0 && (r2 += o2 + " ");
            i2 !== (s2 = vt(r2)) && n2.setAttribute("class", s2)
          }
      }
      return this
    },
    removeClass: function(t22) {
      var e2, n2, r2, i2, o2, a2, s2, u2 = 0;
      if (m(t22)) return this.each(function(e3) {
        S(this).removeClass(t22.call(this, e3, yt(this)))
      });
      if (!arguments.length) return this.attr("class", "");
      if ((e2 = mt(t22)).length) {
        for (; n2 = this[u2++];)
          if (i2 = yt(n2), r2 = n2.nodeType === 1 && " " + vt(i2) + " ") {
            for (a2 = 0; o2 = e2[a2++];)
              for (; - 1 < r2.indexOf(" " + o2 + " ");) r2 = r2.replace(" " + o2 + " ", " ");
            i2 !== (s2 = vt(r2)) && n2.setAttribute("class", s2)
          }
      }
      return this
    },
    toggleClass: function(i2, t22) {
      var o2 = typeof i2,
          a2 = o2 === "string" || Array.isArray(i2);
      return typeof t22 == "boolean" && a2 ? t22 ? this.addClass(i2) : this.removeClass(i2) : m(i2) ? this.each(function(e2) {
        S(this).toggleClass(i2.call(this, e2, yt(this), t22), t22)
      }) : this.each(function() {
        var e2, t23, n2, r2;
        if (a2)
          for (t23 = 0, n2 = S(this), r2 = mt(i2); e2 = r2[t23++];) n2.hasClass(e2) ? n2.removeClass(e2) : n2.addClass(e2);
        else i2 !== void 0 && o2 !== "boolean" || ((e2 = yt(this)) && Y.set(this, "__className__", e2), this.setAttribute && this.setAttribute("class", e2 || i2 === !1 ? "" : Y.get(this, "__className__") || ""))
      })
    },
    hasClass: function(e2) {
      var t22, n2, r2 = 0;
      for (t22 = " " + e2 + " "; n2 = this[r2++];)
        if (n2.nodeType === 1 && -1 < (" " + vt(yt(n2)) + " ").indexOf(t22)) return !0;
      return !1
    }
  });
  var xt = /\r/g;
  S.fn.extend({
    val: function(n2) {
      var r2, e2, i2, t22 = this[0];
      return arguments.length ? (i2 = m(n2), this.each(function(e3) {
        var t23;
        this.nodeType === 1 && ((t23 = i2 ? n2.call(this, e3, S(this).val()) : n2) == null ? t23 = "" : typeof t23 == "number" ? t23 += "" : Array.isArray(t23) && (t23 = S.map(t23, function(e4) {
          return e4 == null ? "" : e4 + ""
        })), (r2 = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set" in r2 && r2.set(this, t23, "value") !== void 0 || (this.value = t23))
      })) : t22 ? (r2 = S.valHooks[t22.type] || S.valHooks[t22.nodeName.toLowerCase()]) && "get" in r2 && (e2 = r2.get(t22, "value")) !== void 0 ? e2 : typeof(e2 = t22.value) == "string" ? e2.replace(xt, "") : e2 ?? "" : void 0
    }
  }), S.extend({
    valHooks: {
      option: {
        get: function(e2) {
          var t22 = S.find.attr(e2, "value");
          return t22 ?? vt(S.text(e2))
        }
      },
      select: {
        get: function(e2) {
          var t22, n2, r2, i2 = e2.options,
              o2 = e2.selectedIndex,
              a2 = e2.type === "select-one",
              s2 = a2 ? null : [],
              u2 = a2 ? o2 + 1 : i2.length;
          for (r2 = o2 < 0 ? u2 : a2 ? o2 : 0; r2 < u2; r2++)
            if (((n2 = i2[r2]).selected || r2 === o2) && !n2.disabled && (!n2.parentNode.disabled || !A(n2.parentNode, "optgroup"))) {
              if (t22 = S(n2).val(), a2) return t22;
              s2.push(t22)
            } return s2
        },
        set: function(e2, t22) {
          for (var n2, r2, i2 = e2.options, o2 = S.makeArray(t22), a2 = i2.length; a2--;)((r2 = i2[a2]).selected = -1 < S.inArray(S.valHooks.option.get(r2), o2)) && (n2 = !0);
          return n2 || (e2.selectedIndex = -1), o2
        }
      }
    }
  }), S.each(["radio", "checkbox"], function() {
    S.valHooks[this] = {
      set: function(e2, t22) {
        if (Array.isArray(t22)) return e2.checked = -1 < S.inArray(S(e2).val(), t22)
      }
    }, y.checkOn || (S.valHooks[this].get = function(e2) {
      return e2.getAttribute("value") === null ? "on" : e2.value
    })
  }), y.focusin = "onfocusin" in C;
  var bt = /^(?:focusinfocus|focusoutblur)$/,
      wt = function(e2) {
        e2.stopPropagation()
      };
  S.extend(S.event, {
    trigger: function(e2, t22, n2, r2) {
      var i2, o2, a2, s2, u2, l2, c2, f2, p2 = [n2 || E],
          d2 = v.call(e2, "type") ? e2.type : e2,
          h2 = v.call(e2, "namespace") ? e2.namespace.split(".") : [];
      if (o2 = f2 = a2 = n2 = n2 || E, n2.nodeType !== 3 && n2.nodeType !== 8 && !bt.test(d2 + S.event.triggered) && (-1 < d2.indexOf(".") && (d2 = (h2 = d2.split(".")).shift(), h2.sort()), u2 = d2.indexOf(":") < 0 && "on" + d2, (e2 = e2[S.expando] ? e2 : new S.Event(d2, typeof e2 == "object" && e2)).isTrigger = r2 ? 2 : 3, e2.namespace = h2.join("."), e2.rnamespace = e2.namespace ? new RegExp("(^|\\.)" + h2.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e2.result = void 0, e2.target || (e2.target = n2), t22 = t22 == null ? [e2] : S.makeArray(t22, [e2]), c2 = S.event.special[d2] || {}, r2 || !c2.trigger || c2.trigger.apply(n2, t22) !== !1)) {
        if (!r2 && !c2.noBubble && !x(n2)) {
          for (s2 = c2.delegateType || d2, bt.test(s2 + d2) || (o2 = o2.parentNode); o2; o2 = o2.parentNode) p2.push(o2), a2 = o2;
          a2 === (n2.ownerDocument || E) && p2.push(a2.defaultView || a2.parentWindow || C)
        }
        for (i2 = 0;
             (o2 = p2[i2++]) && !e2.isPropagationStopped();) f2 = o2, e2.type = 1 < i2 ? s2 : c2.bindType || d2, (l2 = (Y.get(o2, "events") || Object.create(null))[e2.type] && Y.get(o2, "handle")) && l2.apply(o2, t22), (l2 = u2 && o2[u2]) && l2.apply && V(o2) && (e2.result = l2.apply(o2, t22), e2.result === !1 && e2.preventDefault());
        return e2.type = d2, r2 || e2.isDefaultPrevented() || c2._default && c2._default.apply(p2.pop(), t22) !== !1 || !V(n2) || u2 && m(n2[d2]) && !x(n2) && ((a2 = n2[u2]) && (n2[u2] = null), S.event.triggered = d2, e2.isPropagationStopped() && f2.addEventListener(d2, wt), n2[d2](), e2.isPropagationStopped() && f2.removeEventListener(d2, wt), S.event.triggered = void 0, a2 && (n2[u2] = a2)), e2.result
      }
    },
    simulate: function(e2, t22, n2) {
      var r2 = S.extend(new S.Event, n2, {
        type: e2,
        isSimulated: !0
      });
      S.event.trigger(r2, null, t22)
    }
  }), S.fn.extend({
    trigger: function(e2, t22) {
      return this.each(function() {
        S.event.trigger(e2, t22, this)
      })
    },
    triggerHandler: function(e2, t22) {
      var n2 = this[0];
      if (n2) return S.event.trigger(e2, t22, n2, !0)
    }
  }), y.focusin || S.each({
    focus: "focusin",
    blur: "focusout"
  }, function(n2, r2) {
    var i2 = function(e2) {
      S.event.simulate(r2, e2.target, S.event.fix(e2))
    };
    S.event.special[r2] = {
      setup: function() {
        var e2 = this.ownerDocument || this.document || this,
            t22 = Y.access(e2, r2);
        t22 || e2.addEventListener(n2, i2, !0), Y.access(e2, r2, (t22 || 0) + 1)
      },
      teardown: function() {
        var e2 = this.ownerDocument || this.document || this,
            t22 = Y.access(e2, r2) - 1;
        t22 ? Y.access(e2, r2, t22) : (e2.removeEventListener(n2, i2, !0), Y.remove(e2, r2))
      }
    }
  });
  var Tt = C.location,
      Ct = {
        guid: Date.now()
      },
      Et = /\?/;
  S.parseXML = function(e2) {
    var t22;
    if (!e2 || typeof e2 != "string") return null;
    try {
      t22 = new C.DOMParser().parseFromString(e2, "text/xml")
    } catch {
      t22 = void 0
    }
    return t22 && !t22.getElementsByTagName("parsererror").length || S.error("Invalid XML: " + e2), t22
  };
  var St = /\[\]$/,
      kt = /\r?\n/g,
      At = /^(?:submit|button|image|reset|file)$/i,
      Nt = /^(?:input|select|textarea|keygen)/i;

  function Dt(n2, e2, r2, i2) {
    var t22;
    if (Array.isArray(e2)) S.each(e2, function(e3, t23) {
      r2 || St.test(n2) ? i2(n2, t23) : Dt(n2 + "[" + (typeof t23 == "object" && t23 != null ? e3 : "") + "]", t23, r2, i2)
    });
    else if (r2 || w(e2) !== "object") i2(n2, e2);
    else
      for (t22 in e2) Dt(n2 + "[" + t22 + "]", e2[t22], r2, i2)
  }
  S.param = function(e2, t22) {
    var n2, r2 = [],
        i2 = function(e3, t23) {
          var n3 = m(t23) ? t23() : t23;
          r2[r2.length] = encodeURIComponent(e3) + "=" + encodeURIComponent(n3 ?? "")
        };
    if (e2 == null) return "";
    if (Array.isArray(e2) || e2.jquery && !S.isPlainObject(e2)) S.each(e2, function() {
      i2(this.name, this.value)
    });
    else
      for (n2 in e2) Dt(n2, e2[n2], t22, i2);
    return r2.join("&")
  }, S.fn.extend({
    serialize: function() {
      return S.param(this.serializeArray())
    },
    serializeArray: function() {
      return this.map(function() {
        var e2 = S.prop(this, "elements");
        return e2 ? S.makeArray(e2) : this
      }).filter(function() {
        var e2 = this.type;
        return this.name && !S(this).is(":disabled") && Nt.test(this.nodeName) && !At.test(e2) && (this.checked || !pe.test(e2))
      }).map(function(e2, t22) {
        var n2 = S(this).val();
        return n2 == null ? null : Array.isArray(n2) ? S.map(n2, function(e3) {
          return {
            name: t22.name,
            value: e3.replace(kt, `\r
`)
          }
        }) : {
          name: t22.name,
          value: n2.replace(kt, `\r
`)
        }
      }).get()
    }
  });
  var jt = /%20/g,
      qt = /#.*$/,
      Lt = /([?&])_=[^&]*/,
      Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      Ot = /^(?:GET|HEAD)$/,
      Pt = /^\/\//,
      Rt = {},
      Mt = {},
      It = "*/".concat("*"),
      Wt = E.createElement("a");

  function Ft(o2) {
    return function(e2, t22) {
      typeof e2 != "string" && (t22 = e2, e2 = "*");
      var n2, r2 = 0,
          i2 = e2.toLowerCase().match(P) || [];
      if (m(t22))
        for (; n2 = i2[r2++];) n2[0] === "+" ? (n2 = n2.slice(1) || "*", (o2[n2] = o2[n2] || []).unshift(t22)) : (o2[n2] = o2[n2] || []).push(t22)
    }
  }

  function Bt(t22, i2, o2, a2) {
    var s2 = {},
        u2 = t22 === Mt;

    function l2(e2) {
      var r2;
      return s2[e2] = !0, S.each(t22[e2] || [], function(e3, t23) {
        var n2 = t23(i2, o2, a2);
        return typeof n2 != "string" || u2 || s2[n2] ? u2 ? !(r2 = n2) : void 0 : (i2.dataTypes.unshift(n2), l2(n2), !1)
      }), r2
    }
    return l2(i2.dataTypes[0]) || !s2["*"] && l2("*")
  }

  function $t(e2, t22) {
    var n2, r2, i2 = S.ajaxSettings.flatOptions || {};
    for (n2 in t22) t22[n2] !== void 0 && ((i2[n2] ? e2 : r2 || (r2 = {}))[n2] = t22[n2]);
    return r2 && S.extend(!0, e2, r2), e2
  }
  Wt.href = Tt.href, S.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Tt.href,
      type: "GET",
      isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": It,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": JSON.parse,
        "text xml": S.parseXML
      },
      flatOptions: {
        url: !0,
        context: !0
      }
    },
    ajaxSetup: function(e2, t22) {
      return t22 ? $t($t(e2, S.ajaxSettings), t22) : $t(S.ajaxSettings, e2)
    },
    ajaxPrefilter: Ft(Rt),
    ajaxTransport: Ft(Mt),
    ajax: function(e2, t22) {
      typeof e2 == "object" && (t22 = e2, e2 = void 0), t22 = t22 || {};
      var c2, f2, p2, n2, d2, r2, h2, g2, i2, o2, v2 = S.ajaxSetup({}, t22),
          y2 = v2.context || v2,
          m2 = v2.context && (y2.nodeType || y2.jquery) ? S(y2) : S.event,
          x2 = S.Deferred(),
          b2 = S.Callbacks("once memory"),
          w2 = v2.statusCode || {},
          a2 = {},
          s2 = {},
          u2 = "canceled",
          T2 = {
            readyState: 0,
            getResponseHeader: function(e3) {
              var t23;
              if (h2) {
                if (!n2)
                  for (n2 = {}; t23 = Ht.exec(p2);) n2[t23[1].toLowerCase() + " "] = (n2[t23[1].toLowerCase() + " "] || []).concat(t23[2]);
                t23 = n2[e3.toLowerCase() + " "]
              }
              return t23 == null ? null : t23.join(", ")
            },
            getAllResponseHeaders: function() {
              return h2 ? p2 : null
            },
            setRequestHeader: function(e3, t23) {
              return h2 == null && (e3 = s2[e3.toLowerCase()] = s2[e3.toLowerCase()] || e3, a2[e3] = t23), this
            },
            overrideMimeType: function(e3) {
              return h2 == null && (v2.mimeType = e3), this
            },
            statusCode: function(e3) {
              var t23;
              if (e3)
                if (h2) T2.always(e3[T2.status]);
                else
                  for (t23 in e3) w2[t23] = [w2[t23], e3[t23]];
              return this
            },
            abort: function(e3) {
              var t23 = e3 || u2;
              return c2 && c2.abort(t23), l2(0, t23), this
            }
          };
      if (x2.promise(T2), v2.url = ((e2 || v2.url || Tt.href) + "").replace(Pt, Tt.protocol + "//"), v2.type = t22.method || t22.type || v2.method || v2.type, v2.dataTypes = (v2.dataType || "*").toLowerCase().match(P) || [""], v2.crossDomain == null) {
        r2 = E.createElement("a");
        try {
          r2.href = v2.url, r2.href = r2.href, v2.crossDomain = Wt.protocol + "//" + Wt.host != r2.protocol + "//" + r2.host
        } catch {
          v2.crossDomain = !0
        }
      }
      if (v2.data && v2.processData && typeof v2.data != "string" && (v2.data = S.param(v2.data, v2.traditional)), Bt(Rt, v2, t22, T2), h2) return T2;
      for (i2 in (g2 = S.event && v2.global) && S.active++ == 0 && S.event.trigger("ajaxStart"), v2.type = v2.type.toUpperCase(), v2.hasContent = !Ot.test(v2.type), f2 = v2.url.replace(qt, ""), v2.hasContent ? v2.data && v2.processData && (v2.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (v2.data = v2.data.replace(jt, "+")) : (o2 = v2.url.slice(f2.length), v2.data && (v2.processData || typeof v2.data == "string") && (f2 += (Et.test(f2) ? "&" : "?") + v2.data, delete v2.data), v2.cache === !1 && (f2 = f2.replace(Lt, "$1"), o2 = (Et.test(f2) ? "&" : "?") + "_=" + Ct.guid++ + o2), v2.url = f2 + o2), v2.ifModified && (S.lastModified[f2] && T2.setRequestHeader("If-Modified-Since", S.lastModified[f2]), S.etag[f2] && T2.setRequestHeader("If-None-Match", S.etag[f2])), (v2.data && v2.hasContent && v2.contentType !== !1 || t22.contentType) && T2.setRequestHeader("Content-Type", v2.contentType), T2.setRequestHeader("Accept", v2.dataTypes[0] && v2.accepts[v2.dataTypes[0]] ? v2.accepts[v2.dataTypes[0]] + (v2.dataTypes[0] !== "*" ? ", " + It + "; q=0.01" : "") : v2.accepts["*"]), v2.headers) T2.setRequestHeader(i2, v2.headers[i2]);
      if (v2.beforeSend && (v2.beforeSend.call(y2, T2, v2) === !1 || h2)) return T2.abort();
      if (u2 = "abort", b2.add(v2.complete), T2.done(v2.success), T2.fail(v2.error), c2 = Bt(Mt, v2, t22, T2)) {
        if (T2.readyState = 1, g2 && m2.trigger("ajaxSend", [T2, v2]), h2) return T2;
        v2.async && 0 < v2.timeout && (d2 = C.setTimeout(function() {
          T2.abort("timeout")
        }, v2.timeout));
        try {
          h2 = !1, c2.send(a2, l2)
        } catch (e3) {
          if (h2) throw e3;
          l2(-1, e3)
        }
      } else l2(-1, "No Transport");

      function l2(e3, t23, n3, r3) {
        var i3, o3, a3, s3, u3, l3 = t23;
        h2 || (h2 = !0, d2 && C.clearTimeout(d2), c2 = void 0, p2 = r3 || "", T2.readyState = 0 < e3 ? 4 : 0, i3 = 200 <= e3 && e3 < 300 || e3 === 304, n3 && (s3 = function(e4, t24, n4) {
          for (var r4, i4, o4, a4, s4 = e4.contents, u4 = e4.dataTypes; u4[0] === "*";) u4.shift(), r4 === void 0 && (r4 = e4.mimeType || t24.getResponseHeader("Content-Type"));
          if (r4) {
            for (i4 in s4)
              if (s4[i4] && s4[i4].test(r4)) {
                u4.unshift(i4);
                break
              }
          }
          if (u4[0] in n4) o4 = u4[0];
          else {
            for (i4 in n4) {
              if (!u4[0] || e4.converters[i4 + " " + u4[0]]) {
                o4 = i4;
                break
              }
              a4 || (a4 = i4)
            }
            o4 = o4 || a4
          }
          if (o4) return o4 !== u4[0] && u4.unshift(o4), n4[o4]
        }(v2, T2, n3)), !i3 && -1 < S.inArray("script", v2.dataTypes) && (v2.converters["text script"] = function() {}), s3 = function(e4, t24, n4, r4) {
          var i4, o4, a4, s4, u4, l4 = {},
              c3 = e4.dataTypes.slice();
          if (c3[1])
            for (a4 in e4.converters) l4[a4.toLowerCase()] = e4.converters[a4];
          for (o4 = c3.shift(); o4;)
            if (e4.responseFields[o4] && (n4[e4.responseFields[o4]] = t24), !u4 && r4 && e4.dataFilter && (t24 = e4.dataFilter(t24, e4.dataType)), u4 = o4, o4 = c3.shift()) {
              if (o4 === "*") o4 = u4;
              else if (u4 !== "*" && u4 !== o4) {
                if (!(a4 = l4[u4 + " " + o4] || l4["* " + o4])) {
                  for (i4 in l4)
                    if ((s4 = i4.split(" "))[1] === o4 && (a4 = l4[u4 + " " + s4[0]] || l4["* " + s4[0]])) {
                      a4 === !0 ? a4 = l4[i4] : l4[i4] !== !0 && (o4 = s4[0], c3.unshift(s4[1]));
                      break
                    }
                }
                if (a4 !== !0)
                  if (a4 && e4.throws) t24 = a4(t24);
                  else try {
                    t24 = a4(t24)
                  } catch (e5) {
                    return {
                      state: "parsererror",
                      error: a4 ? e5 : "No conversion from " + u4 + " to " + o4
                    }
                  }
              }
            } return {
            state: "success",
            data: t24
          }
        }(v2, s3, T2, i3), i3 ? (v2.ifModified && ((u3 = T2.getResponseHeader("Last-Modified")) && (S.lastModified[f2] = u3), (u3 = T2.getResponseHeader("etag")) && (S.etag[f2] = u3)), e3 === 204 || v2.type === "HEAD" ? l3 = "nocontent" : e3 === 304 ? l3 = "notmodified" : (l3 = s3.state, o3 = s3.data, i3 = !(a3 = s3.error))) : (a3 = l3, !e3 && l3 || (l3 = "error", e3 < 0 && (e3 = 0))), T2.status = e3, T2.statusText = (t23 || l3) + "", i3 ? x2.resolveWith(y2, [o3, l3, T2]) : x2.rejectWith(y2, [T2, l3, a3]), T2.statusCode(w2), w2 = void 0, g2 && m2.trigger(i3 ? "ajaxSuccess" : "ajaxError", [T2, v2, i3 ? o3 : a3]), b2.fireWith(y2, [T2, l3]), g2 && (m2.trigger("ajaxComplete", [T2, v2]), --S.active || S.event.trigger("ajaxStop")))
      }
      return T2
    },
    getJSON: function(e2, t22, n2) {
      return S.get(e2, t22, n2, "json")
    },
    getScript: function(e2, t22) {
      return S.get(e2, void 0, t22, "script")
    }
  }), S.each(["get", "post"], function(e2, i2) {
    S[i2] = function(e3, t22, n2, r2) {
      return m(t22) && (r2 = r2 || n2, n2 = t22, t22 = void 0), S.ajax(S.extend({
        url: e3,
        type: i2,
        dataType: r2,
        data: t22,
        success: n2
      }, S.isPlainObject(e3) && e3))
    }
  }), S.ajaxPrefilter(function(e2) {
    var t22;
    for (t22 in e2.headers) t22.toLowerCase() === "content-type" && (e2.contentType = e2.headers[t22] || "")
  }), S._evalUrl = function(e2, t22, n2) {
    return S.ajax({
      url: e2,
      type: "GET",
      dataType: "script",
      cache: !0,
      async: !1,
      global: !1,
      converters: {
        "text script": function() {}
      },
      dataFilter: function(e3) {
        S.globalEval(e3, t22, n2)
      }
    })
  }, S.fn.extend({
    wrapAll: function(e2) {
      var t22;
      return this[0] && (m(e2) && (e2 = e2.call(this[0])), t22 = S(e2, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t22.insertBefore(this[0]), t22.map(function() {
        for (var e3 = this; e3.firstElementChild;) e3 = e3.firstElementChild;
        return e3
      }).append(this)), this
    },
    wrapInner: function(n2) {
      return m(n2) ? this.each(function(e2) {
        S(this).wrapInner(n2.call(this, e2))
      }) : this.each(function() {
        var e2 = S(this),
            t22 = e2.contents();
        t22.length ? t22.wrapAll(n2) : e2.append(n2)
      })
    },
    wrap: function(t22) {
      var n2 = m(t22);
      return this.each(function(e2) {
        S(this).wrapAll(n2 ? t22.call(this, e2) : t22)
      })
    },
    unwrap: function(e2) {
      return this.parent(e2).not("body").each(function() {
        S(this).replaceWith(this.childNodes)
      }), this
    }
  }), S.expr.pseudos.hidden = function(e2) {
    return !S.expr.pseudos.visible(e2)
  }, S.expr.pseudos.visible = function(e2) {
    return !!(e2.offsetWidth || e2.offsetHeight || e2.getClientRects().length)
  }, S.ajaxSettings.xhr = function() {
    try {
      return new C.XMLHttpRequest
    } catch {}
  };
  var _t = {
        0: 200,
        1223: 204
      },
      zt = S.ajaxSettings.xhr();
  y.cors = !!zt && "withCredentials" in zt, y.ajax = zt = !!zt, S.ajaxTransport(function(i2) {
    var o2, a2;
    if (y.cors || zt && !i2.crossDomain) return {
      send: function(e2, t22) {
        var n2, r2 = i2.xhr();
        if (r2.open(i2.type, i2.url, i2.async, i2.username, i2.password), i2.xhrFields)
          for (n2 in i2.xhrFields) r2[n2] = i2.xhrFields[n2];
        for (n2 in i2.mimeType && r2.overrideMimeType && r2.overrideMimeType(i2.mimeType), i2.crossDomain || e2["X-Requested-With"] || (e2["X-Requested-With"] = "XMLHttpRequest"), e2) r2.setRequestHeader(n2, e2[n2]);
        o2 = function(e3) {
          return function() {
            o2 && (o2 = a2 = r2.onload = r2.onerror = r2.onabort = r2.ontimeout = r2.onreadystatechange = null, e3 === "abort" ? r2.abort() : e3 === "error" ? typeof r2.status != "number" ? t22(0, "error") : t22(r2.status, r2.statusText) : t22(_t[r2.status] || r2.status, r2.statusText, (r2.responseType || "text") !== "text" || typeof r2.responseText != "string" ? {
              binary: r2.response
            } : {
              text: r2.responseText
            }, r2.getAllResponseHeaders()))
          }
        }, r2.onload = o2(), a2 = r2.onerror = r2.ontimeout = o2("error"), r2.onabort !== void 0 ? r2.onabort = a2 : r2.onreadystatechange = function() {
          r2.readyState === 4 && C.setTimeout(function() {
            o2 && a2()
          })
        }, o2 = o2("abort");
        try {
          r2.send(i2.hasContent && i2.data || null)
        } catch (e3) {
          if (o2) throw e3
        }
      },
      abort: function() {
        o2 && o2()
      }
    }
  }), S.ajaxPrefilter(function(e2) {
    e2.crossDomain && (e2.contents.script = !1)
  }), S.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /\b(?:java|ecma)script\b/
    },
    converters: {
      "text script": function(e2) {
        return S.globalEval(e2), e2
      }
    }
  }), S.ajaxPrefilter("script", function(e2) {
    e2.cache === void 0 && (e2.cache = !1), e2.crossDomain && (e2.type = "GET")
  }), S.ajaxTransport("script", function(n2) {
    var r2, i2;
    if (n2.crossDomain || n2.scriptAttrs) return {
      send: function(e2, t22) {
        r2 = S("<script>").attr(n2.scriptAttrs || {}).prop({
          charset: n2.scriptCharset,
          src: n2.url
        }).on("load error", i2 = function(e3) {
          r2.remove(), i2 = null, e3 && t22(e3.type === "error" ? 404 : 200, e3.type)
        }), E.head.appendChild(r2[0])
      },
      abort: function() {
        i2 && i2()
      }
    }
  });
  var Ut, Xt = [],
      Vt = /(=)\?(?=&|$)|\?\?/;
  S.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function() {
      var e2 = Xt.pop() || S.expando + "_" + Ct.guid++;
      return this[e2] = !0, e2
    }
  }), S.ajaxPrefilter("json jsonp", function(e2, t22, n2) {
    var r2, i2, o2, a2 = e2.jsonp !== !1 && (Vt.test(e2.url) ? "url" : typeof e2.data == "string" && (e2.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Vt.test(e2.data) && "data");
    if (a2 || e2.dataTypes[0] === "jsonp") return r2 = e2.jsonpCallback = m(e2.jsonpCallback) ? e2.jsonpCallback() : e2.jsonpCallback, a2 ? e2[a2] = e2[a2].replace(Vt, "$1" + r2) : e2.jsonp !== !1 && (e2.url += (Et.test(e2.url) ? "&" : "?") + e2.jsonp + "=" + r2), e2.converters["script json"] = function() {
      return o2 || S.error(r2 + " was not called"), o2[0]
    }, e2.dataTypes[0] = "json", i2 = C[r2], C[r2] = function() {
      o2 = arguments
    }, n2.always(function() {
      i2 === void 0 ? S(C).removeProp(r2) : C[r2] = i2, e2[r2] && (e2.jsonpCallback = t22.jsonpCallback, Xt.push(r2)), o2 && m(i2) && i2(o2[0]), o2 = i2 = void 0
    }), "script"
  }), y.createHTMLDocument = ((Ut = E.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", Ut.childNodes.length === 2), S.parseHTML = function(e2, t22, n2) {
    return typeof e2 != "string" ? [] : (typeof t22 == "boolean" && (n2 = t22, t22 = !1), t22 || (y.createHTMLDocument ? ((r2 = (t22 = E.implementation.createHTMLDocument("")).createElement("base")).href = E.location.href, t22.head.appendChild(r2)) : t22 = E), o2 = !n2 && [], (i2 = N.exec(e2)) ? [t22.createElement(i2[1])] : (i2 = xe([e2], t22, o2), o2 && o2.length && S(o2).remove(), S.merge([], i2.childNodes)));
    var r2, i2, o2
  }, S.fn.load = function(e2, t22, n2) {
    var r2, i2, o2, a2 = this,
        s2 = e2.indexOf(" ");
    return -1 < s2 && (r2 = vt(e2.slice(s2)), e2 = e2.slice(0, s2)), m(t22) ? (n2 = t22, t22 = void 0) : t22 && typeof t22 == "object" && (i2 = "POST"), 0 < a2.length && S.ajax({
      url: e2,
      type: i2 || "GET",
      dataType: "html",
      data: t22
    }).done(function(e3) {
      o2 = arguments, a2.html(r2 ? S("<div>").append(S.parseHTML(e3)).find(r2) : e3)
    }).always(n2 && function(e3, t23) {
      a2.each(function() {
        n2.apply(this, o2 || [e3.responseText, t23, e3])
      })
    }), this
  }, S.expr.pseudos.animated = function(t22) {
    return S.grep(S.timers, function(e2) {
      return t22 === e2.elem
    }).length
  }, S.offset = {
    setOffset: function(e2, t22, n2) {
      var r2, i2, o2, a2, s2, u2, l2 = S.css(e2, "position"),
          c2 = S(e2),
          f2 = {};
      l2 === "static" && (e2.style.position = "relative"), s2 = c2.offset(), o2 = S.css(e2, "top"), u2 = S.css(e2, "left"), (l2 === "absolute" || l2 === "fixed") && -1 < (o2 + u2).indexOf("auto") ? (a2 = (r2 = c2.position()).top, i2 = r2.left) : (a2 = parseFloat(o2) || 0, i2 = parseFloat(u2) || 0), m(t22) && (t22 = t22.call(e2, n2, S.extend({}, s2))), t22.top != null && (f2.top = t22.top - s2.top + a2), t22.left != null && (f2.left = t22.left - s2.left + i2), "using" in t22 ? t22.using.call(e2, f2) : (typeof f2.top == "number" && (f2.top += "px"), typeof f2.left == "number" && (f2.left += "px"), c2.css(f2))
    }
  }, S.fn.extend({
    offset: function(t22) {
      if (arguments.length) return t22 === void 0 ? this : this.each(function(e3) {
        S.offset.setOffset(this, t22, e3)
      });
      var e2, n2, r2 = this[0];
      return r2 ? r2.getClientRects().length ? (e2 = r2.getBoundingClientRect(), n2 = r2.ownerDocument.defaultView, {
        top: e2.top + n2.pageYOffset,
        left: e2.left + n2.pageXOffset
      }) : {
        top: 0,
        left: 0
      } : void 0
    },
    position: function() {
      if (this[0]) {
        var e2, t22, n2, r2 = this[0],
            i2 = {
              top: 0,
              left: 0
            };
        if (S.css(r2, "position") === "fixed") t22 = r2.getBoundingClientRect();
        else {
          for (t22 = this.offset(), n2 = r2.ownerDocument, e2 = r2.offsetParent || n2.documentElement; e2 && (e2 === n2.body || e2 === n2.documentElement) && S.css(e2, "position") === "static";) e2 = e2.parentNode;
          e2 && e2 !== r2 && e2.nodeType === 1 && ((i2 = S(e2).offset()).top += S.css(e2, "borderTopWidth", !0), i2.left += S.css(e2, "borderLeftWidth", !0))
        }
        return {
          top: t22.top - i2.top - S.css(r2, "marginTop", !0),
          left: t22.left - i2.left - S.css(r2, "marginLeft", !0)
        }
      }
    },
    offsetParent: function() {
      return this.map(function() {
        for (var e2 = this.offsetParent; e2 && S.css(e2, "position") === "static";) e2 = e2.offsetParent;
        return e2 || re
      })
    }
  }), S.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function(t22, i2) {
    var o2 = i2 === "pageYOffset";
    S.fn[t22] = function(e2) {
      return $2(this, function(e3, t23, n2) {
        var r2;
        if (x(e3) ? r2 = e3 : e3.nodeType === 9 && (r2 = e3.defaultView), n2 === void 0) return r2 ? r2[i2] : e3[t23];
        r2 ? r2.scrollTo(o2 ? r2.pageXOffset : n2, o2 ? n2 : r2.pageYOffset) : e3[t23] = n2
      }, t22, e2, arguments.length)
    }
  }), S.each(["top", "left"], function(e2, n2) {
    S.cssHooks[n2] = $e(y.pixelPosition, function(e3, t22) {
      if (t22) return t22 = Be(e3, n2), Me.test(t22) ? S(e3).position()[n2] + "px" : t22
    })
  }), S.each({
    Height: "height",
    Width: "width"
  }, function(a2, s2) {
    S.each({
      padding: "inner" + a2,
      content: s2,
      "": "outer" + a2
    }, function(r2, o2) {
      S.fn[o2] = function(e2, t22) {
        var n2 = arguments.length && (r2 || typeof e2 != "boolean"),
            i2 = r2 || (e2 === !0 || t22 === !0 ? "margin" : "border");
        return $2(this, function(e3, t23, n3) {
          var r3;
          return x(e3) ? o2.indexOf("outer") === 0 ? e3["inner" + a2] : e3.document.documentElement["client" + a2] : e3.nodeType === 9 ? (r3 = e3.documentElement, Math.max(e3.body["scroll" + a2], r3["scroll" + a2], e3.body["offset" + a2], r3["offset" + a2], r3["client" + a2])) : n3 === void 0 ? S.css(e3, t23, i2) : S.style(e3, t23, n3, i2)
        }, s2, n2 ? e2 : void 0, n2)
      }
    })
  }), S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e2, t22) {
    S.fn[t22] = function(e3) {
      return this.on(t22, e3)
    }
  }), S.fn.extend({
    bind: function(e2, t22, n2) {
      return this.on(e2, null, t22, n2)
    },
    unbind: function(e2, t22) {
      return this.off(e2, null, t22)
    },
    delegate: function(e2, t22, n2, r2) {
      return this.on(t22, e2, n2, r2)
    },
    undelegate: function(e2, t22, n2) {
      return arguments.length === 1 ? this.off(e2, "**") : this.off(t22, e2 || "**", n2)
    },
    hover: function(e2, t22) {
      return this.mouseenter(e2).mouseleave(t22 || e2)
    }
  }), S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e2, n2) {
    S.fn[n2] = function(e3, t22) {
      return 0 < arguments.length ? this.on(n2, null, e3, t22) : this.trigger(n2)
    }
  });
  var Gt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  S.proxy = function(e2, t22) {
    var n2, r2, i2;
    if (typeof t22 == "string" && (n2 = e2[t22], t22 = e2, e2 = n2), m(e2)) return r2 = s.call(arguments, 2), (i2 = function() {
      return e2.apply(t22 || this, r2.concat(s.call(arguments)))
    }).guid = e2.guid = e2.guid || S.guid++, i2
  }, S.holdReady = function(e2) {
    e2 ? S.readyWait++ : S.ready(!0)
  }, S.isArray = Array.isArray, S.parseJSON = JSON.parse, S.nodeName = A, S.isFunction = m, S.isWindow = x, S.camelCase = X, S.type = w, S.now = Date.now, S.isNumeric = function(e2) {
    var t22 = S.type(e2);
    return (t22 === "number" || t22 === "string") && !isNaN(e2 - parseFloat(e2))
  }, S.trim = function(e2) {
    return e2 == null ? "" : (e2 + "").replace(Gt, "")
  }, typeof define == "function" && define.amd && define("jquery", [], function() {
    return S
  });
  var Yt = C.jQuery,
      Qt = C.$;
  return S.noConflict = function(e2) {
    return C.$ === S && (C.$ = Qt), e2 && C.jQuery === S && (C.jQuery = Yt), S
  }, typeof e > "u" && (C.jQuery = C.$ = S), S
}), typeof ShopifyAPI > "u" && (ShopifyAPI = {});

function attributeToString(attribute) {
  return typeof attribute != "string" && (attribute += "", attribute === "undefined" && (attribute = "")), jQuery.trim(attribute)
}
ShopifyAPI.onCartUpdate = function(cart) {}, ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: "POST",
    url: theme.routes.cart_url + "/update.js",
    data: "note=" + attributeToString(note),
    dataType: "json",
    success: function(cart) {
      typeof callback == "function" ? callback(cart) : ShopifyAPI.onCartUpdate(cart)
    },
    error: function(XMLHttpRequest2, textStatus2) {
      ShopifyAPI.onError(XMLHttpRequest2, textStatus2)
    }
  };
  jQuery.ajax(params)
}, ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  data.message && data.message != "cannot update empty cart" && alert(data.message + "(" + data.status + "): " + data.description)
},
  ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: "POST",
    url: theme.routes.cart_url + "/add.js",
    data: jQuery(form).serialize(),
    dataType: "json",
    success: function(line_item) {
      typeof callback == "function" ? callback(line_item, form) : ShopifyAPI.onItemAdded(line_item, form)
    },
    error: function(XMLHttpRequest2, textStatus2) {
      typeof errorCallback == "function" ? errorCallback(XMLHttpRequest2, textStatus2, form) : ShopifyAPI.onError(XMLHttpRequest2, textStatus2), $("body").trigger("ajaxCart.errorAddItem")
    }
  };
  jQuery.ajax(params)
}, ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON("/cart.js", function(cart, textStatus2) {
    typeof callback == "function" ? callback(cart) : ShopifyAPI.onCartUpdate(cart)
  })
  document.dispatchEvent(new CustomEvent('upsale-products:fetch'));
}, ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $cartForm = $("[data-cart-form]"),
      $cartErrors = $("[data-cart-errors]"),
      oldCartItemCount = 0;
  jQuery.getJSON("/cart.js", function(cart, textStatus2) {
    oldCartItemCount = cart.item_count;
    var params = {
      type: "POST",
      url: theme.routes.cart_url + "/change.js",
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      cache: !1,
      success: function(cart2) {
        var newCartItemCount = cart2.item_count;
        if (typeof callback == "function" ? callback(cart2) : ShopifyAPI.onCartUpdate(cart2), oldCartItemCount === newCartItemCount) {
          var updatedProductTitle = cart2.items[line - 1].product_title;
          $cartErrors.find("[data-cart-errors-message]").html(theme.strings.limit_error + '<span class="cart__errors__product">' + updatedProductTitle + "</span>").end().slideDown()
        } else $cartErrors.stop().slideUp()
      },
      error: function(XMLHttpRequest2, textStatus3) {
        ShopifyAPI.onError(XMLHttpRequest2, textStatus3), $cartForm.removeClass("is-loading")
      }
    };
    jQuery.ajax(params)
  })
};
var ajaxCart = function(module2, $2) {
  "use strict";
  var init, loadCart, destroy, settings, isUpdating, $formContainer, $addToCart, $cartContainer, $drawerContainer, updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, freeShippingMessageHandle,
      cartUpdateCallback, buildCart, cartCallback, cartAcceptanceCallback, adjustCart, adjustCartCallback, qtySelectors, validateQty, trapFocus, observeAdditionalCheckoutButtons, updateCartData, hideErrors = 0,
      namespace = ".ajaxCart";
  return init = function(options) {
    settings = {
      namespace: ".ajaxCart",
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: "[data-api-cart]",
      addToCartSelector: 'input[type="submit"]',
      moneyFormat: "${{amount}}",
      disableAjaxCart: theme.settings.cartType == "page",
      enableQtySelectors: !0
    };
    $2.extend(settings, options);
    $formContainer = $2(settings.formSelector)
    $cartContainer = $2(settings.cartContainer)
    $addToCart = $formContainer.find(settings.addToCartSelector)
    namespace = settings.namespace
    isUpdating = !1
    $cartContainer.off(namespace)
    settings.enableQtySelectors && qtySelectors()
    !settings.disableAjaxCart && $addToCart.length && formOverride()
    adjustCart()
    this.updateCartData = updateCartData
  },
    loadCart = function() {
    var $body = $2("body"),
        isCartTemplate = $body.hasClass("template-cart");
    isCartTemplate ? $body.trigger("ajaxCart.cartPageFormUpdate") : ($2("body").addClass("drawer--is-loading"), ShopifyAPI.getCart(cartUpdateCallback))
  },

  updateCountPrice = function(cart) {
    $2(".cart__count").each(function() {
      $2(this).toggleClass("cart__count--has-items", !!cart.item_count)
    })
  },
    formOverride = function() {
    $formContainer.on("submit", function(evt) {
      evt.preventDefault();
      var $currentForm = $2(evt.target),
      $qtyInput = $currentForm.find("[data-quantity-input]"),
      qty2 = $qtyInput.val(),
      $submitButton = $2(this).find("[data-add-to-cart]");

      if (!$submitButton.hasClass("is-adding")) {
        if (qty2 < 1) {
          $qtyInput.addClass("field-error"), $currentForm.find(".errors").remove(), $currentForm.find(".variants-wrapper").after('<div class="errors qty-error">' + theme.strings.zero_qty_error + "</div>"), hideErrors && clearTimeout(hideErrors), hideErrors = setTimeout(function() {
            $currentForm.find(".errors").fadeOut(function() {
              $qtyInput.removeClass("field-error"), $currentForm.find(".errors").remove()
            })
          }, 3e3);
          return
        } else $qtyInput.removeClass("field-error"), $currentForm.find(".errors").remove();
        $submitButton.removeClass("is-added").addClass("is-adding").attr("disabled", !0),
        $currentForm.find(".errors").remove(),
        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback)
      }
    })
  },
    itemAddedCallback = function(product2, form) {
    var $submitButton = $2(form).find("[data-add-to-cart]"),
        $body = $2("body"),
        isCartTemplate = $body.hasClass("template-cart");
    $submitButton.removeClass("is-adding").addClass("is-added").attr("disabled", !1),
        isCartTemplate ? $body.trigger("ajaxCart.cartPageFormUpdate") :
            ShopifyAPI.getCart(cartUpdateCallback)
  },
  updateCartData = function() {
    ShopifyAPI.getCart(cartUpdateCallback);
  },
  itemErrorCallback = function(XMLHttpRequest2, textStatus2, form) {
    const response = XMLHttpRequest2.responseJSON,
        $currentForm = $2(form),
        $qtyInput = $currentForm.find("[data-quantity-input]"),
        $submitButton = $2(form).find("[data-add-to-cart]");
    typeof response == "object" && response.status == 422 && ($currentForm.find(".variants-wrapper").after('<div class="errors qty-error">' + response.description + "</div>"), hideErrors && clearTimeout(hideErrors), hideErrors = setTimeout(function() {
      $currentForm.find(".errors").fadeOut(function() {
        $qtyInput.removeClass("field-error"), $currentForm.find(".errors").remove()
      })
    }, 3e3)), $currentForm.removeClass("is-loading"), $submitButton.removeClass("is-adding is-added").attr("disabled", !1)
  },
    cartUpdateCallback = function(cart) {
        updateCountPrice(cart),
        buildCart(cart),
        freeShippingMessageHandle(cart.total_price),
        document.dispatchEvent(new CustomEvent('fetch-upsale-products'))
    },
    buildCart = function(cart) {
    var $cartContainer2 = $2("[data-api-cart]"),
        acceptanceChecked = !!$cartContainer2.attr("data-acceptance-checked") || !1,
        isCartTemplate = $2("body").hasClass("template-cart");
    if ($cartContainer2.empty(), cart.item_count === 0) {
      $cartContainer2.append("<p>" + theme.strings.cart_empty + "</p>"), cartCallback(cart);
      return
    }
    var items = [],
        item = {},
        discounts = [],
        data2 = {},
        errors = "",
        source = $2("#CartTemplate").html();
    $2.each(cart.items, function(index, cartItem) {
      var itemDiscounts = [],
          itemDiscount = [],
          unitPrice = "",
          unitBase = "";
      if (cartItem.image != null) var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_120x120$1").replace("http:", "");
      else var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      $2.each(cartItem.line_level_discount_allocations, function(index2, discountItem) {
        itemDiscount = {
          title: discountItem.discount_application.title,
          amount: slate.Currency.formatMoney(discountItem.amount, theme.moneyFormat)
        }, itemDiscounts.push(itemDiscount)
      });
      var sellingPlanName = cartItem.selling_plan_allocation ? cartItem.selling_plan_allocation.selling_plan.name : "";
      cartItem.unit_price && (unitPrice = slate.Currency.formatMoney(cartItem.unit_price, theme.moneyFormat) + " ", cartItem.unit_price_measurement.reference_value != 1 && (unitBase += cartItem.unit_price_measurement.reference_value), unitBase += cartItem.unit_price_measurement.reference_unit), item = {
        id: cartItem.variant_id,
        line: index + 1,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title.replace(/(<([^>]+)>)/gi, ""),
        sellingPlanName,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity++,
        itemMinus: cartItem.quantity--,
        itemQty: cartItem.quantity,
        finalPrice: slate.Currency.formatMoney(cartItem.final_line_price, theme.moneyFormat),
        originalPrice: cartItem.original_line_price > cartItem.final_line_price ? slate.Currency.formatMoney(cartItem.original_line_price, theme.moneyFormat) : 0,
        unitPrice,
        unitBase,
        discounts: itemDiscounts,
        vendor: cartItem.vendor
      }, items.push(item)
    }), $2.each(cart.cart_level_discount_applications, function(index, discountItem) {
      item = {
        title: discountItem.title,
        total_allocated_amount: slate.Currency.formatMoney(discountItem.total_allocated_amount, theme.moneyFormat)
      }, discounts.push(item)
    }), data2 = {
      items,
      errors,
      discounts,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(cart.total_price, theme.moneyFormat),
      acceptanceChecked,
      isCartTemplate
    };
    var template = Sqrl.render(source, data2);
    $cartContainer2.append(template), cartCallback(cart)
  }, cartAcceptanceCallback = function(cart) {
    var selectors = {
      cartForm: "form.cart",
      cartContainer: "[data-api-cart]",
      cartFormDynamicCheckout: ".additional-checkout-buttons form",
      cartAcceptanceCheckbox: "[data-cart-acceptance-checkbox]",
      cartAcceptanceLabel: "[data-cart-acceptance-label]",
      cartButtons: "[data-cart-buttons]",
      cartButtonsFieldset: "[data-cart-buttons-fieldset]",
      cartFormError: "[data-cart-error]"
    };
    if ($2(selectors.cartAcceptanceCheckbox).length) {
      var cartFormErrorElement = '<div class="errors" data-cart-error>' + theme.strings.cart_acceptance_error + "</div>",
          termsAccepted = $2(selectors.cartAcceptanceCheckbox).is(":checked"),
          formSubmitFunction = function(e) {
            var termsAccepted2 = $2(selectors.cartAcceptanceCheckbox).is(":checked");
            if (termsAccepted2) $2(selectors.cartFormError).stop().slideUp("fast", function() {
              $2(this).remove()
            }), $2(selectors.cartButtonsFieldset).removeAttr("disabled"), $2(selectors.cartContainer).attr("data-acceptance-checked", "checked");
            else {
              if (e.preventDefault(), $2(selectors.cartFormError).length) return;
              $2(selectors.cartButtonsFieldset).attr("disabled", !0), $2(selectors.cartAcceptanceLabel).after(cartFormErrorElement), $2(selectors.cartFormError).slideDown("fast"), $2(selectors.cartContainer).removeAttr("data-acceptance-checked")
            }
          };
      termsAccepted || $2(selectors.cartButtonsFieldset).attr("disabled", !0), $2(selectors.cartContainer).on("click" + namespace, selectors.cartButtons, formSubmitFunction).on("submit" + namespace, selectors.cartForm, formSubmitFunction).on("submit" + namespace, selectors.cartFormDynamicCheckout, formSubmitFunction).on("change" + namespace, selectors.cartAcceptanceCheckbox, formSubmitFunction)
    }
  }, cartCallback = function(cart) {
    var $body = $2("body"),
        $cartForm = $2("[data-cart-form]");
        $body.removeClass("drawer--is-loading"),
        $body.trigger("ajaxCart.afterCartLoad", cart),
        $cartForm.removeClass("is-loading"),
        adjustCart(),
        cartAcceptanceCallback(cart),
        qtySelectors(), trapFocus(),
        observeAdditionalCheckoutButtons(),
    window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize()
  },
      adjustCart = function() {
    var $cartContainer2 = $2("[data-api-cart]"),
        $cartForm = $2("[data-cart-form]"),
        actions = "click change submit focus";
    $cartContainer2.off(actions), $cartContainer2.on("click" + namespace, ".js-qty__adjust", function() {
      var $el = $2(this),
          line = $el.data("line"),
          $qtySelector = $el.siblings(".js-qty__input"),
          qty2 = parseInt($qtySelector.val().replace(/\D/g, "")),
          qty2 = validateQty(qty2);
      $el.hasClass("js-qty__adjust--plus") ? qty2++ : (qty2--, qty2 <= 0 && (qty2 = 0)), line ? updateQuantity(line, qty2) : $qtySelector.val(qty2)
    }), $cartContainer2.on("change" + namespace, ".js-qty__input", function() {
      var $el = $2(this),
          line = $el.data("line"),
          qty2 = parseInt($el.val().replace(/\D/g, "")),
          qty2 = validateQty(qty2);
      line && updateQuantity(line, qty2)
    }), $cartContainer2.on("submit" + namespace, "form.ajaxcart", function(evt) {
      isUpdating && evt.preventDefault()
    }), $cartContainer2.on("focus" + namespace, ".js-qty__adjust", function() {
      var $el = $2(this);
      setTimeout(function() {
        $el.select()
      }, 50)
    }), $cartContainer2.on("change" + namespace, 'textarea[name="note"]', function() {
      var newNote = $2(this).val();
      ShopifyAPI.updateCartNote(newNote, function(cart) {})
    }), $cartContainer2.on("click" + namespace, "[data-product-remove]", function(e) {
      var line = $2(this).data("line");
      updateQuantity(line, 0)
    }), $cartContainer2.on("click" + namespace, "[data-cart-errors-remove]", function(e) {
      $2(this).closest("[data-cart-errors]").stop().slideUp()
    });

    function updateQuantity(line, qty2) {
      isUpdating = !0, $cartForm.addClass("is-loading");
      var $row = $cartContainer2.find('.ajaxcart__row[data-line="' + line + '"]').addClass("is-loading");
      qty2 === 0 && $row.parent().addClass("is-removed"), setTimeout(function() {
        ShopifyAPI.changeItem(line, qty2, adjustCartCallback)
      }, 250)
    }
  }, adjustCartCallback = function(cart) {
    isUpdating = !1, updateCountPrice(cart), setTimeout(function() {
      ShopifyAPI.getCart(buildCart)
    }, 150), freeShippingMessageHandle(cart.total_price)
  }, qtySelectors = function() {
    var $body = $2("body"),
        numInputs = $2(".js-qty__num");
    numInputs.length && (numInputs.each(function() {
      var $el = $2(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id"),
          itemAdd = currentQty++,
          itemMinus = currentQty--,
          itemQty = currentQty,
          source = $2("#JsQty").html(),
          data2 = {
            id: $el.data("id"),
            itemQty,
            itemAdd,
            itemMinus,
            inputName,
            inputId
          },
          template = Sqrl.render(source, data2);
      $el.after(template).remove()
    }), $body.off("click", ".js-qty__adjust").on("click", ".js-qty__adjust", function() {
      var $el = $2(this),
          $qtySelector = $el.siblings(".js-qty__input"),
          qty2 = parseInt($qtySelector.val().replace(/\D/g, "")),
          qty2 = validateQty(qty2);
      $el.hasClass("js-qty__adjust--plus") ? qty2 += 1 : (qty2 -= 1, qty2 <= 0 && (qty2 = 0)), $qtySelector.val(qty2), theme.settings.cartType == "drawer" && $qtySelector.trigger("change")
    }))
  }, validateQty = function(qty2) {
    return parseFloat(qty2) == parseInt(qty2) && !isNaN(qty2) || (qty2 = 1), qty2
  }, freeShippingMessageHandle = function(total) {
    const cartMessage = document.querySelector("[data-cart-message]");
    if (cartMessage) {
      const cartMessageDefault = document.querySelector("[data-message-default]"),
          cartMessageProgress = document.querySelector("[data-cart-message-progress]"),
          cartMessageAmountLeft = document.querySelector("[data-free-shipping-amount]"),
          cartFreeShippingLimit = Number(cartMessage.getAttribute("data-limit")) * 100,
          cartLeftToSpend = slate.Currency.formatMoney(cartFreeShippingLimit - total, theme.moneyFormat),
          cartMessageDifference = total / cartFreeShippingLimit * 100;
      cartMessageAmountLeft.innerHTML = cartLeftToSpend, cartMessageProgress.classList.toggle("cart__message__progress--hidden", total / cartFreeShippingLimit >= 1), cartMessage.classList.toggle("is-success", total >= cartFreeShippingLimit), cartMessageDefault.classList.toggle("is-hidden", total >= cartFreeShippingLimit), cartMessage.classList.toggle("is-hidden", total === 0), cartMessageProgress.setAttribute("value", cartMessageDifference)
    }
  }, destroy = function() {
    var $body = $2("body"),
        $cartContainer2 = $2("[data-api-cart]");
    $body.off(namespace).off("ajaxCart"), $cartContainer2.off(namespace)
  }, trapFocus = function() {
    var cartDrawer = document.querySelector("#CartDrawer");
    cartDrawer && (slate.a11y.removeTrapFocus({
      container: cartDrawer
    }), slate.a11y.trapFocus({
      container: cartDrawer,
      elementToFocus: cartDrawer.querySelector(".js-drawer-close")
    }))
  }, observeAdditionalCheckoutButtons = function() {
    const additionalCheckoutButtons = document.querySelector(".additional-checkout-buttons");
    if (!additionalCheckoutButtons) {
      return;
    }
    const observer = new MutationObserver(function() {
          trapFocus(), observer.disconnect()
        });
    observer.observe(additionalCheckoutButtons, {
      subtree: !0,
      childList: !0
    })
  }, module2 = {
    init,
    updateCartData,
    load: loadCart,
    initQtySelectors: qtySelectors,
    destroy
  }, module2
}(ajaxCart || {}, jQuery);
/* ===================================================================================== @preserve =
___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
						|\
						|/
Ajaxinate
version v2.0.11
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */
var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {},
      defaultSettings = {
        pagination: ".AjaxinatePagination",
        method: "scroll",
        namespace: ".Ajaxinate",
        container: ".AjaxinateLoop",
        offset: 0,
        loadingText: theme.strings.loading + '<span class="dots dots--animated"><span>.</span><span>.</span><span>.</span></span>',
        callback: null
      };
  this.settings = Object.assign(defaultSettings, settings), this.addScrollListeners = this.addScrollListeners.bind(this), this.addClickListener = this.addClickListener.bind(this), this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this), this.stopMultipleClicks = this.stopMultipleClicks.bind(this), this.destroy = this.destroy.bind(this), this.namespace = this.settings.namespace, this.containerElement = document.querySelector(this.settings.container), this.paginationElement = document.querySelector(this.settings.pagination), this.initialize()
};
Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]()
  }
}, Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  this.paginationElement && $(window).on("scroll" + this.namespace, this.checkIfPaginationInView).on("resize" + this.namespace, this.checkIfPaginationInView).on("orientationchange" + this.namespace, this.checkIfPaginationInView)
}, Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"), this.clickActive = !0, this.nextPageLinkElement !== null && this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks))
}, Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault(), this.clickActive && (this.nextPageLinkElement.innerHTML = this.settings.loadingText, this.nextPageUrl = this.nextPageLinkElement.href, this.clickActive = !1, this.loadMore())
}, Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
      bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  top <= window.innerHeight && bottom >= 0 && (this.nextPageLinkElement = this.paginationElement.querySelector("a"), this.removeScrollListener(), this.nextPageLinkElement && (this.nextPageLinkElement.innerHTML = this.settings.loadingText, this.nextPageUrl = this.nextPageLinkElement.href, this.loadMore()))
}, Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest, this.request.onreadystatechange = function() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = $(this.request.response).find(this.settings.container),
          newPagination = $(this.request.response).find(this.settings.pagination);
      this.containerElement.insertAdjacentHTML("beforeend", newContainer.html()), this.paginationElement.innerHTML = newPagination.html(), this.settings.callback && typeof this.settings.callback == "function" && this.settings.callback(this.request.response), this.initialize()
    }
  }.bind(this), this.request.open("GET", this.nextPageUrl), this.request.send()
}, Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks)
}, Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  $(window).off("scroll" + this.namespace, this.checkIfPaginationInView).off("resize" + this.namespace, this.checkIfPaginationInView).off("orientationchange" + this.namespace, this.checkIfPaginationInView)
}, Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  var destroyers = {
    click: this.removeClickListener.bind(this),
    scroll: this.removeScrollListener.bind(this)
  };
  return destroyers[this.settings.method](), this
};
/*!
 * JavaScript Cookie v2.1.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(e) {
  if (typeof define == "function" && define.amd) define(e);
  else if (typeof exports == "object") module.exports = e();
  else {
    var n = window.Cookies,
        t21 = window.Cookies = e();
    t21.noConflict = function() {
      return window.Cookies = n, t21
    }
  }
})(function() {
  function e() {
    for (var e2 = 0, n2 = {}; e2 < arguments.length; e2++) {
      var t21 = arguments[e2];
      for (var o in t21) n2[o] = t21[o]
    }
    return n2
  }

  function n(t21) {
    function o(n2, r, i) {
      var c;
      if (arguments.length > 1) {
        if (i = e({
          path: "/"
        }, o.defaults, i), typeof i.expires == "number") {
          var s = new Date;
          s.setMilliseconds(s.getMilliseconds() + 864e5 * i.expires), i.expires = s
        }
        try {
          c = JSON.stringify(r), /^[\{\[]/.test(c) && (r = c)
        } catch {}
        return r = t21.write ? t21.write(r, n2) : encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), n2 = encodeURIComponent(String(n2)), n2 = n2.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), n2 = n2.replace(/[\(\)]/g, escape), document.cookie = [n2, "=", r, i.expires && "; expires=" + i.expires.toUTCString(), i.path && "; path=" + i.path, i.domain && "; domain=" + i.domain, i.secure ? "; secure" : ""].join("")
      }
      n2 || (c = {});
      for (var p = document.cookie ? document.cookie.split("; ") : [], d = /(%[0-9A-Z]{2})+/g, u = 0; u < p.length; u++) {
        var f = p[u].split("="),
            l = f[0].replace(d, decodeURIComponent),
            m = f.slice(1).join("=");
        m.charAt(0) === '"' && (m = m.slice(1, -1));
        try {
          if (m = t21.read ? t21.read(m, l) : t21(m, l) || m.replace(d, decodeURIComponent), this.json) try {
            m = JSON.parse(m)
          } catch {}
          if (n2 === l) {
            c = m;
            break
          }
          n2 || (c[l] = m)
        } catch {}
      }
      return c
    }
    return o.get = o.set = o, o.getJSON = function() {
      return o.apply({
        json: !0
      }, [].slice.call(arguments))
    }, o.defaults = {}, o.remove = function(n2, t22) {
      o(n2, "", e(t22, {
        expires: -1
      }))
    }, o.withConverter = n, o
  }
  return n(function() {})
}), PaloAlto.debounce = function(n, t21, u) {
  var e;
  return function() {
    var a = this,
        r = arguments,
        i = function() {
          e = null, u || n.apply(a, r)
        },
        o = u && !e;
    clearTimeout(e), e = setTimeout(i, t21), o && n.apply(a, r)
  }
};
/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
(function(a, b, c) {
  var d = window.matchMedia;
  typeof module < "u" && module.exports ? module.exports = c(d) : typeof define == "function" && define.amd ? define(function() {
    return b[a] = c(d)
  }) : b[a] = c(d)
})("enquire", this, function(a) {
  "use strict";

  function b(a2, b2) {
    var c2, d2 = 0,
        e2 = a2.length;
    for (d2; e2 > d2 && (c2 = b2(a2[d2], d2), c2 !== !1); d2++);
  }

  function c(a2) {
    return Object.prototype.toString.apply(a2) === "[object Array]"
  }

  function d(a2) {
    return typeof a2 == "function"
  }

  function e(a2) {
    this.options = a2, !a2.deferSetup && this.setup()
  }

  function f(b2, c2) {
    this.query = b2, this.isUnconditional = c2, this.handlers = [], this.mql = a(b2);
    var d2 = this;
    this.listener = function(a2) {
      d2.mql = a2, d2.assess()
    }, this.mql.addListener(this.listener)
  }

  function g() {
    if (!a) throw new Error("matchMedia not present, legacy browsers require a polyfill");
    this.queries = {}, this.browserIsIncapable = !a("only all").matches
  }
  return e.prototype = {
    setup: function() {
      this.options.setup && this.options.setup(), this.initialised = !0
    },
    on: function() {
      !this.initialised && this.setup(), this.options.match && this.options.match()
    },
    off: function() {
      this.options.unmatch && this.options.unmatch()
    },
    destroy: function() {
      this.options.destroy ? this.options.destroy() : this.off()
    },
    equals: function(a2) {
      return this.options === a2 || this.options.match === a2
    }
  }, f.prototype = {
    addHandler: function(a2) {
      var b2 = new e(a2);
      this.handlers.push(b2), this.matches() && b2.on()
    },
    removeHandler: function(a2) {
      var c2 = this.handlers;
      b(c2, function(b2, d2) {
        return b2.equals(a2) ? (b2.destroy(), !c2.splice(d2, 1)) : void 0
      })
    },
    matches: function() {
      return this.mql.matches || this.isUnconditional
    },
    clear: function() {
      b(this.handlers, function(a2) {
        a2.destroy()
      }), this.mql.removeListener(this.listener), this.handlers.length = 0
    },
    assess: function() {
      var a2 = this.matches() ? "on" : "off";
      b(this.handlers, function(b2) {
        b2[a2]()
      })
    }
  }, g.prototype = {
    register: function(a2, e2, g2) {
      var h = this.queries,
          i = g2 && this.browserIsIncapable;
      return h[a2] || (h[a2] = new f(a2, i)), d(e2) && (e2 = {
        match: e2
      }), c(e2) || (e2 = [e2]), b(e2, function(b2) {
        d(b2) && (b2 = {
          match: b2
        }), h[a2].addHandler(b2)
      }), this
    },
    unregister: function(a2, b2) {
      var c2 = this.queries[a2];
      return c2 && (b2 ? c2.removeHandler(b2) : (c2.clear(), delete this.queries[a2])), this
    }
  }, new g
});
/*!
 * Flickity PACKAGED v2.2.2
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */
(function(e, i) {
  typeof define == "function" && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(t21) {
    return i(e, t21)
  }) : typeof module == "object" && module.exports ? module.exports = i(e, require("jquery")) : e.jQueryBridget = i(e, e.jQuery)
})(window, function t(e, r) {
  "use strict";
  var o = Array.prototype.slice,
      i = e.console,
      u = typeof i > "u" ? function() {} : function(t21) {
        i.error(t21)
      };

  function n(h, s, c) {
    if (c = c || r || e.jQuery, !c) return;
    s.prototype.option || (s.prototype.option = function(t21) {
      c.isPlainObject(t21) && (this.options = c.extend(!0, this.options, t21))
    }), c.fn[h] = function(t21) {
      if (typeof t21 == "string") {
        var e2 = o.call(arguments, 1);
        return i2(this, t21, e2)
      }
      return n2(this, t21), this
    };

    function i2(t21, r2, o2) {
      var a2, l = "$()." + h + '("' + r2 + '")';
      return t21.each(function(t22, e2) {
        var i3 = c.data(e2, h);
        if (!i3) {
          u(h + " not initialized. Cannot call methods, i.e. " + l);
          return
        }
        var n3 = i3[r2];
        if (!n3 || r2.charAt(0) == "_") {
          u(l + " is not a valid method");
          return
        }
        var s2 = n3.apply(i3, o2);
        a2 = a2 === void 0 ? s2 : a2
      }), a2 !== void 0 ? a2 : t21
    }

    function n2(t21, n3) {
      t21.each(function(t22, e2) {
        var i3 = c.data(e2, h);
        i3 ? (i3.option(n3), i3._init()) : (i3 = new s(e2, n3), c.data(e2, h, i3))
      })
    }
    a(c)
  }

  function a(t21) {
    !t21 || t21 && t21.bridget || (t21.bridget = n)
  }
  return a(r || e.jQuery), n
}),
    function(t21, e) {
      typeof define == "function" && define.amd ? define("ev-emitter/ev-emitter", e) : typeof module == "object" && module.exports ? module.exports = e() : t21.EvEmitter = e()
    }(typeof window < "u" ? window : this, function() {
      function t21() {}
      var e = t21.prototype;
      return e.on = function(t22, e2) {
        if (!(!t22 || !e2)) {
          var i = this._events = this._events || {},
              n = i[t22] = i[t22] || [];
          return n.indexOf(e2) == -1 && n.push(e2), this
        }
      }, e.once = function(t22, e2) {
        if (!(!t22 || !e2)) {
          this.on(t22, e2);
          var i = this._onceEvents = this._onceEvents || {},
              n = i[t22] = i[t22] || {};
          return n[e2] = !0, this
        }
      }, e.off = function(t22, e2) {
        var i = this._events && this._events[t22];
        if (!(!i || !i.length)) {
          var n = i.indexOf(e2);
          return n != -1 && i.splice(n, 1), this
        }
      }, e.emitEvent = function(t22, e2) {
        var i = this._events && this._events[t22];
        if (!(!i || !i.length)) {
          i = i.slice(0), e2 = e2 || [];
          for (var n = this._onceEvents && this._onceEvents[t22], s = 0; s < i.length; s++) {
            var r = i[s],
                o = n && n[r];
            o && (this.off(t22, r), delete n[r]), r.apply(this, e2)
          }
          return this
        }
      }, e.allOff = function() {
        delete this._events, delete this._onceEvents
      }, t21
    });
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */
(function(t21, e) {
  typeof define == "function" && define.amd ? define("get-size/get-size", e) : typeof module == "object" && module.exports ? module.exports = e() : t21.getSize = e()
})(window, function t2() {
  "use strict";

  function m(t21) {
    var e2 = parseFloat(t21),
        i2 = t21.indexOf("%") == -1 && !isNaN(e2);
    return i2 && e2
  }

  function e() {}
  var i = typeof console > "u" ? e : function(t21) {
        console.error(t21)
      },
      y = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
      b = y.length;

  function E() {
    for (var t21 = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    }, e2 = 0; e2 < b; e2++) {
      var i2 = y[e2];
      t21[i2] = 0
    }
    return t21
  }

  function S(t21) {
    var e2 = getComputedStyle(t21);
    return e2 || i("Style returned " + e2 + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e2
  }
  var n = !1,
      C;

  function x() {
    if (!n) {
      n = !0;
      var t21 = document.createElement("div");
      t21.style.width = "200px", t21.style.padding = "1px 2px 3px 4px", t21.style.borderStyle = "solid", t21.style.borderWidth = "1px 2px 3px 4px", t21.style.boxSizing = "border-box";
      var e2 = document.body || document.documentElement;
      e2.appendChild(t21);
      var i2 = S(t21);
      C = Math.round(m(i2.width)) == 200, s.isBoxSizeOuter = C, e2.removeChild(t21)
    }
  }

  function s(t21) {
    if (x(), typeof t21 == "string" && (t21 = document.querySelector(t21)), !(!t21 || typeof t21 != "object" || !t21.nodeType)) {
      var e2 = S(t21);
      if (e2.display == "none") return E();
      var i2 = {};
      i2.width = t21.offsetWidth, i2.height = t21.offsetHeight;
      for (var n2 = i2.isBorderBox = e2.boxSizing == "border-box", s2 = 0; s2 < b; s2++) {
        var r = y[s2],
            o = e2[r],
            a = parseFloat(o);
        i2[r] = isNaN(a) ? 0 : a
      }
      var l = i2.paddingLeft + i2.paddingRight,
          h = i2.paddingTop + i2.paddingBottom,
          c = i2.marginLeft + i2.marginRight,
          u = i2.marginTop + i2.marginBottom,
          d = i2.borderLeftWidth + i2.borderRightWidth,
          f = i2.borderTopWidth + i2.borderBottomWidth,
          p = n2 && C,
          v = m(e2.width);
      v !== !1 && (i2.width = v + (p ? 0 : l + d));
      var g = m(e2.height);
      return g !== !1 && (i2.height = g + (p ? 0 : h + f)), i2.innerWidth = i2.width - (l + d), i2.innerHeight = i2.height - (h + f), i2.outerWidth = i2.width + c, i2.outerHeight = i2.height + u, i2
    }
  }
  return s
}),
    function(t21, e) {
      "use strict";
      typeof define == "function" && define.amd ? define("desandro-matches-selector/matches-selector", e) : typeof module == "object" && module.exports ? module.exports = e() : t21.matchesSelector = e()
    }(window, function t3() {
      "use strict";
      var n = function() {
        var t21 = window.Element.prototype;
        if (t21.matches) return "matches";
        if (t21.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
          var n2 = e[i],
              s = n2 + "MatchesSelector";
          if (t21[s]) return s
        }
      }();
      return function(e, i) {
        return e[n](i)
      }
    }),
    function(e, i) {
      typeof define == "function" && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(t21) {
        return i(e, t21)
      }) : typeof module == "object" && module.exports ? module.exports = i(e, require("desandro-matches-selector")) : e.fizzyUIUtils = i(e, e.matchesSelector)
    }(window, function t4(h, r) {
      var c = {};
      c.extend = function(t21, e) {
        for (var i2 in e) t21[i2] = e[i2];
        return t21
      }, c.modulo = function(t21, e) {
        return (t21 % e + e) % e
      };
      var i = Array.prototype.slice;
      c.makeArray = function(t21) {
        if (Array.isArray(t21)) return t21;
        if (t21 == null) return [];
        var e = typeof t21 == "object" && typeof t21.length == "number";
        return e ? i.call(t21) : [t21]
      }, c.removeFrom = function(t21, e) {
        var i2 = t21.indexOf(e);
        i2 != -1 && t21.splice(i2, 1)
      }, c.getParent = function(t21, e) {
        for (; t21.parentNode && t21 != document.body;)
          if (t21 = t21.parentNode, r(t21, e)) return t21
      }, c.getQueryElement = function(t21) {
        return typeof t21 == "string" ? document.querySelector(t21) : t21
      }, c.handleEvent = function(t21) {
        var e = "on" + t21.type;
        this[e] && this[e](t21)
      }, c.filterFindElements = function(t21, n) {
        t21 = c.makeArray(t21);
        var s = [];
        return t21.forEach(function(t22) {
          if (t22 instanceof HTMLElement) {
            if (!n) {
              s.push(t22);
              return
            }
            r(t22, n) && s.push(t22);
            for (var e = t22.querySelectorAll(n), i2 = 0; i2 < e.length; i2++) s.push(e[i2])
          }
        }), s
      }, c.debounceMethod = function(t21, e, n) {
        n = n || 100;
        var s = t21.prototype[e],
            r2 = e + "Timeout";
        t21.prototype[e] = function() {
          var t22 = this[r2];
          clearTimeout(t22);
          var e2 = arguments,
              i2 = this;
          this[r2] = setTimeout(function() {
            s.apply(i2, e2), delete i2[r2]
          }, n)
        }
      }, c.docReady = function(t21) {
        var e = document.readyState;
        e == "complete" || e == "interactive" ? setTimeout(t21) : document.addEventListener("DOMContentLoaded", t21)
      }, c.toDashed = function(t21) {
        return t21.replace(/(.)([A-Z])/g, function(t22, e, i2) {
          return e + "-" + i2
        }).toLowerCase()
      };
      var u = h.console;
      return c.htmlInit = function(a, l) {
        c.docReady(function() {
          var t21 = c.toDashed(l),
              s = "data-" + t21,
              e = document.querySelectorAll("[" + s + "]"),
              i2 = document.querySelectorAll(".js-" + t21),
              n = c.makeArray(e).concat(c.makeArray(i2)),
              r2 = s + "-options",
              o = h.jQuery;
          n.forEach(function(e2) {
            var t22 = e2.getAttribute(s) || e2.getAttribute(r2),
                i3;
            try {
              i3 = t22 && JSON.parse(t22)
            } catch (t23) {
              u && u.error("Error parsing " + s + " on " + e2.className + ": " + t23);
              return
            }
            var n2 = new a(e2, i3);
            o && o.data(e2, l, n2)
          })
        })
      }, c
    }),
    function(e, i) {
      typeof define == "function" && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function(t21) {
        return i(e, t21)
      }) : typeof module == "object" && module.exports ? module.exports = i(e, require("get-size")) : (e.Flickity = e.Flickity || {}, e.Flickity.Cell = i(e, e.getSize))
    }(window, function t5(e, i) {
      function n(t21, e2) {
        this.element = t21, this.parent = e2, this.create()
      }
      var s = n.prototype;
      return s.create = function() {
        this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), this.x = 0, this.shift = 0
      }, s.destroy = function() {
        this.unselect(), this.element.style.position = "";
        var t21 = this.parent.originSide;
        this.element.style[t21] = "", this.element.removeAttribute("aria-hidden")
      }, s.getSize = function() {
        this.size = i(this.element)
      }, s.setPosition = function(t21) {
        this.x = t21, this.updateTarget(), this.renderPosition(t21)
      }, s.updateTarget = s.setDefaultTarget = function() {
        var t21 = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[t21] + this.size.width * this.parent.cellAlign
      }, s.renderPosition = function(t21) {
        var e2 = this.parent.originSide;
        this.element.style[e2] = this.parent.getPositionValue(t21)
      }, s.select = function() {
        this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
      }, s.unselect = function() {
        this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
      }, s.wrapShift = function(t21) {
        this.shift = t21, this.renderPosition(this.x + this.parent.slideableWidth * t21)
      }, s.remove = function() {
        this.element.parentNode.removeChild(this.element)
      }, n
    }),
    function(t21, e) {
      typeof define == "function" && define.amd ? define("flickity/js/slide", e) : typeof module == "object" && module.exports ? module.exports = e() : (t21.Flickity = t21.Flickity || {}, t21.Flickity.Slide = e())
    }(window, function t6() {
      "use strict";

      function e(t21) {
        this.parent = t21, this.isOriginLeft = t21.originSide == "left", this.cells = [], this.outerWidth = 0, this.height = 0
      }
      var i = e.prototype;
      return i.addCell = function(t21) {
        if (this.cells.push(t21), this.outerWidth += t21.size.outerWidth, this.height = Math.max(t21.size.outerHeight, this.height), this.cells.length == 1) {
          this.x = t21.x;
          var e2 = this.isOriginLeft ? "marginLeft" : "marginRight";
          this.firstMargin = t21.size[e2]
        }
      }, i.updateTarget = function() {
        var t21 = this.isOriginLeft ? "marginRight" : "marginLeft",
            e2 = this.getLastCell(),
            i2 = e2 ? e2.size[t21] : 0,
            n = this.outerWidth - (this.firstMargin + i2);
        this.target = this.x + this.firstMargin + n * this.parent.cellAlign
      }, i.getLastCell = function() {
        return this.cells[this.cells.length - 1]
      }, i.select = function() {
        this.cells.forEach(function(t21) {
          t21.select()
        })
      }, i.unselect = function() {
        this.cells.forEach(function(t21) {
          t21.unselect()
        })
      }, i.getCellElements = function() {
        return this.cells.map(function(t21) {
          return t21.element
        })
      }, e
    }),
    function(e, i) {
      typeof define == "function" && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function(t21) {
        return i(e, t21)
      }) : typeof module == "object" && module.exports ? module.exports = i(e, require("fizzy-ui-utils")) : (e.Flickity = e.Flickity || {}, e.Flickity.animatePrototype = i(e, e.fizzyUIUtils))
    }(window, function t7(e, i) {
      var n = {};
      return n.startAnimation = function() {
        this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
      }, n.animate = function() {
        this.applyDragForce(), this.applySelectedAttraction();
        var t21 = this.x;
        if (this.integratePhysics(), this.positionSlider(), this.settle(t21), this.isAnimating) {
          var e2 = this;
          requestAnimationFrame(function() {
            e2.animate()
          })
        }
      }, n.positionSlider = function() {
        var t21 = this.x;
        this.options.wrapAround && this.cells.length > 1 && (t21 = i.modulo(t21, this.slideableWidth), t21 -= this.slideableWidth, this.shiftWrapCells(t21)), this.setTranslateX(t21, this.isAnimating), this.dispatchScrollEvent()
      }, n.setTranslateX = function(t21, e2) {
        t21 += this.cursorPosition, t21 = this.options.rightToLeft ? -t21 : t21;
        var i2 = this.getPositionValue(t21);
        this.slider.style.transform = e2 ? "translate3d(" + i2 + ",0,0)" : "translateX(" + i2 + ")"
      }, n.dispatchScrollEvent = function() {
        var t21 = this.slides[0];
        if (t21) {
          var e2 = -this.x - t21.target,
              i2 = e2 / this.slidesWidth;
          this.dispatchEvent("scroll", null, [i2, e2])
        }
      }, n.positionSliderAtSelected = function() {
        this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
      }, n.getPositionValue = function(t21) {
        return this.options.percentPosition ? Math.round(t21 / this.size.innerWidth * 1e4) * .01 + "%" : Math.round(t21) + "px"
      }, n.settle = function(t21) {
        var e2 = !this.isPointerDown && Math.round(this.x * 100) == Math.round(t21 * 100);
        e2 && this.restingFrames++, this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
      }, n.shiftWrapCells = function(t21) {
        var e2 = this.cursorPosition + t21;
        this._shiftCells(this.beforeShiftCells, e2, -1);
        var i2 = this.size.innerWidth - (t21 + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, i2, 1)
      }, n._shiftCells = function(t21, e2, i2) {
        for (var n2 = 0; n2 < t21.length; n2++) {
          var s = t21[n2],
              r = e2 > 0 ? i2 : 0;
          s.wrapShift(r), e2 -= s.size.outerWidth
        }
      }, n._unshiftCells = function(t21) {
        if (!(!t21 || !t21.length))
          for (var e2 = 0; e2 < t21.length; e2++) t21[e2].wrapShift(0)
      }, n.integratePhysics = function() {
        this.x += this.velocity, this.velocity *= this.getFrictionFactor()
      }, n.applyForce = function(t21) {
        this.velocity += t21
      }, n.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
      }, n.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor())
      }, n.applyDragForce = function() {
        if (!(!this.isDraggable || !this.isPointerDown)) {
          var t21 = this.dragX - this.x,
              e2 = t21 - this.velocity;
          this.applyForce(e2)
        }
      }, n.applySelectedAttraction = function() {
        var t21 = this.isDraggable && this.isPointerDown;
        if (!(t21 || this.isFreeScrolling || !this.slides.length)) {
          var e2 = this.selectedSlide.target * -1 - this.x,
              i2 = e2 * this.options.selectedAttraction;
          this.applyForce(i2)
        }
      }, n
    }),
    function(o, a) {
      if (typeof define == "function" && define.amd) define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function(t22, e, i, n, s, r) {
        return a(o, t22, e, i, n, s, r)
      });
      else if (typeof module == "object" && module.exports) module.exports = a(o, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
      else {
        var t21 = o.Flickity;
        o.Flickity = a(o, o.EvEmitter, o.getSize, o.fizzyUIUtils, t21.Cell, t21.Slide, t21.animatePrototype)
      }
    }(window, function t8(n, e, i, a, s, o, r) {
      var l = n.jQuery,
          h = n.getComputedStyle,
          c = n.console;

      function u(t21, e2) {
        for (t21 = a.makeArray(t21); t21.length;) e2.appendChild(t21.shift())
      }
      var d = 0,
          f = {};

      function p(t21, e2) {
        var i2 = a.getQueryElement(t21);
        if (!i2) {
          c && c.error("Bad element for Flickity: " + (i2 || t21));
          return
        }
        if (this.element = i2, this.element.flickityGUID) {
          var n2 = f[this.element.flickityGUID];
          return n2 && n2.option(e2), n2
        }
        l && (this.$element = l(this.element)), this.options = a.extend({}, this.constructor.defaults), this.option(e2), this._create()
      }
      p.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        namespaceJQueryEvents: !0,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
      }, p.createMethods = [];
      var v = p.prototype;
      a.extend(v, e.prototype), v._create = function() {
        var t21 = this.guid = ++d;
        this.element.flickityGUID = t21, f[t21] = this, this.selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && n.addEventListener("resize", this);
        for (var e2 in this.options.on) {
          var i2 = this.options.on[e2];
          this.on(e2, i2)
        }
        p.createMethods.forEach(function(t22) {
          this[t22]()
        }, this), this.options.watchCSS ? this.watchCSS() : this.activate()
      }, v.option = function(t21) {
        a.extend(this.options, t21)
      }, v.activate = function() {
        if (!this.isActive) {
          this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize();
          var t21 = this._filterFindCellElements(this.element.children);
          u(t21, this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready")
        }
      }, v._createSlider = function() {
        var t21 = document.createElement("div");
        t21.className = "flickity-slider", t21.style[this.originSide] = 0, this.slider = t21
      }, v._filterFindCellElements = function(t21) {
        return a.filterFindElements(t21, this.options.cellSelector)
      }, v.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
      }, v._makeCells = function(t21) {
        var e2 = this._filterFindCellElements(t21),
            i2 = e2.map(function(t22) {
              return new s(t22, this)
            }, this);
        return i2
      }, v.getLastCell = function() {
        return this.cells[this.cells.length - 1]
      }, v.getLastSlide = function() {
        return this.slides[this.slides.length - 1]
      }, v.positionCells = function() {
        this._sizeCells(this.cells), this._positionCells(0)
      }, v._positionCells = function(t21) {
        t21 = t21 || 0, this.maxCellHeight = t21 && this.maxCellHeight || 0;
        var e2 = 0;
        if (t21 > 0) {
          var i2 = this.cells[t21 - 1];
          e2 = i2.x + i2.size.outerWidth
        }
        for (var n2 = this.cells.length, s2 = t21; s2 < n2; s2++) {
          var r2 = this.cells[s2];
          r2.setPosition(e2), e2 += r2.size.outerWidth, this.maxCellHeight = Math.max(r2.size.outerHeight, this.maxCellHeight)
        }
        this.slideableWidth = e2, this.updateSlides(), this._containSlides(), this.slidesWidth = n2 ? this.getLastSlide().target - this.slides[0].target : 0
      }, v._sizeCells = function(t21) {
        t21.forEach(function(t22) {
          t22.getSize()
        })
      }, v.updateSlides = function() {
        if (this.slides = [], !!this.cells.length) {
          var n2 = new o(this);
          this.slides.push(n2);
          var t21 = this.originSide == "left",
              s2 = t21 ? "marginRight" : "marginLeft",
              r2 = this._getCanCellFit();
          this.cells.forEach(function(t22, e2) {
            if (!n2.cells.length) {
              n2.addCell(t22);
              return
            }
            var i2 = n2.outerWidth - n2.firstMargin + (t22.size.outerWidth - t22.size[s2]);
            r2.call(this, e2, i2) || (n2.updateTarget(), n2 = new o(this), this.slides.push(n2)), n2.addCell(t22)
          }, this), n2.updateTarget(), this.updateSelectedSlide()
        }
      }, v._getCanCellFit = function() {
        var t21 = this.options.groupCells;
        if (t21) {
          if (typeof t21 == "number") {
            var e2 = parseInt(t21, 10);
            return function(t22) {
              return t22 % e2 !== 0
            }
          }
        } else return function() {
          return !1
        };
        var i2 = typeof t21 == "string" && t21.match(/^(\d+)%$/),
            n2 = i2 ? parseInt(i2[1], 10) / 100 : 1;
        return function(t22, e3) {
          return e3 <= (this.size.innerWidth + 1) * n2
        }
      }, v._init = v.reposition = function() {
        this.positionCells(), this.positionSliderAtSelected()
      }, v.getSize = function() {
        this.size = i(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
      };
      var g = {
        center: {
          left: .5,
          right: .5
        },
        left: {
          left: 0,
          right: 1
        },
        right: {
          right: 0,
          left: 1
        }
      };
      return v.setCellAlign = function() {
        var t21 = g[this.options.cellAlign];
        this.cellAlign = t21 ? t21[this.originSide] : this.options.cellAlign
      }, v.setGallerySize = function() {
        if (this.options.setGallerySize) {
          var t21 = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
          this.viewport.style.height = t21 + "px"
        }
      }, v._getWrapShiftCells = function() {
        if (this.options.wrapAround) {
          this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
          var t21 = this.cursorPosition,
              e2 = this.cells.length - 1;
          this.beforeShiftCells = this._getGapCells(t21, e2, -1), t21 = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(t21, 0, 1)
        }
      }, v._getGapCells = function(t21, e2, i2) {
        for (var n2 = []; t21 > 0;) {
          var s2 = this.cells[e2];
          if (!s2) break;
          n2.push(s2), e2 += i2, t21 -= s2.size.outerWidth
        }
        return n2
      }, v._containSlides = function() {
        if (!(!this.options.contain || this.options.wrapAround || !this.cells.length)) {
          var t21 = this.options.rightToLeft,
              e2 = t21 ? "marginRight" : "marginLeft",
              i2 = t21 ? "marginLeft" : "marginRight",
              n2 = this.slideableWidth - this.getLastCell().size[i2],
              s2 = n2 < this.size.innerWidth,
              r2 = this.cursorPosition + this.cells[0].size[e2],
              o2 = n2 - this.size.innerWidth * (1 - this.cellAlign);
          this.slides.forEach(function(t22) {
            s2 ? t22.target = n2 * this.cellAlign : (t22.target = Math.max(t22.target, r2), t22.target = Math.min(t22.target, o2))
          }, this)
        }
      }, v.dispatchEvent = function(t21, e2, i2) {
        var n2 = e2 ? [e2].concat(i2) : i2;
        if (this.emitEvent(t21, n2), l && this.$element) {
          t21 += this.options.namespaceJQueryEvents ? ".flickity" : "";
          var s2 = t21;
          if (e2) {
            var r2 = new l.Event(e2);
            r2.type = t21, s2 = r2
          }
          this.$element.trigger(s2, i2)
        }
      }, v.select = function(t21, e2, i2) {
        if (this.isActive && (t21 = parseInt(t21, 10), this._wrapSelect(t21), (this.options.wrapAround || e2) && (t21 = a.modulo(t21, this.slides.length)), !!this.slides[t21])) {
          var n2 = this.selectedIndex;
          this.selectedIndex = t21, this.updateSelectedSlide(), i2 ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [t21]), t21 != n2 && this.dispatchEvent("change", null, [t21]), this.dispatchEvent("cellSelect")
        }
      }, v._wrapSelect = function(t21) {
        var e2 = this.slides.length,
            i2 = this.options.wrapAround && e2 > 1;
        if (!i2) return t21;
        var n2 = a.modulo(t21, e2),
            s2 = Math.abs(n2 - this.selectedIndex),
            r2 = Math.abs(n2 + e2 - this.selectedIndex),
            o2 = Math.abs(n2 - e2 - this.selectedIndex);
        !this.isDragSelect && r2 < s2 ? t21 += e2 : !this.isDragSelect && o2 < s2 && (t21 -= e2), t21 < 0 ? this.x -= this.slideableWidth : t21 >= e2 && (this.x += this.slideableWidth)
      }, v.previous = function(t21, e2) {
        this.select(this.selectedIndex - 1, t21, e2)
      }, v.next = function(t21, e2) {
        this.select(this.selectedIndex + 1, t21, e2)
      }, v.updateSelectedSlide = function() {
        var t21 = this.slides[this.selectedIndex];
        t21 && (this.unselectSelectedSlide(), this.selectedSlide = t21, t21.select(), this.selectedCells = t21.cells, this.selectedElements = t21.getCellElements(), this.selectedCell = t21.cells[0], this.selectedElement = this.selectedElements[0])
      }, v.unselectSelectedSlide = function() {
        this.selectedSlide && this.selectedSlide.unselect()
      }, v.selectInitialIndex = function() {
        var t21 = this.options.initialIndex;
        if (this.isInitActivated) {
          this.select(this.selectedIndex, !1, !0);
          return
        }
        if (t21 && typeof t21 == "string") {
          var e2 = this.queryCell(t21);
          if (e2) {
            this.selectCell(t21, !1, !0);
            return
          }
        }
        var i2 = 0;
        t21 && this.slides[t21] && (i2 = t21), this.select(i2, !1, !0)
      }, v.selectCell = function(t21, e2, i2) {
        var n2 = this.queryCell(t21);
        if (n2) {
          var s2 = this.getCellSlideIndex(n2);
          this.select(s2, e2, i2)
        }
      }, v.getCellSlideIndex = function(t21) {
        for (var e2 = 0; e2 < this.slides.length; e2++) {
          var i2 = this.slides[e2],
              n2 = i2.cells.indexOf(t21);
          if (n2 != -1) return e2
        }
      }, v.getCell = function(t21) {
        for (var e2 = 0; e2 < this.cells.length; e2++) {
          var i2 = this.cells[e2];
          if (i2.element == t21) return i2
        }
      }, v.getCells = function(t21) {
        t21 = a.makeArray(t21);
        var i2 = [];
        return t21.forEach(function(t22) {
          var e2 = this.getCell(t22);
          e2 && i2.push(e2)
        }, this), i2
      }, v.getCellElements = function() {
        return this.cells.map(function(t21) {
          return t21.element
        })
      }, v.getParentCell = function(t21) {
        var e2 = this.getCell(t21);
        return e2 || (t21 = a.getParent(t21, ".flickity-slider > *"), this.getCell(t21))
      }, v.getAdjacentCellElements = function(t21, e2) {
        if (!t21) return this.selectedSlide.getCellElements();
        e2 = e2 === void 0 ? this.selectedIndex : e2;
        var i2 = this.slides.length;
        if (1 + t21 * 2 >= i2) return this.getCellElements();
        for (var n2 = [], s2 = e2 - t21; s2 <= e2 + t21; s2++) {
          var r2 = this.options.wrapAround ? a.modulo(s2, i2) : s2,
              o2 = this.slides[r2];
          o2 && (n2 = n2.concat(o2.getCellElements()))
        }
        return n2
      }, v.queryCell = function(t21) {
        if (typeof t21 == "number") return this.cells[t21];
        if (typeof t21 == "string") {
          if (t21.match(/^[#.]?[\d/]/)) return;
          t21 = this.element.querySelector(t21)
        }
        return this.getCell(t21)
      }, v.uiChange = function() {
        this.emitEvent("uiChange")
      }, v.childUIPointerDown = function(t21) {
        t21.type != "touchstart" && t21.preventDefault(), this.focus()
      }, v.onresize = function() {
        this.watchCSS(), this.resize()
      }, a.debounceMethod(p, "onresize", 150), v.resize = function() {
        if (this.isActive) {
          this.getSize(), this.options.wrapAround && (this.x = a.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
          var t21 = this.selectedElements && this.selectedElements[0];
          this.selectCell(t21, !1, !0)
        }
      }, v.watchCSS = function() {
        var t21 = this.options.watchCSS;
        if (t21) {
          var e2 = h(this.element, ":after").content;
          e2.indexOf("flickity") != -1 ? this.activate() : this.deactivate()
        }
      }, v.onkeydown = function(t21) {
        var e2 = document.activeElement && document.activeElement != this.element;
        if (!(!this.options.accessibility || e2)) {
          var i2 = p.keyboardHandlers[t21.keyCode];
          i2 && i2.call(this)
        }
      }, p.keyboardHandlers = {
        37: function() {
          var t21 = this.options.rightToLeft ? "next" : "previous";
          this.uiChange(), this[t21]()
        },
        39: function() {
          var t21 = this.options.rightToLeft ? "previous" : "next";
          this.uiChange(), this[t21]()
        }
      }, v.focus = function() {
        var t21 = n.pageYOffset;
        this.element.focus({
          preventScroll: !0
        }), n.pageYOffset != t21 && n.scrollTo(n.pageXOffset, t21)
      }, v.deactivate = function() {
        this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach(function(t21) {
          t21.destroy()
        }), this.element.removeChild(this.viewport), u(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
      }, v.destroy = function() {
        this.deactivate(), n.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), l && this.$element && l.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete f[this.guid]
      }, a.extend(v, r), p.data = function(t21) {
        t21 = a.getQueryElement(t21);
        var e2 = t21 && t21.flickityGUID;
        return e2 && f[e2]
      }, a.htmlInit(p, "flickity"), l && l.bridget && l.bridget("flickity", p), p.setJQuery = function(t21) {
        l = t21
      }, p.Cell = s, p.Slide = o, p
    });
/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */
(function(e, i) {
  typeof define == "function" && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function(t21) {
    return i(e, t21)
  }) : typeof module == "object" && module.exports ? module.exports = i(e, require("ev-emitter")) : e.Unipointer = i(e, e.EvEmitter)
})(window, function t9(s, e) {
  function i() {}

  function n() {}
  var r = n.prototype = Object.create(e.prototype);
  r.bindStartEvent = function(t21) {
    this._bindStartEvent(t21, !0)
  }, r.unbindStartEvent = function(t21) {
    this._bindStartEvent(t21, !1)
  }, r._bindStartEvent = function(t21, e2) {
    e2 = e2 === void 0 ? !0 : e2;
    var i2 = e2 ? "addEventListener" : "removeEventListener",
        n2 = "mousedown";
    s.PointerEvent ? n2 = "pointerdown" : "ontouchstart" in s && (n2 = "touchstart"), t21[i2](n2, this)
  }, r.handleEvent = function(t21) {
    var e2 = "on" + t21.type;
    this[e2] && this[e2](t21)
  }, r.getTouch = function(t21) {
    for (var e2 = 0; e2 < t21.length; e2++) {
      var i2 = t21[e2];
      if (i2.identifier == this.pointerIdentifier) return i2
    }
  }, r.onmousedown = function(t21) {
    var e2 = t21.button;
    e2 && e2 !== 0 && e2 !== 1 || this._pointerDown(t21, t21)
  }, r.ontouchstart = function(t21) {
    this._pointerDown(t21, t21.changedTouches[0])
  }, r.onpointerdown = function(t21) {
    this._pointerDown(t21, t21)
  }, r._pointerDown = function(t21, e2) {
    t21.button || this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = e2.pointerId !== void 0 ? e2.pointerId : e2.identifier, this.pointerDown(t21, e2))
  }, r.pointerDown = function(t21, e2) {
    this._bindPostStartEvents(t21), this.emitEvent("pointerDown", [t21, e2])
  };
  var o = {
    mousedown: ["mousemove", "mouseup"],
    touchstart: ["touchmove", "touchend", "touchcancel"],
    pointerdown: ["pointermove", "pointerup", "pointercancel"]
  };
  return r._bindPostStartEvents = function(t21) {
    if (t21) {
      var e2 = o[t21.type];
      e2.forEach(function(t22) {
        s.addEventListener(t22, this)
      }, this), this._boundPointerEvents = e2
    }
  }, r._unbindPostStartEvents = function() {
    this._boundPointerEvents && (this._boundPointerEvents.forEach(function(t21) {
      s.removeEventListener(t21, this)
    }, this), delete this._boundPointerEvents)
  }, r.onmousemove = function(t21) {
    this._pointerMove(t21, t21)
  }, r.onpointermove = function(t21) {
    t21.pointerId == this.pointerIdentifier && this._pointerMove(t21, t21)
  }, r.ontouchmove = function(t21) {
    var e2 = this.getTouch(t21.changedTouches);
    e2 && this._pointerMove(t21, e2)
  }, r._pointerMove = function(t21, e2) {
    this.pointerMove(t21, e2)
  }, r.pointerMove = function(t21, e2) {
    this.emitEvent("pointerMove", [t21, e2])
  }, r.onmouseup = function(t21) {
    this._pointerUp(t21, t21)
  }, r.onpointerup = function(t21) {
    t21.pointerId == this.pointerIdentifier && this._pointerUp(t21, t21)
  }, r.ontouchend = function(t21) {
    var e2 = this.getTouch(t21.changedTouches);
    e2 && this._pointerUp(t21, e2)
  }, r._pointerUp = function(t21, e2) {
    this._pointerDone(), this.pointerUp(t21, e2)
  }, r.pointerUp = function(t21, e2) {
    this.emitEvent("pointerUp", [t21, e2])
  }, r._pointerDone = function() {
    this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
  }, r._pointerReset = function() {
    this.isPointerDown = !1, delete this.pointerIdentifier
  }, r.pointerDone = i, r.onpointercancel = function(t21) {
    t21.pointerId == this.pointerIdentifier && this._pointerCancel(t21, t21)
  }, r.ontouchcancel = function(t21) {
    var e2 = this.getTouch(t21.changedTouches);
    e2 && this._pointerCancel(t21, e2)
  }, r._pointerCancel = function(t21, e2) {
    this._pointerDone(), this.pointerCancel(t21, e2)
  }, r.pointerCancel = function(t21, e2) {
    this.emitEvent("pointerCancel", [t21, e2])
  }, n.getPointerPoint = function(t21) {
    return {
      x: t21.pageX,
      y: t21.pageY
    }
  }, n
});
/*!
 * Unidragger v2.3.1
 * Draggable base class
 * MIT license
 */
(function(e, i) {
  typeof define == "function" && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function(t21) {
    return i(e, t21)
  }) : typeof module == "object" && module.exports ? module.exports = i(e, require("unipointer")) : e.Unidragger = i(e, e.Unipointer)
})(window, function t10(r, e) {
  function i() {}
  var n = i.prototype = Object.create(e.prototype);
  n.bindHandles = function() {
    this._bindHandles(!0)
  }, n.unbindHandles = function() {
    this._bindHandles(!1)
  }, n._bindHandles = function(t21) {
    t21 = t21 === void 0 ? !0 : t21;
    for (var e2 = t21 ? "addEventListener" : "removeEventListener", i2 = t21 ? this._touchActionValue : "", n2 = 0; n2 < this.handles.length; n2++) {
      var s2 = this.handles[n2];
      this._bindStartEvent(s2, t21), s2[e2]("click", this), r.PointerEvent && (s2.style.touchAction = i2)
    }
  }, n._touchActionValue = "none", n.pointerDown = function(t21, e2) {
    var i2 = this.okayPointerDown(t21);
    i2 && (this.pointerDownPointer = {
      pageX: e2.pageX,
      pageY: e2.pageY
    }, t21.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(t21), this.emitEvent("pointerDown", [t21, e2]))
  };
  var s = {
        TEXTAREA: !0,
        INPUT: !0,
        SELECT: !0,
        OPTION: !0
      },
      o = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0
      };
  return n.okayPointerDown = function(t21) {
    var e2 = s[t21.target.nodeName],
        i2 = o[t21.target.type],
        n2 = !e2 || i2;
    return n2 || this._pointerReset(), n2
  }, n.pointerDownBlur = function() {
    var t21 = document.activeElement,
        e2 = t21 && t21.blur && t21 != document.body;
    e2 && t21.blur()
  }, n.pointerMove = function(t21, e2) {
    var i2 = this._dragPointerMove(t21, e2);
    this.emitEvent("pointerMove", [t21, e2, i2]), this._dragMove(t21, e2, i2)
  }, n._dragPointerMove = function(t21, e2) {
    var i2 = {
      x: e2.pageX - this.pointerDownPointer.pageX,
      y: e2.pageY - this.pointerDownPointer.pageY
    };
    return !this.isDragging && this.hasDragStarted(i2) && this._dragStart(t21, e2), i2
  }, n.hasDragStarted = function(t21) {
    return Math.abs(t21.x) > 3 || Math.abs(t21.y) > 3
  }, n.pointerUp = function(t21, e2) {
    this.emitEvent("pointerUp", [t21, e2]), this._dragPointerUp(t21, e2)
  }, n._dragPointerUp = function(t21, e2) {
    this.isDragging ? this._dragEnd(t21, e2) : this._staticClick(t21, e2)
  }, n._dragStart = function(t21, e2) {
    this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(t21, e2)
  }, n.dragStart = function(t21, e2) {
    this.emitEvent("dragStart", [t21, e2])
  }, n._dragMove = function(t21, e2, i2) {
    this.isDragging && this.dragMove(t21, e2, i2)
  }, n.dragMove = function(t21, e2, i2) {
    t21.preventDefault(), this.emitEvent("dragMove", [t21, e2, i2])
  }, n._dragEnd = function(t21, e2) {
    this.isDragging = !1, setTimeout(function() {
      delete this.isPreventingClicks
    }.bind(this)), this.dragEnd(t21, e2)
  }, n.dragEnd = function(t21, e2) {
    this.emitEvent("dragEnd", [t21, e2])
  }, n.onclick = function(t21) {
    this.isPreventingClicks && t21.preventDefault()
  }, n._staticClick = function(t21, e2) {
    this.isIgnoringMouseUp && t21.type == "mouseup" || (this.staticClick(t21, e2), t21.type != "mouseup" && (this.isIgnoringMouseUp = !0, setTimeout(function() {
      delete this.isIgnoringMouseUp
    }.bind(this), 400)))
  }, n.staticClick = function(t21, e2) {
    this.emitEvent("staticClick", [t21, e2])
  }, i.getPointerPoint = e.getPointerPoint, i
}),
    function(n, s) {
      typeof define == "function" && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function(t21, e, i) {
        return s(n, t21, e, i)
      }) : typeof module == "object" && module.exports ? module.exports = s(n, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : n.Flickity = s(n, n.Flickity, n.Unidragger, n.fizzyUIUtils)
    }(window, function t11(n, e, i, a) {
      a.extend(e.defaults, {
        draggable: ">1",
        dragThreshold: 3
      }), e.createMethods.push("_createDrag");
      var s = e.prototype;
      a.extend(s, i.prototype), s._touchActionValue = "pan-y";
      var r = "createTouch" in document,
          o = !1;
      s._createDrag = function() {
        this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), r && !o && (n.addEventListener("touchmove", function() {}), o = !0)
      }, s.onActivateDrag = function() {
        this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
      }, s.onDeactivateDrag = function() {
        this.unbindHandles(), this.element.classList.remove("is-draggable")
      }, s.updateDraggable = function() {
        this.options.draggable == ">1" ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
      }, s.bindDrag = function() {
        this.options.draggable = !0, this.updateDraggable()
      }, s.unbindDrag = function() {
        this.options.draggable = !1, this.updateDraggable()
      }, s._uiChangeDrag = function() {
        delete this.isFreeScrolling
      }, s.pointerDown = function(t21, e2) {
        if (!this.isDraggable) {
          this._pointerDownDefault(t21, e2);
          return
        }
        var i2 = this.okayPointerDown(t21);
        i2 && (this._pointerDownPreventDefault(t21), this.pointerDownFocus(t21), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = h(), n.addEventListener("scroll", this), this._pointerDownDefault(t21, e2))
      }, s._pointerDownDefault = function(t21, e2) {
        this.pointerDownPointer = {
          pageX: e2.pageX,
          pageY: e2.pageY
        }, this._bindPostStartEvents(t21), this.dispatchEvent("pointerDown", t21, [e2])
      };
      var l = {
        INPUT: !0,
        TEXTAREA: !0,
        SELECT: !0
      };
      s.pointerDownFocus = function(t21) {
        var e2 = l[t21.target.nodeName];
        e2 || this.focus()
      }, s._pointerDownPreventDefault = function(t21) {
        var e2 = t21.type == "touchstart",
            i2 = t21.pointerType == "touch",
            n2 = l[t21.target.nodeName];
        !e2 && !i2 && !n2 && t21.preventDefault()
      }, s.hasDragStarted = function(t21) {
        return Math.abs(t21.x) > this.options.dragThreshold
      }, s.pointerUp = function(t21, e2) {
        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", t21, [e2]), this._dragPointerUp(t21, e2)
      }, s.pointerDone = function() {
        n.removeEventListener("scroll", this), delete this.pointerDownScroll
      }, s.dragStart = function(t21, e2) {
        this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), n.removeEventListener("scroll", this), this.dispatchEvent("dragStart", t21, [e2]))
      }, s.pointerMove = function(t21, e2) {
        var i2 = this._dragPointerMove(t21, e2);
        this.dispatchEvent("pointerMove", t21, [e2, i2]), this._dragMove(t21, e2, i2)
      }, s.dragMove = function(t21, e2, i2) {
        if (this.isDraggable) {
          t21.preventDefault(), this.previousDragX = this.dragX;
          var n2 = this.options.rightToLeft ? -1 : 1;
          this.options.wrapAround && (i2.x %= this.slideableWidth);
          var s2 = this.dragStartPosition + i2.x * n2;
          if (!this.options.wrapAround && this.slides.length) {
            var r2 = Math.max(-this.slides[0].target, this.dragStartPosition);
            s2 = s2 > r2 ? (s2 + r2) * .5 : s2;
            var o2 = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            s2 = s2 < o2 ? (s2 + o2) * .5 : s2
          }
          this.dragX = s2, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", t21, [e2, i2])
        }
      }, s.dragEnd = function(t21, e2) {
        if (this.isDraggable) {
          this.options.freeScroll && (this.isFreeScrolling = !0);
          var i2 = this.dragEndRestingSelect();
          if (this.options.freeScroll && !this.options.wrapAround) {
            var n2 = this.getRestingPosition();
            this.isFreeScrolling = -n2 > this.slides[0].target && -n2 < this.getLastSlide().target
          } else !this.options.freeScroll && i2 == this.selectedIndex && (i2 += this.dragEndBoostSelect());
          delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(i2), delete this.isDragSelect, this.dispatchEvent("dragEnd", t21, [e2])
        }
      }, s.dragEndRestingSelect = function() {
        var t21 = this.getRestingPosition(),
            e2 = Math.abs(this.getSlideDistance(-t21, this.selectedIndex)),
            i2 = this._getClosestResting(t21, e2, 1),
            n2 = this._getClosestResting(t21, e2, -1),
            s2 = i2.distance < n2.distance ? i2.index : n2.index;
        return s2
      }, s._getClosestResting = function(t21, e2, i2) {
        for (var n2 = this.selectedIndex, s2 = 1 / 0, r2 = this.options.contain && !this.options.wrapAround ? function(t22, e3) {
          return t22 <= e3
        } : function(t22, e3) {
          return t22 < e3
        }; r2(e2, s2) && (n2 += i2, s2 = e2, e2 = this.getSlideDistance(-t21, n2), e2 !== null);) e2 = Math.abs(e2);
        return {
          distance: s2,
          index: n2 - i2
        }
      }, s.getSlideDistance = function(t21, e2) {
        var i2 = this.slides.length,
            n2 = this.options.wrapAround && i2 > 1,
            s2 = n2 ? a.modulo(e2, i2) : e2,
            r2 = this.slides[s2];
        if (!r2) return null;
        var o2 = n2 ? this.slideableWidth * Math.floor(e2 / i2) : 0;
        return t21 - (r2.target + o2)
      }, s.dragEndBoostSelect = function() {
        if (this.previousDragX === void 0 || !this.dragMoveTime || new Date - this.dragMoveTime > 100) return 0;
        var t21 = this.getSlideDistance(-this.dragX, this.selectedIndex),
            e2 = this.previousDragX - this.dragX;
        return t21 > 0 && e2 > 0 ? 1 : t21 < 0 && e2 < 0 ? -1 : 0
      }, s.staticClick = function(t21, e2) {
        var i2 = this.getParentCell(t21.target),
            n2 = i2 && i2.element,
            s2 = i2 && this.cells.indexOf(i2);
        this.dispatchEvent("staticClick", t21, [e2, n2, s2])
      }, s.onscroll = function() {
        var t21 = h(),
            e2 = this.pointerDownScroll.x - t21.x,
            i2 = this.pointerDownScroll.y - t21.y;
        (Math.abs(e2) > 3 || Math.abs(i2) > 3) && this._pointerDone()
      };

      function h() {
        return {
          x: n.pageXOffset,
          y: n.pageYOffset
        }
      }
      return e
    }),
    function(n, s) {
      typeof define == "function" && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function(t21, e, i) {
        return s(n, t21, e, i)
      }) : typeof module == "object" && module.exports ? module.exports = s(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
    }(window, function t12(e, i, n, s) {
      "use strict";
      var r = "http://www.w3.org/2000/svg";

      function o(t21, e2) {
        this.direction = t21, this.parent = e2, this._create()
      }
      o.prototype = Object.create(n.prototype), o.prototype._create = function() {
        this.isEnabled = !0, this.isPrevious = this.direction == -1;
        var t21 = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == t21;
        var e2 = this.element = document.createElement("button");
        e2.className = "flickity-button flickity-prev-next-button", e2.className += this.isPrevious ? " previous" : " next", e2.setAttribute("type", "button"), this.disable(), e2.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        var i2 = this.createSVG();
        e2.appendChild(i2), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
      }, o.prototype.activate = function() {
        this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
      }, o.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this)
      }, o.prototype.createSVG = function() {
        var t21 = document.createElementNS(r, "svg");
        t21.setAttribute("class", "flickity-button-icon"), t21.setAttribute("viewBox", "0 0 100 100");
        var e2 = document.createElementNS(r, "path"),
            i2 = a(this.parent.options.arrowShape);
        return e2.setAttribute("d", i2), e2.setAttribute("class", "arrow"), this.isLeft || e2.setAttribute("transform", "translate(100, 100) rotate(180) "), t21.appendChild(e2), t21
      };

      function a(t21) {
        return typeof t21 == "string" ? t21 : "M " + t21.x0 + ",50 L " + t21.x1 + "," + (t21.y1 + 50) + " L " + t21.x2 + "," + (t21.y2 + 50) + " L " + t21.x3 + ",50  L " + t21.x2 + "," + (50 - t21.y2) + " L " + t21.x1 + "," + (50 - t21.y1) + " Z"
      }
      o.prototype.handleEvent = s.handleEvent, o.prototype.onclick = function() {
        if (this.isEnabled) {
          this.parent.uiChange();
          var t21 = this.isPrevious ? "previous" : "next";
          this.parent[t21]()
        }
      }, o.prototype.enable = function() {
        this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
      }, o.prototype.disable = function() {
        this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
      }, o.prototype.update = function() {
        var t21 = this.parent.slides;
        if (this.parent.options.wrapAround && t21.length > 1) {
          this.enable();
          return
        }
        var e2 = t21.length ? t21.length - 1 : 0,
            i2 = this.isPrevious ? 0 : e2,
            n2 = this.parent.selectedIndex == i2 ? "disable" : "enable";
        this[n2]()
      }, o.prototype.destroy = function() {
        this.deactivate(), this.allOff()
      }, s.extend(i.defaults, {
        prevNextButtons: !0,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 70,
          y2: 40,
          x3: 30
        }
      }), i.createMethods.push("_createPrevNextButtons");
      var l = i.prototype;
      return l._createPrevNextButtons = function() {
        this.options.prevNextButtons && (this.prevButton = new o(-1, this), this.nextButton = new o(1, this), this.on("activate", this.activatePrevNextButtons))
      }, l.activatePrevNextButtons = function() {
        this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
      }, l.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
      }, i.PrevNextButton = o, i
    }),
    function(n, s) {
      typeof define == "function" && define.amd ? define("flickity/js/page-dots", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function(t21, e, i) {
        return s(n, t21, e, i)
      }) : typeof module == "object" && module.exports ? module.exports = s(n, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils)
    }(window, function t13(e, i, n, s) {
      function r(t21) {
        this.parent = t21, this._create()
      }
      r.prototype = Object.create(n.prototype), r.prototype._create = function() {
        this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
      }, r.prototype.activate = function() {
        this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder)
      }, r.prototype.deactivate = function() {
        this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder)
      }, r.prototype.setDots = function() {
        var t21 = this.parent.slides.length - this.dots.length;
        t21 > 0 ? this.addDots(t21) : t21 < 0 && this.removeDots(-t21)
      }, r.prototype.addDots = function(t21) {
        for (var e2 = document.createDocumentFragment(), i2 = [], n2 = this.dots.length, s2 = n2 + t21, r2 = n2; r2 < s2; r2++) {
          var o2 = document.createElement("li");
          o2.className = "dot", o2.setAttribute("aria-label", "Page dot " + (r2 + 1)), e2.appendChild(o2), i2.push(o2)
        }
        this.holder.appendChild(e2), this.dots = this.dots.concat(i2)
      }, r.prototype.removeDots = function(t21) {
        var e2 = this.dots.splice(this.dots.length - t21, t21);
        e2.forEach(function(t22) {
          this.holder.removeChild(t22)
        }, this)
      }, r.prototype.updateSelected = function() {
        this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute("aria-current", "step"))
      }, r.prototype.onTap = r.prototype.onClick = function(t21) {
        var e2 = t21.target;
        if (e2.nodeName == "LI") {
          this.parent.uiChange();
          var i2 = this.dots.indexOf(e2);
          this.parent.select(i2)
        }
      }, r.prototype.destroy = function() {
        this.deactivate(), this.allOff()
      }, i.PageDots = r, s.extend(i.defaults, {
        pageDots: !0
      }), i.createMethods.push("_createPageDots");
      var o = i.prototype;
      return o._createPageDots = function() {
        this.options.pageDots && (this.pageDots = new r(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
      }, o.activatePageDots = function() {
        this.pageDots.activate()
      }, o.updateSelectedPageDots = function() {
        this.pageDots.updateSelected()
      }, o.updatePageDots = function() {
        this.pageDots.setDots()
      }, o.deactivatePageDots = function() {
        this.pageDots.deactivate()
      }, i.PageDots = r, i
    }),
    function(t21, n) {
      typeof define == "function" && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function(t22, e, i) {
        return n(t22, e, i)
      }) : typeof module == "object" && module.exports ? module.exports = n(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : n(t21.EvEmitter, t21.fizzyUIUtils, t21.Flickity)
    }(window, function t14(e, i, n) {
      function s(t21) {
        this.parent = t21, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
      }
      s.prototype = Object.create(e.prototype), s.prototype.play = function() {
        if (this.state != "playing") {
          var t21 = document.hidden;
          if (t21) {
            document.addEventListener("visibilitychange", this.onVisibilityPlay);
            return
          }
          this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()
        }
      }, s.prototype.tick = function() {
        if (this.state == "playing") {
          var t21 = this.parent.options.autoPlay;
          t21 = typeof t21 == "number" ? t21 : 3e3;
          var e2 = this;
          this.clear(), this.timeout = setTimeout(function() {
            e2.parent.next(!0), e2.tick()
          }, t21)
        }
      }, s.prototype.stop = function() {
        this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
      }, s.prototype.clear = function() {
        clearTimeout(this.timeout)
      }, s.prototype.pause = function() {
        this.state == "playing" && (this.state = "paused", this.clear())
      }, s.prototype.unpause = function() {
        this.state == "paused" && this.play()
      }, s.prototype.visibilityChange = function() {
        var t21 = document.hidden;
        this[t21 ? "pause" : "unpause"]()
      }, s.prototype.visibilityPlay = function() {
        this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
      }, i.extend(n.defaults, {
        pauseAutoPlayOnHover: !0
      }), n.createMethods.push("_createPlayer");
      var r = n.prototype;
      return r._createPlayer = function() {
        this.player = new s(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
      }, r.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
      }, r.playPlayer = function() {
        this.player.play()
      }, r.stopPlayer = function() {
        this.player.stop()
      }, r.pausePlayer = function() {
        this.player.pause()
      }, r.unpausePlayer = function() {
        this.player.unpause()
      }, r.deactivatePlayer = function() {
        this.player.stop(), this.element.removeEventListener("mouseenter", this)
      }, r.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
      }, r.onmouseleave = function() {
        this.player.unpause(), this.element.removeEventListener("mouseleave", this)
      }, n.Player = s, n
    }),
    function(i, n) {
      typeof define == "function" && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function(t21, e) {
        return n(i, t21, e)
      }) : typeof module == "object" && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
    }(window, function t15(e, i, n) {
      function l(t21) {
        var e2 = document.createDocumentFragment();
        return t21.forEach(function(t22) {
          e2.appendChild(t22.element)
        }), e2
      }
      var s = i.prototype;
      return s.insert = function(t21, e2) {
        var i2 = this._makeCells(t21);
        if (!(!i2 || !i2.length)) {
          var n2 = this.cells.length;
          e2 = e2 === void 0 ? n2 : e2;
          var s2 = l(i2),
              r = e2 == n2;
          if (r) this.slider.appendChild(s2);
          else {
            var o = this.cells[e2].element;
            this.slider.insertBefore(s2, o)
          }
          if (e2 === 0) this.cells = i2.concat(this.cells);
          else if (r) this.cells = this.cells.concat(i2);
          else {
            var a = this.cells.splice(e2, n2 - e2);
            this.cells = this.cells.concat(i2).concat(a)
          }
          this._sizeCells(i2), this.cellChange(e2, !0)
        }
      }, s.append = function(t21) {
        this.insert(t21, this.cells.length)
      }, s.prepend = function(t21) {
        this.insert(t21, 0)
      }, s.remove = function(t21) {
        var e2 = this.getCells(t21);
        if (!(!e2 || !e2.length)) {
          var i2 = this.cells.length - 1;
          e2.forEach(function(t22) {
            t22.remove();
            var e3 = this.cells.indexOf(t22);
            i2 = Math.min(e3, i2), n.removeFrom(this.cells, t22)
          }, this), this.cellChange(i2, !0)
        }
      }, s.cellSizeChange = function(t21) {
        var e2 = this.getCell(t21);
        if (e2) {
          e2.getSize();
          var i2 = this.cells.indexOf(e2);
          this.cellChange(i2)
        }
      }, s.cellChange = function(t21, e2) {
        var i2 = this.selectedElement;
        this._positionCells(t21), this._getWrapShiftCells(), this.setGallerySize();
        var n2 = this.getCell(i2);
        n2 && (this.selectedIndex = this.getCellSlideIndex(n2)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [t21]), this.select(this.selectedIndex), e2 && this.positionSliderAtSelected()
      }, i
    }),
    function(i, n) {
      typeof define == "function" && define.amd ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function(t21, e) {
        return n(i, t21, e)
      }) : typeof module == "object" && module.exports ? module.exports = n(i, require("./flickity"), require("fizzy-ui-utils")) : n(i, i.Flickity, i.fizzyUIUtils)
    }(window, function t16(e, i, o) {
      "use strict";
      i.createMethods.push("_createLazyload");
      var n = i.prototype;
      n._createLazyload = function() {
        this.on("select", this.lazyLoad)
      }, n.lazyLoad = function() {
        var t21 = this.options.lazyLoad;
        if (t21) {
          var e2 = typeof t21 == "number" ? t21 : 0,
              i2 = this.getAdjacentCellElements(e2),
              n2 = [];
          i2.forEach(function(t22) {
            var e3 = s(t22);
            n2 = n2.concat(e3)
          }), n2.forEach(function(t22) {
            new r(t22, this)
          }, this)
        }
      };

      function s(t21) {
        if (t21.nodeName == "IMG") {
          var e2 = t21.getAttribute("data-flickity-lazyload"),
              i2 = t21.getAttribute("data-flickity-lazyload-src"),
              n2 = t21.getAttribute("data-flickity-lazyload-srcset");
          if (e2 || i2 || n2) return [t21]
        }
        var s2 = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
            r2 = t21.querySelectorAll(s2);
        return o.makeArray(r2)
      }

      function r(t21, e2) {
        this.img = t21, this.flickity = e2, this.load()
      }
      return r.prototype.handleEvent = o.handleEvent, r.prototype.load = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this);
        var t21 = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
            e2 = this.img.getAttribute("data-flickity-lazyload-srcset");
        this.img.src = t21, e2 && this.img.setAttribute("srcset", e2), this.img.removeAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset")
      }, r.prototype.onload = function(t21) {
        this.complete(t21, "flickity-lazyloaded")
      }, r.prototype.onerror = function(t21) {
        this.complete(t21, "flickity-lazyerror")
      }, r.prototype.complete = function(t21, e2) {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
        var i2 = this.flickity.getParentCell(this.img),
            n2 = i2 && i2.element;
        this.flickity.cellSizeChange(n2), this.img.classList.add(e2), this.flickity.dispatchEvent("lazyLoad", t21, n2)
      }, i.LazyLoader = r, i
    });
/*!
 * Flickity v2.2.2
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */
(function(t21, e) {
  typeof define == "function" && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], e) : typeof module == "object" && module.exports && (module.exports = e(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")))
})(window, function t17(e) {
  return e
});
/*!
 * Flickity asNavFor v2.0.2
 * enable asNavFor for Flickity
 */
(function(t21, e) {
  typeof define == "function" && define.amd ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], e) : typeof module == "object" && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : t21.Flickity = e(t21.Flickity, t21.fizzyUIUtils)
})(window, function t18(n, s) {
  n.createMethods.push("_createAsNavFor");
  var e = n.prototype;
  e._createAsNavFor = function() {
    this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
    var e2 = this.options.asNavFor;
    if (e2) {
      var i = this;
      setTimeout(function() {
        i.setNavCompanion(e2)
      })
    }
  }, e.setNavCompanion = function(t21) {
    t21 = s.getQueryElement(t21);
    var e2 = n.data(t21);
    if (!(!e2 || e2 == this)) {
      this.navCompanion = e2;
      var i = this;
      this.onNavCompanionSelect = function() {
        i.navCompanionSelect()
      }, e2.on("select", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), this.navCompanionSelect(!0)
    }
  }, e.navCompanionSelect = function(t21) {
    var e2 = this.navCompanion && this.navCompanion.selectedCells;
    if (e2) {
      var i = e2[0],
          n2 = this.navCompanion.cells.indexOf(i),
          s2 = n2 + e2.length - 1,
          r = Math.floor(a(n2, s2, this.navCompanion.cellAlign));
      if (this.selectCell(r, !1, t21), this.removeNavSelectedElements(), !(r >= this.cells.length)) {
        var o = this.cells.slice(n2, s2 + 1);
        this.navSelectedElements = o.map(function(t22) {
          return t22.element
        }), this.changeNavSelectedClass("add")
      }
    }
  };

  function a(t21, e2, i) {
    return (e2 - t21) * i + t21
  }
  return e.changeNavSelectedClass = function(e2) {
    this.navSelectedElements.forEach(function(t21) {
      t21.classList[e2]("is-nav-selected")
    })
  }, e.activateAsNavFor = function() {
    this.navCompanionSelect(!0)
  }, e.removeNavSelectedElements = function() {
    this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements)
  }, e.onNavStaticClick = function(t21, e2, i, n2) {
    typeof n2 == "number" && this.navCompanion.selectCell(n2)
  }, e.deactivateAsNavFor = function() {
    this.removeNavSelectedElements()
  }, e.destroyAsNavFor = function() {
    this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion)
  }, n
});
/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
(function(e, i) {
  "use strict";
  typeof define == "function" && define.amd ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function(t21) {
    return i(e, t21)
  }) : typeof module == "object" && module.exports ? module.exports = i(e, require("ev-emitter")) : e.imagesLoaded = i(e, e.EvEmitter)
})(typeof window < "u" ? window : this, function t19(e, i) {
  var s = e.jQuery,
      r = e.console;

  function o(t21, e2) {
    for (var i2 in e2) t21[i2] = e2[i2];
    return t21
  }
  var n = Array.prototype.slice;

  function a(t21) {
    if (Array.isArray(t21)) return t21;
    var e2 = typeof t21 == "object" && typeof t21.length == "number";
    return e2 ? n.call(t21) : [t21]
  }

  function l(t21, e2, i2) {
    if (!(this instanceof l)) return new l(t21, e2, i2);
    var n2 = t21;
    if (typeof t21 == "string" && (n2 = document.querySelectorAll(t21)), !n2) {
      r.error("Bad element for imagesLoaded " + (n2 || t21));
      return
    }
    this.elements = a(n2), this.options = o({}, this.options), typeof e2 == "function" ? i2 = e2 : o(this.options, e2), i2 && this.on("always", i2), this.getImages(), s && (this.jqDeferred = new s.Deferred), setTimeout(this.check.bind(this))
  }
  l.prototype = Object.create(i.prototype), l.prototype.options = {}, l.prototype.getImages = function() {
    this.images = [], this.elements.forEach(this.addElementImages, this)
  }, l.prototype.addElementImages = function(t21) {
    t21.nodeName == "IMG" && this.addImage(t21), this.options.background === !0 && this.addElementBackgroundImages(t21);
    var e2 = t21.nodeType;
    if (!(!e2 || !h[e2])) {
      for (var i2 = t21.querySelectorAll("img"), n2 = 0; n2 < i2.length; n2++) {
        var s2 = i2[n2];
        this.addImage(s2)
      }
      if (typeof this.options.background == "string") {
        var r2 = t21.querySelectorAll(this.options.background);
        for (n2 = 0; n2 < r2.length; n2++) {
          var o2 = r2[n2];
          this.addElementBackgroundImages(o2)
        }
      }
    }
  };
  var h = {
    1: !0,
    9: !0,
    11: !0
  };
  l.prototype.addElementBackgroundImages = function(t21) {
    var e2 = getComputedStyle(t21);
    if (e2)
      for (var i2 = /url\((['"])?(.*?)\1\)/gi, n2 = i2.exec(e2.backgroundImage); n2 !== null;) {
        var s2 = n2 && n2[2];
        s2 && this.addBackground(s2, t21), n2 = i2.exec(e2.backgroundImage)
      }
  }, l.prototype.addImage = function(t21) {
    var e2 = new c(t21);
    this.images.push(e2)
  }, l.prototype.addBackground = function(t21, e2) {
    var i2 = new u(t21, e2);
    this.images.push(i2)
  }, l.prototype.check = function() {
    var n2 = this;
    if (this.progressedCount = 0, this.hasAnyBroken = !1, !this.images.length) {
      this.complete();
      return
    }

    function e2(t21, e3, i2) {
      setTimeout(function() {
        n2.progress(t21, e3, i2)
      })
    }
    this.images.forEach(function(t21) {
      t21.once("progress", e2), t21.check()
    })
  }, l.prototype.progress = function(t21, e2, i2) {
    this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t21.isLoaded, this.emitEvent("progress", [this, t21, e2]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t21), this.progressedCount == this.images.length && this.complete(), this.options.debug && r && r.log("progress: " + i2, t21, e2)
  }, l.prototype.complete = function() {
    var t21 = this.hasAnyBroken ? "fail" : "done";
    if (this.isComplete = !0, this.emitEvent(t21, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
      var e2 = this.hasAnyBroken ? "reject" : "resolve";
      this.jqDeferred[e2](this)
    }
  };

  function c(t21) {
    this.img = t21
  }
  c.prototype = Object.create(i.prototype), c.prototype.check = function() {
    var t21 = this.getIsImageComplete();
    if (t21) {
      this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
      return
    }
    this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src
  }, c.prototype.getIsImageComplete = function() {
    return this.img.complete && this.img.naturalWidth
  }, c.prototype.confirm = function(t21, e2) {
    this.isLoaded = t21, this.emitEvent("progress", [this, this.img, e2])
  }, c.prototype.handleEvent = function(t21) {
    var e2 = "on" + t21.type;
    this[e2] && this[e2](t21)
  }, c.prototype.onload = function() {
    this.confirm(!0, "onload"), this.unbindEvents()
  }, c.prototype.onerror = function() {
    this.confirm(!1, "onerror"), this.unbindEvents()
  }, c.prototype.unbindEvents = function() {
    this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
  };

  function u(t21, e2) {
    this.url = t21, this.element = e2, this.img = new Image
  }
  return u.prototype = Object.create(c.prototype), u.prototype.check = function() {
    this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;
    var t21 = this.getIsImageComplete();
    t21 && (this.confirm(this.img.naturalWidth !== 0, "naturalWidth"), this.unbindEvents())
  }, u.prototype.unbindEvents = function() {
    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
  }, u.prototype.confirm = function(t21, e2) {
    this.isLoaded = t21, this.emitEvent("progress", [this, this.element, e2])
  }, l.makeJQueryPlugin = function(t21) {
    t21 = t21 || e.jQuery, t21 && (s = t21, s.fn.imagesLoaded = function(t22, e2) {
      var i2 = new l(this, t22, e2);
      return i2.jqDeferred.promise(s(this))
    })
  }, l.makeJQueryPlugin(), l
});
/*!
 * Flickity imagesLoaded v2.0.0
 * enables imagesLoaded option for Flickity
 */
(function(i, n) {
  typeof define == "function" && define.amd ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function(t21, e) {
    return n(i, t21, e)
  }) : typeof module == "object" && module.exports ? module.exports = n(i, require("flickity"), require("imagesloaded")) : i.Flickity = n(i, i.Flickity, i.imagesLoaded)
})(window, function t20(e, i, s) {
  "use strict";
  i.createMethods.push("_createImagesLoaded");
  var n = i.prototype;
  return n._createImagesLoaded = function() {
    this.on("activate", this.imagesLoaded)
  }, n.imagesLoaded = function() {
    if (!this.options.imagesLoaded) return;
    var n2 = this;

    function t21(t22, e2) {
      var i2 = n2.getParentCell(e2.img);
      n2.cellSizeChange(i2 && i2.element), n2.options.freeScroll || n2.positionSliderAtSelected()
    }
    s(this.slider).on("progress", t21)
  }, i
});
/*!
 * imagesLoaded PACKAGED v4.1.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
(function(t21, e) {
  typeof define == "function" && define.amd ? define("ev-emitter/ev-emitter", e) : typeof module == "object" && module.exports ? module.exports = e() : t21.EvEmitter = e()
})(this, function() {
  function t21() {}
  var e = t21.prototype;
  return e.on = function(t22, e2) {
    if (t22 && e2) {
      var i = this._events = this._events || {},
          n = i[t22] = i[t22] || [];
      return n.indexOf(e2) == -1 && n.push(e2), this
    }
  }, e.once = function(t22, e2) {
    if (t22 && e2) {
      this.on(t22, e2);
      var i = this._onceEvents = this._onceEvents || {},
          n = i[t22] = i[t22] || [];
      return n[e2] = !0, this
    }
  }, e.off = function(t22, e2) {
    var i = this._events && this._events[t22];
    if (i && i.length) {
      var n = i.indexOf(e2);
      return n != -1 && i.splice(n, 1), this
    }
  }, e.emitEvent = function(t22, e2) {
    var i = this._events && this._events[t22];
    if (i && i.length) {
      var n = 0,
          o = i[n];
      e2 = e2 || [];
      for (var r = this._onceEvents && this._onceEvents[t22]; o;) {
        var s = r && r[o];
        s && (this.off(t22, o), delete r[o]), o.apply(this, e2), n += s ? 0 : 1, o = i[n]
      }
      return this
    }
  }, t21
}),
    function(t21, e) {
      "use strict";
      typeof define == "function" && define.amd ? define(["ev-emitter/ev-emitter"], function(i) {
        return e(t21, i)
      }) : typeof module == "object" && module.exports ? module.exports = e(t21, require("ev-emitter")) : t21.imagesLoaded = e(t21, t21.EvEmitter)
    }(window, function(t21, e) {
      function i(t22, e2) {
        for (var i2 in e2) t22[i2] = e2[i2];
        return t22
      }

      function n(t22) {
        var e2 = [];
        if (Array.isArray(t22)) e2 = t22;
        else if (typeof t22.length == "number")
          for (var i2 = 0; i2 < t22.length; i2++) e2.push(t22[i2]);
        else e2.push(t22);
        return e2
      }

      function o(t22, e2, r2) {
        return this instanceof o ? (typeof t22 == "string" && (t22 = document.querySelectorAll(t22)), this.elements = n(t22), this.options = i({}, this.options), typeof e2 == "function" ? r2 = e2 : i(this.options, e2), r2 && this.on("always", r2), this.getImages(), h && (this.jqDeferred = new h.Deferred), void setTimeout(function() {
          this.check()
        }.bind(this))) : new o(t22, e2, r2)
      }

      function r(t22) {
        this.img = t22
      }

      function s(t22, e2) {
        this.url = t22, this.element = e2, this.img = new Image
      }
      var h = t21.jQuery,
          a = t21.console;
      o.prototype = Object.create(e.prototype), o.prototype.options = {}, o.prototype.getImages = function() {
        this.images = [], this.elements.forEach(this.addElementImages, this)
      }, o.prototype.addElementImages = function(t22) {
        t22.nodeName == "IMG" && this.addImage(t22), this.options.background === !0 && this.addElementBackgroundImages(t22);
        var e2 = t22.nodeType;
        if (e2 && d[e2]) {
          for (var i2 = t22.querySelectorAll("img"), n2 = 0; n2 < i2.length; n2++) {
            var o2 = i2[n2];
            this.addImage(o2)
          }
          if (typeof this.options.background == "string") {
            var r2 = t22.querySelectorAll(this.options.background);
            for (n2 = 0; n2 < r2.length; n2++) {
              var s2 = r2[n2];
              this.addElementBackgroundImages(s2)
            }
          }
        }
      };
      var d = {
        1: !0,
        9: !0,
        11: !0
      };
      return o.prototype.addElementBackgroundImages = function(t22) {
        var e2 = getComputedStyle(t22);
        if (e2)
          for (var i2 = /url\((['"])?(.*?)\1\)/gi, n2 = i2.exec(e2.backgroundImage); n2 !== null;) {
            var o2 = n2 && n2[2];
            o2 && this.addBackground(o2, t22), n2 = i2.exec(e2.backgroundImage)
          }
      }, o.prototype.addImage = function(t22) {
        var e2 = new r(t22);
        this.images.push(e2)
      }, o.prototype.addBackground = function(t22, e2) {
        var i2 = new s(t22, e2);
        this.images.push(i2)
      }, o.prototype.check = function() {
        function t22(t23, i2, n2) {
          setTimeout(function() {
            e2.progress(t23, i2, n2)
          })
        }
        var e2 = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function(e3) {
          e3.once("progress", t22), e3.check()
        }) : void this.complete()
      }, o.prototype.progress = function(t22, e2, i2) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t22.isLoaded, this.emitEvent("progress", [this, t22, e2]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t22), this.progressedCount == this.images.length && this.complete(), this.options.debug && a && a.log("progress: " + i2, t22, e2)
      }, o.prototype.complete = function() {
        var t22 = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(t22, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
          var e2 = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[e2](this)
        }
      }, r.prototype = Object.create(e.prototype), r.prototype.check = function() {
        var t22 = this.getIsImageComplete();
        return t22 ? void this.confirm(this.img.naturalWidth !== 0, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void(this.proxyImage.src = this.img.src))
      }, r.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth !== void 0
      }, r.prototype.confirm = function(t22, e2) {
        this.isLoaded = t22, this.emitEvent("progress", [this, this.img, e2])
      }, r.prototype.handleEvent = function(t22) {
        var e2 = "on" + t22.type;
        this[e2] && this[e2](t22)
      }, r.prototype.onload = function() {
        this.confirm(!0, "onload"), this.unbindEvents()
      }, r.prototype.onerror = function() {
        this.confirm(!1, "onerror"), this.unbindEvents()
      }, r.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
      }, s.prototype = Object.create(r.prototype), s.prototype.check = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;
        var t22 = this.getIsImageComplete();
        t22 && (this.confirm(this.img.naturalWidth !== 0, "naturalWidth"), this.unbindEvents())
      }, s.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
      }, s.prototype.confirm = function(t22, e2) {
        this.isLoaded = t22, this.emitEvent("progress", [this, this.element, e2])
      }, o.makeJQueryPlugin = function(e2) {
        e2 = e2 || t21.jQuery, e2 && (h = e2, h.fn.imagesLoaded = function(t22, e3) {
          var i2 = new o(this, t22, e3);
          return i2.jqDeferred.promise(h(this))
        })
      }, o.makeJQueryPlugin(), o
    }), PaloAlto.isInViewport = function(el) {
  const rect = el.getBoundingClientRect(),
      windowHeight = window.innerHeight || document.documentElement.clientHeight,
      windowWidth = window.innerWidth || document.documentElement.clientWidth,
      vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0,
      horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
  return vertInView && horInView
},
    function(o) {
      var t21 = null;
      o.modal = function(e, i) {
        o.modal.close();
        var s, l;
        if (this.$body = o("body"), this.options = o.extend({}, o.modal.defaults, i), this.options.doFade = !isNaN(parseInt(this.options.fadeDuration, 10)), e.is("a"))
          if (l = e.attr("href"), /^#/.test(l)) {
            if (this.$elm = o(l), this.$elm.length !== 1) return null;
            this.$body.append(this.$elm), this.open()
          } else this.$elm = o("<div>"), this.$body.append(this.$elm), s = function(o2, t22) {
            t22.elm.remove()
          }, this.showSpinner(), e.trigger(o.modal.AJAX_SEND), o.get(l).done(function(i2) {
            t21 && (e.trigger(o.modal.AJAX_SUCCESS), t21.$elm.empty().append(i2).on(o.modal.CLOSE, s), t21.hideSpinner(), t21.open(), e.trigger(o.modal.AJAX_COMPLETE))
          }).fail(function() {
            e.trigger(o.modal.AJAX_FAIL), t21.hideSpinner(), e.trigger(o.modal.AJAX_COMPLETE)
          });
        else this.$elm = e, this.$body.append(this.$elm), this.open()
      }, o.modal.prototype = {
        constructor: o.modal,
        open: function() {
          var t22 = this;
          this.options.doFade ? (this.block(), setTimeout(function() {
            t22.show()
          }, this.options.fadeDuration * this.options.fadeDelay)) : (this.block(), this.show()), this.options.escapeClose && o(document).on("keydown.modal", function(t23) {
            t23.which == 27 && o.modal.close()
          }), this.options.clickClose && this.blocker.click(function(t23) {
            t23.target == this && o.modal.close()
          })
        },
        close: function() {
          this.unblock(), this.hide(), o(document).off("keydown.modal")
        },
        block: function() {
          this.$elm.trigger(o.modal.BEFORE_BLOCK, [this._ctx()]), this.blocker = o('<div class="jquery-modal blocker"></div>'), this.$body.css("overflow", "hidden"), this.$body.append(this.blocker), this.options.doFade && this.blocker.css("opacity", 0).animate({
            opacity: 1
          }, this.options.fadeDuration), this.$elm.trigger(o.modal.BLOCK, [this._ctx()])
        },
        unblock: function() {
          if (this.options.doFade) {
            var o2 = this;
            this.blocker.fadeOut(this.options.fadeDuration, function() {
              o2.blocker.children().appendTo(o2.$body), o2.blocker.remove(), o2.$body.css("overflow", "")
            })
          } else this.blocker.children().appendTo(this.$body), this.blocker.remove(), this.$body.css("overflow", "")
        },
        show: function() {
          this.$elm.trigger(o.modal.BEFORE_OPEN, [this._ctx()]), this.options.showClose && (this.closeButton = o('<a href="#close-modal" rel="modal:close" class="close-modal ' + this.options.closeClass + '">' + this.options.closeText + "</a>"), this.$elm.append(this.closeButton)), this.$elm.addClass(this.options.modalClass + " current"), this.$elm.appendTo(this.blocker), this.options.doFade ? this.$elm.css("opacity", 0).show().animate({
            opacity: 1
          }, this.options.fadeDuration) : this.$elm.show(), this.$elm.trigger(o.modal.OPEN, [this._ctx()])
        },
        hide: function() {
          this.$elm.trigger(o.modal.BEFORE_CLOSE, [this._ctx()]), this.closeButton && this.closeButton.remove(), this.$elm.removeClass("current");
          var t22 = this;
          this.options.doFade ? this.$elm.fadeOut(this.options.fadeDuration, function() {
            t22.$elm.trigger(o.modal.AFTER_CLOSE, [t22._ctx()])
          }) : this.$elm.hide(0, function() {
            t22.$elm.trigger(o.modal.AFTER_CLOSE, [t22._ctx()])
          }), this.$elm.trigger(o.modal.CLOSE, [this._ctx()])
        },
        showSpinner: function() {
          this.options.showSpinner && (this.spinner = this.spinner || o('<div class="' + this.options.modalClass + '-spinner"></div>').append(this.options.spinnerHtml), this.$body.append(this.spinner), this.spinner.show())
        },
        hideSpinner: function() {
          this.spinner && this.spinner.remove()
        },
        _ctx: function() {
          return {
            elm: this.$elm,
            blocker: this.blocker,
            options: this.options
          }
        }
      }, o.modal.close = function(o2) {
        if (t21) {
          o2 && o2.preventDefault(), t21.close();
          var e = t21.$elm;
          return t21 = null, e
        }
      }, o.modal.isActive = function() {
        return !!t21
      }, o.modal.defaults = {
        escapeClose: !0,
        clickClose: !0,
        closeText: "",
        closeClass: "",
        modalClass: "modal",
        spinnerHtml: null,
        showSpinner: !0,
        showClose: !0,
        fadeDuration: null,
        fadeDelay: 1
      }, o.modal.BEFORE_BLOCK = "modal:before-block", o.modal.BLOCK = "modal:block", o.modal.BEFORE_OPEN = "modal:before-open", o.modal.OPEN = "modal:open", o.modal.BEFORE_CLOSE = "modal:before-close", o.modal.CLOSE = "modal:close", o.modal.AFTER_CLOSE = "modal:after-close", o.modal.AJAX_SEND = "modal:ajax:send", o.modal.AJAX_SUCCESS = "modal:ajax:success", o.modal.AJAX_FAIL = "modal:ajax:fail", o.modal.AJAX_COMPLETE = "modal:ajax:complete", o.fn.modal = function(e) {
        return this.length === 1 && (t21 = new o.modal(this, e)), this
      }, o(document).on("click.modal", 'a[rel="modal:close"]', o.modal.close), o(document).on("click.modal", 'a[rel="modal:open"]', function(t22) {
        t22.preventDefault(), o(this).modal()
      })
    }(jQuery);
/**
 * @license
 * Lodash 4.17.15 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
(function() {
  function n(n2) {
    return H(n2) && pn.call(n2, "callee") && !yn.call(n2, "callee")
  }

  function t21(n2, t22) {
    return n2.push.apply(n2, t22), n2
  }

  function r(n2) {
    return function(t22) {
      return t22 == null ? Z : t22[n2]
    }
  }

  function e(n2, t22, r2, e2, u2) {
    return u2(n2, function(n3, u3, o2) {
      r2 = e2 ? (e2 = !1, n3) : t22(r2, n3, u3, o2)
    }), r2
  }

  function u(n2, t22) {
    return j(t22, function(t23) {
      return n2[t23]
    })
  }

  function o(n2) {
    return n2 instanceof i ? n2 : new i(n2)
  }

  function i(n2, t22) {
    this.__wrapped__ = n2, this.__actions__ = [], this.__chain__ = !!t22
  }

  function c(n2, t22, r2) {
    if (typeof n2 != "function") throw new TypeError("Expected a function");
    return setTimeout(function() {
      n2.apply(Z, r2)
    }, t22)
  }

  function f(n2, t22) {
    var r2 = !0;
    return mn(n2, function(n3, e2, u2) {
      return r2 = !!t22(n3, e2, u2)
    }), r2
  }

  function a(n2, t22, r2) {
    for (var e2 = -1, u2 = n2.length; ++e2 < u2;) {
      var o2 = n2[e2],
          i2 = t22(o2);
      if (i2 != null && (c2 === Z ? i2 === i2 : r2(i2, c2))) var c2 = i2,
          f2 = o2
    }
    return f2
  }

  function l(n2, t22) {
    var r2 = [];
    return mn(n2, function(n3, e2, u2) {
      t22(n3, e2, u2) && r2.push(n3)
    }), r2
  }

  function p(n2, r2, e2, u2, o2) {
    var i2 = -1,
        c2 = n2.length;
    for (e2 || (e2 = R), o2 || (o2 = []); ++i2 < c2;) {
      var f2 = n2[i2];
      0 < r2 && e2(f2) ? 1 < r2 ? p(f2, r2 - 1, e2, u2, o2) : t21(o2, f2) : u2 || (o2[o2.length] = f2)
    }
    return o2
  }

  function s(n2, t22) {
    return n2 && On(n2, t22, Dn)
  }

  function h(n2, t22) {
    return l(t22, function(t23) {
      return U(n2[t23])
    })
  }

  function v(n2, t22) {
    return n2 > t22
  }

  function b(n2, t22, r2, e2, u2) {
    return n2 === t22 || (n2 == null || t22 == null || !H(n2) && !H(t22) ? n2 !== n2 && t22 !== t22 : y(n2, t22, r2, e2, b, u2))
  }

  function y(n2, t22, r2, e2, u2, o2) {
    var i2 = Nn(n2),
        c2 = Nn(t22),
        f2 = i2 ? "[object Array]" : hn.call(n2),
        a2 = c2 ? "[object Array]" : hn.call(t22),
        f2 = f2 == "[object Arguments]" ? "[object Object]" : f2,
        a2 = a2 == "[object Arguments]" ? "[object Object]" : a2,
        l2 = f2 == "[object Object]",
        c2 = a2 == "[object Object]",
        a2 = f2 == a2;
    o2 || (o2 = []);
    var p2 = An(o2, function(t23) {
          return t23[0] == n2
        }),
        s2 = An(o2, function(n3) {
          return n3[0] == t22
        });
    if (p2 && s2) return p2[1] == t22;
    if (o2.push([n2, t22]), o2.push([t22, n2]), a2 && !l2) {
      if (i2) r2 = T(n2, t22, r2, e2, u2, o2);
      else n: {
        switch (f2) {
          case "[object Boolean]":
          case "[object Date]":
          case "[object Number]":
            r2 = J(+n2, +t22);
            break n;
          case "[object Error]":
            r2 = n2.name == t22.name && n2.message == t22.message;
            break n;
          case "[object RegExp]":
          case "[object String]":
            r2 = n2 == t22 + "";
            break n
        }
        r2 = !1
      }
      return o2.pop(), r2
    }
    return 1 & r2 || (i2 = l2 && pn.call(n2, "__wrapped__"), f2 = c2 && pn.call(t22, "__wrapped__"), !i2 && !f2) ? !!a2 && (r2 = B(n2, t22, r2, e2, u2, o2), o2.pop(), r2) : (i2 = i2 ? n2.value() : n2, f2 = f2 ? t22.value() : t22, r2 = u2(i2, f2, r2, e2, o2), o2.pop(), r2)
  }

  function g(n2) {
    return typeof n2 == "function" ? n2 : n2 == null ? X : (typeof n2 == "object" ? d : r)(n2)
  }

  function _2(n2, t22) {
    return n2 < t22
  }

  function j(n2, t22) {
    var r2 = -1,
        e2 = M(n2) ? Array(n2.length) : [];
    return mn(n2, function(n3, u2, o2) {
      e2[++r2] = t22(n3, u2, o2)
    }), e2
  }

  function d(n2) {
    var t22 = _n(n2);
    return function(r2) {
      var e2 = t22.length;
      if (r2 == null) return !e2;
      for (r2 = Object(r2); e2--;) {
        var u2 = t22[e2];
        if (!(u2 in r2 && b(n2[u2], r2[u2], 3))) return !1
      }
      return !0
    }
  }

  function m(n2, t22) {
    return n2 = Object(n2), C(t22, function(t23, r2) {
      return r2 in n2 && (t23[r2] = n2[r2]), t23
    }, {})
  }

  function O(n2) {
    return xn(I(n2, void 0, X), n2 + "")
  }

  function x(n2, t22, r2) {
    var e2 = -1,
        u2 = n2.length;
    for (0 > t22 && (t22 = -t22 > u2 ? 0 : u2 + t22), r2 = r2 > u2 ? u2 : r2, 0 > r2 && (r2 += u2), u2 = t22 > r2 ? 0 : r2 - t22 >>> 0, t22 >>>= 0, r2 = Array(u2); ++e2 < u2;) r2[e2] = n2[e2 + t22];
    return r2
  }

  function A(n2) {
    return x(n2, 0, n2.length)
  }

  function E(n2, t22) {
    var r2;
    return mn(n2, function(n3, e2, u2) {
      return r2 = t22(n3, e2, u2), !r2
    }), !!r2
  }

  function w(n2, r2) {
    return C(r2, function(n3, r3) {
      return r3.func.apply(r3.thisArg, t21([n3], r3.args))
    }, n2)
  }

  function k(n2, t22, r2) {
    var e2 = !r2;
    r2 || (r2 = {});
    for (var u2 = -1, o2 = t22.length; ++u2 < o2;) {
      var i2 = t22[u2],
          c2 = Z;
      if (c2 === Z && (c2 = n2[i2]), e2) r2[i2] = c2;
      else {
        var f2 = r2,
            a2 = f2[i2];
        pn.call(f2, i2) && J(a2, c2) && (c2 !== Z || i2 in f2) || (f2[i2] = c2)
      }
    }
    return r2
  }

  function N(n2) {
    return O(function(t22, r2) {
      var e2 = -1,
          u2 = r2.length,
          o2 = 1 < u2 ? r2[u2 - 1] : Z,
          o2 = 3 < n2.length && typeof o2 == "function" ? (u2--, o2) : Z;
      for (t22 = Object(t22); ++e2 < u2;) {
        var i2 = r2[e2];
        i2 && n2(t22, i2, e2, o2)
      }
      return t22
    })
  }

  function F(n2) {
    return function() {
      var t22 = arguments,
          r2 = dn(n2.prototype),
          t22 = n2.apply(r2, t22);
      return V(t22) ? t22 : r2
    }
  }

  function S(n2, t22, r2) {
    function e2() {
      for (var o2 = -1, i2 = arguments.length, c2 = -1, f2 = r2.length, a2 = Array(f2 + i2), l2 = this && this !== on && this instanceof e2 ? u2 : n2; ++c2 < f2;) a2[c2] = r2[c2];
      for (; i2--;) a2[c2++] = arguments[++o2];
      return l2.apply(t22, a2)
    }
    if (typeof n2 != "function") throw new TypeError("Expected a function");
    var u2 = F(n2);
    return e2
  }

  function T(n2, t22, r2, e2, u2, o2) {
    var i2 = n2.length,
        c2 = t22.length;
    if (i2 != c2 && !(1 & r2 && c2 > i2)) return !1;
    for (var c2 = -1, f2 = !0, a2 = 2 & r2 ? [] : Z; ++c2 < i2;) {
      var l2 = n2[c2],
          p2 = t22[c2];
      if (Z !== void 0) {
        f2 = !1;
        break
      }
      if (a2) {
        if (!E(t22, function(n3, t23) {
          if (!P(a2, t23) && (l2 === n3 || u2(l2, n3, r2, e2, o2))) return a2.push(t23)
        })) {
          f2 = !1;
          break
        }
      } else if (l2 !== p2 && !u2(l2, p2, r2, e2, o2)) {
        f2 = !1;
        break
      }
    }
    return f2
  }

  function B(n2, t22, r2, e2, u2, o2) {
    var i2 = 1 & r2,
        c2 = Dn(n2),
        f2 = c2.length,
        a2 = Dn(t22).length;
    if (f2 != a2 && !i2) return !1;
    for (var l2 = f2; l2--;) {
      var p2 = c2[l2];
      if (!(i2 ? p2 in t22 : pn.call(t22, p2))) return !1
    }
    for (a2 = !0; ++l2 < f2;) {
      var p2 = c2[l2],
          s2 = n2[p2],
          h2 = t22[p2];
      if (Z !== void 0 || s2 !== h2 && !u2(s2, h2, r2, e2, o2)) {
        a2 = !1;
        break
      }
      i2 || (i2 = p2 == "constructor")
    }
    return a2 && !i2 && (r2 = n2.constructor, e2 = t22.constructor, r2 != e2 && "constructor" in n2 && "constructor" in t22 && !(typeof r2 == "function" && r2 instanceof r2 && typeof e2 == "function" && e2 instanceof e2) && (a2 = !1)), a2
  }

  function R(t22) {
    return Nn(t22) || n(t22)
  }

  function D(n2) {
    var t22 = [];
    if (n2 != null)
      for (var r2 in Object(n2)) t22.push(r2);
    return t22
  }

  function I(n2, t22, r2) {
    return t22 = jn(t22 === Z ? n2.length - 1 : t22, 0),
        function() {
          for (var e2 = arguments, u2 = -1, o2 = jn(e2.length - t22, 0), i2 = Array(o2); ++u2 < o2;) i2[u2] = e2[t22 + u2];
          for (u2 = -1, o2 = Array(t22 + 1); ++u2 < t22;) o2[u2] = e2[u2];
          return o2[t22] = r2(i2), n2.apply(this, o2)
        }
  }

  function $2(n2) {
    return n2 != null && n2.length ? p(n2, 1) : []
  }

  function q(n2) {
    return n2 && n2.length ? n2[0] : Z
  }

  function P(n2, t22, r2) {
    var e2 = n2 == null ? 0 : n2.length;
    r2 = typeof r2 == "number" ? 0 > r2 ? jn(e2 + r2, 0) : r2 : 0, r2 = (r2 || 0) - 1;
    for (var u2 = t22 === t22; ++r2 < e2;) {
      var o2 = n2[r2];
      if (u2 ? o2 === t22 : o2 !== o2) return r2
    }
    return -1
  }

  function z(n2, t22) {
    return mn(n2, g(t22))
  }

  function C(n2, t22, r2) {
    return e(n2, g(t22), r2, 3 > arguments.length, mn)
  }

  function G(n2, t22) {
    var r2;
    if (typeof t22 != "function") throw new TypeError("Expected a function");
    return n2 = Fn(n2),
        function() {
          return 0 < --n2 && (r2 = t22.apply(this, arguments)), 1 >= n2 && (t22 = Z), r2
        }
  }

  function J(n2, t22) {
    return n2 === t22 || n2 !== n2 && t22 !== t22
  }

  function M(n2) {
    var t22;
    return (t22 = n2 != null) && (t22 = n2.length, t22 = typeof t22 == "number" && -1 < t22 && t22 % 1 == 0 && 9007199254740991 >= t22), t22 && !U(n2)
  }

  function U(n2) {
    return !!V(n2) && (n2 = hn.call(n2), n2 == "[object Function]" || n2 == "[object GeneratorFunction]" || n2 == "[object AsyncFunction]" || n2 == "[object Proxy]")
  }

  function V(n2) {
    var t22 = typeof n2;
    return n2 != null && (t22 == "object" || t22 == "function")
  }

  function H(n2) {
    return n2 != null && typeof n2 == "object"
  }

  function K(n2) {
    return typeof n2 == "number" || H(n2) && hn.call(n2) == "[object Number]"
  }

  function L(n2) {
    return typeof n2 == "string" || !Nn(n2) && H(n2) && hn.call(n2) == "[object String]"
  }

  function Q(n2) {
    return typeof n2 == "string" ? n2 : n2 == null ? "" : n2 + ""
  }

  function W(n2) {
    return n2 == null ? [] : u(n2, Dn(n2))
  }

  function X(n2) {
    return n2
  }

  function Y(n2, r2, e2) {
    var u2 = Dn(r2),
        o2 = h(r2, u2);
    e2 != null || V(r2) && (o2.length || !u2.length) || (e2 = r2, r2 = n2, n2 = this, o2 = h(r2, Dn(r2)));
    var i2 = !(V(e2) && "chain" in e2 && !e2.chain),
        c2 = U(n2);
    return mn(o2, function(e3) {
      var u3 = r2[e3];
      n2[e3] = u3, c2 && (n2.prototype[e3] = function() {
        var r3 = this.__chain__;
        if (i2 || r3) {
          var e4 = n2(this.__wrapped__);
          return (e4.__actions__ = A(this.__actions__)).push({
            func: u3,
            args: arguments,
            thisArg: n2
          }), e4.__chain__ = r3, e4
        }
        return u3.apply(n2, t21([this.value()], arguments))
      })
    }), n2
  }
  var Z, nn = 1 / 0,
      tn = /[&<>"']/g,
      rn = RegExp(tn.source),
      en = /^(?:0|[1-9]\d*)$/,
      un = typeof self == "object" && self && self.Object === Object && self,
      on = typeof global == "object" && global && global.Object === Object && global || un || Function("return this")(),
      cn = (un = typeof exports == "object" && exports && !exports.nodeType && exports) && typeof module == "object" && module && !module.nodeType && module,
      fn = function(n2) {
        return function(t22) {
          return n2 == null ? Z : n2[t22]
        }
      }({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }),
      an = Array.prototype,
      ln = Object.prototype,
      pn = ln.hasOwnProperty,
      sn = 0,
      hn = ln.toString,
      vn = on._,
      bn = Object.create,
      yn = ln.propertyIsEnumerable,
      gn = on.isFinite,
      _n = function(n2, t22) {
        return function(r2) {
          return n2(t22(r2))
        }
      }(Object.keys, Object),
      jn = Math.max,
      dn = function() {
        function n2() {}
        return function(t22) {
          return V(t22) ? bn ? bn(t22) : (n2.prototype = t22, t22 = new n2, n2.prototype = Z, t22) : {}
        }
      }();
  i.prototype = dn(o.prototype), i.prototype.constructor = i;
  var mn = function(n2, t22) {
        return function(r2, e2) {
          if (r2 == null) return r2;
          if (!M(r2)) return n2(r2, e2);
          for (var u2 = r2.length, o2 = t22 ? u2 : -1, i2 = Object(r2);
               (t22 ? o2-- : ++o2 < u2) && e2(i2[o2], o2, i2) !== !1;);
          return r2
        }
      }(s),
      On = function(n2) {
        return function(t22, r2, e2) {
          var u2 = -1,
              o2 = Object(t22);
          e2 = e2(t22);
          for (var i2 = e2.length; i2--;) {
            var c2 = e2[n2 ? i2 : ++u2];
            if (r2(o2[c2], c2, o2) === !1) break
          }
          return t22
        }
      }(),
      xn = X,
      An = function(n2) {
        return function(t22, r2, e2) {
          var u2 = Object(t22);
          if (!M(t22)) {
            var o2 = g(r2);
            t22 = Dn(t22), r2 = function(n3) {
              return o2(u2[n3], n3, u2)
            }
          }
          return r2 = n2(t22, r2, e2), -1 < r2 ? u2[o2 ? t22[r2] : r2] : Z
        }
      }(function(n2, t22, r2) {
        var e2 = n2 == null ? 0 : n2.length;
        if (!e2) return -1;
        r2 = r2 == null ? 0 : Fn(r2), 0 > r2 && (r2 = jn(e2 + r2, 0));
        n: {
          for (t22 = g(t22), e2 = n2.length, r2 += -1; ++r2 < e2;)
            if (t22(n2[r2], r2, n2)) {
              n2 = r2;
              break n
            } n2 = -1
        }
        return n2
      }),
      En = O(function(n2, t22, r2) {
        return S(n2, t22, r2)
      }),
      wn = O(function(n2, t22) {
        return c(n2, 1, t22)
      }),
      kn = O(function(n2, t22, r2) {
        return c(n2, Sn(t22) || 0, r2)
      }),
      Nn = Array.isArray,
      Fn = Number,
      Sn = Number,
      Tn = N(function(n2, t22) {
        k(t22, _n(t22), n2)
      }),
      Bn = N(function(n2, t22) {
        k(t22, D(t22), n2)
      }),
      Rn = O(function(n2, t22) {
        n2 = Object(n2);
        var r2, e2 = -1,
            u2 = t22.length,
            o2 = 2 < u2 ? t22[2] : Z;
        if (r2 = o2) {
          r2 = t22[0];
          var i2 = t22[1];
          if (V(o2)) {
            var c2 = typeof i2;
            if (c2 == "number") {
              if (c2 = M(o2)) var c2 = o2.length,
                  f2 = typeof i2,
                  c2 = c2 ?? 9007199254740991,
                  c2 = !!c2 && (f2 == "number" || f2 != "symbol" && en.test(i2)) && -1 < i2 && i2 % 1 == 0 && i2 < c2
            } else c2 = c2 == "string" && i2 in o2;
            r2 = !!c2 && J(o2[i2], r2)
          } else r2 = !1
        }
        for (r2 && (u2 = 1); ++e2 < u2;)
          for (o2 = t22[e2], r2 = In(o2), i2 = -1, c2 = r2.length; ++i2 < c2;) {
            var f2 = r2[i2],
                a2 = n2[f2];
            (a2 === Z || J(a2, ln[f2]) && !pn.call(n2, f2)) && (n2[f2] = o2[f2])
          }
        return n2
      }),
      Dn = _n,
      In = D,
      $n = function(n2) {
        return xn(I(n2, Z, $2), n2 + "")
      }(function(n2, t22) {
        return n2 == null ? {} : m(n2, t22)
      });
  o.assignIn = Bn, o.before = G, o.bind = En, o.chain = function(n2) {
    return n2 = o(n2), n2.__chain__ = !0, n2
  }, o.compact = function(n2) {
    return l(n2, Boolean)
  }, o.concat = function() {
    var n2 = arguments.length;
    if (!n2) return [];
    for (var r2 = Array(n2 - 1), e2 = arguments[0]; n2--;) r2[n2 - 1] = arguments[n2];
    return t21(Nn(e2) ? A(e2) : [e2], p(r2, 1))
  }, o.create = function(n2, t22) {
    var r2 = dn(n2);
    return t22 == null ? r2 : Tn(r2, t22)
  }, o.defaults = Rn, o.defer = wn, o.delay = kn, o.filter = function(n2, t22) {
    return l(n2, g(t22))
  }, o.flatten = $2, o.flattenDeep = function(n2) {
    return n2 != null && n2.length ? p(n2, nn) : []
  }, o.iteratee = g, o.keys = Dn, o.map = function(n2, t22) {
    return j(n2, g(t22))
  }, o.matches = function(n2) {
    return d(Tn({}, n2))
  }, o.mixin = Y, o.negate = function(n2) {
    if (typeof n2 != "function") throw new TypeError("Expected a function");
    return function() {
      return !n2.apply(this, arguments)
    }
  }, o.once = function(n2) {
    return G(2, n2)
  }, o.pick = $n, o.slice = function(n2, t22, r2) {
    var e2 = n2 == null ? 0 : n2.length;
    return r2 = r2 === Z ? e2 : +r2, e2 ? x(n2, t22 == null ? 0 : +t22, r2) : []
  }, o.sortBy = function(n2, t22) {
    var e2 = 0;
    return t22 = g(t22), j(j(n2, function(n3, r2, u2) {
      return {
        value: n3,
        index: e2++,
        criteria: t22(n3, r2, u2)
      }
    }).sort(function(n3, t23) {
      var r2;
      n: {
        r2 = n3.criteria;
        var e3 = t23.criteria;
        if (r2 !== e3) {
          var u2 = r2 !== Z,
              o2 = r2 === null,
              i2 = r2 === r2,
              c2 = e3 !== Z,
              f2 = e3 === null,
              a2 = e3 === e3;
          if (!f2 && r2 > e3 || o2 && c2 && a2 || !u2 && a2 || !i2) {
            r2 = 1;
            break n
          }
          if (!o2 && r2 < e3 || f2 && u2 && i2 || !c2 && i2 || !a2) {
            r2 = -1;
            break n
          }
        }
        r2 = 0
      }
      return r2 || n3.index - t23.index
    }), r("value"))
  }, o.tap = function(n2, t22) {
    return t22(n2), n2
  }, o.thru = function(n2, t22) {
    return t22(n2)
  }, o.toArray = function(n2) {
    return M(n2) ? n2.length ? A(n2) : [] : W(n2)
  }, o.values = W, o.extend = Bn, Y(o, o), o.clone = function(n2) {
    return V(n2) ? Nn(n2) ? A(n2) : k(n2, _n(n2)) : n2
  }, o.escape = function(n2) {
    return (n2 = Q(n2)) && rn.test(n2) ? n2.replace(tn, fn) : n2
  }, o.every = function(n2, t22, r2) {
    return t22 = r2 ? Z : t22, f(n2, g(t22))
  }, o.find = An, o.forEach = z, o.has = function(n2, t22) {
    return n2 != null && pn.call(n2, t22)
  }, o.head = q, o.identity = X, o.indexOf = P, o.isArguments = n, o.isArray = Nn, o.isBoolean = function(n2) {
    return n2 === !0 || n2 === !1 || H(n2) && hn.call(n2) == "[object Boolean]"
  }, o.isDate = function(n2) {
    return H(n2) && hn.call(n2) == "[object Date]"
  }, o.isEmpty = function(t22) {
    return M(t22) && (Nn(t22) || L(t22) || U(t22.splice) || n(t22)) ? !t22.length : !_n(t22).length
  }, o.isEqual = function(n2, t22) {
    return b(n2, t22)
  }, o.isFinite = function(n2) {
    return typeof n2 == "number" && gn(n2)
  }, o.isFunction = U, o.isNaN = function(n2) {
    return K(n2) && n2 != +n2
  }, o.isNull = function(n2) {
    return n2 === null
  }, o.isNumber = K, o.isObject = V, o.isRegExp = function(n2) {
    return H(n2) && hn.call(n2) == "[object RegExp]"
  }, o.isString = L, o.isUndefined = function(n2) {
    return n2 === Z
  }, o.last = function(n2) {
    var t22 = n2 == null ? 0 : n2.length;
    return t22 ? n2[t22 - 1] : Z
  }, o.max = function(n2) {
    return n2 && n2.length ? a(n2, X, v) : Z
  }, o.min = function(n2) {
    return n2 && n2.length ? a(n2, X, _2) : Z
  }, o.noConflict = function() {
    return on._ === this && (on._ = vn), this
  }, o.noop = function() {}, o.reduce = C, o.result = function(n2, t22, r2) {
    return t22 = n2 == null ? Z : n2[t22], t22 === Z && (t22 = r2), U(t22) ? t22.call(n2) : t22
  }, o.size = function(n2) {
    return n2 == null ? 0 : (n2 = M(n2) ? n2 : _n(n2), n2.length)
  }, o.some = function(n2, t22, r2) {
    return t22 = r2 ? Z : t22, E(n2, g(t22))
  }, o.uniqueId = function(n2) {
    var t22 = ++sn;
    return Q(n2) + t22
  }, o.each = z, o.first = q, Y(o, function() {
    var n2 = {};
    return s(o, function(t22, r2) {
      pn.call(o.prototype, r2) || (n2[r2] = t22)
    }), n2
  }(), {
    chain: !1
  }), o.VERSION = "4.17.15", mn("pop join replace reverse split push shift sort splice unshift".split(" "), function(n2) {
    var t22 = (/^(?:replace|split)$/.test(n2) ? String.prototype : an)[n2],
        r2 = /^(?:push|sort|unshift)$/.test(n2) ? "tap" : "thru",
        e2 = /^(?:pop|join|replace|shift)$/.test(n2);
    o.prototype[n2] = function() {
      var n3 = arguments;
      if (e2 && !this.__chain__) {
        var u2 = this.value();
        return t22.apply(Nn(u2) ? u2 : [], n3)
      }
      return this[r2](function(r3) {
        return t22.apply(Nn(r3) ? r3 : [], n3)
      })
    }
  }), o.prototype.toJSON = o.prototype.valueOf = o.prototype.value = function() {
    return w(this.__wrapped__, this.__actions__)
  }, typeof define == "function" && typeof define.amd == "object" && define.amd ? (on._ = o, define(function() {
    return o
  })) : cn ? ((cn.exports = o)._ = o, un._ = o) : on._ = o
}).call(this);
/*! Magnific Popup - v1.1.0 - 2016-02-20
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2016 Dmitry Semenov; */
(function(a) {
  typeof define == "function" && define.amd ? define(["jquery"], a) : a(typeof exports == "object" ? require("jquery") : window.jQuery || window.Zepto)
})(function(a) {
  var b, c, d, e, f, g, h = "Close",
      i = "BeforeClose",
      j = "AfterClose",
      k = "BeforeAppend",
      l = "MarkupParse",
      m = "Open",
      n = "Change",
      o = "mfp",
      p = "." + o,
      q = "mfp-ready",
      r = "mfp-removing",
      s = "mfp-prevent-close",
      t21 = function() {},
      u = !!window.jQuery,
      v = a(window),
      w = function(a2, c2) {
        b.ev.on(o + a2 + p, c2)
      },
      x = function(b2, c2, d2, e2) {
        var f2 = document.createElement("div");
        return f2.className = "mfp-" + b2, d2 && (f2.innerHTML = d2), e2 ? c2 && c2.appendChild(f2) : (f2 = a(f2), c2 && f2.appendTo(c2)), f2
      },
      y = function(c2, d2) {
        b.ev.triggerHandler(o + c2, d2), b.st.callbacks && (c2 = c2.charAt(0).toLowerCase() + c2.slice(1), b.st.callbacks[c2] && b.st.callbacks[c2].apply(b, a.isArray(d2) ? d2 : [d2]))
      },
      z = function(c2) {
        return c2 === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c2), b.currTemplate.closeBtn
      },
      A = function() {
        a.magnificPopup.instance || (b = new t21, b.init(), a.magnificPopup.instance = b)
      },
      B = function() {
        var a2 = document.createElement("p").style,
            b2 = ["ms", "O", "Moz", "Webkit"];
        if (a2.transition !== void 0) return !0;
        for (; b2.length;)
          if (b2.pop() + "Transition" in a2) return !0;
        return !1
      };
  t21.prototype = {
    constructor: t21,
    init: function() {
      var c2 = navigator.appVersion;
      b.isLowIE = b.isIE8 = document.all && !document.addEventListener, b.isAndroid = /android/gi.test(c2), b.isIOS = /iphone|ipad|ipod/gi.test(c2), b.supportsTransition = B(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {}
    },
    open: function(c2) {
      var e2;
      if (c2.isObj === !1) {
        b.items = c2.items.toArray(), b.index = 0;
        var g2, h2 = c2.items;
        for (e2 = 0; e2 < h2.length; e2++)
          if (g2 = h2[e2], g2.parsed && (g2 = g2.el[0]), g2 === c2.el[0]) {
            b.index = e2;
            break
          }
      } else b.items = a.isArray(c2.items) ? c2.items : [c2.items], b.index = c2.index || 0;
      if (b.isOpen) return void b.updateItemHTML();
      b.types = [], f = "", c2.mainEl && c2.mainEl.length ? b.ev = c2.mainEl.eq(0) : b.ev = d, c2.key ? (b.popupsCache[c2.key] || (b.popupsCache[c2.key] = {}), b.currTemplate = b.popupsCache[c2.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c2), b.fixedContentPos = b.st.fixedContentPos === "auto" ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function() {
        b.close()
      }), b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function(a2) {
        b._checkIfClose(a2.target) && b.close()
      }), b.container = x("container", b.wrap)), b.contentContainer = x("content"), b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
      var i2 = a.magnificPopup.modules;
      for (e2 = 0; e2 < i2.length; e2++) {
        var j2 = i2[e2];
        j2 = j2.charAt(0).toUpperCase() + j2.slice(1), b["init" + j2].call(b)
      }
      y("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function(a2, b2, c3, d2) {
        c3.close_replaceWith = z(d2.type)
      }), f += " mfp-close-btn-in") : b.wrap.append(z())), b.st.alignTop && (f += " mfp-align-top"), b.fixedContentPos ? b.wrap.css({
        overflow: b.st.overflowY,
        overflowX: "hidden",
        overflowY: b.st.overflowY
      }) : b.wrap.css({
        top: v.scrollTop(),
        position: "absolute"
      }), (b.st.fixedBgPos === !1 || b.st.fixedBgPos === "auto" && !b.fixedContentPos) && b.bgOverlay.css({
        height: d.height(),
        position: "absolute"
      }), b.st.enableEscapeKey && d.on("keyup" + p, function(a2) {
        a2.keyCode === 27 && b.close()
      }), v.on("resize" + p, function() {
        b.updateSize()
      }), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f);
      var k2 = b.wH = v.height(),
          n2 = {};
      if (b.fixedContentPos && b._hasScrollBar(k2)) {
        var o2 = b._getScrollbarSize();
        o2 && (n2.marginRight = o2)
      }
      b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n2.overflow = "hidden");
      var r2 = b.st.mainClass;
      return b.isIE7 && (r2 += " mfp-ie7"), r2 && b._addClassToMFP(r2), b.updateItemHTML(), y("BuildControls"), a("html").css(n2), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function() {
        b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn)
      }, 16), b.isOpen = !0, b.updateSize(k2), y(m), c2
    },
    close: function() {
      b.isOpen && (y(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r), setTimeout(function() {
        b._close()
      }, b.st.removalDelay)) : b._close())
    },
    _close: function() {
      y(h);
      var c2 = r + " " + q + " ";
      if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c2 += b.st.mainClass + " "), b._removeClassFromMFP(c2), b.fixedContentPos) {
        var e2 = {
          marginRight: ""
        };
        b.isIE7 ? a("body, html").css("overflow", "") : e2.overflow = "", a("html").css(e2)
      }
      d.off("keyup" + p + " focusin" + p), b.ev.off(p), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, y(j)
    },
    updateSize: function(a2) {
      if (b.isIOS) {
        var c2 = document.documentElement.clientWidth / window.innerWidth,
            d2 = window.innerHeight * c2;
        b.wrap.css("height", d2), b.wH = d2
      } else b.wH = a2 || v.height();
      b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize")
    },
    updateItemHTML: function() {
      var c2 = b.items[b.index];
      b.contentContainer.detach(), b.content && b.content.detach(), c2.parsed || (c2 = b.parseEl(b.index));
      var d2 = c2.type;
      if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d2]), b.currItem = c2, !b.currTemplate[d2]) {
        var f2 = b.st[d2] ? b.st[d2].markup : !1;
        y("FirstMarkupParse", f2), f2 ? b.currTemplate[d2] = a(f2) : b.currTemplate[d2] = !0
      }
      e && e !== c2.type && b.container.removeClass("mfp-" + e + "-holder");
      var g2 = b["get" + d2.charAt(0).toUpperCase() + d2.slice(1)](c2, b.currTemplate[d2]);
      b.appendContent(g2, d2), c2.preloaded = !0, y(n, c2), e = c2.type, b.container.prepend(b.contentContainer), y("AfterChange")
    },
    appendContent: function(a2, c2) {
      b.content = a2, a2 ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c2] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a2 : b.content = "", y(k), b.container.addClass("mfp-" + c2 + "-holder"), b.contentContainer.append(b.content)
    },
    parseEl: function(c2) {
      var d2, e2 = b.items[c2];
      if (e2.tagName ? e2 = {
        el: a(e2)
      } : (d2 = e2.type, e2 = {
        data: e2,
        src: e2.src
      }), e2.el) {
        for (var f2 = b.types, g2 = 0; g2 < f2.length; g2++)
          if (e2.el.hasClass("mfp-" + f2[g2])) {
            d2 = f2[g2];
            break
          } e2.src = e2.el.attr("data-mfp-src"), e2.src || (e2.src = e2.el.attr("href"))
      }
      return e2.type = d2 || b.st.type || "inline", e2.index = c2, e2.parsed = !0, b.items[c2] = e2, y("ElementParse", e2), b.items[c2]
    },
    addGroup: function(a2, c2) {
      var d2 = function(d3) {
        d3.mfpEl = this, b._openClick(d3, a2, c2)
      };
      c2 || (c2 = {});
      var e2 = "click.magnificPopup";
      c2.mainEl = a2, c2.items ? (c2.isObj = !0, a2.off(e2).on(e2, d2)) : (c2.isObj = !1, c2.delegate ? a2.off(e2).on(e2, c2.delegate, d2) : (c2.items = a2, a2.off(e2).on(e2, d2)))
    },
    _openClick: function(c2, d2, e2) {
      var f2 = e2.midClick !== void 0 ? e2.midClick : a.magnificPopup.defaults.midClick;
      if (f2 || !(c2.which === 2 || c2.ctrlKey || c2.metaKey || c2.altKey || c2.shiftKey)) {
        var g2 = e2.disableOn !== void 0 ? e2.disableOn : a.magnificPopup.defaults.disableOn;
        if (g2) {
          if (a.isFunction(g2)) {
            if (!g2.call(b)) return !0
          } else if (v.width() < g2) return !0
        }
        c2.type && (c2.preventDefault(), b.isOpen && c2.stopPropagation()), e2.el = a(c2.mfpEl), e2.delegate && (e2.items = d2.find(e2.delegate)), b.open(e2)
      }
    },
    updateStatus: function(a2, d2) {
      if (b.preloader) {
        c !== a2 && b.container.removeClass("mfp-s-" + c), d2 || a2 !== "loading" || (d2 = b.st.tLoading);
        var e2 = {
          status: a2,
          text: d2
        };
        y("UpdateStatus", e2), a2 = e2.status, d2 = e2.text, b.preloader.html(d2), b.preloader.find("a").on("click", function(a3) {
          a3.stopImmediatePropagation()
        }), b.container.addClass("mfp-s-" + a2), c = a2
      }
    },
    _checkIfClose: function(c2) {
      if (!a(c2).hasClass(s)) {
        var d2 = b.st.closeOnContentClick,
            e2 = b.st.closeOnBgClick;
        if (d2 && e2 || !b.content || a(c2).hasClass("mfp-close") || b.preloader && c2 === b.preloader[0]) return !0;
        if (c2 === b.content[0] || a.contains(b.content[0], c2)) {
          if (d2) return !0
        } else if (e2 && a.contains(document, c2)) return !0;
        return !1
      }
    },
    _addClassToMFP: function(a2) {
      b.bgOverlay.addClass(a2), b.wrap.addClass(a2)
    },
    _removeClassFromMFP: function(a2) {
      this.bgOverlay.removeClass(a2), b.wrap.removeClass(a2)
    },
    _hasScrollBar: function(a2) {
      return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a2 || v.height())
    },
    _setFocus: function() {
      (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus()
    },
    _onFocusIn: function(c2) {
      return c2.target === b.wrap[0] || a.contains(b.wrap[0], c2.target) ? void 0 : (b._setFocus(), !1)
    },
    _parseMarkup: function(b2, c2, d2) {
      var e2;
      d2.data && (c2 = a.extend(d2.data, c2)), y(l, [b2, c2, d2]), a.each(c2, function(c3, d3) {
        if (d3 === void 0 || d3 === !1) return !0;
        if (e2 = c3.split("_"), e2.length > 1) {
          var f2 = b2.find(p + "-" + e2[0]);
          if (f2.length > 0) {
            var g2 = e2[1];
            g2 === "replaceWith" ? f2[0] !== d3[0] && f2.replaceWith(d3) : g2 === "img" ? f2.is("img") ? f2.attr("src", d3) : f2.replaceWith(a("<img>").attr("src", d3).attr("class", f2.attr("class"))) : f2.attr(e2[1], d3)
          }
        } else b2.find(p + "-" + c3).html(d3)
      })
    },
    _getScrollbarSize: function() {
      if (b.scrollbarSize === void 0) {
        var a2 = document.createElement("div");
        a2.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a2), b.scrollbarSize = a2.offsetWidth - a2.clientWidth, document.body.removeChild(a2)
      }
      return b.scrollbarSize
    }
  }, a.magnificPopup = {
    instance: null,
    proto: t21.prototype,
    modules: [],
    open: function(b2, c2) {
      return A(), b2 = b2 ? a.extend(!0, {}, b2) : {}, b2.isObj = !0, b2.index = c2 || 0, this.instance.open(b2)
    },
    close: function() {
      return a.magnificPopup.instance && a.magnificPopup.instance.close()
    },
    registerModule: function(b2, c2) {
      c2.options && (a.magnificPopup.defaults[b2] = c2.options), a.extend(this.proto, c2.proto), this.modules.push(b2)
    },
    defaults: {
      disableOn: 0,
      key: null,
      midClick: !1,
      mainClass: "",
      preloader: !0,
      focus: "",
      closeOnContentClick: !1,
      closeOnBgClick: !0,
      closeBtnInside: !0,
      showCloseBtn: !0,
      enableEscapeKey: !0,
      modal: !1,
      alignTop: !1,
      removalDelay: 0,
      prependTo: null,
      fixedContentPos: "auto",
      fixedBgPos: "auto",
      overflowY: "auto",
      closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
      tClose: "Close (Esc)",
      tLoading: "Loading...",
      autoFocusLast: !0
    }
  }, a.fn.magnificPopup = function(c2) {
    A();
    var d2 = a(this);
    if (typeof c2 == "string")
      if (c2 === "open") {
        var e2, f2 = u ? d2.data("magnificPopup") : d2[0].magnificPopup,
            g2 = parseInt(arguments[1], 10) || 0;
        f2.items ? e2 = f2.items[g2] : (e2 = d2, f2.delegate && (e2 = e2.find(f2.delegate)), e2 = e2.eq(g2)), b._openClick({
          mfpEl: e2
        }, d2, f2)
      } else b.isOpen && b[c2].apply(b, Array.prototype.slice.call(arguments, 1));
    else c2 = a.extend(!0, {}, c2), u ? d2.data("magnificPopup", c2) : d2[0].magnificPopup = c2, b.addGroup(d2, c2);
    return d2
  };
  var C, D, E, F = "inline",
      G = function() {
        E && (D.after(E.addClass(C)).detach(), E = null)
      };
  a.magnificPopup.registerModule(F, {
    options: {
      hiddenClass: "hide",
      markup: "",
      tNotFound: "Content not found"
    },
    proto: {
      initInline: function() {
        b.types.push(F), w(h + "." + F, function() {
          G()
        })
      },
      getInline: function(c2, d2) {
        if (G(), c2.src) {
          var e2 = b.st.inline,
              f2 = a(c2.src);
          if (f2.length) {
            var g2 = f2[0].parentNode;
            g2 && g2.tagName && (D || (C = e2.hiddenClass, D = x(C), C = "mfp-" + C), E = f2.after(D).detach().removeClass(C)), b.updateStatus("ready")
          } else b.updateStatus("error", e2.tNotFound), f2 = a("<div>");
          return c2.inlineElement = f2, f2
        }
        return b.updateStatus("ready"), b._parseMarkup(d2, {}, c2), d2
      }
    }
  });
  var H, I = "ajax",
      J = function() {
        H && a(document.body).removeClass(H)
      },
      K = function() {
        J(), b.req && b.req.abort()
      };
  a.magnificPopup.registerModule(I, {
    options: {
      settings: null,
      cursor: "mfp-ajax-cur",
      tError: '<a href="%url%">The content</a> could not be loaded.'
    },
    proto: {
      initAjax: function() {
        b.types.push(I), H = b.st.ajax.cursor, w(h + "." + I, K), w("BeforeChange." + I, K)
      },
      getAjax: function(c2) {
        H && a(document.body).addClass(H), b.updateStatus("loading");
        var d2 = a.extend({
          url: c2.src,
          success: function(d3, e2, f2) {
            var g2 = {
              data: d3,
              xhr: f2
            };
            y("ParseAjax", g2), b.appendContent(a(g2.data), I), c2.finished = !0, J(), b._setFocus(), setTimeout(function() {
              b.wrap.addClass(q)
            }, 16), b.updateStatus("ready"), y("AjaxContentAdded")
          },
          error: function() {
            J(), c2.finished = c2.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c2.src))
          }
        }, b.st.ajax.settings);
        return b.req = a.ajax(d2), ""
      }
    }
  });
  var L, M = function(c2) {
    if (c2.data && c2.data.title !== void 0) return c2.data.title;
    var d2 = b.st.image.titleSrc;
    if (d2) {
      if (a.isFunction(d2)) return d2.call(b, c2);
      if (c2.el) return c2.el.attr(d2) || ""
    }
    return ""
  };
  a.magnificPopup.registerModule("image", {
    options: {
      markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
      cursor: "mfp-zoom-out-cur",
      titleSrc: "title",
      verticalFit: !0,
      tError: '<a href="%url%">The image</a> could not be loaded.'
    },
    proto: {
      initImage: function() {
        var c2 = b.st.image,
            d2 = ".image";
        b.types.push("image"), w(m + d2, function() {
          b.currItem.type === "image" && c2.cursor && a(document.body).addClass(c2.cursor)
        }), w(h + d2, function() {
          c2.cursor && a(document.body).removeClass(c2.cursor), v.off("resize" + p)
        }), w("Resize" + d2, b.resizeImage), b.isLowIE && w("AfterChange", b.resizeImage)
      },
      resizeImage: function() {
        var a2 = b.currItem;
        if (a2 && a2.img && b.st.image.verticalFit) {
          var c2 = 0;
          b.isLowIE && (c2 = parseInt(a2.img.css("padding-top"), 10) + parseInt(a2.img.css("padding-bottom"), 10)), a2.img.css("max-height", b.wH - c2)
        }
      },
      _onImageHasSize: function(a2) {
        a2.img && (a2.hasSize = !0, L && clearInterval(L), a2.isCheckingImgSize = !1, y("ImageHasSize", a2), a2.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a2.imgHidden = !1))
      },
      findImageSize: function(a2) {
        var c2 = 0,
            d2 = a2.img[0],
            e2 = function(f2) {
              L && clearInterval(L), L = setInterval(function() {
                return d2.naturalWidth > 0 ? void b._onImageHasSize(a2) : (c2 > 200 && clearInterval(L), c2++, void(c2 === 3 ? e2(10) : c2 === 40 ? e2(50) : c2 === 100 && e2(500)))
              }, f2)
            };
        e2(1)
      },
      getImage: function(c2, d2) {
        var e2 = 0,
            f2 = function() {
              c2 && (c2.img[0].complete ? (c2.img.off(".mfploader"), c2 === b.currItem && (b._onImageHasSize(c2), b.updateStatus("ready")), c2.hasSize = !0, c2.loaded = !0, y("ImageLoadComplete")) : (e2++, 200 > e2 ? setTimeout(f2, 100) : g2()))
            },
            g2 = function() {
              c2 && (c2.img.off(".mfploader"), c2 === b.currItem && (b._onImageHasSize(c2), b.updateStatus("error", h2.tError.replace("%url%", c2.src))), c2.hasSize = !0, c2.loaded = !0, c2.loadError = !0)
            },
            h2 = b.st.image,
            i2 = d2.find(".mfp-img");
        if (i2.length) {
          var j2 = document.createElement("img");
          j2.className = "mfp-img", c2.el && c2.el.find("img").length && (j2.alt = c2.el.find("img").attr("alt")), c2.img = a(j2).on("load.mfploader", f2).on("error.mfploader", g2), j2.src = c2.src, i2.is("img") && (c2.img = c2.img.clone()), j2 = c2.img[0], j2.naturalWidth > 0 ? c2.hasSize = !0 : j2.width || (c2.hasSize = !1)
        }
        return b._parseMarkup(d2, {
          title: M(c2),
          img_replaceWith: c2.img
        }, c2), b.resizeImage(), c2.hasSize ? (L && clearInterval(L), c2.loadError ? (d2.addClass("mfp-loading"), b.updateStatus("error", h2.tError.replace("%url%", c2.src))) : (d2.removeClass("mfp-loading"), b.updateStatus("ready")), d2) : (b.updateStatus("loading"), c2.loading = !0, c2.hasSize || (c2.imgHidden = !0, d2.addClass("mfp-loading"), b.findImageSize(c2)), d2)
      }
    }
  });
  var N, O = function() {
    return N === void 0 && (N = document.createElement("p").style.MozTransform !== void 0), N
  };
  a.magnificPopup.registerModule("zoom", {
    options: {
      enabled: !1,
      easing: "ease-in-out",
      duration: 300,
      opener: function(a2) {
        return a2.is("img") ? a2 : a2.find("img")
      }
    },
    proto: {
      initZoom: function() {
        var a2, c2 = b.st.zoom,
            d2 = ".zoom";
        if (c2.enabled && b.supportsTransition) {
          var e2, f2, g2 = c2.duration,
              j2 = function(a3) {
                var b2 = a3.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                    d3 = "all " + c2.duration / 1e3 + "s " + c2.easing,
                    e3 = {
                      position: "fixed",
                      zIndex: 9999,
                      left: 0,
                      top: 0,
                      "-webkit-backface-visibility": "hidden"
                    },
                    f3 = "transition";
                return e3["-webkit-" + f3] = e3["-moz-" + f3] = e3["-o-" + f3] = e3[f3] = d3, b2.css(e3), b2
              },
              k2 = function() {
                b.content.css("visibility", "visible")
              };
          w("BuildControls" + d2, function() {
            if (b._allowZoom()) {
              if (clearTimeout(e2), b.content.css("visibility", "hidden"), a2 = b._getItemToZoom(), !a2) return void k2();
              f2 = j2(a2), f2.css(b._getOffset()), b.wrap.append(f2), e2 = setTimeout(function() {
                f2.css(b._getOffset(!0)), e2 = setTimeout(function() {
                  k2(), setTimeout(function() {
                    f2.remove(), a2 = f2 = null, y("ZoomAnimationEnded")
                  }, 16)
                }, g2)
              }, 16)
            }
          }), w(i + d2, function() {
            if (b._allowZoom()) {
              if (clearTimeout(e2), b.st.removalDelay = g2, !a2) {
                if (a2 = b._getItemToZoom(), !a2) return;
                f2 = j2(a2)
              }
              f2.css(b._getOffset(!0)), b.wrap.append(f2), b.content.css("visibility", "hidden"), setTimeout(function() {
                f2.css(b._getOffset())
              }, 16)
            }
          }), w(h + d2, function() {
            b._allowZoom() && (k2(), f2 && f2.remove(), a2 = null)
          })
        }
      },
      _allowZoom: function() {
        return b.currItem.type === "image"
      },
      _getItemToZoom: function() {
        return b.currItem.hasSize ? b.currItem.img : !1
      },
      _getOffset: function(c2) {
        var d2;
        d2 = c2 ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
        var e2 = d2.offset(),
            f2 = parseInt(d2.css("padding-top"), 10),
            g2 = parseInt(d2.css("padding-bottom"), 10);
        e2.top -= a(window).scrollTop() - f2;
        var h2 = {
          width: d2.width(),
          height: (u ? d2.innerHeight() : d2[0].offsetHeight) - g2 - f2
        };
        return O() ? h2["-moz-transform"] = h2.transform = "translate(" + e2.left + "px," + e2.top + "px)" : (h2.left = e2.left, h2.top = e2.top), h2
      }
    }
  });
  var P = "iframe",
      Q = "//about:blank",
      R = function(a2) {
        if (b.currTemplate[P]) {
          var c2 = b.currTemplate[P].find("iframe");
          c2.length && (a2 || (c2[0].src = Q), b.isIE8 && c2.css("display", a2 ? "block" : "none"))
        }
      };
  a.magnificPopup.registerModule(P, {
    options: {
      markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
      srcAction: "iframe_src",
      patterns: {
        youtube: {
          index: "youtube.com",
          id: "v=",
          src: "//www.youtube.com/embed/%id%?autoplay=1"
        },
        vimeo: {
          index: "vimeo.com/",
          id: "/",
          src: "//player.vimeo.com/video/%id%?autoplay=1"
        },
        gmaps: {
          index: "//maps.google.",
          src: "%id%&output=embed"
        }
      }
    },
    proto: {
      initIframe: function() {
        b.types.push(P), w("BeforeChange", function(a2, b2, c2) {
          b2 !== c2 && (b2 === P ? R() : c2 === P && R(!0))
        }), w(h + "." + P, function() {
          R()
        })
      },
      getIframe: function(c2, d2) {
        var e2 = c2.src,
            f2 = b.st.iframe;
        a.each(f2.patterns, function() {
          return e2.indexOf(this.index) > -1 ? (this.id && (e2 = typeof this.id == "string" ? e2.substr(e2.lastIndexOf(this.id) + this.id.length, e2.length) : this.id.call(this, e2)), e2 = this.src.replace("%id%", e2), !1) : void 0
        });
        var g2 = {};
        return f2.srcAction && (g2[f2.srcAction] = e2), b._parseMarkup(d2, g2, c2), b.updateStatus("ready"), d2
      }
    }
  });
  var S = function(a2) {
        var c2 = b.items.length;
        return a2 > c2 - 1 ? a2 - c2 : 0 > a2 ? c2 + a2 : a2
      },
      T = function(a2, b2, c2) {
        return a2.replace(/%curr%/gi, b2 + 1).replace(/%total%/gi, c2)
      };
  a.magnificPopup.registerModule("gallery", {
    options: {
      enabled: !1,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      preload: [0, 2],
      navigateByImgClick: !0,
      arrows: !0,
      tPrev: "Previous (Left arrow key)",
      tNext: "Next (Right arrow key)",
      tCounter: "%curr% of %total%"
    },
    proto: {
      initGallery: function() {
        var c2 = b.st.gallery,
            e2 = ".mfp-gallery";
        return b.direction = !0, c2 && c2.enabled ? (f += " mfp-gallery", w(m + e2, function() {
          c2.navigateByImgClick && b.wrap.on("click" + e2, ".mfp-img", function() {
            return b.items.length > 1 ? (b.next(), !1) : void 0
          }), d.on("keydown" + e2, function(a2) {
            a2.keyCode === 37 ? b.prev() : a2.keyCode === 39 && b.next()
          })
        }), w("UpdateStatus" + e2, function(a2, c3) {
          c3.text && (c3.text = T(c3.text, b.currItem.index, b.items.length))
        }), w(l + e2, function(a2, d2, e3, f2) {
          var g2 = b.items.length;
          e3.counter = g2 > 1 ? T(c2.tCounter, f2.index, g2) : ""
        }), w("BuildControls" + e2, function() {
          if (b.items.length > 1 && c2.arrows && !b.arrowLeft) {
            var d2 = c2.arrowMarkup,
                e3 = b.arrowLeft = a(d2.replace(/%title%/gi, c2.tPrev).replace(/%dir%/gi, "left")).addClass(s),
                f2 = b.arrowRight = a(d2.replace(/%title%/gi, c2.tNext).replace(/%dir%/gi, "right")).addClass(s);
            e3.click(function() {
              b.prev()
            }), f2.click(function() {
              b.next()
            }), b.container.append(e3.add(f2))
          }
        }), w(n + e2, function() {
          b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function() {
            b.preloadNearbyImages(), b._preloadTimeout = null
          }, 16)
        }), void w(h + e2, function() {
          d.off(e2), b.wrap.off("click" + e2), b.arrowRight = b.arrowLeft = null
        })) : !1
      },
      next: function() {
        b.direction = !0, b.index = S(b.index + 1), b.updateItemHTML()
      },
      prev: function() {
        b.direction = !1, b.index = S(b.index - 1), b.updateItemHTML()
      },
      goTo: function(a2) {
        b.direction = a2 >= b.index, b.index = a2, b.updateItemHTML()
      },
      preloadNearbyImages: function() {
        var a2, c2 = b.st.gallery.preload,
            d2 = Math.min(c2[0], b.items.length),
            e2 = Math.min(c2[1], b.items.length);
        for (a2 = 1; a2 <= (b.direction ? e2 : d2); a2++) b._preloadItem(b.index + a2);
        for (a2 = 1; a2 <= (b.direction ? d2 : e2); a2++) b._preloadItem(b.index - a2)
      },
      _preloadItem: function(c2) {
        if (c2 = S(c2), !b.items[c2].preloaded) {
          var d2 = b.items[c2];
          d2.parsed || (d2 = b.parseEl(c2)), y("LazyLoad", d2), d2.type === "image" && (d2.img = a('<img class="mfp-img" />').on("load.mfploader", function() {
            d2.hasSize = !0
          }).on("error.mfploader", function() {
            d2.hasSize = !0, d2.loadError = !0, y("LazyLoadError", d2)
          }).attr("src", d2.src)), d2.preloaded = !0
        }
      }
    }
  });
  var U = "retina";
  a.magnificPopup.registerModule(U, {
    options: {
      replaceSrc: function(a2) {
        return a2.src.replace(/\.\w+$/, function(a3) {
          return "@2x" + a3
        })
      },
      ratio: 1
    },
    proto: {
      initRetina: function() {
        if (window.devicePixelRatio > 1) {
          var a2 = b.st.retina,
              c2 = a2.ratio;
          c2 = isNaN(c2) ? c2() : c2, c2 > 1 && (w("ImageHasSize." + U, function(a3, b2) {
            b2.img.css({
              "max-width": b2.img[0].naturalWidth / c2,
              width: "100%"
            })
          }), w("ElementParse." + U, function(b2, d2) {
            d2.src = a2.replaceSrc(d2, c2)
          }))
        }
      }
    }
  }), A()
}), PaloAlto.Modals = function() {
  function Modal(id, name, options) {
    var defaults = {
      close: ".js-modal-close",
      open: ".js-modal-open-" + name,
      openClass: "modal--is-active",
      openBodyClass: "modal--is-visible",
      closeModalOnClick: !1,
      scrollIntoView: !1
    };
    if (this.modal = document.getElementById(id), !this.modal) return !1;
    this.nodes = {
      parents: [document.querySelector("html"), document.body]
    }, this.config = Object.assign(defaults, options), this.modalIsOpen = !1, this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal, this.openElement = document.querySelector(this.config.open), this.init()
  }
  return Modal.prototype.init = function() {
    this.openElement.addEventListener("click", this.open.bind(this)), this.modal.querySelector(this.config.close).addEventListener("click", this.closeModal.bind(this))
  }, Modal.prototype.open = function(evt) {
    var self2 = this,
        externalCall = !1;
    if (!this.modalIsOpen) {
      evt ? evt.preventDefault() : externalCall = !0, evt && evt.stopPropagation && evt.stopPropagation(), this.modalIsOpen && !externalCall && this.closeModal(), PaloAlto.Drawers.close(), this.modal.classList.add(this.config.openClass), this.nodes.parents.forEach(function(node) {
        node.classList.add(self2.config.openBodyClass)
      }), this.modalIsOpen = !0;
      var scrollableElement = document.querySelector(".store-availabilities-list");
      scrollLock.disablePageScroll(scrollableElement), this.config.scrollIntoView && this.scrollIntoView(), this.bindEvents()
    }
  }, Modal.prototype.closeModal = function() {
    if (this.modalIsOpen) {
      document.activeElement.blur(), this.modal.classList.remove(this.config.openClass);
      var self2 = this;
      this.nodes.parents.forEach(function(node) {
        node.classList.remove(self2.config.openBodyClass)
      }), this.modalIsOpen = !1, this.openElement.focus(), this.unbindEvents();
      var scrollLockTimer = 0,
          scrollableElement = document.querySelector(".store-availabilities-list");
      scrollLockTimer && clearTimeout(scrollLockTimer), scrollLockTimer = setTimeout(function() {
        scrollLock.enablePageScroll(scrollableElement)
      }, 400)
    }
  }, Modal.prototype.bindEvents = function() {
    this.keyupHandler = this.keyupHandler.bind(this), this.clickHandler = this.clickHandler.bind(this), document.body.addEventListener("keyup", this.keyupHandler), document.body.addEventListener("click", this.clickHandler)
  }, Modal.prototype.unbindEvents = function() {
    document.body.removeEventListener("keyup", this.keyupHandler), document.body.removeEventListener("click", this.clickHandler)
  }, Modal.prototype.keyupHandler = function(event) {
    event.keyCode === 27 && this.closeModal()
  }, Modal.prototype.clickHandler = function(event) {
    this.config.closeModalOnClick && !this.modal.contains(event.target) && this.closeModal()
  }, Modal.prototype.scrollIntoView = function() {
    this.focusOnOpen.scrollIntoView({
      behavior: "smooth"
    })
  }, Modal
}(),
    function(n) {
      n.fn.prepareTransition = function() {
        return this.each(function() {
          var i = n(this);
          i.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
            i.removeClass("is-transitioning")
          });
          var t21 = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
              o = 0;
          n.each(t21, function(n2, t22) {
            o || (o = parseFloat(i.css(t22)))
          }), o != 0 && (i.addClass("is-transitioning"), i[0].offsetWidth)
        })
      }
    }(jQuery),
    function(e, t21) {
      typeof define == "function" && define.amd ? define([], t21) : typeof module == "object" && module.exports ? module.exports = t21() : e.Rellax = t21()
    }(typeof window < "u" ? window : global, function() {
      var y = function(e, t21) {
        "use strict";
        var l = Object.create(y.prototype),
            a = 0,
            d = 0,
            c = [],
            n = !0,
            o = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function(e2) {
              return setTimeout(e2, 1e3 / 60)
            },
            i = null,
            r = !1;
        try {
          var s = Object.defineProperty({}, "passive", {
            get: function() {
              r = !0
            }
          });
          window.addEventListener("testPassive", null, s), window.removeEventListener("testPassive", null, s)
        } catch {}
        var m = window.cancelAnimationFrame || window.mozCancelAnimationFrame || clearTimeout,
            u = window.transformProp || function() {
              var e2 = document.createElement("div");
              if (e2.style.transform === null) {
                var t22, n2 = ["Webkit", "Moz", "ms"];
                for (t22 in n2)
                  if (e2.style[n2[t22] + "Transform"] !== void 0) return n2[t22] + "Transform"
              }
              return "transform"
            }();
        if (l.options = {
          round: !0,
          frame: null,
          callback: function() {}
        }, t21 && Object.keys(t21).forEach(function(e2) {
          l.options[e2] = t21[e2]
        }), e = typeof(e = e || ".rellax") == "string" ? document.querySelectorAll(e) : [e], 0 < e.length) {
          if (l.elems = e, l.options.frame && !l.options.frame.nodeType) {
            if (e = document.querySelector(l.options.frame), !e) return void console.warn("Rellax: The frame you're trying to use doesn't exist.");
            l.options.frame = e
          }
          var f = function() {
                for (var e2 = 0; e2 < c.length; e2++) l.elems[e2].style.cssText = c[e2].style;
                c = [], d = window.innerHeight, window.innerWidth, v(),
                    function() {
                      for (var e3 = 0; e3 < l.elems.length; e3++) {
                        var t22 = w(l.elems[e3]);
                        c.push(t22)
                      }
                    }(), p(), n && (window.addEventListener("resize", f), n = !1, g())
              },
              w = function(e2) {
                var t22 = e2.getAttribute("data-rellax-zindex") || 0,
                    n2 = 0 + e2.getBoundingClientRect().top,
                    o2 = e2.clientHeight || e2.offsetHeight || e2.scrollHeight,
                    i2 = 0 + e2.getBoundingClientRect().left,
                    r2 = e2.clientWidth || e2.offsetWidth || e2.scrollWidth,
                    s2 = e2.style.cssText,
                    l2 = "",
                    a2 = /transform\s*:/i.exec(s2);
                return a2 && (e2 = a2.index, l2 = (e2 = (a2 = s2.slice(e2)).indexOf(";")) ? " " + a2.slice(11, e2).replace(/\s/g, "") : " " + a2.slice(11).replace(/\s/g, "")), {
                  top: n2,
                  left: i2,
                  height: o2,
                  width: r2,
                  style: s2,
                  transform: l2,
                  zindex: t22
                }
              },
              v = function() {
                return a != (a = (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset)
              },
              h = function() {
                window.removeEventListener("resize", h), window.removeEventListener("orientationchange", h), window.removeEventListener("scroll", h), document.removeEventListener("touchmove", h), i = o(g)
              },
              g = function() {
                v() && n === !1 ? (p(), i = o(g)) : (i = null, window.addEventListener("resize", h), window.addEventListener("orientationchange", h), window.addEventListener("scroll", h, !!r && {
                  passive: !0
                }), document.addEventListener("touchmove", h, !!r && {
                  passive: !0
                }))
              },
              p = function() {
                for (var e2 = 0; e2 < l.elems.length; e2++) {
                  var t22 = l.elems[e2].parentNode,
                      n2 = t22.clientHeight || t22.offsetHeight || t22.scrollHeight,
                      o2 = t22.getBoundingClientRect().top + a,
                      i2 = n2 + o2,
                      r2 = c[e2].height - n2;
                  if (i2 < a || a + d < o2) return;
                  var s2 = document.body,
                      t22 = document.documentElement,
                      t22 = Math.max(s2.scrollHeight, s2.offsetHeight, t22.clientHeight, t22.scrollHeight, t22.offsetHeight),
                      r2 = "translate3d(0px," + (o2 < d ? r2 / (n2 + o2) * -(a + o2 - o2) + r2 / 2 : t22 - i2 < d ? r2 / (n2 + (t22 - i2)) * -(a + d - o2) + r2 / 2 : r2 / (n2 + d) * -(a + d - o2) + r2 / 2) + "px," + c[e2].zindex + "px) " + c[e2].transform;
                  l.elems[e2].style[u] = r2
                }
              };
          return l.destroy = function() {
            for (var e2 = 0; e2 < l.elems.length; e2++) l.elems[e2].style.cssText = c[e2].style;
            n || (window.removeEventListener("resize", f), n = !0), m(i), i = null
          }, f(), l.refresh = f, l
        }
        console.warn("Rellax: The elements you're trying to select don't exist.")
      };
      return y
    });

function replaceUrlParam(e, r, a) {
  var n = new RegExp("(" + r + "=).*?(&|$)"),
      c = e;
  return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a
}
/*!
 * Scroll lock
 * https://github.com/FL3NKEY/scroll-lock
 */
(function(e, t21) {
  typeof exports == "object" && typeof module == "object" ? module.exports = t21() : typeof define == "function" && define.amd ? define([], t21) : typeof exports == "object" ? exports.scrollLock = t21() : e.scrollLock = t21()
})(this, function() {
  return function(l) {
    var r = {};

    function o(e) {
      if (r[e]) return r[e].exports;
      var t21 = r[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return l[e].call(t21.exports, t21, t21.exports, o), t21.l = !0, t21.exports
    }
    return o.m = l, o.c = r, o.d = function(e, t21, l2) {
      o.o(e, t21) || Object.defineProperty(e, t21, {
        enumerable: !0,
        get: l2
      })
    }, o.r = function(e) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      })
    }, o.t = function(t21, e) {
      if (1 & e && (t21 = o(t21)), 8 & e || 4 & e && typeof t21 == "object" && t21 && t21.__esModule) return t21;
      var l2 = Object.create(null);
      if (o.r(l2), Object.defineProperty(l2, "default", {
        enumerable: !0,
        value: t21
      }), 2 & e && typeof t21 != "string")
        for (var r2 in t21) o.d(l2, r2, function(e2) {
          return t21[e2]
        }.bind(null, r2));
      return l2
    }, o.n = function(e) {
      var t21 = e && e.__esModule ? function() {
        return e.default
      } : function() {
        return e
      };
      return o.d(t21, "a", t21), t21
    }, o.o = function(e, t21) {
      return Object.prototype.hasOwnProperty.call(e, t21)
    }, o.p = "", o(o.s = 0)
  }([function(e, t21, l) {
    "use strict";
    l.r(t21);
    var r = function(e2) {
          return Array.isArray(e2) ? e2 : [e2]
        },
        a = function(e2) {
          return e2 instanceof Node
        },
        o = function(e2, t22) {
          if (e2 && t22) {
            e2 = e2 instanceof NodeList ? e2 : [e2];
            for (var l2 = 0; l2 < e2.length && t22(e2[l2], l2, e2.length) !== !0; l2++);
          }
        },
        n = function(e2) {
          return console.error("[scroll-lock] ".concat(e2))
        },
        b = function(e2) {
          if (Array.isArray(e2)) return e2.join(", ")
        },
        c = function(e2) {
          var t22 = [];
          return o(e2, function(e3) {
            return t22.push(e3)
          }), t22
        },
        h = function(e2, t22) {
          var l2 = !(2 < arguments.length && arguments[2] !== void 0) || arguments[2],
              r2 = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : document;
          if (l2 && c(r2.querySelectorAll(t22)).indexOf(e2) !== -1) return e2;
          for (;
              (e2 = e2.parentElement) && c(r2.querySelectorAll(t22)).indexOf(e2) === -1;);
          return e2
        },
        v = function(e2, t22) {
          var l2 = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : document;
          return c(l2.querySelectorAll(t22)).indexOf(e2) !== -1
        },
        i = function(e2) {
          if (e2) return getComputedStyle(e2).overflow === "hidden"
        },
        m = function(e2) {
          if (e2) return !!i(e2) || e2.scrollTop <= 0
        },
        S = function(e2) {
          if (e2) {
            if (i(e2)) return !0;
            var t22 = e2.scrollTop;
            return e2.scrollHeight <= t22 + e2.offsetHeight
          }
        },
        y = function(e2) {
          if (e2) return !!i(e2) || e2.scrollLeft <= 0
        },
        k = function(e2) {
          if (e2) {
            if (i(e2)) return !0;
            var t22 = e2.scrollLeft;
            return e2.scrollWidth <= t22 + e2.offsetWidth
          }
        };
    l.d(t21, "disablePageScroll", function() {
      return d
    }), l.d(t21, "enablePageScroll", function() {
      return s
    }), l.d(t21, "getScrollState", function() {
      return f
    }), l.d(t21, "clearQueueScrollLocks", function() {
      return p
    }), l.d(t21, "getTargetScrollBarWidth", function() {
      return g
    }), l.d(t21, "getCurrentTargetScrollBarWidth", function() {
      return A
    }), l.d(t21, "getPageScrollBarWidth", function() {
      return G
    }), l.d(t21, "getCurrentPageScrollBarWidth", function() {
      return T
    }), l.d(t21, "addScrollableTarget", function() {
      return L
    }), l.d(t21, "removeScrollableTarget", function() {
      return W
    }), l.d(t21, "addScrollableSelector", function() {
      return x
    }), l.d(t21, "removeScrollableSelector", function() {
      return F
    }), l.d(t21, "addLockableTarget", function() {
      return Y
    }), l.d(t21, "addLockableSelector", function() {
      return E
    }), l.d(t21, "setFillGapMethod", function() {
      return O
    }), l.d(t21, "addFillGapTarget", function() {
      return P
    }), l.d(t21, "removeFillGapTarget", function() {
      return j
    }), l.d(t21, "addFillGapSelector", function() {
      return q
    }), l.d(t21, "removeFillGapSelector", function() {
      return M
    }), l.d(t21, "refillGaps", function() {
      return N
    });
    var u = ["padding", "margin", "width", "max-width", "none"],
        w = {
          scroll: !0,
          queue: 0,
          scrollableSelectors: ["[data-scroll-lock-scrollable]"],
          lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
          fillGapSelectors: ["body", "[data-scroll-lock-fill-gap]", "[data-scroll-lock-lockable]"],
          fillGapMethod: u[0],
          startTouchY: 0,
          startTouchX: 0
        },
        d = function(e2) {
          w.queue <= 0 && (w.scroll = !1, B(), X()), L(e2), w.queue++
        },
        s = function(e2) {
          0 < w.queue && w.queue--, w.queue <= 0 && (w.scroll = !0, C(), Q()), W(e2)
        },
        f = function() {
          return w.scroll
        },
        p = function() {
          w.queue = 0
        },
        g = function(e2) {
          var t22 = 1 < arguments.length && arguments[1] !== void 0 && arguments[1];
          if (a(e2)) {
            var l2 = e2.style.overflowY;
            t22 ? f() || (e2.style.overflowY = e2.getAttribute("data-scroll-lock-saved-overflow-y-property")) : e2.style.overflowY = "scroll";
            var r2 = A(e2);
            return e2.style.overflowY = l2, r2
          }
          return 0
        },
        A = function(e2) {
          if (a(e2)) {
            if (e2 === document.body) {
              var t22 = document.documentElement.clientWidth;
              return window.innerWidth - t22
            }
            var l2 = e2.style.borderLeftWidth,
                r2 = e2.style.borderRightWidth;
            e2.style.borderLeftWidth = "0px", e2.style.borderRightWidth = "0px";
            var o2 = e2.offsetWidth - e2.clientWidth;
            return e2.style.borderLeftWidth = l2, e2.style.borderRightWidth = r2, o2
          }
          return 0
        },
        G = function() {
          var e2 = 0 < arguments.length && arguments[0] !== void 0 && arguments[0];
          return g(document.body, e2)
        },
        T = function() {
          return A(document.body)
        },
        L = function(e2) {
          e2 && r(e2).map(function(e3) {
            o(e3, function(e4) {
              a(e4) ? e4.setAttribute("data-scroll-lock-scrollable", "") : n('"'.concat(e4, '" is not a Element.'))
            })
          })
        },
        W = function(e2) {
          e2 && r(e2).map(function(e3) {
            o(e3, function(e4) {
              a(e4) ? e4.removeAttribute("data-scroll-lock-scrollable") : n('"'.concat(e4, '" is not a Element.'))
            })
          })
        },
        x = function(e2) {
          e2 && r(e2).map(function(e3) {
            w.scrollableSelectors.push(e3)
          })
        },
        F = function(e2) {
          e2 && r(e2).map(function(t22) {
            w.scrollableSelectors = w.scrollableSelectors.filter(function(e3) {
              return e3 !== t22
            })
          })
        },
        Y = function(e2) {
          e2 && (r(e2).map(function(e3) {
            o(e3, function(e4) {
              a(e4) ? e4.setAttribute("data-scroll-lock-lockable", "") : n('"'.concat(e4, '" is not a Element.'))
            })
          }), f() || B())
        },
        E = function(e2) {
          e2 && (r(e2).map(function(e3) {
            w.lockableSelectors.push(e3)
          }), f() || B(), q(e2))
        },
        O = function(e2) {
          if (e2)
            if (u.indexOf(e2) !== -1) w.fillGapMethod = e2, N();
            else {
              var t22 = u.join(", ");
              n('"'.concat(e2, `" method is not available!
Available fill gap methods: `).concat(t22, "."))
            }
        },
        P = function(e2) {
          e2 && r(e2).map(function(e3) {
            o(e3, function(e4) {
              a(e4) ? (e4.setAttribute("data-scroll-lock-fill-gap", ""), w.scroll || H(e4)) : n('"'.concat(e4, '" is not a Element.'))
            })
          })
        },
        j = function(e2) {
          e2 && r(e2).map(function(e3) {
            o(e3, function(e4) {
              a(e4) ? (e4.removeAttribute("data-scroll-lock-fill-gap"), w.scroll || I(e4)) : n('"'.concat(e4, '" is not a Element.'))
            })
          })
        },
        q = function(e2) {
          e2 && r(e2).map(function(e3) {
            w.fillGapSelectors.indexOf(e3) === -1 && (w.fillGapSelectors.push(e3), w.scroll || D(e3))
          })
        },
        M = function(e2) {
          e2 && r(e2).map(function(t22) {
            w.fillGapSelectors = w.fillGapSelectors.filter(function(e3) {
              return e3 !== t22
            }), w.scroll || z(t22)
          })
        },
        N = function() {
          w.scroll || X()
        },
        B = function() {
          var e2 = b(w.lockableSelectors);
          K(e2)
        },
        C = function() {
          var e2 = b(w.lockableSelectors);
          R(e2)
        },
        K = function(e2) {
          var t22 = document.querySelectorAll(e2);
          o(t22, function(e3) {
            U(e3)
          })
        },
        R = function(e2) {
          var t22 = document.querySelectorAll(e2);
          o(t22, function(e3) {
            _2(e3)
          })
        },
        U = function(e2) {
          if (a(e2) && e2.getAttribute("data-scroll-lock-locked") !== "true") {
            var t22 = window.getComputedStyle(e2);
            e2.setAttribute("data-scroll-lock-saved-overflow-y-property", t22.overflowY), e2.setAttribute("data-scroll-lock-saved-inline-overflow-property", e2.style.overflow), e2.setAttribute("data-scroll-lock-saved-inline-overflow-y-property", e2.style.overflowY), e2.style.overflow = "hidden", e2.setAttribute("data-scroll-lock-locked", "true")
          }
        },
        _2 = function(e2) {
          a(e2) && e2.getAttribute("data-scroll-lock-locked") === "true" && (e2.style.overflow = e2.getAttribute("data-scroll-lock-saved-inline-overflow-property"), e2.style.overflowY = e2.getAttribute("data-scroll-lock-saved-inline-overflow-y-property"), e2.removeAttribute("data-scroll-lock-saved-overflow-property"), e2.removeAttribute("data-scroll-lock-saved-inline-overflow-property"), e2.removeAttribute("data-scroll-lock-saved-inline-overflow-y-property"), e2.removeAttribute("data-scroll-lock-locked"))
        },
        X = function() {
          w.fillGapSelectors.map(function(e2) {
            D(e2)
          })
        },
        Q = function() {
          w.fillGapSelectors.map(function(e2) {
            z(e2)
          })
        },
        D = function(e2) {
          var t22 = document.querySelectorAll(e2),
              l2 = w.lockableSelectors.indexOf(e2) !== -1;
          o(t22, function(e3) {
            H(e3, l2)
          })
        },
        H = function(e2) {
          var t22 = 1 < arguments.length && arguments[1] !== void 0 && arguments[1];
          if (a(e2)) {
            var l2;
            if (e2.getAttribute("data-scroll-lock-lockable") === "" || t22) l2 = g(e2, !0);
            else {
              var r2 = h(e2, b(w.lockableSelectors));
              l2 = g(r2, !0)
            }
            e2.getAttribute("data-scroll-lock-filled-gap") === "true" && I(e2);
            var o2 = window.getComputedStyle(e2);
            if (e2.setAttribute("data-scroll-lock-filled-gap", "true"), e2.setAttribute("data-scroll-lock-current-fill-gap-method", w.fillGapMethod), w.fillGapMethod === "margin") {
              var n2 = parseFloat(o2.marginRight);
              e2.style.marginRight = "".concat(n2 + l2, "px")
            } else if (w.fillGapMethod === "width") e2.style.width = "calc(100% - ".concat(l2, "px)");
            else if (w.fillGapMethod === "max-width") e2.style.maxWidth = "calc(100% - ".concat(l2, "px)");
            else if (w.fillGapMethod === "padding") {
              var c2 = parseFloat(o2.paddingRight);
              e2.style.paddingRight = "".concat(c2 + l2, "px")
            }
          }
        },
        z = function(e2) {
          var t22 = document.querySelectorAll(e2);
          o(t22, function(e3) {
            I(e3)
          })
        },
        I = function(e2) {
          if (a(e2) && e2.getAttribute("data-scroll-lock-filled-gap") === "true") {
            var t22 = e2.getAttribute("data-scroll-lock-current-fill-gap-method");
            e2.removeAttribute("data-scroll-lock-filled-gap"), e2.removeAttribute("data-scroll-lock-current-fill-gap-method"), t22 === "margin" ? e2.style.marginRight = "" : t22 === "width" ? e2.style.width = "" : t22 === "max-width" ? e2.style.maxWidth = "" : t22 === "padding" && (e2.style.paddingRight = "")
          }
        };
    typeof window < "u" && window.addEventListener("resize", function(e2) {
      N()
    }), typeof document < "u" && (document.addEventListener("touchstart", function(e2) {
      w.scroll || (w.startTouchY = e2.touches[0].clientY, w.startTouchX = e2.touches[0].clientX)
    }), document.addEventListener("touchmove", function(n2) {
      if (!w.scroll) {
        var e2 = w.startTouchY,
            t22 = w.startTouchX,
            l2 = n2.touches[0].clientY,
            r2 = n2.touches[0].clientX;
        if (n2.touches.length < 2) {
          var c2 = b(w.scrollableSelectors),
              a2 = e2 < l2,
              i2 = l2 < e2,
              u2 = t22 < r2,
              d2 = r2 < t22,
              s2 = e2 + 3 < l2,
              f2 = l2 < e2 - 3,
              p2 = t22 + 3 < r2,
              g2 = r2 < t22 - 3;
          (function e3(t23) {
            var l3 = 1 < arguments.length && arguments[1] !== void 0 && arguments[1];
            if (t23) {
              var r3 = h(t23, c2, !1);
              if (v(t23, 'input[type="range"]')) return !1;
              if (l3 || v(t23, 'textarea, [contenteditable="true"]') && h(t23, c2) || v(t23, c2)) {
                var o2 = !1;
                y(t23) && k(t23) ? (a2 && m(t23) || i2 && S(t23)) && (o2 = !0) : m(t23) && S(t23) ? (u2 && y(t23) || d2 && k(t23)) && (o2 = !0) : (s2 && m(t23) || f2 && S(t23) || p2 && y(t23) || g2 && k(t23)) && (o2 = !0), o2 && (r3 ? e3(r3, !0) : n2.preventDefault())
              } else e3(r3)
            } else n2.preventDefault()
          })(n2.target)
        }
      }
    }, {
      passive: !1
    }), document.addEventListener("touchend", function(e2) {
      w.scroll || (w.startTouchY = 0, w.startTouchX = 0)
    }));
    var J = {
          hide: function(e2) {
            n(`"hide" is deprecated! Use "disablePageScroll" instead. 
 https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget`), d(e2)
          },
          show: function(e2) {
            n(`"show" is deprecated! Use "enablePageScroll" instead. 
 https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget`), s(e2)
          },
          toggle: function(e2) {
            n('"toggle" is deprecated! Do not use it.'), f() ? d() : s(e2)
          },
          getState: function() {
            return n(`"getState" is deprecated! Use "getScrollState" instead. 
 https://github.com/FL3NKEY/scroll-lock#getscrollstate`), f()
          },
          getWidth: function() {
            return n(`"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. 
 https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth`), G()
          },
          getCurrentWidth: function() {
            return n(`"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. 
 https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth`), T()
          },
          setScrollableTargets: function(e2) {
            n(`"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. 
 https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget`), L(e2)
          },
          setFillGapSelectors: function(e2) {
            n(`"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. 
 https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector`), q(e2)
          },
          setFillGapTargets: function(e2) {
            n(`"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. 
 https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget`), P(e2)
          },
          clearQueue: function() {
            n(`"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. 
 https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks`), p()
          }
        },
        V = function(o2) {
          for (var e2 = 1; e2 < arguments.length; e2++) {
            var n2 = arguments[e2] != null ? arguments[e2] : {},
                t22 = Object.keys(n2);
            typeof Object.getOwnPropertySymbols == "function" && (t22 = t22.concat(Object.getOwnPropertySymbols(n2).filter(function(e3) {
              return Object.getOwnPropertyDescriptor(n2, e3).enumerable
            }))), t22.forEach(function(e3) {
              var t23, l2, r2;
              t23 = o2, r2 = n2[l2 = e3], l2 in t23 ? Object.defineProperty(t23, l2, {
                value: r2,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : t23[l2] = r2
            })
          }
          return o2
        }({
          disablePageScroll: d,
          enablePageScroll: s,
          getScrollState: f,
          clearQueueScrollLocks: p,
          getTargetScrollBarWidth: g,
          getCurrentTargetScrollBarWidth: A,
          getPageScrollBarWidth: G,
          getCurrentPageScrollBarWidth: T,
          addScrollableSelector: x,
          removeScrollableSelector: F,
          addScrollableTarget: L,
          removeScrollableTarget: W,
          addLockableSelector: E,
          addLockableTarget: Y,
          addFillGapSelector: q,
          removeFillGapSelector: M,
          addFillGapTarget: P,
          removeFillGapTarget: j,
          setFillGapMethod: O,
          refillGaps: N,
          _state: w
        }, J);
    t21.default = V
  }]).default
}),
    function(e, t21) {
      typeof exports == "object" && typeof module < "u" ? t21(exports) : typeof define == "function" && define.amd ? define(["exports"], t21) : t21((e = typeof globalThis < "u" ? globalThis : e || self).Sqrl = {})
    }(this, function(e) {
      "use strict";

      function t21(e2) {
        var n2, r2, a2 = new Error(e2);
        return n2 = a2, r2 = t21.prototype, Object.setPrototypeOf ? Object.setPrototypeOf(n2, r2) : n2.__proto__ = r2, a2
      }

      function n(e2, n2, r2) {
        var a2 = n2.slice(0, r2).split(/\n/),
            i2 = a2.length,
            s2 = a2[i2 - 1].length + 1;
        throw t21(e2 += " at line " + i2 + " col " + s2 + `:

  ` + n2.split(/\n/)[i2 - 1] + `
  ` + Array(s2).join(" ") + "^")
      }
      t21.prototype = Object.create(Error.prototype, {
        name: {
          value: "Squirrelly Error",
          enumerable: !1
        }
      });
      var r = new Function("return this")().Promise,
          a = !1;
      try {
        a = new Function("return (async function(){}).constructor")()
      } catch (e2) {
        if (!(e2 instanceof SyntaxError)) throw e2
      }

      function i(e2, t22) {
        return Object.prototype.hasOwnProperty.call(e2, t22)
      }

      function s(e2, t22, n2) {
        for (var r2 in t22) i(t22, r2) && (t22[r2] == null || typeof t22[r2] != "object" || r2 !== "storage" && r2 !== "prefixes" || n2 ? e2[r2] = t22[r2] : e2[r2] = s({}, t22[r2]));
        return e2
      }
      var c = /^async +/,
          o = /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})*}|(?!\${)[^\\`])*`/g,
          l = /'(?:\\[\s\w"'\\`]|[^\n\r'\\])*?'/g,
          f = /"(?:\\[\s\w"'\\`]|[^\n\r"\\])*?"/g,
          u = /[.*+\-?^${}()|[\]\\]/g;

      function p(e2) {
        return u.test(e2) ? e2.replace(u, "\\$&") : e2
      }

      function h(e2, r2) {
        r2.rmWhitespace && (e2 = e2.replace(/[\r\n]+/g, `
`).replace(/^\s+|\s+$/gm, "")), o.lastIndex = 0, l.lastIndex = 0, f.lastIndex = 0;
        var a2 = r2.prefixes,
            i2 = [a2.h, a2.b, a2.i, a2.r, a2.c, a2.e].reduce(function(e3, t22) {
              return e3 && t22 ? e3 + "|" + p(t22) : t22 ? p(t22) : e3
            }, ""),
            s2 = new RegExp("([|()]|=>)|('|\"|`|\\/\\*)|\\s*((\\/)?(-|_)?" + p(r2.tags[1]) + ")", "g"),
            u2 = new RegExp("([^]*?)" + p(r2.tags[0]) + "(-|_)?\\s*(" + i2 + ")?\\s*", "g"),
            h2 = 0,
            d2 = !1;

        function g2(t22, a3) {
          var i3, p2 = {
                f: []
              },
              g3 = 0,
              v3 = "c";

          function m3(t23) {
            var a4 = e2.slice(h2, t23),
                i4 = a4.trim();
            if (v3 === "f") i4 === "safe" ? p2.raw = !0 : r2.async && c.test(i4) ? (i4 = i4.replace(c, ""), p2.f.push([i4, "", !0])) : p2.f.push([i4, ""]);
            else if (v3 === "fp") p2.f[p2.f.length - 1][1] += i4;
            else if (v3 === "err") {
              if (i4) {
                var s3 = a4.search(/\S/);
                n("invalid syntax", e2, h2 + s3)
              }
            } else p2[v3] = i4;
            h2 = t23 + 1
          }
          for (a3 === "h" || a3 === "b" || a3 === "c" ? v3 = "n" : a3 === "r" && (p2.raw = !0, a3 = "i"), s2.lastIndex = h2;
               (i3 = s2.exec(e2)) !== null;) {
            var y3 = i3[1],
                x2 = i3[2],
                b2 = i3[3],
                w2 = i3[4],
                F2 = i3[5],
                S2 = i3.index;
            if (y3) y3 === "(" ? (g3 === 0 && (v3 === "n" ? (m3(S2), v3 = "p") : v3 === "f" && (m3(S2), v3 = "fp")), g3++) : y3 === ")" ? --g3 === 0 && v3 !== "c" && (m3(S2), v3 = "err") : g3 === 0 && y3 === "|" ? (m3(S2), v3 = "f") : y3 === "=>" && (m3(S2), h2 += 1, v3 = "res");
            else if (x2)
              if (x2 === "/*") {
                var I2 = e2.indexOf("*/", s2.lastIndex);
                I2 === -1 && n("unclosed comment", e2, i3.index), s2.lastIndex = I2 + 2
              } else x2 === "'" ? (l.lastIndex = i3.index, l.exec(e2) ? s2.lastIndex = l.lastIndex : n("unclosed string", e2, i3.index)) : x2 === '"' ? (f.lastIndex = i3.index, f.exec(e2) ? s2.lastIndex = f.lastIndex : n("unclosed string", e2, i3.index)) : x2 === "`" && (o.lastIndex = i3.index, o.exec(e2) ? s2.lastIndex = o.lastIndex : n("unclosed string", e2, i3.index));
            else if (b2) return m3(S2), h2 = S2 + i3[0].length, u2.lastIndex = h2, d2 = F2, w2 && a3 === "h" && (a3 = "s"), p2.t = a3, p2
          }
          return n("unclosed tag", e2, t22), p2
        }
        var v2 = function i3(s3, o2) {
          s3.b = [], s3.d = [];
          var l2, f2 = !1,
              p2 = [];

          function v3(e3, t22) {
            e3 && (e3 = function(e4, t23, n2, r3) {
              var a3, i4;
              return typeof t23.autoTrim == "string" ? a3 = i4 = t23.autoTrim : Array.isArray(t23.autoTrim) && (a3 = t23.autoTrim[1], i4 = t23.autoTrim[0]), (n2 || n2 === !1) && (a3 = n2), (r3 || r3 === !1) && (i4 = r3), a3 === "slurp" && i4 === "slurp" ? e4.trim() : (a3 === "_" || a3 === "slurp" ? e4 = String.prototype.trimLeft ? e4.trimLeft() : e4.replace(/^[\s\uFEFF\xA0]+/, "") : a3 !== "-" && a3 !== "nl" || (e4 = e4.replace(/^(?:\n|\r|\r\n)/, "")), i4 === "_" || i4 === "slurp" ? e4 = String.prototype.trimRight ? e4.trimRight() : e4.replace(/[\s\uFEFF\xA0]+$/, "") : i4 !== "-" && i4 !== "nl" || (e4 = e4.replace(/(?:\n|\r|\r\n)$/, "")), e4)
            }(e3, r2, d2, t22)) && (e3 = e3.replace(/\\|'/g, "\\$&").replace(/\r\n|\n|\r/g, "\\n"), p2.push(e3))
          }
          for (;
              (l2 = u2.exec(e2)) !== null;) {
            var m3, y3 = l2[1],
                x2 = l2[2],
                b2 = l2[3] || "";
            for (var w2 in a2)
              if (a2[w2] === b2) {
                m3 = w2;
                break
              } v3(y3, x2), h2 = l2.index + l2[0].length, m3 || n("unrecognized tag type: " + b2, e2, h2);
            var F2 = g2(l2.index, m3),
                S2 = F2.t;
            if (S2 === "h") {
              var I2 = F2.n || "";
              r2.async && c.test(I2) && (F2.a = !0, F2.n = I2.replace(c, "")), F2 = i3(F2), p2.push(F2)
            } else if (S2 === "c") {
              if (s3.n === F2.n) return f2 ? (f2.d = p2, s3.b.push(f2)) : s3.d = p2, s3;
              n("Helper start and end don't match", e2, l2.index + l2[0].length)
            } else if (S2 === "b") {
              f2 ? (f2.d = p2, s3.b.push(f2)) : s3.d = p2;
              var R2 = F2.n || "";
              r2.async && c.test(R2) && (F2.a = !0, F2.n = R2.replace(c, "")), f2 = F2, p2 = []
            } else if (S2 === "s") {
              var T2 = F2.n || "";
              r2.async && c.test(T2) && (F2.a = !0, F2.n = T2.replace(c, "")), p2.push(F2)
            } else p2.push(F2)
          }
          if (!o2) throw t21('unclosed helper "' + s3.n + '"');
          return v3(e2.slice(h2, e2.length), !1), s3.d = p2, s3
        }({
          f: []
        }, !0);
        if (r2.plugins)
          for (var m2 = 0; m2 < r2.plugins.length; m2++) {
            var y2 = r2.plugins[m2];
            y2.processAST && (v2.d = y2.processAST(v2.d, r2))
          }
        return v2.d
      }

      function d(e2, t22) {
        var n2 = h(e2, t22),
            r2 = "var tR='';" + (t22.useWith ? "with(" + t22.varName + "||{}){" : "") + x(n2, t22) + "if(cb){cb(null,tR)} return tR" + (t22.useWith ? "}" : "");
        if (t22.plugins)
          for (var a2 = 0; a2 < t22.plugins.length; a2++) {
            var i2 = t22.plugins[a2];
            i2.processFnString && (r2 = i2.processFnString(r2, t22))
          }
        return r2
      }

      function g(e2, t22) {
        for (var n2 = 0; n2 < t22.length; n2++) {
          var r2 = t22[n2][0],
              a2 = t22[n2][1];
          e2 = (t22[n2][2] ? "await " : "") + "c.l('F','" + r2 + "')(" + e2, a2 && (e2 += "," + a2), e2 += ")"
        }
        return e2
      }

      function v(e2, t22, n2, r2, a2, i2) {
        var s2 = "{exec:" + (a2 ? "async " : "") + y(n2, t22, e2) + ",params:[" + r2 + "]";
        return i2 && (s2 += ",name:'" + i2 + "'"), a2 && (s2 += ",async:true"), s2 += "}"
      }

      function m(e2, t22) {
        for (var n2 = "[", r2 = 0; r2 < e2.length; r2++) {
          var a2 = e2[r2];
          n2 += v(t22, a2.res || "", a2.d, a2.p || "", a2.a, a2.n), r2 < e2.length && (n2 += ",")
        }
        return n2 += "]"
      }

      function y(e2, t22, n2) {
        return "function(" + t22 + "){var tR='';" + x(e2, n2) + "return tR}"
      }

      function x(e2, t22) {
        for (var n2 = 0, r2 = e2.length, a2 = ""; n2 < r2; n2++) {
          var i2 = e2[n2];
          if (typeof i2 == "string") a2 += "tR+='" + i2 + "';";
          else {
            var s2 = i2.t,
                c2 = i2.c || "",
                o2 = i2.f,
                l2 = i2.n || "",
                f2 = i2.p || "",
                u2 = i2.res || "",
                p2 = i2.b,
                h2 = !!i2.a;
            if (s2 === "i") {
              t22.defaultFilter && (c2 = "c.l('F','" + t22.defaultFilter + "')(" + c2 + ")");
              var d2 = g(c2, o2);
              !i2.raw && t22.autoEscape && (d2 = "c.l('F','e')(" + d2 + ")"), a2 += "tR+=" + d2 + ";"
            } else if (s2 === "h")
              if (t22.storage.nativeHelpers.get(l2)) a2 += t22.storage.nativeHelpers.get(l2)(i2, t22);
              else {
                var y2 = (h2 ? "await " : "") + "c.l('H','" + l2 + "')(" + v(t22, u2, i2.d, f2, h2);
                y2 += p2 ? "," + m(p2, t22) : ",[]", a2 += "tR+=" + g(y2 += ",c)", o2) + ";"
              }
            else s2 === "s" ? a2 += "tR+=" + g((h2 ? "await " : "") + "c.l('H','" + l2 + "')({params:[" + f2 + "]},[],c)", o2) + ";" : s2 === "e" && (a2 += c2 + `
`)
          }
        }
        return a2
      }
      var b = function() {
            function e2(e3) {
              this.cache = e3
            }
            return e2.prototype.define = function(e3, t22) {
              this.cache[e3] = t22
            }, e2.prototype.get = function(e3) {
              return this.cache[e3]
            }, e2.prototype.remove = function(e3) {
              delete this.cache[e3]
            }, e2.prototype.reset = function() {
              this.cache = {}
            }, e2.prototype.load = function(e3) {
              s(this.cache, e3, !0)
            }, e2
          }(),
          w = new b({});

      function F(e2, n2, r2, a2) {
        if (n2 && n2.length > 0) throw t21((a2 ? "Native" : "") + "Helper '" + e2 + "' doesn't accept blocks");
        if (r2 && r2.length > 0) throw t21((a2 ? "Native" : "") + "Helper '" + e2 + "' doesn't accept filters")
      }
      var S = new b({
            each: function(e2, t22) {
              var n2 = "",
                  r2 = e2.params[0];
              if (F("each", t22, !1), e2.async) return new Promise(function(t23) {
                (function e3(t24, n3, r3, a3, i2) {
                  r3(t24[n3], n3).then(function(s2) {
                    a3 += s2, n3 === t24.length - 1 ? i2(a3) : e3(t24, n3 + 1, r3, a3, i2)
                  })
                })(r2, 0, e2.exec, n2, t23)
              });
              for (var a2 = 0; a2 < r2.length; a2++) n2 += e2.exec(r2[a2], a2);
              return n2
            },
            foreach: function(e2, t22) {
              var n2 = e2.params[0];
              if (F("foreach", t22, !1), e2.async) return new Promise(function(t23) {
                (function e3(t24, n3, r3, a3, i2, s2) {
                  a3(n3[r3], t24[n3[r3]]).then(function(c2) {
                    i2 += c2, r3 === n3.length - 1 ? s2(i2) : e3(t24, n3, r3 + 1, a3, i2, s2)
                  })
                })(n2, Object.keys(n2), 0, e2.exec, "", t23)
              });
              var r2 = "";
              for (var a2 in n2) i(n2, a2) && (r2 += e2.exec(a2, n2[a2]));
              return r2
            },
            include: function(e2, n2, r2) {
              F("include", n2, !1);
              var a2 = r2.storage.templates.get(e2.params[0]);
              if (!a2) throw t21('Could not fetch template "' + e2.params[0] + '"');
              return a2(e2.params[1], r2)
            },
            extends: function(e2, n2, r2) {
              var a2 = e2.params[1] || {};
              a2.content = e2.exec();
              for (var i2 = 0; i2 < n2.length; i2++) {
                var s2 = n2[i2];
                a2[s2.name] = s2.exec()
              }
              var c2 = r2.storage.templates.get(e2.params[0]);
              if (!c2) throw t21('Could not fetch template "' + e2.params[0] + '"');
              return c2(a2, r2)
            },
            useScope: function(e2, t22) {
              return F("useScope", t22, !1), e2.exec(e2.params[0])
            }
          }),
          I = new b({
            if: function(e2, t22) {
              F("if", !1, e2.f, !0);
              var n2 = "if(" + e2.p + "){" + x(e2.d, t22) + "}";
              if (e2.b)
                for (var r2 = 0; r2 < e2.b.length; r2++) {
                  var a2 = e2.b[r2];
                  a2.n === "else" ? n2 += "else{" + x(a2.d, t22) + "}" : a2.n === "elif" && (n2 += "else if(" + a2.p + "){" + x(a2.d, t22) + "}")
                }
              return n2
            },
            try: function(e2, n2) {
              if (F("try", !1, e2.f, !0), !e2.b || e2.b.length !== 1 || e2.b[0].n !== "catch") throw t21("native helper 'try' only accepts 1 block, 'catch'");
              var r2 = "try{" + x(e2.d, n2) + "}",
                  a2 = e2.b[0];
              return r2 += "catch" + (a2.res ? "(" + a2.res + ")" : "") + "{" + x(a2.d, n2) + "}"
            },
            block: function(e2, t22) {
              return F("block", e2.b, e2.f, !0), "if(!" + t22.varName + "[" + e2.p + "]){tR+=(" + y(e2.d, "", t22) + ")()}else{tR+=" + t22.varName + "[" + e2.p + "]}"
            }
          }),
          R = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
          };

      function T(e2) {
        return R[e2]
      }
      var E = new b({
            e: function(e2) {
              var t22 = String(e2);
              return /[&<>"']/.test(t22) ? t22.replace(/[&<>"']/g, T) : t22
            }
          }),
          j = {
            varName: "it",
            autoTrim: [!1, "nl"],
            autoEscape: !0,
            defaultFilter: !1,
            tags: ["{{", "}}"],
            l: function(e2, n2) {
              if (e2 === "H") {
                var r2 = this.storage.helpers.get(n2);
                if (r2) return r2;
                throw t21("Can't find helper '" + n2 + "'")
              }
              if (e2 === "F") {
                var a2 = this.storage.filters.get(n2);
                if (a2) return a2;
                throw t21("Can't find filter '" + n2 + "'")
              }
            },
            async: !1,
            storage: {
              helpers: S,
              nativeHelpers: I,
              filters: E,
              templates: w
            },
            prefixes: {
              h: "@",
              b: "#",
              i: "",
              r: "*",
              c: "/",
              e: "!"
            },
            cache: !1,
            plugins: [],
            useWith: !1
          };

      function H(e2, t22) {
        var n2 = {};
        return s(n2, j), t22 && s(n2, t22), e2 && s(n2, e2), n2.l.bind(n2), n2
      }

      function O(e2, n2) {
        var r2 = H(n2 || {}),
            i2 = Function;
        if (r2.async) {
          if (!a) throw t21("This environment doesn't support async/await");
          i2 = a
        }
        try {
          return new i2(r2.varName, "c", "cb", d(e2, r2))
        } catch (n3) {
          throw n3 instanceof SyntaxError ? t21(`Bad template syntax

` + n3.message + `
` + Array(n3.message.length + 1).join("=") + `
` + d(e2, r2)) : n3
        }
      }

      function _2(e2, t22) {
        var n2;
        return t22.cache && t22.name && t22.storage.templates.get(t22.name) ? t22.storage.templates.get(t22.name) : (n2 = typeof e2 == "function" ? e2 : O(e2, t22), t22.cache && t22.name && t22.storage.templates.define(t22.name, n2), n2)
      }
      j.l.bind(j), e.compile = O, e.compileScope = x, e.compileScopeIntoFunction = y, e.compileToString = d, e.defaultConfig = j, e.filters = E, e.getConfig = H, e.helpers = S, e.nativeHelpers = I, e.parse = h, e.render = function(e2, n2, a2, i2) {
        var s2 = H(a2 || {});
        if (!s2.async) return _2(e2, s2)(n2, s2);
        if (!i2) {
          if (typeof r == "function") return new r(function(t22, r2) {
            try {
              t22(_2(e2, s2)(n2, s2))
            } catch (e3) {
              r2(e3)
            }
          });
          throw t21("Please provide a callback function, this env doesn't support Promises")
        }
        try {
          _2(e2, s2)(n2, s2, i2)
        } catch (e3) {
          return i2(e3)
        }
      }, e.templates = w, Object.defineProperty(e, "__esModule", {
        value: !0
      })
    }),
    function(n, t21) {
      "$:nomunge";
      var o, u = n.jQuery || n.Cowboy || (n.Cowboy = {});
      u.throttle = o = function(n2, o2, e, i) {
        var r, a = 0;

        function c() {
          var u2 = this,
              c2 = +new Date - a,
              f = arguments;

          function d() {
            a = +new Date, e.apply(u2, f)
          }
          i && !r && d(), r && clearTimeout(r), i === t21 && c2 > n2 ? d() : o2 !== !0 && (r = setTimeout(i ? function() {
            r = t21
          } : d, i === t21 ? n2 - c2 : n2))
        }
        return typeof o2 != "boolean" && (i = e, e = o2, o2 = t21), u.guid && (c.guid = e.guid = e.guid || u.guid++), c
      }
    }(this), window.isYoutubeAPILoaded = !1;

function loadYoutubeAPI() {
  if (!isYoutubeAPILoaded) {
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }
}

function onYouTubeIframeAPIReady() {
  window.isYoutubeAPILoaded = !0, PaloAlto.ProductVideo.loadVideos(PaloAlto.ProductVideo.hosts.youtube), $("body").trigger("youtubeAPIReady")
}
/*!
  Zoom 1.7.20
  license: MIT
  http://www.jacklmoore.com/zoom
*/
(function(o) {
  var t21 = {
    url: !1,
    callback: !1,
    target: !1,
    duration: 120,
    on: "mouseover",
    touch: !0,
    onZoomIn: !1,
    onZoomOut: !1,
    magnify: 1
  };
  o.zoom = function(t22, n, e, i) {
    var u, c, r, a, m, l, s, f = o(t22),
        h = f.css("position"),
        d = o(n);
    return t22.style.position = /(absolute|fixed)/.test(h) ? h : "relative", t22.style.overflow = "hidden", e.style.width = e.style.height = "", o(e).addClass("zoomImg").css({
      position: "absolute",
      top: 0,
      left: 0,
      opacity: 0,
      width: e.width * i,
      height: e.height * i,
      border: "none",
      maxWidth: "none",
      maxHeight: "none"
    }).appendTo(t22), {
      init: function() {
        c = f.outerWidth(), u = f.outerHeight(), n === t22 ? (a = c, r = u) : (a = d.outerWidth(), r = d.outerHeight()), m = (e.width - c) / a, l = (e.height - u) / r, s = d.offset()
      },
      move: function(o2) {
        var t23 = o2.pageX - s.left,
            n2 = o2.pageY - s.top;
        n2 = Math.max(Math.min(n2, r), 0), t23 = Math.max(Math.min(t23, a), 0), e.style.left = t23 * -m + "px", e.style.top = n2 * -l + "px"
      }
    }
  }, o.fn.zoom = function(n) {
    return this.each(function() {
      var e = o.extend({}, t21, n || {}),
          i = e.target && o(e.target)[0] || this,
          u = this,
          c = o(u),
          r = document.createElement("img"),
          a = o(r),
          m = "mousemove.zoom",
          l = !1,
          s = !1;
      if (!e.url) {
        var f = u.querySelector("img");
        if (f && (e.url = f.getAttribute("data-src") || f.currentSrc || f.src), !e.url) return
      }
      c.one("zoom.destroy", function(o2, t22) {
        c.off(".zoom"), i.style.position = o2, i.style.overflow = t22, r.onload = null, a.remove()
      }.bind(this, i.style.position, i.style.overflow)), r.onload = function() {
        function t22(t23) {
          f2.init(), f2.move(t23), a.stop().fadeTo(o.support.opacity ? e.duration : 0, 1, o.isFunction(e.onZoomIn) ? e.onZoomIn.call(r) : !1)
        }

        function n2() {
          a.stop().fadeTo(e.duration, 0, o.isFunction(e.onZoomOut) ? e.onZoomOut.call(r) : !1)
        }
        var f2 = o.zoom(i, u, r, e.magnify);
        e.on === "grab" ? c.on("mousedown.zoom", function(e2) {
          e2.which === 1 && (o(document).one("mouseup.zoom", function() {
            n2(), o(document).off(m, f2.move)
          }), t22(e2), o(document).on(m, f2.move), e2.preventDefault())
        }) : e.on === "click" ? c.on("click.zoom", function(e2) {
          return l ? void 0 : (l = !0, t22(e2), o(document).on(m, f2.move), o(document).one("click.zoom", function() {
            n2(), l = !1, o(document).off(m, f2.move)
          }), !1)
        }) : e.on === "toggle" ? c.on("click.zoom", function(o2) {
          l ? n2() : t22(o2), l = !l
        }) : e.on === "mouseover" && (f2.init(), c.on("mouseenter.zoom", t22).on("mouseleave.zoom", n2).on(m, f2.move)), e.touch && c.on("touchstart.zoom", function(o2) {
          o2.preventDefault(), s ? (s = !1, n2()) : (s = !0, t22(o2.originalEvent.touches[0] || o2.originalEvent.changedTouches[0]))
        }).on("touchmove.zoom", function(o2) {
          o2.preventDefault(), f2.move(o2.originalEvent.touches[0] || o2.originalEvent.changedTouches[0])
        }).on("touchend.zoom", function(o2) {
          o2.preventDefault(), s && (s = !1, n2())
        }), o.isFunction(e.callback) && e.callback.call(r)
      }, r.setAttribute("role", "presentation"), r.src = e.url
    })
  }, o.fn.zoom.defaults = t21
})(window.jQuery), slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null,
    trigger: null
  },
  pageLinkFocus: function($element) {
    var focusClass = "js-focus-hidden";
    $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex")
    }
  },
  trapFocus: function(options) {
    var focusableElements = Array.from(options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function(element) {
      var width = element.offsetWidth,
          height = element.offsetHeight;
      return width !== 0 && height !== 0 && getComputedStyle(element).getPropertyValue("display") !== "none"
    });
    this.state.firstFocusable = focusableElements[0], this.state.lastFocusable = focusableElements[focusableElements.length - 1], options.elementToFocus || (options.elementToFocus = options.container), options.container.setAttribute("tabindex", "-1"), options.elementToFocus.focus(), this._setupHandlers(), document.addEventListener("focusin", this._onFocusInHandler), document.addEventListener("focusout", this._onFocusOutHandler)
  },
  removeTrapFocus: function(options) {
    const focusVisible = !document.body.classList.contains("no-outline");
    options && options.container && options.container.removeAttribute("tabindex"), document.removeEventListener("focusin", this._onFocusInHandler), this.state.trigger && focusVisible && this.state.trigger.focus()
  },
  _manageFocus: function(evt) {
    evt.keyCode === slate.utils.keyboardKeys.TAB && (evt.target === this.state.lastFocusable && !evt.shiftKey && (evt.preventDefault(), this.state.firstFocusable.focus()), evt.target === this.state.firstFocusable && evt.shiftKey && (evt.preventDefault(), this.state.lastFocusable.focus()))
  },
  _onFocusOut: function() {
    document.removeEventListener("keydown", this._manageFocusHandler)
  },
  _onFocusIn: function(evt) {
    evt.target !== this.state.lastFocusable && evt.target !== this.state.firstFocusable || document.addEventListener("keydown", this._manageFocusHandler)
  },
  _setupHandlers: function() {
    this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)), this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)), this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this))
  }
}, slate.Currency = function() {
  var moneyFormat = "${{amount}}";

  function formatMoney(cents, format) {
    typeof cents == "string" && (cents = cents.replace(".", ""));
    var value = "",
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      if (thousands = thousands || ",", decimal = decimal || ".", isNaN(number) || number === null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split("."),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break
    }
    return formatString.replace(placeholderRegex, value)
  }
  return {
    formatMoney
  }
}(), slate.utils = {
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++)
      if (array[i][key] === value) return array[i]
  },
  removeInstance: function(array, key, value) {
    for (var i = array.length; i--;)
      if (array[i][key] === value) {
        array.splice(i, 1);
        break
      } return array
  },
  compact: function(array) {
    for (var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = []; ++index < length;) {
      var value = array[index];
      value && (result[resIndex++] = value)
    }
    return result
  },
  defaultTo: function(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value
  },
  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
}, slate.Variants = function() {
  function Variants(options) {
    this.$container = options.$container, this.product = options.product, this.singleOptionSelector = options.singleOptionSelector, this.originalSelectorId = options.originalSelectorId, this.enableHistoryState = options.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), this.storeAvailability = options.storeAvailability, $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this)), this.storeAvailability && this.storeAvailability.updateContent(this.currentVariant.id, this.product.title)
  }
  return Variants.prototype = $.extend({}, Variants.prototype, {
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element),
            type = $element.attr("type"),
            currentOption = {};
        return type === "radio" || type === "checkbox" ? $element[0].checked ? (currentOption.value = $element.val(), currentOption.index = $element.data("index"), currentOption) : !1 : (currentOption.value = $element.val(), currentOption.index = $element.data("index"), currentOption)
      });
      return currentOptions = slate.utils.compact(currentOptions), currentOptions
    },
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions(),
          variants = this.product?.variants,
          found = !1;
      const availableOption2 = document.querySelector("[data-option='option2']");

      document.querySelectorAll("[data-option-value]").forEach(elem => {
        elem.style.display = "block";
      });

      variants?.forEach(function(variant) {
        var satisfied = !0;
        if (selectedValues.length > 2) {
          var selectedColor = selectedValues.find(option => option.index == "option1")?.value,
              option2DropdownElem = document.querySelector(`[data-option-available='${variant.option2}']`),
              variantOptionsStr = variant.options.join(" / ");

          if (variant.available == !1 && variant.option1 == selectedColor) {
            option2DropdownElem?.classList.add("out-of-stock-option");
          } else {
            option2DropdownElem?.classList.remove("out-of-stock-option");
          }

          selectedValues.forEach(selectedOption => {
            var isIncluded = variantOptionsStr.includes(selectedOption.value);
            if (!isIncluded) satisfied = !1;
          });

          if (satisfied) {
            const option2Elem = document.querySelector("[data-selected-option='2']");
            const option3Elem = document.querySelector("[data-selected-option='3']");
            if (option2Elem) option2Elem.innerHTML = variant.option2;
            if (option3Elem) option3Elem.innerHTML = variant.option3;
          }
        } else {
          selectedValues.forEach(function(option) {
            if (availableOption2) {
              if (option.index === "option1") {
                if (option.value !== variant.option1) {
                  if (variant.option2.includes("cm")) {
                    const optionValueElem = document.querySelector(`[data-option-value='${variant.option2}']`);
                    if (optionValueElem) optionValueElem.style.display = "none";
                  }
                } else if (option.value == variant.option1 && selectedValues[1] && selectedValues[1].option2 === variant.option2) {
                  const option2Elem = document.querySelector("[data-selected-option='2']");
                  if (option2Elem) option2Elem.innerHTML = variant.option2;
                }
              }
              if (variant.available == !1) {
                const option2AvailableElem = document.querySelector(`[data-option-available='${variant.option2}']`);
                if (option2AvailableElem) option2AvailableElem.style.opacity = "0.7";
              }
            } else if (variant.available == !1) {
              const option1AvailableElem = document.querySelector(`[data-option-available='${variant.option1}']`);
              if (option1AvailableElem) option1AvailableElem.style.opacity = "0.7";
            }
            if (satisfied) satisfied = option.value === variant[option.index];
          });
        }

        if (satisfied) found = variant;
      });

      return found || null;
    },
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: "variantChange",
        variant
      }), variant && (this._updateMasterSelect(variant), this._updateImages(variant), this._updatePrice(variant), this._updateUnits(variant), this._updateStoreAvailabilityContent(variant), this.currentVariant = variant, this.enableHistoryState && this._updateHistoryState(variant))
    },
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {},
          currentVariantImage = this.currentVariant.featured_image || {};
      !variant.featured_image || variantImage.src === currentVariantImage.src || this.$container.trigger({
        type: "variantImageChange",
        variant
      })
    },
    _updatePrice: function(variant) {
      variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
        type: "variantPriceChange",
        variant
      })
    },
    _updateUnits: function(variant) {
      this.$container.trigger({
        type: "variantUnitChange",
        variant
      })
    },
    _updateHistoryState: function(variant) {
      if (!(!history.replaceState || !variant)) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
        window.history.replaceState({
          path: newurl
        }, "", newurl)
      }
    },
    _updateStoreAvailabilityContent: function(variant) {
      this.storeAvailability && (variant ? this.storeAvailability.updateContent(variant.id, this.product.title) : this.storeAvailability.clearContent())
    },
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id
    }
  }), Variants
}(), PaloAlto.initCart = function() {
  var selectors = {
        body: "body",
        templateCart: ".template-cart",
        cart: ".cart",
        cartUpdate: ".cart__update",
        cartSection: "[data-cart-section]",
        cartFormContainer: "[data-cart-form-container]",
        cartForm: "form.cart",
        cartFormDynamicCheckout: ".additional-checkout-buttons form",
        cartRow: ".cart__row",
        cartRemove: ".cart__remove",
        cartItems: ".cart__items",
        cartItemQty: "[data-item-qty]",
        cartItemCount: "[data-item-count]",
        cartDiscounts: ".cart__discounts",
        cartSubtotalPrice: ".cart__subtotal__price",
        cartAcceptanceCheckbox: "[data-cart-acceptance-checkbox]",
        cartAcceptanceLabel: "[data-cart-acceptance-label]",
        cartButtons: "[data-cart-buttons]",
        cartButtonsFieldset: "[data-cart-buttons-fieldset]",
        cartFormError: "[data-cart-error]",
        cartErrors: "[data-cart-errors]",
        cartErrorsMessage: "[data-cart-errors-message]",
        cartErrorsClose: "[data-cart-errors-close]",
        continueShopping: "[data-continue-shopping]",
        inputQty: ".js-qty__input",
        inputQtyParent: ".js-qty"
      },
      classes = {
        isLoading: "is-loading",
        cartSectionEmpty: "cart-section--empty",
        cartUpdateShow: "cart__update--show"
      },
      namespace = ".cart";
  if (ajaxCart.initQtySelectors(), $(selectors.body).on("ajaxCart.cartPageFormUpdate", function() {
    getCart()
  }), theme.settings.cartType == "page" && $(selectors.cartUpdate).addClass(classes.cartUpdateShow), $(selectors.templateCart).off(namespace).on("change" + namespace, selectors.inputQty, function(e) {
    if (theme.settings.cartType != "page") {
      var $qtyInput = $(this),
          $form = $(selectors.cartForm),
          qty2 = parseInt($qtyInput.val()),
          line = parseInt($qtyInput.closest(selectors.cartRow).index() + 1);
      $form.addClass(classes.isLoading), $(selectors.inputQty).prop("disabled", !0).parents(selectors.inputQtyParent).end().siblings().prop("disabled", !0), $.ajax({
        type: "post",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          quantity: qty2,
          line
        },
        success: function(data2) {
          updateCart(data2, line)
        },
        error: function() {
          $(selectors.inputQty).prop("disabled", !1).parents(selectors.inputQtyParent).end().siblings().prop("disabled", !1), $form.removeClass(classes.isLoading)
        }
      }), qty2 == 0 && $(this).closest(selectors.cartRow).fadeOut(function() {
        $(this).remove()
      })
    }
  }).on("click" + namespace, selectors.cartRemove, function(e) {
    theme.settings.cartType == "drawer" && (e.preventDefault(), $(this).closest(selectors.cartRow).find(selectors.inputQty).prop("value", 0).change())
  }).on("click" + namespace, selectors.continueShopping, function(e) {
    var referrer = document.referrer,
        origin = window.location.origin + "/",
        isCustomLink = $(this)[0].hasAttribute("data-custom-link");
    isCustomLink || (e.preventDefault(), referrer === origin ? window.location.href = theme.routes.root_url : history.back(1))
  }), $(selectors.cartErrorsClose).on("click", function(e) {
    $(this).closest(selectors.cartErrors).stop().slideUp(), e.preventDefault()
  }), $(selectors.cartAcceptanceCheckbox).length) {
    var cartFormErrorElement = '<div class="errors" data-cart-error>' + theme.strings.cart_acceptance_error + "</div>",
        termsAccepted = $(selectors.cartAcceptanceCheckbox).is(":checked"),
        formSubmitFunction = function(e) {
          var termsAccepted2 = $(selectors.cartAcceptanceCheckbox).is(":checked"),
              updateCart2 = $(e.originalEvent.submitter).is('[name="update"]');
          if (!updateCart2)
            if (termsAccepted2) $(selectors.cartFormError).stop().slideUp("fast", function() {
              $(this).remove()
            }), $(selectors.cartButtonsFieldset).removeAttr("disabled"), $(selectors.cartContainer).attr("data-acceptance-checked", "checked");
            else {
              if (e.preventDefault(), $(selectors.cartFormError).length) return;
              $(selectors.cartButtonsFieldset).attr("disabled", !0), $(selectors.cartAcceptanceLabel).after(cartFormErrorElement), $(selectors.cartFormError).slideDown(), $(selectors.cartContainer).removeAttr("data-acceptance-checked")
            }
        };
    termsAccepted || $(selectors.cartButtonsFieldset).attr("disabled", !0), $(selectors.templateCart).on("click" + namespace, selectors.cartButtons, formSubmitFunction).on("submit" + namespace, selectors.cartForm, formSubmitFunction).on("submit" + namespace, selectors.cartFormDynamicCheckout, formSubmitFunction).on("change" + namespace, selectors.cartAcceptance, formSubmitFunction)
  }
  var updateCart = function(data2, line) {
        var oldCartItemCount = $(selectors.cartItemCount).length ? parseInt($(selectors.cartItemCount).attr("data-item-count")) : 0,
            newCartItemCount = parseInt(data2.item_count),
            totalItems = data2.item_count;
        oldCartItemCount === newCartItemCount ? showCartQuantityError(data2, line) : $(selectors.cartErrors).stop().slideUp(), $(selectors.cartSection).toggleClass(classes.cartSectionEmpty, !totalItems), getCart()
      },
      showCartQuantityError = function(data2, line) {
        var updatedProductTitle = data2.items[line - 1].title;
        $(selectors.cartErrors).find(selectors.cartErrorsMessage).html(theme.strings.limit_error + '<span class="cart__errors__product">' + updatedProductTitle + "</span>").end().slideDown()
      },
      getCart = function() {
        fetch(theme.routes.cart_url + "/cart.js").then(response => response.json()).then(response => fetch("/cart?section_id=api-cart-items")).then(response => response.text()).then(response => {
          const element = document.createElement("div");
          element.innerHTML = response;
          const cleanResponse = element.querySelector("[data-api-content]").innerHTML;
          buildCart(cleanResponse)
        }).catch(error => console.log(error)), window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        })
      },
      buildCart = function(data2) {
        $(selectors.cartFormContainer).html(data2);
        const totalItems = parseInt($(selectors.cartItemCount).attr("data-item-count"));
        $(selectors.inputQty).prop("disabled", !1).parents(selectors.inputQtyParent).end().siblings().prop("disabled", !1), $(selectors.cartSection).toggleClass(classes.cartSectionEmpty, !totalItems), $(selectors.cartForm).removeClass(classes.isLoading), $(selectors.body).trigger("ajaxCart.afterCartLoad"), ajaxCart.initQtySelectors()
      }
}, PaloAlto.checkFirstSectionHeight = function() {
  var showAnnouncementBar = $(".top-bar").length,
      announcementBarHeight = $("#shopify-section-announcement-bar").height(),
      $firstSection = $(".main-content").children(".shopify-section").first(),
      $sliders = $firstSection.find(".flickity-enabled");
  showAnnouncementBar ? $firstSection.find(".one-hundred-height-hero").css("max-height", "calc(100vh - " + announcementBarHeight + "px)") : $firstSection.find(".one-hundred-height-hero").css("max-height", "100vh"), $sliders.each(function() {
    $(this).data("flickity") && $(this).flickity("resize")
  })
}, PaloAlto.initCollapsible = function() {
  var selectors = {
        collapsibleTrigger: "[data-collapsible-trigger]",
        collapsibleTriggerMobile: "[data-collapsible-trigger-mobile]",
        collapsibleContent: "[data-collapsible-content]",
        collapsibleContentMobile: "[data-collapsible-content-mobile]"
      },
      classes = {
        isExpanded: "is-expanded"
      },
      isTransitioning = !1,
      resetHeight = 0,
      collapsibleToggleEvent = function(e) {
        if (!(e.keyCode && e.keyCode !== slate.utils.keyboardKeys.ESCAPE) && !isTransitioning) {
          var windowWidth = window.innerWidth || document.documentElement.clientWidth,
              isMobile = windowWidth < 768,
              trigger = $(this),
              triggerMobile = $(this).is(selectors.collapsibleTriggerMobile),
              dropdownId = $(this).attr("aria-controls"),
              dropdown = $("#" + dropdownId),
              dropdownHeight = $(dropdown).find(selectors.collapsibleContent).eq(0).outerHeight() || $(dropdown).find(selectors.collapsibleContentMobile).eq(0).outerHeight(),
              isExpanded = $(trigger).hasClass(classes.isExpanded);
          triggerMobile && !isMobile || !isExpanded && e.keyCode === slate.utils.keyboardKeys.ESCAPE || (isTransitioning = !0, isExpanded && setTimeout(function() {
            dropdownHeight = 0, setDropdownHeight(dropdown, dropdownHeight, isExpanded)
          }, 0), $(trigger).attr("aria-expanded", !isExpanded).toggleClass(classes.isExpanded, !isExpanded), setDropdownHeight(dropdown, dropdownHeight, isExpanded))
        }
      };

  function setDropdownHeight(dropdown, dropdownHeight, isExpanded) {
    $(dropdown).prepareTransition().css("height", dropdownHeight).attr("aria-hidden", isExpanded).toggleClass(classes.isExpanded, !isExpanded), resetHeight && clearTimeout(resetHeight), dropdownHeight == 0 && (resetHeight = setTimeout(function() {
      $(dropdown).css("height", "")
    }, 500)), isExpanded ? isTransitioning = !1 : setTimeout(function() {
      $(dropdown).css("height", "auto"), isTransitioning = !1
    }, 500)
  }
  $(selectors.collapsibleTrigger).off("click keyup").on("click keyup", collapsibleToggleEvent), $(selectors.collapsibleTriggerMobile).off("click keyup").on("click keyup", collapsibleToggleEvent)
}, PaloAlto.Drawers = {
  selectors: {
    body: "body",
    header: ".site-header",
    drawer: ".drawer",
    openDrawer: ".js-drawer-open",
    openNavDrawer: ".js-drawer-open-nav",
    openCartDrawer: ".js-drawer-open-cart",
    closeDrawer: ".js-drawer-close",
    drawerTriggers: "[data-drawer]",
    tlSwitcher: "[data-switcher]"
  },
  classes: {
    drawer: "js-drawer-open-",
    drawers: "js-drawer-open js-drawer-open-left js-drawer-open-right",
    drawerOpen: "js-drawer-open",
    navDrawer: "js-drawer-open-left",
    cartDrawer: "js-drawer-open-right",
    tlSwitcherHide: "hide-switcher",
    tlSwitcherDisable: "disable-switcher"
  },
  initHideSwitcherOnGermanDomain: function() {
    window.location.hostname.split(".").find(sub => sub === "de") && $(this.selectors.tlSwitcher).addClass(this.classes.tlSwitcherDisable)
  },
  initCloseListener: function() {
    var instance = this;
    $(this.selectors.closeDrawer).on("click", function(e) {
      e.preventDefault(), instance.close()
    }), $(this.selectors.drawer).on("keyup", function(e) {
      e.keyCode === slate.utils.keyboardKeys.ESCAPE && (PaloAlto.NavSearch.close(), PaloAlto.Drawers.close())
    })
  },
  initOpenListener: function(element) {
    var instance = this,
        drawerClass = this.classes.drawerOpen + " " + this.classes.drawer + $(element).data("drawer"),
        drawer = $(element).attr("aria-controls");
    $(element).on("click", function(e) {
      e.preventDefault(), slate.a11y.state.trigger = element;
      var isDrawerOpen = $(instance.selectors.body).hasClass(instance.classes.drawerOpen);
      isDrawerOpen ? instance.close() : ($(this).attr("aria-expanded", !0), instance.open(drawer, drawerClass))
    })
  },
  open: function(drawer, drawerClass) {
    $(this.selectors.body).addClass(drawerClass), $(this.selectors.tlSwitcher).addClass(this.classes.tlSwitcherHide), $(this.selectors.body).trigger(drawer + ":open");
    var scrollableElement = drawer === "CartDrawer" ? document.querySelector("#CartDrawer") : document.querySelector("#NavDrawer");
    scrollLock.disablePageScroll(scrollableElement)
  },
  close: function() {
    var drawerOpen = $(this.selectors.body).hasClass(this.classes.drawerOpen);
    if (drawerOpen) {
      var $currentDrawer = this.getCurrentVisibleDrawer(),
          drawer = $currentDrawer.attr("aria-controls");
      $(this.selectors.body).removeClass(this.classes.drawers), $(this.selectors.drawerTriggers).attr("aria-expanded", !1), $(this.selectors.body).trigger(drawer + ":close");
      var scrollLockTimer = 0,
          scrollableElement = drawer === "CartDrawer" ? document.querySelector("#CartDrawer") : document.querySelector("#NavDrawer");
      setTimeout(() => $(this.selectors.tlSwitcher).removeClass(this.classes.tlSwitcherHide), 400), scrollLockTimer && clearTimeout(scrollLockTimer), scrollLockTimer = setTimeout(function() {
        scrollLock.enablePageScroll(scrollableElement)
      }, 400)
    }
  },
  getCurrentVisibleDrawer: function() {
    var isNavDrawer = $(this.selectors.body).hasClass(this.classes.navDrawer),
        isCartDrawer = $(this.selectors.body).hasClass(this.classes.cartDrawer);
    if (isNavDrawer) return $(this.selectors.openNavDrawer);
    if (isCartDrawer) return $(this.selectors.openCartDrawer)
  }
}, PaloAlto.flickitySmoothScrolling = function(slider) {
  $(slider).on("dragStart.flickity", function(event, pointer) {
    document.ontouchmove = function(e) {
      e.preventDefault()
    }
  }), $(slider).on("dragEnd.flickity", function(event, pointer) {
    document.ontouchmove = function(e) {
      return !0
    }
  })
};

function readHeights() {
  const h = {};
  return h.windowHeight = window.innerHeight, h.announcementHeight = getHeight('[data-section-type*="announcement"]'), h.footerHeight = getHeight('[data-section-type*="footer"]'), h.headerHeight = getHeight("[data-header-height]"), h.collectionStickyBarHeight = getHeight("[data-collection-sticky-bar]"), h
}

function setVarsOnResize() {
  document.addEventListener("theme:resize", resizeVars), setVars()
}

function setVars() {
  const {
    windowHeight,
    announcementHeight,
    headerHeight,
    footerHeight,
    collectionStickyBarHeight
  } = readHeights();
  document.documentElement.style.setProperty("--full-height", `${windowHeight}px`), document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`), document.documentElement.style.setProperty("--header-height", `${headerHeight}px`), document.documentElement.style.setProperty("--footer-height", `${footerHeight}px`), document.documentElement.style.setProperty("--content-full", `${windowHeight-headerHeight}px`), document.documentElement.style.setProperty("--content-min", `${windowHeight-headerHeight-footerHeight}px`), document.documentElement.style.setProperty("--collection-sticky-bar-height", `${collectionStickyBarHeight}px`)
}

function resizeVars() {
  const {
    windowHeight,
    announcementHeight,
    headerHeight,
    footerHeight,
    collectionStickyBarHeight
  } = readHeights();
  document.documentElement.style.setProperty("--full-height", `${windowHeight}px`), document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`), document.documentElement.style.setProperty("--header-height", `${headerHeight}px`), document.documentElement.style.setProperty("--footer-height", `${footerHeight}px`), document.documentElement.style.setProperty("--content-full", `${windowHeight-headerHeight}px`), document.documentElement.style.setProperty("--content-min", `${windowHeight-headerHeight-footerHeight}px`), document.documentElement.style.setProperty("--collection-sticky-bar-height", `${collectionStickyBarHeight}px`)
}

function getHeight(selector) {
  const el = document.querySelector(selector);
  return el ? el.clientHeight : 0
}
PaloAlto.Helpers = function() {
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;
    return cookieEnabled || (document.cookie = "testcookie", cookieEnabled = document.cookie.indexOf("testcookie") !== -1), cookieEnabled
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date;
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3), expires = "; expires=" + date.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/"
  }

  function getCookie(name) {
    var cookie = document.cookie.split("; ").find(function(row) {
      return row.startsWith(name)
    });
    return cookie ? cookie.split("=")[1] : null
  }
  return {
    cookiesEnabled,
    setCookie,
    getCookie
  }
}(), PaloAlto.initTransparentHeader = function() {
  var selectors = {
        body: "body",
        header: ".site-header",
        mainContent: ".main-content",
        shopifySection: ".shopify-section",
        preventTransparentHeader: "[data-prevent-transparent-header]"
      },
      classes = {
        transparentHeader: "transparent-header",
        siteHeaderTransparent: "site-header--transparent",
        hasTransparentHeader: "has-transparent-header"
      },
      $body = $(selectors.body),
      $header = $(selectors.header),
      transparent = $header.data("transparent"),
      firstSection = $(selectors.mainContent).children(selectors.shopifySection).first(),
      preventTransparentHeader = $(firstSection).find(selectors.preventTransparentHeader + ":first-of-type").length;
  isHeaderTransparent = transparent && $(firstSection).hasClass(classes.transparentHeader), preventTransparentHeader && (isHeaderTransparent = !1), isHeaderTransparent ? ($header.addClass(classes.siteHeaderTransparent), $body.addClass(classes.hasTransparentHeader)) : ($header.removeClass(classes.siteHeaderTransparent), $body.removeClass(classes.hasTransparentHeader))
}, PaloAlto.initListeners = function() {
  var namespace = ".listeners",
      selectors = {
        body: "body",
        jsDrawerOpenCart: ".js-drawer-open-cart",
        cartDrawerTriggers: "#CartDrawer, #CartDrawer *, .js-drawer-open-cart, .js-drawer-open-cart *",
        navDrawerTriggers: "#NavDrawer, #NavDrawer *, .js-drawer-open-nav, .js-drawer-open-nav *",
        mfpProductForm: ".mfp-wrap .product__form",
        buttonSubmit: 'button[type="submit"]'
      },
      classes = {
        noOutline: "no-outline",
        isLoading: "is-loading",
        jsDrawerOpen: "js-drawer-open",
        jsDrawerOpenRight: "js-drawer-open-right",
        quickViewEnabled: "quick-view-enabled"
      },
      isQuickViewEnabled = theme.settings.quickButton == "view";
  $(document).off(namespace), $(selectors.body).off(namespace), $(document).one("mousedown" + namespace, selectors.body, function() {
    $(this).addClass(classes.noOutline)
  }).on("keydown" + namespace, selectors.body, function(e) {
    e.keyCode === slate.utils.keyboardKeys.TAB && $(selectors.body).removeClass(classes.noOutline).one("mousedown", function() {
      $(this).addClass(classes.noOutline)
    })
  }).on("click" + namespace, selectors.body, function(e) {
    var clickOutsideCart = !$(e.target).is(selectors.cartDrawerTriggers),
        clickOutsideMobileNav = !$(e.target).is(selectors.navDrawerTriggers),
        isDrawerOpen = $(selectors.body).hasClass(classes.jsDrawerOpen);
    clickOutsideCart && clickOutsideMobileNav && isDrawerOpen && PaloAlto.Drawers.close()
  }), $(selectors.body).on("ajaxCart.afterCartLoad" + namespace, function(evt, cart) {
    if (theme.settings.cartType == "drawer") {
      var $openCartDrawer = $(selectors.jsDrawerOpenCart),
          isCartDrawerOpen = $(selectors.body).hasClass(classes.jsDrawerOpenRight);
      isCartDrawerOpen || $openCartDrawer.eq(0).trigger("click")
    }
  }), isQuickViewEnabled && $(selectors.body).on("ajaxCart.afterCartLoad" + namespace, function() {
    $.magnificPopup.close(), setTimeout(function() {
      $(selectors.mfpProductForm).removeClass(classes.isLoading).find(selectors.buttonSubmit).attr("disabled", !1)
    }, 500)
  }).on("ajaxCart.errorAddItem" + namespace, function() {
    setTimeout(function() {
      $(selectors.mfpProductForm).removeClass(classes.isLoading).find(selectors.buttonSubmit).attr("disabled", !1)
    }, 500)
  })
}, PaloAlto.initQuickButton = function(container) {
  var quickButton = theme.settings.quickButton;
  switch (quickButton) {
    case "view":
      PaloAlto.QuickViewPopup.init(container);
      break;
    case "buy":
      PaloAlto.QuickBuy.init(container);
      break
  }
}, PaloAlto.initSections = function() {
  var sections = new PaloAlto.Sections;
  sections.register("header", PaloAlto.Header), sections.register("footer", PaloAlto.Footer), sections.register("announcement-bar", PaloAlto.AnnouncementBar), sections.register("product-template", PaloAlto.Product), sections.register("related-products", PaloAlto.RelatedProducts), sections.register("store-availability", PaloAlto.StoreAvailability), sections.register("collection-template", PaloAlto.CollectionTemplate), sections.register("list-collections", PaloAlto.ListCollections), sections.register("featured-collection", PaloAlto.FeaturedCollection), sections.register("tabbed-collections", PaloAlto.TabbedCollections), sections.register("featured-product", PaloAlto.Product), sections.register("slider", PaloAlto.Slider), sections.register("image-with-text", PaloAlto.RichText), sections.register("featured-image", PaloAlto.FeaturedImage), sections.register("featured-blog", PaloAlto.FeaturedBlog), sections.register("blog-posts", PaloAlto.BlogPosts), sections.register("featured-video", PaloAlto.FeaturedVideo), sections.register("logo-list", PaloAlto.LogoList), sections.register("icons-row", PaloAlto.IconsRow), sections.register("locations", PaloAlto.Locations), sections.register("testimonials", PaloAlto.Testimonials), sections.register("faq", PaloAlto.Faq), sections.register("press", PaloAlto.Press), sections.register("product-feature", PaloAlto.ProductFeature), sections.register("popup", PaloAlto.Popup), sections.register("image-columns", PaloAlto.ImageColumns), sections.register("about-page", PaloAlto.AboutPage), sections.register("password-template", PaloAlto.PasswordTemplate), sections.register("search-template", PaloAlto.SearchTemplate), sections.register("subcollections", PaloAlto.Subcollections), $(document).on("shopify:section:load shopify:section:reorder shopify:section:unload", function() {
    setTimeout(function() {
      PaloAlto.initTransparentHeader(), PaloAlto.setMainSpacing(), PaloAlto.checkFirstSectionHeight()
    }, 300)
  })
}, PaloAlto.pauseOtherMedia = function(mediaId = "") {
  var productMediaSlider = "[data-product-single-media-slider]",
      productMediaWrapper = "[data-product-single-media-wrapper]",
      $currentMedia = $(productMediaWrapper + '[data-media-id="' + mediaId + '"]'),
      $otherMedia = $(productMediaWrapper + ':not([data-media-id="' + mediaId + '"])');
  $currentMedia.removeClass("media--hidden"), $otherMedia.trigger("mediaHidden").addClass("media--hidden"), $(productMediaSlider).removeClass("has-media-active")
}, PaloAlto.Badge = {
  setPosition: function() {
    var $badge = $(".product__tag"),
        imageSize = theme.settings.gridImageSize;
    !$badge.length || imageSize == "cover" || $badge.each(function() {
      var $badge2 = $(this),
          $image = $badge2.siblings("[data-aspectratio]"),
          imageAspectRatio = parseFloat($image.data("aspectratio") || 1),
          imageWidth = $image.outerWidth(),
          imageHeight = $image.outerHeight(),
          containerAspectRatio = imageWidth / imageHeight,
          posTop = 0,
          posLeft = 0;
      imageAspectRatio < containerAspectRatio ? posLeft = (imageWidth - imageHeight * imageAspectRatio) / 2 : posTop = (imageHeight - imageWidth / imageAspectRatio) / 2, $badge2.css({
        top: posTop,
        left: posLeft
      })
    })
  }
};

function dispatch() {
  document.dispatchEvent(new CustomEvent("theme:resize", {
    bubbles: !0
  }))
}

function resizeListener() {
  window.addEventListener("resize", PaloAlto.debounce(dispatch, 50))
}
PaloAlto.QuickBuy = {
  init: function(container) {
    if (theme.settings.cartType == "page") return !0;
    var selectors = {
          body: "body",
          form: "form",
          quickBuy: "[data-button-quick-buy]",
          productGridImage: "[data-product-media-container]",
          error: ".error"
        },
        classes = {
          isLoading: "is-loading"
        },
        isSubmitting2 = !1,
        $quickBuyButton = $(selectors.quickBuy, container),
        $body = $(selectors.body),
        removeError = 0;
    $quickBuyButton.off("click").on("click", function(e) {
      e.preventDefault();
      var $imageContainer = $(this).closest(selectors.productGridImage),
          $form = $(this).closest(selectors.form),
          formArray = $form.serializeArray(),
          formData = {};
      if ($.map(formArray, function(val, i) {
        formData[val.name] = val.value
      }), !isSubmitting2) isSubmitting2 = !0, $(this).attr("disabled", !0).addClass(classes.isLoading), $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: formData,
        dataType: "json",
        success: function(line_item) {
          ajaxCart.load()
        },
        error: function(XMLHttpRequest2, textStatus2) {
          $body.trigger("ajaxCart.errorAddItem")
        }
      }).always(function() {
        setTimeout(function() {
          isSubmitting2 = !1, $quickBuyButton.removeClass(classes.isLoading).attr("disabled", !1)
        }, 500)
      }).fail(function(XMLHttpRequest2) {
        if (typeof XMLHttpRequest2.responseJSON == "object") {
          var errorHTML = '<div class="error">' + XMLHttpRequest2.responseJSON.description + "</div>";
          $imageContainer.find(selectors.error).remove().end().append(errorHTML), removeError && clearTimeout(removeError), removeError = setTimeout(function() {
            $imageContainer.find(selectors.error).remove()
          }, 3e3)
        }
      });
      else return !1
    })
  }
}, PaloAlto.QuickViewPopup = {
  init: function(container) {
    var self2 = this;
    this.$container = $(container), this.sectionId = $(container).data("section-id"), this.product = {}, this.isFlickityDragging = !1, this.enablePaymentButton = theme.settings.enablePaymentButton && !theme.settings.enableAcceptTerms, this.selectors = {
      addToCart: "[data-add-to-cart]",
      addToCartForm: "#AddToCartForm--",
      addToCartId: "#AddToCart--",
      addToCartText: "[data-add-to-cart-text]",
      cartContainer: "[data-api-cart]",
      colorLabel: "[data-color-label]",
      colorSwatch: "[data-color-swatch]",
      comparePrice: "[data-compare-price]",
      errors: ".errors",
      notificationForm: "[data-notification-form]",
      originalSelectorId: "[data-product-select]",
      popoutOption: "[data-popout-option]",
      popoutToggleQuantity: "[data-popout-quantity]",
      priceWrapper: "[data-price-wrapper]",
      product: "[data-product]",
      productForm: "[data-product-form]",
      productFormWrapper: "[data-product-form-wrapper]",
      productMediaSlider: "[data-product-single-media-slider]",
      productMediaThumb: "[data-thumbnail-id]",
      productMediaThumbLink: ".product-single__thumbnail-link",
      productMediaThumbs: "[data-product-single-media-thumbs]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productModel: "[data-product-media-type-model]",
      productPrice: "[data-product-price]",
      productSingle: ".product-single",
      productSingleMediaImage: ".product-single__media--image",
      productTitle: ".product__title",
      productVideo: "[data-product-media-type-video]",
      productJSON: "[data-product-json]",
      quantityButton: "[data-quantity-button]",
      quantityInput: "[data-quantity-input]",
      quantitySelect: "[data-quantity-select]",
      buttonQuickView: "[data-button-quick-view]",
      singleOptionSelector: "[data-single-option-selector]",
      unitBase: "[data-unit-base]",
      unitPrice: "[data-unit-price]",
      unitWrapper: "[data-unit-wrapper]",
      variantsWrapper: ".variants-wrapper"
    }, this.classes = {
      fieldError: "field-error",
      hasMediaActive: "has-media-active",
      hide: "hide",
      isSelected: "is-selected",
      isLoading: "is-loading",
      mediaHidden: "media--hidden",
      noOutline: "no-outline",
      notificationFormHidden: "product__notification--hidden",
      productFormIsLoading: "product__form--is-loading",
      productPriceSale: "product__price--with-sale",
      quantityButtonIncrease: "quantity__btn--increase",
      visuallyHidden: "visually-hidden"
    }, this.ids = {
      addToCartFormId: "AddToCartForm--",
      addToCartId: "AddToCart--"
    }, $(this.selectors.buttonQuickView, container).on("click", function(e) {
      e.preventDefault(), PaloAlto.pauseOtherMedia(), slate.a11y.state.trigger = this;
      var productUrl = theme.routes.root_url + "products/" + $(this).data("handle") + "?section_id=api-quickview";
      $.magnificPopup.open({
        items: {
          src: productUrl
        },
        type: "ajax",
        cache: !1,
        removalDelay: 300,
        mainClass: "popup-quick-view mfp-fade",
        autoFocusLast: !1,
        closeMarkup: '<button title="%title%" class="mfp-close">' + theme.icons.close + "</i></button>",
        callbacks: {
          parseAjax: function(mfpResponse) {
            var $mfpContent = $(mfpResponse.data).children(),
                $mfpData = $mfpContent.filter(self2.selectors.product).add($mfpContent.filter(self2.selectors.productJSON)),
                $productContainer = $mfpData.filter(self2.selectors.product),
                sectionId = $productContainer.attr("data-section-id");
            return product = JSON.parse($mfpData.filter(self2.selectors.productJSON)[0].innerHTML), self2.$container = $productContainer, self2.$container.addClass(self2.classes.isLoading), self2.sectionId = sectionId, self2.product = product, mfpResponse.data = $mfpData
          },
          ajaxContentAdded: function() {
            var formSuffix = self2.sectionId + "-" + self2.product.handle;
            self2.addFormSuffix(self2.$container, formSuffix), self2.initProductSlider(), self2.initMediaSwitch(), self2.initProductVideo(), self2.initModelViewerLibraries(), self2.initShopifyXrLaunch(), self2.initQuantityPicker(), self2.initQuantityInput(), self2.bindFormSubmit(self2.$container);
            var $popoutOptions = $(self2.selectors.popoutOption, self2.$container),
                popoutOptions = {},
                popoutDisableSubmit = !0;
            $popoutOptions.length && $popoutOptions.each(function() {
              $popoutOption = $(this), popoutOptions = new PaloAlto.Popout($popoutOption, popoutDisableSubmit)
            });
            var options = {
              $container: self2.$container,
              enableHistoryState: !1,
              singleOptionSelector: self2.selectors.singleOptionSelector,
              originalSelectorId: self2.selectors.originalSelectorId,
              product: self2.product
            };
            self2.namespace = ".product--" + self2.sectionId, self2.variants = new slate.Variants(options), self2.$container.on("variantChange" + self2.namespace, self2.updateAddToCartState.bind(self2)), self2.$container.on("variantPriceChange" + self2.namespace, self2.updateProductPrices.bind(self2)), self2.$container.on("variantUnitChange" + self2.namespace, self2.updateProductUnits.bind(self2)), self2.$container.on("variantImageChange" + self2.namespace, self2.updateProductImage.bind(self2)),
                self2.$container.on("variantChange" + self2.namespace, self2.updateColorName.bind(self2)),
                ajaxCart.init({
                  namespace: ".ajaxCart--" + formSuffix,
                  formSelector: self2.selectors.addToCartForm + formSuffix,
                  cartContainer: self2.selectors.cartContainer,
                  addToCartSelector: self2.selectors.addToCartId + formSuffix,
                  moneyFormat: theme.moneyFormat
                }),
                PaloAlto.initListeners(), PaloAlto.videoLink(), slate.a11y.trapFocus({
              container: document.querySelector(".mfp-content"),
              elementToFocus: document.querySelector(".mfp-content .mfp-close")
            }), Shopify.PaymentButton && Shopify.PaymentButton.init(), self2.$container.find(self2.selectors.productForm).removeClass(self2.classes.productFormIsLoading), self2.$container.removeClass(self2.classes.isLoading)
          },
          afterClose: function() {
            slate.a11y.removeTrapFocus()
          }
        }
      })
    })
  },
  updateAddToCartState: function(evt) {
    var variant = evt.variant;
    variant ? variant.available ? ($(this.selectors.addToCart, this.$container).prop("disabled", !1), $(this.selectors.addToCartText, this.$container).html(theme.strings.add_to_cart), $(this.selectors.notificationForm, this.$container).addClass(this.classes.notificationFormHidden)) : ($(this.selectors.addToCart, this.$container).prop("disabled", !0), $(this.selectors.addToCartText, this.$container).html(theme.strings.sold_out), $(this.selectors.notificationForm, this.$container).removeClass(this.classes.notificationFormHidden)) : ($(this.selectors.addToCart, this.$container).prop("disabled", !0), $(this.selectors.addToCartText, this.$container).html(theme.strings.unavailable), $(this.selectors.notificationForm, this.$container).removeClass(this.classes.notificationFormHidden))
  },
  updateProductPrices: function(evt) {
    var variant = evt.variant,
        $comparePrice = $(this.selectors.comparePrice, this.$container),
        $productPrice = $(this.selectors.productPrice, this.$container);
    $(this.selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat)), variant.compare_at_price > variant.price ? ($comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass(this.classes.hide), $productPrice.addClass(this.classes.productPriceSale)) : ($comparePrice.html("").addClass(this.classes.hide), $productPrice.removeClass(this.classes.productPriceSale))
  },
  updateProductUnits: function(evt) {
    var variant = evt.variant;
    if (typeof variant.unit_price < "u") {
      var price = slate.Currency.formatMoney(variant.unit_price, theme.moneyFormat),
          base = this.getBaseUnit(variant);
      $(this.selectors.unitPrice, this.$container).html(price), $(this.selectors.unitBase, this.$container).html(base), $(this.selectors.unitWrapper, this.$container).show()
    } else $(this.selectors.unitWrapper, this.$container).hide()
  },
  getBaseUnit: function(variant) {
    return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
  },
  updateProductImage: function(evt) {
    var variant = evt.variant,
        variantMediaId = variant.featured_media ? variant.featured_media.id : "",
        $imgSlider = $(this.selectors.productMediaSlider, this.$container),
        flick = $imgSlider.data("flickity");
    if (flick && flick.isActive) {
      var $variantSlide = $imgSlider.find('[data-id="' + variantMediaId + '"]');
      $variantSlide.index() != -1 && flick.select($variantSlide.index())
    }
  },
  updateColorName: function(evt) {
    var colorName = $(this.selectors.colorSwatch, this.$container).filter(":checked").val();
    $(this.selectors.colorLabel).text(colorName)
  },
  bindFormSubmit: function(container) {
    var hideErrors = 0,
        self2 = this;
    $(this.selectors.addToCart, container).on("click", function(e) {
      var $productForm = $(this).closest("form"),
          $qtyInput = $productForm.find('[name="quantity"]'),
          qty2 = $qtyInput.val();
      if (isSubmitting = $productForm.hasClass(self2.classes.isLoading), hideErrors && clearTimeout(hideErrors), !isSubmitting && qty2 > 0) $(this).attr("disabled", !0).closest(self2.selectors.productForm).submit().addClass(self2.classes.isLoading), $qtyInput.removeClass(self2.classes.fieldError), $productForm.find(self2.selectors.errors).remove();
      else return qty2 == 0 && ($qtyInput.addClass(self2.classes.fieldError), $productForm.find(self2.selectors.errors).remove(), $productForm.find(self2.selectors.variantsWrapper).after('<div class="errors qty-error">' + theme.strings.zero_qty_error + "</div>")), hideErrors = setTimeout(function() {
        $productForm.find(self2.selectors.errors).fadeOut(function() {
          $productForm.find(self2.selectors.errors).remove(), $qtyInput.removeClass(self2.classes.fieldError)
        })
      }, 3e3), !1
    })
  },
  initProductSlider: function() {
    var self2 = this,
        $slider = $(this.selectors.productMediaSlider, this.$container),
        $thumbs = $(this.selectors.productMediaThumbs, this.$container),
        $thumbLink = $(this.selectors.productMediaThumbLink, this.$container),
        hasSlides = $(this.selectors.productMediaWrapper, this.$container).length > 1;
    hasSlides && ($slider.on("ready.flickity", function(event, pointer, moveVector) {
      $slider.attr("tabindex", "-1")
    }), $slider.flickity({
      wrapAround: !0,
      pageDots: !1,
      adaptiveHeight: !0
    }), this.sliderInstance = $slider.data("flickity"), $slider.on("dragMove.flickity", function(event, pointer, moveVector) {
      self2.isFlickityDragging = !0
    }).on("staticClick.flickity", function(event, pointer, moveVector) {
      self2.isFlickityDragging = !1
    }).on("settle.flickity", function(event, index) {
      var $currentSlide = $slider.find(self2.selectors.productMediaWrapper).eq(index),
          mediaId = $currentSlide.data("media-id");
      $currentSlide.has(self2.selectors.productSingleMediaImage).attr("tabindex", "0").siblings().attr("tabindex", "-1"), self2.switchMedia(mediaId)
    }), $(this.selectors.productMediaWrapper, this.$container).on("playModel playVideo playYoutubeVideo", function() {
      var isSelectedSlide = $(this).hasClass(self2.classes.isSelected);
      isSelectedSlide && (self2.sliderInstance.options.draggable = !1, self2.sliderInstance.updateDraggable(), $(this).closest(self2.selectors.productMediaSlider).addClass(self2.classes.hasMediaActive))
    }).on("pauseModel pauseVideo pauseYoutubeVideo", function() {
      var isSelectedSlide = $(this).hasClass(self2.classes.isSelected);
      isSelectedSlide && (self2.sliderInstance.options.draggable = !0, self2.sliderInstance.updateDraggable(), $(this).closest(self2.selectors.productMediaSlider).removeClass(self2.classes.hasMediaActive))
    }), PaloAlto.flickitySmoothScrolling($slider), $thumbs.on("ready.flickity", function() {
      $thumbs.attr("tabindex", "-1")
    }), $thumbs.flickity({
      asNavFor: $slider[0],
      pageDots: !1,
      contain: !0,
      prevNextButtons: !1
    }), $thumbLink.on("click", function(e) {
      e.preventDefault()
    }))
  },
  handleMediaFocus: function(e) {
    if (!(e.keyCode !== 13 && e.keyCode !== 9)) {
      var mediaId = $(e.currentTarget).data("thumbnail-id"),
          slideIndex = $(this.selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]', this.$container).index(),
          flick = $(this.selectors.productMediaSlider, this.$container).data("flickity"),
          flickNav = $(this.selectors.productMediaThumbs, this.$container).data("flickity");
      flick && flick.isActive && slideIndex > -1 && e.keyCode === 13 && flick.select(slideIndex), flickNav && flickNav.isActive && slideIndex > -1 && flickNav.select(slideIndex)
    }
  },
  switchMedia: function(mediaId) {
    var $currentMedia = $(this.selectors.productMediaWrapper + ":not(.media--hidden)", this.$container),
        $newMedia = $(this.selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]', this.$container),
        $otherMedia = $(this.selectors.productMediaWrapper + ':not([data-media-id="' + mediaId + '"])', this.$container),
        isFocusEnabled = !$("body").hasClass(this.classes.noOutline);
    isFocusEnabled && $newMedia.focus(), $currentMedia.trigger("mediaHidden"), $otherMedia.addClass(this.classes.mediaHidden), $newMedia.removeClass(this.classes.mediaHidden).trigger("mediaVisible"), $newMedia.find("[data-deferred-media]").length && !$newMedia.find("[data-deferred-media]").attr("loaded") && $newMedia.find("[data-deferred-media-button]").trigger("click")
  },
  initMediaSwitch: function() {
    var self2 = this,
        $productThumbImages = $(this.selectors.productMediaThumb, this.$container);
    $productThumbImages.length && $productThumbImages.on("click", function(e) {
      e.preventDefault()
    }).on("keyup", self2.handleMediaFocus.bind(self2))
  },
  initProductVideo: function() {
    const sectionId = this.sectionId;
    let $videos = $(this.selectors.productVideo, this.$container);
    $videos.length && $videos.each(function() {
      let $video = $(this);
      PaloAlto.ProductVideo.init($video, sectionId)
    })
  },
  initModelViewerLibraries: function() {
    const sectionId = this.sectionId;
    let $modelViewerElements = $(this.selectors.productModel, this.$container);
    $modelViewerElements.length && $modelViewerElements.each(function() {
      let $model = $(this);
      PaloAlto.ProductModel.init($model, sectionId)
    })
  },
  initShopifyXrLaunch: function() {
    var self2 = this;
    $(document).on("shopify_xr_launch", function() {
      var $currentMedia = $(self2.selectors.productMediaWrapper + ":not(.media--hidden)", self2.$container);
      $currentMedia.trigger("xrLaunch")
    })
  },
  initQuantityPicker: function() {
    var self2 = this;
    this.$container.off("click", this.selectors.quantityButton), this.$container.on("click", this.selectors.quantityButton, function(e) {
      e.preventDefault();
      var $adjustBtn = $(this),
          $qtySelector = $(this).siblings(self2.selectors.quantityInput);
      qty = validateQty(parseInt($qtySelector.val().replace(/\D/g, ""))), $adjustBtn.hasClass(self2.classes.quantityButtonIncrease) ? qty += 1 : (qty -= 1, qty < 1 && (qty = 1)), $qtySelector.val(qty)
    }), this.$container.off("focusout", this.selectors.quantityInput), this.$container.on("focusout", this.selectors.quantityInput, function(e) {
      var currentValue = $(this).val();
      currentValue || $(this).prop("value", 1)
    }), this.$container.off("keydown", self2.selectors.quantityInput), this.$container.on("keydown", self2.selectors.quantityInput, function(e) {
      var currentValue = $(this).val();
      e.keyCode === slate.utils.keyboardKeys.ENTER && !currentValue && $(this).prop("value", 1)
    });

    function validateQty(qty2) {
      return (parseFloat(qty2) != parseInt(qty2) || isNaN(qty2)) && (qty2 = 1), qty2
    }
  },
  initQuantityInput: function() {
    var self2 = this;
    $(this.selectors.quantitySelect, this.$container).on("change", function() {
      var quantity = $(this).text();
      if (quantity < 10) $(self2.selectors.quantityInput, self2.$container).val(quantity);
      else {
        var quantityId = this.id;
        $(self2.selectors.popoutToggleQuantity, self2.$container).remove(), $(self2.selectors.quantityButton, self2.$container).removeClass(self2.classes.visuallyHidden), $(self2.selectors.quantityInput, self2.$container).attr({
          id: quantityId,
          type: "number"
        }).val(10).select()
      }
    }), $(this.selectors.quantityInput, this.$container).on("change", function() {
      var quantity = this.value;
      $(self2.selectors.quantityInput, self2.$container).val(quantity)
    })
  },
  addFormSuffix: function(container, formSuffix) {
    var formId = this.ids.addToCartFormId + formSuffix,
        addToCartId = this.ids.addToCartId + formSuffix;
    $(this.selectors.productForm, container).attr("id", formId), $(this.selectors.addToCart, container).attr("id", addToCartId)
  }
}, PaloAlto.Sections = function Sections() {
  this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, PaloAlto.Sections.prototype = _.assignIn({}, PaloAlto.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container),
        id = $container.attr("data-section-id"),
        type = $container.attr("data-section-type");
    if (constructor = constructor || this.constructors[type], !_.isUndefined(constructor)) {
      var instance = _.assignIn(new constructor(container), {
        id,
        type,
        container
      });
      this.instances.push(instance)
    }
  },
  _onSectionLoad: function(evt) {
    var container = $("[data-section-id]", evt.target)[0];
    container && this._createInstance(container)
  },
  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;
      return isEventInstance && _.isFunction(instance.onUnload) && instance.onUnload(evt), !isEventInstance
    })
  },
  _onSelect: function(evt) {
    var instance = _.find(this.instances, function(instance2) {
      return instance2.id === evt.detail.sectionId
    });
    !_.isUndefined(instance) && _.isFunction(instance.onSelect) && instance.onSelect(evt)
  },
  _onDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance2) {
      return instance2.id === evt.detail.sectionId
    });
    !_.isUndefined(instance) && _.isFunction(instance.onDeselect) && instance.onDeselect(evt)
  },
  _onBlockSelect: function(evt) {
    var instance = _.find(this.instances, function(instance2) {
      return instance2.id === evt.detail.sectionId
    });
    !_.isUndefined(instance) && _.isFunction(instance.onBlockSelect) && instance.onBlockSelect(evt)
  },
  _onBlockDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance2) {
      return instance2.id === evt.detail.sectionId
    });
    !_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect) && instance.onBlockDeselect(evt)
  },
  register: function(type, constructor) {
    this.constructors[type] = constructor, $("[data-section-type=" + type + "]").each(function(index, container) {
      this._createInstance(container, constructor)
    }.bind(this))
  }
}), PaloAlto.setMainSpacing = function() {
  $("body").removeClass("has-scrolled");
  document.body.style.removeProperty('--bar-height')
  var $pageContainer = $("#PageContainer"),
      $header = $(".site-header"),
      $headerGroup = $("#HeaderGroupWrapper"),
      $announcement = $("#announcementContainer"),
      $headerSection = $(".shopify-section-header"),
      isHeaderSticky = $header.data("position") == "fixed",
      isListCollectionsTemplate = $(".template-list-collections").length,
      hasCollectionFilters = $("[data-collection-filters]").length,
      headerElHeight = $header ? parseInt($header.outerHeight()) : 0,
      headerGroupElHeight = $headerGroup ? parseInt($headerGroup.outerHeight()) : 0,
      announcementHeight = $header ? parseInt($header.outerHeight()) : 0,
      headerHeight = isHeaderTransparent ? 0 : headerElHeight + announcementHeight;
  initialHeaderHeight = parseInt($header.data("height")), $pageContainer.css("paddingTop", headerGroupElHeight), isHeaderSticky && !hasCollectionFilters ? $header.parent().addClass("header--sticky") : $header.parent().removeClass("header--sticky"), !isHeaderSticky && isListCollectionsTemplate && $headerSection.addClass("header--relative"), $(window).trigger("scroll.header")
}, PaloAlto.setScrollbarWidth = function() {
  if (!(typeof scrollLock > "u")) {
    var root = document.documentElement,
        scrollbarWidth = scrollLock.getPageScrollBarWidth() + "px";
    root.style.setProperty("--scrollbar-width", scrollbarWidth)
  }
}, PaloAlto.videoLink = function() {
  var $playButton = $("[data-play-button]");
  $playButton.length && $playButton.each(function() {
    $(this).magnificPopup({
      disableOn: 200,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: !1,
      fixedContentPos: !1,
      preloader: !1,
      fixedContentPos: !1,
      closeMarkup: '<button title="%title%" class="mfp-close">' + theme.icons.close + "</i></button>",
      closeOnBgClick: !0,
      tClose: "Close (Esc)",
      iframe: {
        markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay; fullscreen"></iframe></div>',
        patterns: {
          youtube_short: {
            index: "youtu.be/",
            id: "youtu.be/",
            src: "//www.youtube.com/embed/%id%?autoplay=1&autohide=0&branding=0&cc_load_policy=0&controls=0&fs=0&iv_load_policy=3&modestbranding=1&playsinline=1&quality=hd720&rel=0&showinfo=0&wmode=opaque"
          }
        }
      }
    })
  })
};
const loaders = {};

function loadScript(options = {}) {
  if (options.url) return loaders[options.url] ? loaders[options.url] : getScriptWithPromise(options.url);
  if (options.json) return loaders[options.json] ? Promise.resolve(loaders[options.json]) : window.fetch(options.json).then(response => response.json()).then(response => (loaders[options.json] = response, response));
  if (options.name) {
    const key = "".concat(options.name, options.version);
    return loaders[key] ? loaders[key] : loadShopifyWithPromise(options)
  } else return Promise.reject()
}

function getScriptWithPromise(url) {
  const loader = new Promise((resolve, reject) => {
    $.getScript(url).done(function(data2) {
      resolve(data2)
    }).fail(function(error) {
      reject(error)
    })
  });
  return loaders[url] = loader, loader
}

function loadShopifyWithPromise(options) {
  const key = "".concat(options.name, options.version),
      loader = new Promise((resolve, reject) => {
        try {
          window.Shopify.loadFeatures([{
            name: options.name,
            version: options.version,
            onLoad: err => {
              onLoadFromShopify(resolve, reject, err)
            }
          }])
        } catch (err) {
          reject(err)
        }
      });
  return loaders[key] = loader, loader
}

function onLoadFromShopify(resolve, reject, err) {
  return err ? reject(err) : resolve()
}
PaloAlto.FetchError = function() {
  function FetchError(object) {
    this.status = object.status || null, this.headers = object.headers || null, this.json = object.json || null, this.body = object.body || null
  }
  return FetchError.prototype = Error.prototype, FetchError
}(), PaloAlto.fetchProduct = function(handle) {
  const requestRoute = `${theme.routes.root_url}products/${handle}.js`;
  return window.fetch(requestRoute).then(response => response.json()).catch(e => {
    console.error(e)
  })
}, PaloAlto.formatPrices = function(product2) {
  const badgeStyle = theme.settings.productBadgeStyle,
      onSale = product2.price <= product2.compare_at_price_min,
      soldOut = !product2.available;
  let badgeText, badgeClasses = ` product__tag--${badgeStyle}`,
      customBadge = !1,
      preorder = !1;
  for (let i = 0; i < product2.tags.length; i++) {
    if (product2.tags[i].includes("_badge_")) {
      customBadge = !0, badgeText = product2.tags[i].replace("_badge_", "").split("_").join(" "), badgeClasses += " product__tag--custom";
      break
    }
    if (product2.tags[i].includes("_preorder")) {
      preorder = !0;
      break
    }
  }
  return customBadge || (soldOut ? badgeText = theme.strings.sold_out : preorder ? (badgeText = theme.strings.preorder, badgeClasses += " product__tag--custom") : onSale && (badgeText = theme.strings.on_sale_html)), badgeStyle == "circle" && badgeText && (badgeText = badgeText.replace(" ", "<br>")), {
    ...product2,
    badgeClasses,
    badgeText
  }
}, PaloAlto.Filters = function() {
  const selectors = {
        buttons: "button",
        buttonFiltersToggle: "[data-toggle-filters]",
        buttonFiltersClose: "[data-close-filters]",
        buttonFiltersOpen: "[data-open-filters]",
        collectionWrapper: "[data-collection-wrapper]",
        inputs: "input, select, label, textarea",
        inputSort: "[data-input-sort]",
        filters: "[data-collection-filters]",
        filtersWrapper: "[data-collection-filters-wrapper]",
        filtersList: "[data-collection-filters-list]",
        filtersStickyBar: "[data-collection-sticky-bar]",
        filter: "[data-collection-filter]",
        filterTag: "[data-collection-filter-tag]",
        filterTagButton: "[data-collection-filter-tag-button]",
        filtersForm: "[data-collection-filters-form]",
        filterResetButton: "[data-filter-reset-button]",
        filterTagClearButton: "[data-filter-tag-reset-button]",
        productGrid: "[data-collection-products]",
        productMediaSlideshow: "[data-product-media-slideshow]",
        productMediaSlide: "[data-product-media-slideshow-slide]",
        priceMin: "[data-field-price-min]",
        priceMax: "[data-field-price-max]",
        rangeMin: "[data-se-min-value]",
        rangeMax: "[data-se-max-value]",
        rangeMinValue: "data-se-min-value",
        rangeMaxValue: "data-se-max-value",
        searchForm: "[data-search-form]"
      },
      classes = {
        filtersVisible: "collection__filters--visible",
        isActive: "is-active",
        isExpanded: "is-expanded",
        isVisible: "is-visible",
        isLoading: "is-loading"
      };
  let pageScrollLockTimeout = 0;

  function Filters(container) {
    this.container = container, this.sectionId = container.dataset.sectionId, this.namespace = "." + container.dataset.sectionId, this.enableFilters = this.container.dataset.enableFilters === "true", this.filterMode = container.dataset.filterMode, this.collectionHandle = this.container.dataset.collection, this.productGrid = this.container.querySelector(selectors.productGrid), this.filters = this.container.querySelector(selectors.filters), this.filtersStickyBar = this.container.querySelector(selectors.filtersStickyBar), this.filtersForm = this.container.querySelector(selectors.filtersForm), this.searchForm = this.container.querySelector(selectors.searchForm), this.inputSort = this.container.querySelectorAll(selectors.inputSort), this.filterData = [], this.hideFilters = this.hideFilters.bind(this), this.showFilters = this.showFilters.bind(this), this.onFilterResetClick = this.onFilterResetClick.bind(this), this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this), this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this), this.onFilterToggleClick = this.onFilterToggleClick.bind(this), this.onKeyUpHandler = this.onKeyUpHandler.bind(this), this.updateRangeEvent = this.updateRange.bind(this), this.debouncedSubmitEvent = PaloAlto.debounce(function(event) {
      this.onSubmitHandler(event)
    }, 500), this.debouncedSortEvent = PaloAlto.debounce(function(event) {
      this.onSortChange(event)
    }, 500), this.initTagFilters(), this.initFacetedFilters(), this.bindToggleButtonsEvents(), this.bindFilterButtonsEvents(), this.initProductGridSlideshow(), this.initInfinityScroll(), PaloAlto.initQuickButton(container), PaloAlto.initCollapsible(), PaloAlto.Badge.setPosition(), setVars(), window.addEventListener("popstate", this.onHistoryChange.bind(this)), this.setBadgePositionOnResize = PaloAlto.debounce(function() {
      PaloAlto.Badge.setPosition()
    }, 250), document.addEventListener("theme:resize", this.setBadgePositionOnResize)
  }
  return Filters.prototype = $.extend({}, Filters.prototype, {
    initFacetedFilters: function() {
      this.filterMode == "tag" || this.filterMode == "group" || !this.enableFilters || new PaloAlto.RangeSlider(this.container)
    },
    updateRange: function() {
      const rangeMin = this.filtersForm.querySelector(selectors.rangeMin),
          rangeMax = this.filtersForm.querySelector(selectors.rangeMax),
          priceMin = this.filtersForm.querySelector(selectors.priceMin),
          priceMax = this.filtersForm.querySelector(selectors.priceMax);
      if (rangeMin.hasAttribute(selectors.rangeMinValue) && rangeMax.hasAttribute(selectors.rangeMaxValue)) {
        const priceMinValue = parseFloat(priceMin.placeholder, 10),
            priceMaxValue = parseFloat(priceMax.placeholder, 10),
            rangeMinValue = parseFloat(rangeMin.getAttribute(selectors.rangeMinValue), 10),
            rangeMaxValue = parseFloat(rangeMax.getAttribute(selectors.rangeMaxValue), 10);
        (priceMinValue !== rangeMinValue || priceMaxValue !== rangeMaxValue) && (priceMin.value = parseInt(rangeMinValue), priceMax.value = parseInt(rangeMaxValue), this.filtersForm.dispatchEvent(new Event("input", {
          bubbles: !0
        })))
      }
    },
    onSubmitHandler: function(event) {
      event.preventDefault();
      const formData = new FormData(event.target.closest("form")),
          searchParams = new URLSearchParams(formData).toString();
      this.renderSection(searchParams, event)
    },
    onHistoryChange: function(event) {
      const searchParams = event.state?.searchParams || "";
      this.renderSection(searchParams, null, !1)
    },
    renderSection: function(searchParams, event, updateURLHash = !0) {
      this.startLoading();
      const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`,
          filterDataUrl = element => element.url === url;
      this.filterData.some(filterDataUrl) ? this.renderSectionFromCache(filterDataUrl, event) : this.renderSectionFromFetch(url, event), updateURLHash && this.updateURLHash(searchParams)
    },
    renderSectionFromFetch: function(url, event) {
      fetch(url).then(response => response.text()).then(responseText => {
        const html = responseText;
        this.filterData = [...this.filterData, {
          html,
          url
        }], this.renderFilters(html), this.renderProductGrid(html), this.finishLoading()
      })
    },
    renderSectionFromCache: function(filterDataUrl, event) {
      const html = this.filterData.find(filterDataUrl).html;
      this.renderFilters(html, event), this.renderProductGrid(html), this.finishLoading()
    },
    renderProductGrid: function(html) {
      const productGridHTML = new DOMParser().parseFromString(html, "text/html").querySelector(selectors.productGrid).innerHTML;
      this.productGrid.innerHTML = productGridHTML, this.initProductGridEvents()
    },
    renderFilters: function(html) {
      const filtersHTML = new DOMParser().parseFromString(html, "text/html").querySelector(selectors.filters).innerHTML;
      this.filters.innerHTML = filtersHTML, this.filtersForm = document.querySelector(selectors.filtersForm), this.bindFilterButtonsEvents(), this.bindToggleButtonsEvents(), PaloAlto.initCollapsible(), document.dispatchEvent(new CustomEvent("theme:filters:init", {
        bubbles: !0
      }))
    },
    updateURLHash: function(searchParams) {
      history.pushState({
        searchParams
      }, "", `${window.location.pathname}${searchParams&&"?".concat(searchParams)}`)
    },
    bindFilterButtonsEvents: function() {
      this.container.querySelectorAll(selectors.filterResetButton).forEach(button => {
        button.addEventListener("click", this.onFilterResetClick, {
          once: !0
        })
      }), this.filtersForm && (this.filtersForm.addEventListener("input", this.debouncedSubmitEvent.bind(this)), this.filtersForm.addEventListener("range:filter:update", this.updateRangeEvent))
    },
    onFilterResetClick: function(event) {
      event.preventDefault(), this.renderSection(new URL(event.currentTarget.href).searchParams.toString())
    },
    bindToggleButtonsEvents: function() {
      this.container.querySelectorAll(selectors.buttonFiltersToggle).forEach(button => {
        button.addEventListener("click", this.onFilterToggleClick)
      }), this.container.querySelectorAll(selectors.buttonFiltersClose).forEach(button => {
        button.addEventListener("click", this.hideFilters)
      }), this.container.querySelectorAll(selectors.buttonFiltersOpen).forEach(button => {
        button.addEventListener("click", this.showFilters)
      }), this.container.querySelector(selectors.collectionWrapper).addEventListener("keyup", this.onKeyUpHandler)
    },
    onKeyUpHandler: function(event) {
      event.keyCode === slate.utils.keyboardKeys.ESCAPE && this.hideFilters()
    },
    onFilterToggleClick: function(event) {
      event.preventDefault(), this.filters.classList.contains(classes.filtersVisible) ? this.hideFilters() : this.showFilters()
    },
    showFilters: function() {
      const instance = this,
          scrollableElement = document.querySelector(selectors.filtersList);
      let windowWidth = window.innerWidth || document.documentElement.clientWidth;
      if (slate.a11y.state.trigger = document.querySelector(selectors.buttonFiltersToggle), slate.a11y.trapFocus({
        container: instance.filters,
        elementToFocus: instance.filters.querySelector(selectors.buttons)
      }), windowWidth < 1320 && (this.filters.classList.add(classes.filtersVisible), pageScrollLockTimeout && clearTimeout(pageScrollLockTimeout), scrollLock.disablePageScroll(scrollableElement)), this.filtersStickyBar) {
        let stickyBarOffsetTop = this.getStickyBarOffsetTop();
        window.scrollTo({
          top: stickyBarOffsetTop,
          left: 0,
          behavior: "smooth"
        })
      }
    },
    hideFilters: function() {
      let filtersVisible = this.filters.classList.contains(classes.filtersVisible),
          loading = this.container.classList.contains(classes.isLoading);
      filtersVisible && (this.filters.classList.remove(classes.filtersVisible), slate.a11y.removeTrapFocus()), loading || (pageScrollLockTimeout && clearTimeout(pageScrollLockTimeout), pageScrollLockTimeout = setTimeout(function() {
        scrollLock.clearQueueScrollLocks(), scrollLock.enablePageScroll()
      }, 300))
    },
    initTagFilters: function() {
      this.filterMode != "tag" && this.filterMode != "group" || !this.enableFilters || (this.tags = this.container.dataset.tags.split("+").filter(item => item), this.bindFilterTagButtonsEvents(), this.bindSortChangeEvent(), this.resizeEvent = PaloAlto.debounce(this.hideFilters.bind(this), 250), document.addEventListener("theme:resize", this.resizeEvent))
    },
    renderTagFiltersProducts: function(url) {
      var instance = this;
      this.startLoading(), typeof this.endlessCollection == "object" && this.endlessCollection.destroy(), fetch(url).then(response => response.text()).then(responseText => {
        const html = responseText,
            parsedData = new DOMParser().parseFromString(html, "text/html"),
            productsHTML = parsedData.querySelector(selectors.productGrid).innerHTML,
            filtersHTML = parsedData.querySelector(selectors.filters).innerHTML;
        this.productGrid.innerHTML = productsHTML, this.filters.innerHTML = filtersHTML, this.inputSort = this.container.querySelectorAll(selectors.inputSort), this.filtersForm = document.querySelector(selectors.filtersForm), this.filterData = [...this.filterData, {
          html,
          url
        }], instance.initInfinityScroll(), this.initProductGridEvents(), this.bindFilterTagButtonsEvents(), this.bindSortChangeEvent(), this.bindToggleButtonsEvents(), PaloAlto.initCollapsible(), PaloAlto.Badge.setPosition(), history.replaceState && window.history.pushState({
          path: url
        }, "", url)
      }).catch(error => {
        this.finishLoading(), console.log(`Error: ${error}`)
      })
    },
    bindFilterTagButtonsEvents: function() {
      this.container.querySelectorAll(selectors.filterTagButton).forEach(button => {
        button.addEventListener("click", this.onFilterTagButtonClick.bind(this), {
          once: !0
        })
      }), this.container.querySelectorAll(selectors.filterTagClearButton).forEach(button => {
        button.addEventListener("click", this.onFilterTagClearClick, {
          once: !0
        })
      }), this.container.querySelectorAll(selectors.filterResetButton).forEach(button => {
        button.addEventListener("click", this.onFilterTagResetClick, {
          once: !0
        })
      })
    },
    bindSortChangeEvent: function() {
      this.container.querySelectorAll(selectors.inputSort).forEach(input => {
        input.addEventListener("input", this.debouncedSortEvent.bind(this))
      })
    },
    onFilterTagButtonClick: function(e) {
      e.preventDefault();
      const button = e.currentTarget,
          selectedTag = button.dataset.tag;
      if (button.parentNode.classList.contains(classes.isActive)) {
        let tagIndex = this.tags.indexOf(selectedTag);
        button.parentNode.classList.remove(classes.isActive), tagIndex > -1 && this.tags.splice(tagIndex, 1)
      } else button.parentNode.classList.add(classes.isActive), this.tags.push(selectedTag);
      let url = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
      this.container.querySelector(selectors.filter).classList.remove(classes.isExpanded), this.container.querySelector(selectors.filter).setAttribute("aria-expanded", !1), this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(url)
    },
    onFilterTagClearClick: function(e) {
      e.preventDefault();
      const selectedTag = e.currentTarget.dataset.tag,
          tagIndex = this.tags.indexOf(selectedTag);
      tagIndex > -1 && this.tags.splice(tagIndex, 1);
      const url = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
      this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(url)
    },
    onSortChange: function() {
      let url = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
      this.renderTagFiltersProducts(url)
    },
    getSortValue: function() {
      let sortValue = "";
      return this.inputSort.forEach(input => {
        input.checked && (sortValue = input.value)
      }), sortValue
    },
    onFilterTagResetClick: function(e) {
      e.preventDefault(), this.container.querySelectorAll(selectors.filterTag).forEach(element => {
        element.classList.remove(classes.isActive)
      }), this.container.querySelectorAll(selectors.filter).forEach(element => {
        element.classList.remove(classes.isExpanded), element.setAttribute("aria-expanded", !1)
      }), this.tags = [], this.container.setAttribute("data-tags", "");
      let url = this.collectionHandle + "/?sort_by=" + this.getSortValue();
      this.renderTagFiltersProducts(url)
    },
    getProductsOffsetTop: function() {
      return this.productGrid.getBoundingClientRect().top - document.body.getBoundingClientRect().top - this.filtersStickyBar.offsetHeight
    },
    getStickyBarOffsetTop: function() {
      return this.filtersStickyBar.getBoundingClientRect().top - document.body.getBoundingClientRect().top
    },
    initProductGridEvents: function() {
      PaloAlto.initQuickButton(this.container), PaloAlto.Badge.setPosition(), this.initProductGridSlideshow(), this.initInfinityScroll(), setTimeout(() => {
        this.finishLoading()
      }, 450)
    },
    initProductGridSlideshow: function() {
      theme.settings.productGridSlideshow && this.container.querySelectorAll(selectors.productMediaSlideshow).forEach(element => {
        if (element.querySelectorAll(selectors.productMediaSlide).length > 1) {
          const flkty = new Flickity(element, {
            cellSelector: ".product__media-slide",
            contain: !0,
            wrapAround: !0,
            imagesLoaded: !0,
            lazyLoad: !0,
            pageDots: !1,
            adaptiveHeight: !1
          })
        }
      })
    },
    initInfinityScroll: function() {
      if (theme.settings.enableInfinityScroll) {
        var instance = this,
            namespace = this.namespace;
        this.endlessCollection = new Ajaxinate({
          container: "#AjaxinateLoop",
          pagination: "#AjaxinatePagination",
          method: "scroll",
          namespace,
          callback: function() {
            PaloAlto.initQuickButton(instance.container), instance.initProductGridSlideshow(), PaloAlto.Badge.setPosition()
          }
        })
      }
    },
    startLoading: function() {
      this.container.classList.add(classes.isLoading), this.hideFilters(), scrollLock.disablePageScroll();
      let productsTop = this.getProductsOffsetTop();
      window.scrollTo({
        top: productsTop,
        left: 0,
        behavior: "smooth"
      })
    },
    finishLoading: function() {
      this.container.classList.remove(classes.isLoading), scrollLock.clearQueueScrollLocks(), scrollLock.enablePageScroll()
    },
    onDeselect: function() {
      $.magnificPopup.close()
    },
    onUnload: function(evt) {
      typeof this.endlessCollection == "object" && this.endlessCollection.destroy(), $.magnificPopup.close()
    }
  }), Filters
}(), PaloAlto.Popout = function() {
  var selectors = {
        popoutList: "[data-popout-list]",
        popoutItem: "[data-popout-item]",
        popoutToggle: "[data-popout-toggle]",
        popoutInput: "[data-popout-input]",
        popoutOptions: "[data-popout-option]",
        popoutText: "[data-popout-text]"
      },
      classes = {
        toggleExpanded: "popout__toggle--expanded",
        listVisible: "popout-list--visible",
        current: "popout-list__item--current"
      };

  function Popout($popout, popoutDisableSubmit) {
    this.$container = $popout, this.popoutDisableSubmit = popoutDisableSubmit, this.cache = {}, this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut()
  }
  return Popout.prototype = $.extend({}, Popout.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $popoutList: this.$container.find(selectors.popoutList),
        $popoutItem: this.$container.find(selectors.popoutItem),
        $popoutToggle: this.$container.find(selectors.popoutToggle),
        $popoutInput: this.$container.find(selectors.popoutInput),
        $popoutOptions: this.$container.find(selectors.popoutOptions),
        $popoutText: this.$container.find(selectors.popoutText)
      }
    },
    _connectToggle: function() {
      this.cache.$popoutToggle.on("click", function(evt) {
        var ariaExpanded = $(evt.currentTarget).attr("aria-expanded") === "true";
        $(evt.currentTarget).attr("aria-expanded", !ariaExpanded), this.cache.$popoutList.toggleClass(classes.listVisible), this.cache.$popoutToggle.toggleClass(classes.toggleExpanded)
      }.bind(this))
    },
    _connectOptions: function() {
      var popoutDisableSubmit = this.popoutDisableSubmit;
      this.cache.$popoutOptions.on("click", function(evt) {
        popoutDisableSubmit ? (this._updateOptionValue($(evt.currentTarget).data("value")), this._updateSelectedItem(evt)) : this._submitForm($(evt.currentTarget).data("value")), evt.preventDefault()
      }.bind(this))
    },
    _onFocusOut: function() {
      this.cache.$popoutToggle.on("focusout", function(evt) {
        var popoutLostFocus = this.$container.has(evt.relatedTarget).length === 0;
        popoutLostFocus && this._hideList()
      }.bind(this)), this.cache.$popoutList.on("focusout", function(evt) {
        var childInFocus = $(evt.currentTarget).has(evt.relatedTarget).length > 0,
            isVisible = this.cache.$popoutList.hasClass(classes.listVisible);
        isVisible && !childInFocus && this._hideList()
      }.bind(this)), this.$container.on("keyup", function(evt) {
        evt.which === slate.utils.keyboardKeys.ESCAPE && (this._hideList(), this.cache.$popoutToggle.focus())
      }.bind(this)), this.bodyOnClick = function(evt) {
        var isOption = this.$container.has(evt.target).length > 0,
            isVisible = this.cache.$popoutList.hasClass(classes.listVisible);
        isVisible && !isOption && this._hideList()
      }.bind(this), $("body").on("click", this.bodyOnClick)
    },
    _submitForm: function(value) {
      this.cache.$popoutInput.val(value), this.$container.parents("form").submit()
    },
    _updateOptionValue: function(value) {
      this.cache.$popoutInput.val(value).triggerHandler("change"), typeof value == "string" ? this.cache.$popoutText.text(value.replace(/Model/g, "").split("/")[0]).triggerHandler("change") : this.cache.$popoutText.text(value).triggerHandler("change"), this._hideList()
    },
    _updateSelectedItem: function(evt) {
      var $currentPopoutItem = $(evt.target).closest(selectors.popoutItem);
      this.cache.$popoutItem.attr("aria-current", !1).removeClass(classes.current), $currentPopoutItem.attr("aria-current", !0).addClass(classes.current)
    },
    _hideList: function() {
      this.cache.$popoutList.removeClass(classes.listVisible), this.cache.$popoutToggle.removeClass(classes.toggleExpanded).attr("aria-expanded", !1)
    },
    unload: function() {
      $("body").off("click", this.bodyOnClick), this.cache.$popoutOptions.off(), this.cache.$popoutToggle.off(), this.cache.$popoutList.off(), this.$container.off()
    }
  }), Popout
}();
var LibraryLoader = function() {
  var types = {
        link: "link",
        script: "script"
      },
      status = {
        requested: "requested",
        loaded: "loaded"
      },
      cloudCdn = "https://cdn.shopify.com/shopifycloud/",
      libraries = {
        youtubeSdk: {
          tagId: "youtube-sdk",
          src: "https://www.youtube.com/iframe_api",
          type: types.script
        },
        modelViewerUiStyles: {
          tagId: "shopify-model-viewer-ui-styles",
          src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
          type: types.link
        }
      };

  function load(libraryName, callback) {
    var library = libraries[libraryName];
    if (library && library.status !== status.requested) {
      if (callback = callback || function() {}, library.status === status.loaded) {
        callback();
        return
      }
      library.status = status.requested;
      var tag;
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break
      }
      tag.id = library.tagId, library.element = tag;
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement("script");
    return tag.src = library.src, tag.addEventListener("load", function() {
      library.status = status.loaded, callback()
    }), tag
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement("link");
    return tag.href = library.src, tag.rel = "stylesheet", tag.type = "text/css", tag.addEventListener("load", function() {
      library.status = status.loaded, callback()
    }), tag
  }
  return {
    load
  }
}();
PaloAlto.NavSearch = {
  selectors: {
    body: "body",
    header: ".site-header",
    topBar: ".top-bar",
    search: "[data-nav-search]",
    searchOpen: "[data-nav-search-open]",
    searchClose: "[data-nav-search-close]",
    searchForm: "[data-nav-search-form]",
    searchContainer: "[data-nav-search-container]",
    searchScroller: "[data-nav-search-scroller]",
    searchResultsContainer: "[data-nav-search-results]",
    searchInput: "[data-nav-search-input]",
    popularSearchLink: "[data-popular-search-link]",
    productTemplate: "[product-grid-item-template]",
    productsWrapper: "[data-products-wrap]",
    noresultTemplate: "[noresult-item-template]",
    resultsPagination: "[data-results-pagination]"
  },
  classes: {
    pushUp: "push-up",
    relative: "relative",
    drawerOpen: "js-drawer-open",
    isSearching: "is-searching",
    isSearchVisible: "is-search-visible",
    navSearchIsVisible: "nav-search--is-visible",
    loading: "loading",
    isPaginationVisible: "is-pagination-visible"
  },
  init: function() {
    this.namespace = ".search", this.productTemplate = document.querySelector(this.selectors.productTemplate).innerHTML, this.noresultTemplate = document.querySelector(this.selectors.noresultTemplate).innerHTML, this.searchContainer = document.querySelector(this.selectors.search), this.result = null, this.openSearchTimeout = 0, this.initListeners(), $(window).off(this.namespace).on("resize" + this.namespace, PaloAlto.debounce(PaloAlto.Badge.setPosition, 150))
  },
  initListeners: function() {
    const instance = this;
    $(this.selectors.searchForm).on("keyup", this.selectors.searchInput, PaloAlto.debounce(function(e) {
      let query = $(this).val();
      query.length > 1 && ($(instance.selectors.searchContainer).addClass([instance.classes.isSearching, instance.classes.pushUp]), instance.render(query))
    }, 300)), $(this.selectors.search).on("keyup", function(e) {
      e.keyCode === slate.utils.keyboardKeys.ESCAPE && (e.stopImmediatePropagation(), instance.close())
    }), $(this.selectors.searchOpen).on("click", function(e) {
      e.preventDefault(), instance.open()
    }), $(this.selectors.searchClose).on("click", function(e) {
      e.preventDefault(), instance.close()
    }), $(this.selectors.popularSearchLink).on("click", function(e) {
      e.preventDefault();
      const searchText = $(this).text();
      $(instance.selectors.searchInput).val(searchText), window.location.href = `${theme.routes.search_url}?type=product&q=${searchText}&options[prefix]=last`
    })
  },
  open: function() {
    const instance = this;
    let scrollPosition = $(window).scrollTop(),
        pageOffset = $(this.selectors.topBar).length ? $(this.selectors.topBar).outerHeight() : 0,
        isDrawerOpen = $(this.selectors.body).hasClass(this.classes.drawerOpen);
    const $scrollableElement = document.querySelector(this.selectors.searchScroller);
    isDrawerOpen ? (PaloAlto.Drawers.close(), this.openSearchTimeout && clearTimeout(this.openSearchTimeout), this.openSearchTimeout = setTimeout(openSearch, 400)) : openSearch();

    function openSearch() {
      let isHeaderRelative = $(instance.selectors.header).hasClass(instance.classes.relative);
      $(instance.selectors.header).addClass(instance.classes.isSearchVisible), $(instance.selectors.search).addClass(instance.classes.navSearchIsVisible), scrollLock.disablePageScroll($scrollableElement), setTimeout(function() {
        slate.a11y.trapFocus({
          container: instance.searchContainer,
          elementToFocus: $(instance.selectors.searchInput)
        }), $(instance.selectors.searchInput).focus().select()
      }, 100), (isHeaderRelative && scrollPosition > pageOffset || scrollPosition < initialHeaderHeight) && $("html, body").animate({
        scrollTop: pageOffset
      }, 250)
    }
  },
  close: function() {
    const instance = this,
        $scrollableElement = document.querySelector(this.selectors.searchScroller);
    this.reset(), slate.a11y.removeTrapFocus({
      container: instance.searchContainer
    }), $(this.selectors.header).removeClass(this.classes.isSearchVisible), $(this.selectors.search).removeClass(this.classes.navSearchIsVisible), $(this.selectors.searchOpen).trigger("focus"), scrollLock.enablePageScroll($scrollableElement)
  },
  reset: function() {
    $(this.selectors.searchForm)[0].reset(), $(this.selectors.productsWrapper).empty(), $(this.selectors.searchContainer).removeClass([this.classes.isSearching, this.classes.pushUp]), $(this.selectors.searchResultsContainer).removeClass(this.classes.isPaginationVisible)
  },
  render(terms) {
    const instance = this;
    fetch(`/search/suggest.json?q=${encodeURIComponent(terms)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`).then(this.handleErrors).then(response => response.json()).then(response => (this.result = response.resources.results, this.fetchProducts(this.result.products))).then(response => {
      $(this.selectors.productsWrapper).empty(), $(this.selectors.searchResultsContainer).removeClass(this.classes.isPaginationVisible), response === "" ? this.injectHTML($(this.selectors.productsWrapper)[0], this.renderNoResult()) : (this.injectHTML($(this.selectors.productsWrapper)[0], response), this.result.products.length > 9 && ($(`${this.selectors.resultsPagination} > a`).attr("href", `${theme.routes.search_url}?type=product&q=${terms}&options[prefix]=last`), $(this.selectors.searchResultsContainer).addClass(this.classes.isPaginationVisible)), slate.a11y.removeTrapFocus({
        container: instance.searchContainer
      }), slate.a11y.trapFocus({
        container: instance.searchContainer,
        elementToFocus: $(instance.selectors.searchInput)
      }), PaloAlto.Badge.setPosition()), $(this.selectors.searchContainer).removeClass(this.classes.isSearching)
    }).catch(e => {
      console.error(e)
    })
  },
  injectHTML(target, pageHTML) {
    target.innerHTML += pageHTML
  },
  renderNoResult() {
    const updateValues = {
      text: theme.strings.no_results
    };
    return Sqrl.render(this.noresultTemplate, {
      item: updateValues
    })
  },
  fetchProducts(products) {
    const promises = [];
    return products.forEach(product2 => {
      promises.push(PaloAlto.fetchProduct(product2.handle).then(productJSON => {
        const formatted = PaloAlto.formatPrices(productJSON);
        return this.renderProduct(formatted)
      }))
    }), Promise.all(promises).then(result => {
      let str = "";
      return result.forEach(render => {
        str += render
      }), str
    })
  },
  renderProduct(product2) {
    const stripHtmlRegex = /(<([^>]+)>)/gi,
        title = product2.title.replace(stripHtmlRegex, "");
    let media = null,
        image = "";
    product2.media !== void 0 && (media = product2.media[0]), media ? image = {
      thumb: this.bgset(media.preview_image.src, media.preview_image.aspect_ratio),
      aspectRatio: media.preview_image.aspect_ratio
    } : image = {
      thumb: theme.assets.no_image,
      alt: "",
      aspectRatio: 1
    };
    const updateValues = {
      ...product2,
      title,
      image
    };
    return Sqrl.render(this.productTemplate, {
      product: updateValues
    })
  },
  handleErrors(response) {
    return response.ok ? response : response.json().then(function(json) {
      throw new PaloAlto.FetchError({
        status: response.statusText,
        headers: response.headers,
        json
      })
    })
  },
  bgset: function(image, imageAspectRatio) {
    let bgset = "";
    return image.indexOf("no-image") != -1 && image.indexOf("2048x.gif") != -1 && (imageAspectRatio = 1), bgset += image.replace("_2048x.", "_180x.") + " 180w " + Math.round(180 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_360x.") + " 360w " + Math.round(360 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_540x.") + " 540w " + Math.round(540 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_720x.") + " 720w " + Math.round(720 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_900x.") + " 900w " + Math.round(900 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_1080x.") + " 1080w " + Math.round(1080 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_1296x.") + " 1296w " + Math.round(1296 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_1512x.") + " 1512w " + Math.round(1512 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_1728x.") + " 1728w " + Math.round(1728 / imageAspectRatio) + "h,", bgset += image.replace("_2048x.", "_1950x.") + " 1950w " + Math.round(1950 / imageAspectRatio) + "h,", bgset += image + " 2048w " + Math.round(2048 / imageAspectRatio) + "h", bgset
  }
};

function singles(frame, wrappers) {
  let padding = 64,
      tallest = 0;
  wrappers.forEach(wrap => {
    if (wrap.offsetHeight > tallest) {
      const getMarginTop = parseInt(window.getComputedStyle(wrap).marginTop),
          getMarginBottom = parseInt(window.getComputedStyle(wrap).marginBottom),
          getMargin = getMarginTop + getMarginBottom;
      getMargin > padding && (padding = getMargin), tallest = wrap.offsetHeight
    }
  });
  const images = frame.querySelectorAll("[data-overflow-background]");
  [frame, ...images].forEach(el => {
    el.style.setProperty("min-height", `${tallest+padding}px`)
  })
}

function preventOverflow(container) {
  const singleFrames = container.querySelectorAll("[data-overflow-container]");
  singleFrames && singleFrames.forEach(frame => {
    const containers = frame.querySelectorAll("[data-overflow-content]");
    singles(frame, containers), document.addEventListener("theme:resize", () => {
      singles(frame, containers)
    })
  })
}
PaloAlto.ProductVideo = function() {
  let videos = {};
  const hosts = {
        html5: "html5",
        youtube: "youtube"
      },
      selectors = {
        productMediaWrapper: "[data-product-single-media-wrapper]",
        productMediaSlider: "[data-product-single-media-slider]",
        deferredMedia: "[data-deferred-media]",
        deferredMediaButton: "[data-deferred-media-button]"
      };

  function init($videoContainer, sectionId) {
    if (!$videoContainer.length) return;
    const deferredMediaButton = $videoContainer[0].querySelector(selectors.deferredMediaButton);
    deferredMediaButton && deferredMediaButton.addEventListener("click", PaloAlto.ProductVideo.loadContent.bind(this, $videoContainer[0], sectionId))
  }

  function createPlayer(video) {
    const productMediaWrapper = video.container,
        enableLooping = productMediaWrapper.data("enableVideoLooping"),
        mediaId = productMediaWrapper.data("mediaId");
    switch (video.host) {
      case hosts.html5:
        video.element.play(), video.element.addEventListener("play", event => {
          PaloAlto.pauseOtherMedia(mediaId), video.container.closest(selectors.productMediaWrapper).trigger("playVideo")
        }), video.element.addEventListener("pause", event => {
          video.container.closest(selectors.productMediaWrapper).trigger("pauseVideo")
        });
        break;
      case hosts.youtube:
        if (video.host == hosts.youtube && video.player) return;
        const videoId = productMediaWrapper.data("videoId");
        video.player = new YT.Player(video.element, {
          videoId,
          events: {
            onReady: event => {
              event.target.playVideo()
            },
            onStateChange: function(event) {
              event.data === 0 && (enableLooping && event.target.seekTo(0), video.container.closest(selectors.productMediaWrapper).trigger("pauseYoutubeVideo")), event.data === 1 && (PaloAlto.pauseOtherMedia(mediaId), video.container.closest(selectors.productMediaWrapper).trigger("playYoutubeVideo")), event.data === 2 && video.container.closest(selectors.productMediaWrapper).trigger("pauseYoutubeVideo")
            }
          }
        });
        break
    }
    productMediaWrapper.on("mediaHidden xrLaunch", function() {
      video.host === hosts.html5 && video.element && video.element.pause && video.element.pause(), video.host === hosts.youtube && video.player && video.player.pauseVideo && video.player.pauseVideo()
    }), productMediaWrapper.on("mediaVisible", function() {
      video.host === hosts.html5 && video.element && video.element.play && video.element.play(), video.host === hosts.youtube && video.player && video.player.playVideo && video.player.playVideo()
    })
  }

  function loadContent(videoContainer, sectionId) {
    if (!videoContainer.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(videoContainer.querySelector("template").content.firstElementChild.cloneNode(!0));
      const mediaId = videoContainer.dataset.mediaId,
          element = content.querySelector("video, iframe"),
          host = hostFromVideoElement(element),
          deferredMedia = videoContainer.querySelector(selectors.deferredMedia);
      switch (deferredMedia.appendChild(element).focus(), deferredMedia.setAttribute("loaded", !0), videos[mediaId] = {
        mediaId,
        sectionId,
        container: $(videoContainer),
        element,
        host,
        ready: function() {
          createPlayer(this)
        }
      }, videos[mediaId].host) {
        case hosts.html5:
          PaloAlto.ProductVideo.loadVideos(PaloAlto.ProductVideo.hosts.html5);
          break;
        case hosts.youtube:
          window.isYoutubeAPILoaded ? PaloAlto.ProductVideo.loadVideos(PaloAlto.ProductVideo.hosts.youtube) : LibraryLoader.load("youtubeSdk");
          break
      }
    }
  }

  function hostFromVideoElement(video) {
    return video.tagName === "VIDEO" ? hosts.html5 : video.tagName === "IFRAME" && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video.src) ? hosts.youtube : null
  }

  function loadVideos(host) {
    for (let key in videos)
      if (videos.hasOwnProperty(key)) {
        let video = videos[key];
        video.host === host && video.ready()
      }
  }

  function removeSectionVideos(sectionId) {
    for (let key in videos)
      if (videos.hasOwnProperty(key)) {
        let video = videos[key];
        video.sectionId === sectionId && (video.player && video.player.destroy(), delete videos[key])
      }
  }
  return {
    init,
    hosts,
    loadContent,
    loadVideos,
    removeSectionVideos
  }
}(), PaloAlto.ProductModel = function() {
  let modelJsonSections = {},
      models = {},
      xrButtons = {};
  const selectors = {
        mediaGroup: "[data-product-single-media-group]",
        xrButton: "[data-shopify-xr]",
        productMediaSlider: "[data-product-single-media-slider]",
        deferredMedia: "[data-deferred-media]",
        deferredMediaButton: "[data-deferred-media-button]"
      },
      classes = {
        isLoading: "is-loading"
      };

  function init($modelViewerContainer, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: !1
    };
    const deferredMediaButton = $modelViewerContainer[0].querySelector(selectors.deferredMediaButton);
    deferredMediaButton && deferredMediaButton.addEventListener("click", PaloAlto.ProductModel.loadContent.bind(this, $modelViewerContainer[0], sectionId))
  }

  function loadContent(modelViewerContainer, sectionId) {
    modelViewerContainer.classList.add(classes.isLoading);
    const content = document.createElement("div");
    content.appendChild(modelViewerContainer.querySelector("template").content.firstElementChild.cloneNode(!0));
    const modelViewerElement = content.querySelector("model-viewer"),
        deferredMedia = modelViewerContainer.querySelector(selectors.deferredMedia);
    deferredMedia.appendChild(modelViewerElement).focus(), deferredMedia.setAttribute("loaded", !0);
    const mediaId = modelViewerContainer.dataset.mediaId,
        modelId = modelViewerElement.dataset.modelId;
    let $xrButton = $(modelViewerContainer).closest(selectors.mediaGroup).find(selectors.xrButton);
    xrButtons[sectionId] = {
      $element: $xrButton,
      defaultId: modelId
    }, models[mediaId] = {
      modelId,
      mediaId,
      sectionId,
      $container: $(modelViewerContainer),
      $element: $(modelViewerElement)
    }, window.Shopify.loadFeatures([{
      name: "shopify-xr",
      version: "1.0",
      onLoad: setupShopifyXr
    }, {
      name: "model-viewer-ui",
      version: "1.0",
      onLoad: setupModelViewerUi
    }]), LibraryLoader.load("modelViewerUiStyles")
  }

  function setupShopifyXr(errors) {
    if (!errors) {
      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", function() {
          setupShopifyXr()
        });
        return
      }
      for (let sectionId in modelJsonSections)
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          let modelSection = modelJsonSections[sectionId];
          if (modelSection.loaded) continue;
          let $modelJson = $("#ModelJson-" + sectionId);
          if (!$modelJson.length) return;
          window.ShopifyXR.addModels(JSON.parse($modelJson.html())), modelSection.loaded = !0
        } window.ShopifyXR.setupXRElements()
    }
  }

  function setupModelViewerUi(errors) {
    if (errors) return;
    const config = {
      focusOnPlay: !0
    };
    for (let key in models)
      if (models.hasOwnProperty(key)) {
        let model = models[key];
        model.modelViewerUi || (model.modelViewerUi = new Shopify.ModelViewerUI(model.$element, config)), setupModelViewerListeners(model)
      }
  }

  function setupModelViewerListeners(model) {
    let xrButton = xrButtons[model.sectionId];
    model.$container.trigger("playModel"), model.$container.on("mediaVisible", function() {
      xrButton.$element.attr("data-shopify-model3d-id", model.modelId), PaloAlto.pauseOtherMedia(model.mediaId), !window.isTouch && model.modelViewerUi.play()
    }), model.$container.on("mediaHidden", function() {
      xrButton.$element.attr("data-shopify-model3d-id", xrButton.defaultId), model.modelViewerUi.pause()
    }).on("xrLaunch", function() {
      model.modelViewerUi.pause()
    }), model.$element[0].addEventListener("load", () => {
      model.$container.removeClass(classes.isLoading)
    }), model.$element.on("shopify_model_viewer_ui_toggle_play", function() {
      PaloAlto.pauseOtherMedia(model.mediaId), model.$container.trigger("playModel")
    }), model.$element.on("shopify_model_viewer_ui_toggle_pause", function() {
      model.$container.trigger("pauseModel")
    })
  }

  function removeSectionModels(sectionId) {
    for (let key in models) models.hasOwnProperty(key) && models[key].sectionId === sectionId && (models[key].modelViewerUi.destroy(), delete models[key]);
    delete modelJsonSections[sectionId]
  }
  return {
    init,
    loadContent,
    removeSectionModels
  }
}(), PaloAlto.RangeSlider = function() {
  const selectors = {
        rangeSlider: "[data-range-slider]",
        rangeDotLeft: "[data-range-left]",
        rangeDotRight: "[data-range-right]",
        rangeLine: "[data-range-line]",
        rangeHolder: "[data-range-holder]",
        dataMin: "data-se-min",
        dataMax: "data-se-max",
        dataMinValue: "data-se-min-value",
        dataMaxValue: "data-se-max-value",
        dataStep: "data-se-step",
        dataFilterUpdate: "data-range-filter-update",
        priceMin: "[data-field-price-min]",
        priceMax: "[data-field-price-max]"
      },
      classes = {
        classInitialized: "is-initialized"
      };

  function RangeSlider(container) {
    this.container = container, this.init(), document.addEventListener("theme:filters:init", () => {
      this.init()
    })
  }
  return RangeSlider.prototype = $.extend({}, RangeSlider.prototype, {
    init: function() {
      if (this.slider = this.container.querySelector(selectors.rangeSlider), !this.slider) return;
      this.resizeFilters = PaloAlto.debounce(this.reset.bind(this), 50), this.onMoveEvent = event => this.onMove(event), this.onStopEvent = event => this.onStop(event), this.onStartEvent = event => this.onStart(event), this.startX = 0, this.x = 0, this.touchLeft = this.slider.querySelector(selectors.rangeDotLeft), this.touchRight = this.slider.querySelector(selectors.rangeDotRight), this.lineSpan = this.slider.querySelector(selectors.rangeLine), this.min = parseFloat(this.slider.getAttribute(selectors.dataMin)), this.max = parseFloat(this.slider.getAttribute(selectors.dataMax)), this.step = 0, this.normalizeFact = 26;
      let defaultMinValue = this.min;
      this.slider.hasAttribute(selectors.dataMinValue) && (defaultMinValue = parseFloat(this.slider.getAttribute(selectors.dataMinValue)));
      let defaultMaxValue = this.max;
      this.slider.hasAttribute(selectors.dataMaxValue) && (defaultMaxValue = parseFloat(this.slider.getAttribute(selectors.dataMaxValue))), defaultMinValue < this.min && (defaultMinValue = this.min), defaultMaxValue > this.max && (defaultMaxValue = this.max), defaultMinValue > defaultMaxValue && (defaultMinValue = defaultMaxValue), this.slider.getAttribute(selectors.dataStep) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(selectors.dataStep)))), this.reset(), window.addEventListener("resize", this.resizeFilters), this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth, this.selectedTouch = null, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact, this.setMinValue(defaultMinValue), this.setMaxValue(defaultMaxValue), this.touchLeft.addEventListener("mousedown", this.onStartEvent), this.touchRight.addEventListener("mousedown", this.onStartEvent), this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
        passive: !0
      }), this.touchRight.addEventListener("touchstart", this.onStartEvent, {
        passive: !0
      }), this.slider.classList.add(classes.classInitialized)
    },
    reset() {
      this.touchLeft.style.left = "0px", this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.lineSpan.style.marginLeft = "0px", this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.startX = 0, this.x = 0, this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact
    },
    setMinValue(minValue) {
      const ratio = (minValue - this.min) / (this.max - this.min);
      this.touchLeft.style.left = Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(selectors.dataMinValue, minValue)
    },
    setMaxValue(maxValue) {
      const ratio = (maxValue - this.min) / (this.max - this.min);
      this.touchRight.style.left = Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(selectors.dataMaxValue, maxValue)
    },
    onStart(event) {
      event.preventDefault();
      let eventTouch = event;
      event.touches && (eventTouch = event.touches[0]), event.currentTarget === this.touchLeft ? this.x = this.touchLeft.offsetLeft : this.x = this.touchRight.offsetLeft, this.startX = eventTouch.pageX - this.x, this.selectedTouch = event.currentTarget, this.slider.addEventListener("mousemove", this.onMoveEvent), this.slider.addEventListener("mouseup", this.onStopEvent), this.slider.addEventListener("touchmove", this.onMoveEvent, {
        passive: !0
      }), this.slider.addEventListener("touchend", this.onStopEvent, {
        passive: !0
      })
    },
    onMove(event) {
      let eventTouch = event;
      event.touches && (eventTouch = event.touches[0]), this.x = eventTouch.pageX - this.startX, this.selectedTouch === this.touchLeft ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 : this.x < 0 && (this.x = 0), this.selectedTouch.style.left = this.x + "px") : this.selectedTouch === this.touchRight && (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 : this.x > this.maxX && (this.x = this.maxX), this.selectedTouch.style.left = this.x + "px"), this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.calculateValue(), this.slider.getAttribute("on-change") && new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(selectors.dataMinValue), this.slider.getAttribute(selectors.dataMaxValue)), this.onChange(this.slider.getAttribute(selectors.dataMinValue), this.slider.getAttribute(selectors.dataMaxValue))
    },
    onStop(event) {
      this.slider.removeEventListener("mousemove", this.onMoveEvent), this.slider.removeEventListener("mouseup", this.onStopEvent), this.slider.removeEventListener("touchmove", this.onMoveEvent, {
        passive: !0
      }), this.slider.removeEventListener("touchend", this.onStopEvent, {
        passive: !0
      }), this.selectedTouch = null, this.calculateValue(), this.onChanged(this.slider.getAttribute(selectors.dataMinValue), this.slider.getAttribute(selectors.dataMaxValue))
    },
    onChange(min, max) {
      const rangeHolder = this.slider.closest(selectors.rangeHolder);
      if (rangeHolder) {
        const priceMin = rangeHolder.querySelector(selectors.priceMin),
            priceMax = rangeHolder.querySelector(selectors.priceMax);
        priceMin && priceMax && (priceMin.value = parseInt(min), priceMax.value = parseInt(max))
      }
    },
    onChanged(min, max) {
      this.slider.hasAttribute(selectors.dataFilterUpdate) && this.slider.dispatchEvent(new CustomEvent("range:filter:update", {
        bubbles: !0
      }))
    },
    calculateValue() {
      const newValue = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let minValue = this.lineSpan.offsetLeft / this.initialValue,
          maxValue = minValue + newValue;
      if (minValue = minValue * (this.max - this.min) + this.min, maxValue = maxValue * (this.max - this.min) + this.min, this.step !== 0) {
        let multi = Math.floor(minValue / this.step);
        minValue = this.step * multi, multi = Math.floor(maxValue / this.step), maxValue = this.step * multi
      }
      this.selectedTouch === this.touchLeft && this.slider.setAttribute(selectors.dataMinValue, minValue), this.selectedTouch === this.touchRight && this.slider.setAttribute(selectors.dataMaxValue, maxValue)
    }
  }), RangeSlider
}(), PaloAlto.AnnouncementBar = function() {
  function AnnouncementBar(container) {
    var $container = this.$container = $(container),
        sectionId = this.sectionId = $(container).attr("data-section-id");
    this.initSlider()
  }
  return AnnouncementBar.prototype = $.extend({}, AnnouncementBar.prototype, {
    initSlider: function() {
      var $slider = $(".top-bar__slider", this.$container);
      $slider.flickity({
        cellSelector: ".top-bar__slide",
        pageDots: !1,
        prevNextButtons: !1,
        wrapAround: !0,
        autoPlay: 5e3
      })
    },
    onBlockSelect: function(evt) {
      var $slider = $(evt.target).parents(".top-bar__slider"),
          index = $(evt.target).index();
      $slider.data("flickity") && ($slider.flickity("select", index), $slider.flickity("pausePlayer"))
    },
    onBlockDeselect: function(evt) {
      var $slider = $(evt.target).parents(".top-bar__slider");
      $slider.data("flickity") && $slider.flickity("unpausePlayer")
    }
  }), AnnouncementBar
}(), PaloAlto.BlogPosts = function() {
  function BlogPosts(container) {
    this.$container = $(container), this.endlessBlogPosts = {}, this.initInfinityScroll()
  }
  return BlogPosts.prototype = $.extend({}, BlogPosts.prototype, {
    initInfinityScroll: function() {
      theme.settings.enableInfinityScroll && (this.endlessBlogPosts = new Ajaxinate({
        container: "#AjaxinateLoop",
        pagination: "#AjaxinatePagination",
        method: "scroll"
      }))
    },
    onUnload: function(evt) {
      theme.settings.enableInfinityScroll && typeof this.endlessBlogPosts == "object" && this.endlessBlogPosts.destroy === "function" && this.endlessBlogPosts.destroy()
    }
  }), BlogPosts
}(), PaloAlto.Faq = function() {
  function Faq(container) {
    PaloAlto.initCollapsible()
  }
  return Faq
}(), PaloAlto.FeaturedBlog = function() {
  var selectors = {
        article: "[data-blog-item]",
        slider: "[data-slider]",
        sliderItem: "[data-item]",
        buttonProductsShow: "[data-button-show]",
        buttonProductsHide: "[data-button-hide]",
        itemProducts: "[data-item-products]",
        itemProductSlider: "[data-item-products-slider]",
        itemProduct: "[data-item-product]"
      },
      classes = {
        itemActive: "blog-item--active",
        itemProductsVisible: "blog-item__products--visible",
        featuredBlogSlider: "featured-blog__slider"
      };

  function FeaturedBlog(container) {
    this.$container = $(container), this.namespace = this.$container.attr("data-section-id"), this.flkty = null, this.$article = $(selectors.article, this.container), this.$slider = this.$container.find(selectors.slider), this.$itemProducts = $(selectors.itemProducts, this.container), this.$itemProductSlider = this.$container.find(selectors.itemProductSlider), this.$buttonProductsShow = $(selectors.buttonProductsShow, this.$container), this.$buttonProductsHide = $(selectors.buttonProductsHide, this.container), this.checkSlidesSizeOnResize = this.checkSlidesSize.bind(this), this.bindButtons(), this.listen()
  }
  return FeaturedBlog.prototype = $.extend({}, FeaturedBlog.prototype, {
    initSlider: function() {
      var instance = this;
      this.$slider.flickity({
        prevNextButtons: !0,
        pageDots: !1,
        cellAlign: "left",
        wrapAround: !1,
        groupCells: !0,
        contain: !0
      }), this.$slider.on("change.flickity", function(event) {
        event.target.className.includes(classes.featuredBlogSlider) && ($(selectors.sliderItem, instance.$container).removeClass(classes.itemActive).find(selectors.itemProducts).removeClass(classes.itemProductsVisible), instance.flkty && !instance.flkty.options.draggable && (instance.flkty.options.draggable = !0, instance.flkty.updateDraggable()))
      }), instance.flkty = this.$slider.data("flickity")
    },
    destroySlider: function() {
      this.flkty && (this.$slider.flickity("destroy"), this.$slider.removeClass(classes.featuredBlogSliderInfinite), this.flkty = null)
    },
    checkSlidesSize: function() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth,
          gutter = $(selectors.sliderItem, this.$container).outerWidth(!0) - $(selectors.sliderItem, this.$container).width(),
          containerWidth = $(window).width() - gutter * 2,
          itemsWidth = this.getItemsWidth(),
          itemsOverflowViewport = containerWidth < itemsWidth;
      windowWidth >= 768 && itemsOverflowViewport ? this.initSlider() : this.destroySlider()
    },
    getItemsWidth: function() {
      var itemsWidth = 0;
      return $(selectors.sliderItem, this.$slider).each(function() {
        itemsWidth += $(this).outerWidth(!0)
      }), itemsWidth
    },
    bindButtons: function() {
      var instance = this;
      this.$buttonProductsShow.on("click", function() {
        $(selectors.sliderItem, instance.$container).removeClass(classes.itemActive).find(selectors.itemProducts).removeClass(classes.itemProductsVisible), $(this).closest(selectors.sliderItem).addClass(classes.itemActive).find(selectors.itemProducts).addClass(classes.itemProductsVisible), instance.flkty && (instance.flkty.options.draggable = !1, instance.flkty.updateDraggable())
      }), this.$buttonProductsHide.on("click", function() {
        $(this).closest(selectors.sliderItem).removeClass(classes.itemActive).find(selectors.itemProducts).removeClass(classes.itemProductsVisible), instance.flkty && (instance.flkty.options.draggable = !0, instance.flkty.updateDraggable())
      }), this.$itemProductSlider.each(function() {
        var countSlides = $(this).find(selectors.itemProduct).length;
        countSlides > 1 && $(this).flickity({
          prevNextButtons: !0,
          contain: !0,
          pageDots: !1,
          wrapAround: !0
        })
      }), this.$slider.on("keyup", function(e) {
        e.keyCode === slate.utils.keyboardKeys.ESCAPE && ($(this).find(selectors.sliderItem).removeClass(classes.itemActive).find(selectors.itemProducts).removeClass(classes.itemProductsVisible), instance.flkty && (instance.flkty.options.draggable = !0, instance.flkty.updateDraggable()))
      }), $(document).on("click." + this.namespace, function(e) {
        var clickOutsideSliderItem = !$(e.target).is(selectors.sliderItem + " *");
        clickOutsideSliderItem && $(selectors.sliderItem).removeClass(classes.itemActive).find(selectors.itemProducts).removeClass(classes.itemProductsVisible)
      })
    },
    listen: function() {
      document.addEventListener("theme:resize", this.checkSlidesSizeOnResize), this.checkSlidesSize()
    },
    onBlockSelect: function(evt) {
      var sliderData = this.$slider.data("flickity"),
          index = parseInt($(evt.target).index());
      if (sliderData) {
        var slidesPerPage = parseInt(sliderData.slides[0].cells.length),
            groupIndex = Math.floor(index / slidesPerPage);
        this.$slider.flickity("select", groupIndex)
      } else {
        var slider = this.container.querySelector(selectors.slider),
            sliderStyle = slider.currentStyle || window.getComputedStyle(slider),
            sliderPadding = parseInt(sliderStyle.paddingLeft),
            blockPositionLeft = evt.target.offsetLeft - sliderPadding;
        slider.scrollTo({
          top: 0,
          left: blockPositionLeft,
          behavior: "smooth"
        })
      }
    },
    onUnload: function() {
      $(document).off("click." + this.namespace), document.removeEventListener("theme:resize", this.checkSlidesSizeOnResize)
    }
  }), FeaturedBlog
}(), PaloAlto.FeaturedCollection = function() {
  var selectors = {
        slider: "[data-collection-slider]",
        sliderItem: "[data-product-slide]",
        productMediaSlider: "[data-product-media-slideshow]",
        productMediaSlide: "[data-product-media-slideshow-slide]",
        productGridItemImage: "[data-product-media-container]",
        sliderArrows: ".flickity-button",
        flickityButtons: ".flickity-button, .flickity-button *"
      },
      classes = {
        carouselActive: "carousel--active",
        carouselInactive: "carousel--inactive"
      };

  function FeaturedCollection(container) {
    this.$container = $(container), this.$slider = this.$container.find(selectors.slider), this.checkSlidesSizeOnResize = this.checkSlidesSize.bind(this), this.setBadgePositionOnResize = PaloAlto.Badge.setPosition(), theme.settings.productGridSlideshow && !this.$container.data("slider") && this.productGridSlideshow(), PaloAlto.initQuickButton(this.$container), this.listen()
  }
  return FeaturedCollection.prototype = $.extend({}, FeaturedCollection.prototype, {
    initSlider: function() {
      this.$slider.addClass(classes.carouselActive).removeClass(classes.carouselInactive), this.$slider.data("flickity") || (this.$slider.on("ready.flickity", this.setSliderArrowsPosition.bind(this)), this.$slider.flickity({
        pageDots: !1,
        cellSelector: selectors.sliderItem,
        cellAlign: "left",
        groupCells: !0,
        contain: !0,
        wrapAround: !1,
        adaptiveHeight: !1
      }))
    },
    destroySlider: function() {
      this.$slider.removeClass(classes.carouselActive).addClass(classes.carouselInactive), this.$slider.data("flickity") && this.$slider.flickity("destroy")
    },
    checkSlidesSize: function() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth,
          gutter = $(selectors.sliderItem, this.$container).outerWidth(!0) - $(selectors.sliderItem, this.$container).width(),
          containerWidth = $(window).width() - gutter * 2,
          itemWidth = $(selectors.sliderItem, this.$container).outerWidth(!0),
          itemsCount = $(selectors.sliderItem, this.$container).length,
          itemsOverflowViewport = containerWidth < itemWidth * itemsCount;
      windowWidth >= 768 && itemsOverflowViewport ? (this.initSlider(), this.setSliderArrowsPosition()) : this.destroySlider()
    },
    setSliderArrowsPosition: function() {
      var $arrows = this.$slider.find(selectors.sliderArrows),
          imageHeight = this.$slider.find(selectors.productGridItemImage).outerHeight();
      $arrows.css("top", imageHeight / 2)
    },
    productGridSlideshow: function() {
      $(selectors.productMediaSlider, this.$container).each(function() {
        var countImages = $(this).find(selectors.productMediaSlide).length;
        countImages > 1 && $(this).flickity({
          cellSelector: selectors.productMediaSlide,
          contain: !0,
          wrapAround: !0,
          imagesLoaded: !0,
          lazyLoad: !0,
          pageDots: !1,
          adaptiveHeight: !1
        })
      }), this.$container.on("click", selectors.productGridItemImage, function(e) {
        $(e.target).is(selectors.flickityButtons) && e.preventDefault()
      })
    },
    listen: function() {
      document.addEventListener("theme:resize", this.checkSlidesSizeOnResize), document.addEventListener("theme:resize", this.setBadgePositionOnResize), this.checkSlidesSize()
    },
    onSelect: function() {
      PaloAlto.initQuickButton(this.$container)
    },
    onDeselect: function() {
      $.magnificPopup.close()
    },
    onBlockSelect: function(evt) {
      var $slider = $(evt.target).parents(selectors.slider),
          index = $(evt.target).index();
      $slider.data("flickity") && $slider.flickity("select", index)
    },
    onUnload: function(evt) {
      $.magnificPopup.close();
      var $slider = $(evt.target).parents(selectors.slider);
      $slider.data("flickity") && $slider.flickity("destroy"), document.removeEventListener("theme:resize", this.checkSlidesSizeOnResize), document.removeEventListener("theme:resize", this.setBadgePositionOnResize)
    }
  }), FeaturedCollection
}(), PaloAlto.FeaturedImage = function() {
  var selectors = {
    parallaxImg: "[data-parallax-img]"
  };

  function FeaturedImage(container) {
    this.container = container, this.$container = $(container), this.enableParallax = this.container.hasAttribute("data-parallax-wrapper"), this.sectionId = this.$container.attr("data-section-id"), this.parallaxImage = {}, this.init()
  }
  return FeaturedImage.prototype = $.extend({}, FeaturedImage.prototype, {
    init: function() {
      if (!this.enableParallax) return;
      const inner = this.container.querySelector(selectors.parallaxImg),
          frame = "#FeaturedImage--" + this.sectionId;
      this.parallaxImage = new Rellax(inner, {
        center: !0,
        round: !0,
        frame
      })
    },
    onUnload: function() {
      typeof this.parallaxImage.destroy == "function" && this.parallaxImage.destroy()
    }
  }), FeaturedImage
}(), PaloAlto.FeaturedVideo = function() {
  var players = [],
      isYoutubeAPIReady = !1,
      enableSound = !1,
      defaultYoutubeOptions = {
        height: "720",
        width: "1280",
        playerVars: {
          showinfo: 0,
          controls: 0,
          fs: 0,
          rel: 0,
          height: "100%",
          width: "100%",
          iv_load_policy: 3,
          html5: 1,
          loop: 1,
          playsinline: 1,
          modestbranding: 1,
          disablekb: 1,
          wmode: "opaque"
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange
        }
      };

  function FeaturedVideo(container) {
    var $container = this.$container = $(container),
        $player = this.$player = $container.find(".video__iframe");
    enableSound = $container.data("enable-sound"), $player.length && (this.playerID = $player.attr("id"), this.videoID = $player.data("video-id"), this.init())
  }

  function onPlayerReady(event) {
    var iframe = event.target.getIframe(),
        id = $(iframe).attr("id");
    id && ($(iframe).attr("tabindex", "-1"), enableSound ? event.target.unMute() : event.target.mute(), event.target.playVideo(), $(iframe).parent().addClass("loaded"), checkPlayerVisibility(id), $(window).on("scroll." + id, {
      id
    }, $.throttle(150, checkPlayerVisibility)))
  }

  function onPlayerStateChange(event) {
    event.data == 0 && event.target.playVideo()
  }

  function checkPlayerVisibility(id) {
    if (typeof id == "string") var playerID = id;
    else if (id.data != null) var playerID = id.data.id;
    else return !1;
    var playerElement = document.getElementById(playerID + "-container"),
        player = players[playerID],
        isVisible = PaloAlto.isInViewport(playerElement);
    isVisible && player && typeof player.playVideo == "function" ? player.playVideo() : !isVisible && player && typeof player.pauseVideo == "function" && player.pauseVideo()
  }
  return FeaturedVideo.prototype = $.extend({}, FeaturedVideo.prototype, {
    init: function() {
      var self2 = this;
      this.$container.on("click touchstart", ".video-wrapper", function(e) {
        var playerID = $(this).find(".video__iframe").attr("id");
        players[playerID] && players[playerID].playVideo && players[playerID].playVideo()
      }), this.setVideoFullscreenSize(), $(window).on("resize." + this.playerID, PaloAlto.debounce(self2.setVideoFullscreenSize.bind(self2), 250)), isYoutubeAPIReady ? this.loadYoutubePlayer() : (window.loadYoutubeAPI(), $("body").on("youtubeAPIReady", this.loadYoutubePlayer.bind(this)))
    },
    loadYoutubePlayer: function() {
      var currentYoutubeOptions = $.extend({}, defaultYoutubeOptions);
      currentYoutubeOptions.videoId = this.videoID, players[this.playerID] = new YT.Player(this.playerID, currentYoutubeOptions), isYoutubeAPIReady = !0
    },
    setVideoFullscreenSize: function() {
      var $player = this.$container.find(".video__iframe"),
          videoAspectRatio = 16 / 9,
          containerAspectRatio = this.$container.width() / this.$container.outerHeight(),
          videoWidth = 0,
          videoHeight = 0;
      videoAspectRatio > containerAspectRatio ? (videoWidth = this.$container.outerHeight() * videoAspectRatio, videoHeight = this.$container.outerHeight()) : (videoWidth = this.$container.width(), videoHeight = this.$container.width() / videoAspectRatio), $player.css({
        width: videoWidth,
        height: videoHeight
      })
    },
    onUnload: function(evt) {
      var playerID = "video-" + this.$container.data("section-id");
      delete players[playerID], $(window).off("resize." + this.playerID), $(window).off("scroll." + this.playerID)
    }
  }), FeaturedVideo
}(), PaloAlto.Footer = function() {
  function Footer(container) {
    var $container = this.$container = $(container),
        selectors = {
          popoutLocale: "[data-popout-locale]",
          popoutCurrency: "[data-popout-currency]"
        },
        $popoutLocale = $(selectors.popoutLocale, $container),
        popoutLocale = {},
        $popoutCurrency = $(selectors.popoutCurrency, $container),
        popoutCurrency = {};
    $popoutLocale.length && (popoutLocale = new PaloAlto.Popout($popoutLocale)), $popoutCurrency.length && (popoutCurrency = new PaloAlto.Popout($popoutCurrency)), PaloAlto.initCollapsible()
  }
  return Footer
}(), PaloAlto.Header = function() {
  var $window = $(window),
      $body = $("body"),
      $pageContainer = $("#PageContainer"),
      scrollingDirection = "down",
      lastScrollTop = $(window).scrollTop(),
      lastWindowWidth2 = window.innerWidth || document.documentElement.clientWidth,
      headerHeight = 60,
      selectors = {
        activeDropdowns: ".is-expanded",
        cartDrawer: "#CartDrawer",
        cartContainer: "[data-api-cart]",
        closeDrawer: ".js-drawer-close",
        collectionFilters: "[data-collection-filters]",
        dropdown: ".dropdown",
        dropdownActive: ".nav--active",
        dropdownSubmenu: ".dropdown--level-3",
        dropdownParents: ".nav__item--has-items, .dropdown__item--has-items",
        dropdownTrigger: ".dropdown__trigger--hover",
        dropdownLink: ".dropdown__link",
        dropdownCollapsible: ".dropdown__links-container",
        headerTopLevelLinks: ".nav__link, .logo__image-link, .logo__text-link, .cart__toggle",
        logo: ".logo",
        logoLinkHome: ".logo__image-link--home",
        logoImage: ".logo__image",
        logoImageHome: ".logo__image-link--home .logo__image",
        logoImageOther: ".logo__image-link--other .logo__image",
        megamenu: ".megamenu",
        nav: ".nav",
        navDrawer: "#NavDrawer",
        navItem: "[nav-item]",
        navLink: "[nav-link]",
        navSearch: "[data-nav-search]",
        openNavDrawer: ".js-drawer-open-nav",
        openCartDrawer: ".js-drawer-open-cart",
        wrapper: ".wrapper",
        headerNewWrapper: ".header-new__wrapper",
        mobileNavLink: ".mobile-nav__link",
        mobileNavDropdownTrigger: ".mobile-nav__trigger"
      },
      classes = {
        navActive: "nav--active",
        isExpanded: "is-expanded",
        jsDrawerOpen: "js-drawer-open",
        jsDrawerOpenAll: "js-drawer-open js-drawer-open-left js-drawer-open-right",
        jsFocusVisible: "js-focus-visible",
        dropdownTrigger: "dropdown__trigger--hover",
        dropdownTriggerCollapsible: "dropdown__trigger--collapsible",
        dropdownParents: "nav__item--has-items",
        dropdownLink: "dropdown__link",
        dropdownOpen: "dropdown--open",
        dropdownRight: "dropdown--level-2--right",
        dropdownSubmenuLeft: "dropdown--level-3--left",
        megamenuOpen: "megamenu--open",
        megamenuLink: "megamenu__link",
        headerMegamenuOpen: "is-megamenu-open",
        headerNavRight: "site-header--nav-right",
        headerNavCenter: "site-header--nav-center",
        headerTransparent: "site-header--transparent",
        headerLoading: "site-header--loading",
        hasMegamenu: "nav__item--has-megamenu",
        hasScrolled: "has-scrolled",
        hasTransparentHeader: "has-transparent-header",
        hideHeader: "hide-header",
        navCompress: "nav--compress",
        navDefault: "nav--default",
        navItemCompress: "nav__item--compress",
        mobileNavDropdownTrigger: "mobile-nav__link--trigger",
        isTransitioning: "is-transitioning",
        headerSticky: "header--sticky"
      };

  function Header(container) {
    var $container = this.$container = $(container),
        $navSearch = this.$navSearch = $(selectors.navSearch, $container);
    this.namespace = ".header",
    this.$header = $container,
        this.$headerSection = $container.parent(),
        this.$headerWrapper = $container.children(selectors.headerNewWrapper), this.$siteNav = $(selectors.nav, $container), this.$logo = $(selectors.logo, $container), this.$navDrawer = $(selectors.navDrawer), this.$cartDrawer = $(selectors.cartDrawer), this.activeDropdownsClose = 0, PaloAlto.initCollapsible(), PaloAlto.initListeners(), PaloAlto.initTransparentHeader(), PaloAlto.setMainSpacing(), ajaxCart.initQtySelectors(), this.fitNav(), this.initStickyNav(), this.initAccessibleNav(), this.initMobileNav(), this.initDrawers(), this.headerState(), $navSearch.length && PaloAlto.NavSearch.init()
  }
  return Header.prototype = $.extend({}, Header.prototype, {
    initStickyNav: function() {
      var hasCollectionFilters = $(selectors.collectionFilters).length,
          position = hasCollectionFilters ? "relative" : this.$header.data("position");
      headerHeight = parseInt(this.$header.data("height")), position == "fixed" ? this.$headerSection.addClass(classes.headerSticky) : this.$headerSection.removeClass(classes.headerSticky), $window.on("scroll" + this.namespace, this.headerState.bind(this))
    },
    headerState: function() {
      var hasCollectionFilters = $(selectors.collectionFilters).length;
      if (!hasCollectionFilters) {
        var pageOffset = parseInt($pageContainer.offset().top) + parseInt(headerHeight),
            currentScrollTop = $window.pageYOffset || document.documentElement.scrollTop,
            position = this.$header.data("position");
        scrollingDirection = currentScrollTop > lastScrollTop ? "down" : "up", lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop, position == "fixed" && (currentScrollTop > pageOffset ? ($body.addClass(classes.hasScrolled), this.$header.removeClass(classes.headerTransparent)) : ($body.removeClass(classes.hasScrolled), isHeaderTransparent && this.$header.addClass(classes.headerTransparent)), currentScrollTop < pageOffset + 60 && scrollingDirection == "up" ? $body.addClass(classes.hideHeader) : $body.removeClass(classes.hideHeader))

        if (document.body.classList.contains(classes.hasScrolled)) {
          document.body.style.setProperty('--bar-height', '0px')
        } else {
          document.body.style.removeProperty('--bar-height')
        }
      }
    },
    fitNav: function() {
      var self2 = this;
      $window.on("load", this.controlNav.bind(this)).on("resize" + this.namespace, $.throttle(100, function() {
        var newWindowWidth = window.innerWidth || document.documentElement.clientWidth;
        newWindowWidth != lastWindowWidth2 && (self2.controlNav(), $(selectors.dropdownParents).each(function() {
          self2.dropdownFix($(this))
        }), lastWindowWidth2 = newWindowWidth)
      })), this.controlNav()
    },
    controlNav: function() {
      this.$header.removeClass(classes.headerNavRight), this.$siteNav.removeClass(classes.navCompress).addClass(classes.navDefault);
      var logoWidth = this.$logo.length ? this.$logo.outerWidth() : 0,
          maxNavWidth = this.$headerWrapper.width() - logoWidth,
          navWidth = this.$headerWrapper.width() - logoWidth - 20,
          navItemsWidth2 = 0,
          isNavCentered = this.$header.data("nav-position") == "center";
      isNavCentered && (navWidth = this.$headerWrapper.width() - logoWidth * 2), navItemsWidth2 = this.getNavItemsWidth(), navItemsWidth2 > navWidth ? this.$header.removeClass(classes.headerNavCenter).addClass(classes.headerNavRight) : (this.$header.removeClass(classes.headerNavRight), isNavCentered && this.$header.addClass(classes.headerNavCenter)), navItemsWidth2 = this.getNavItemsWidth(), navItemsWidth2 > maxNavWidth ? this.$siteNav.addClass(classes.navCompress).removeClass(classes.navDefault) : this.$siteNav.removeClass(classes.navCompress).addClass(classes.navDefault), $window.trigger("scroll" + this.namespace)
    },
    getNavItemsWidth: function() {
      return navItemsWidth = 0, this.$siteNav.children(selectors.navItem).each(function() {
        var $el = $(this);
        $el.hasClass(classes.navItemCompress) || (navItemsWidth += Math.ceil($(this).outerWidth(!0)))
      }), navItemsWidth
    },
    initAccessibleNav: function() {
      var self2 = this,
          $headerTopLevelLinks = $(selectors.headerTopLevelLinks, this.$header),
          $dropdownParents = $(selectors.dropdownParents, this.$siteNav);
      $dropdownParents.off(this.namespace), $headerTopLevelLinks.off(this.namespace), this.$header.removeClass(classes.headerLoading), $dropdownParents.on("mouseenter" + this.namespace, function() {
        window.isTouch || showDropdown($(this))
      }).on("mouseleave" + this.namespace, function() {
        window.isTouch || hideDropdown($(this))
      }).on("focus" + this.namespace, selectors.navLink, function(e) {
        var $el = $(this).closest(selectors.dropdownParents),
            dropdownOpen = $el.hasClass(classes.navActive);
        dropdownOpen || showDropdown($el)
      }).on("keyup" + this.namespace, selectors.navLink, function(e) {
        if (e.keyCode === slate.utils.keyboardKeys.ESCAPE) {
          var $el = $(this).closest(selectors.dropdownParents);
          hideDropdown($el)
        }
      }).on("keyup touchstart", selectors.dropdownTrigger, function(e) {
        if (e.keyCode === slate.utils.keyboardKeys.ENTER || e.keyCode === slate.utils.keyboardKeys.SPACE || e.type === "touchstart") {
          e.stopImmediatePropagation();
          var $el = $(this).closest(selectors.dropdownParents),
              dropdownOpen = $el.hasClass(classes.navActive);
          dropdownOpen ? hideDropdown($el) : showDropdown($el)
        }
      }).on("keyup" + this.namespace, function(e) {
        if (e.keyCode === slate.utils.keyboardKeys.ESCAPE) {
          e.stopImmediatePropagation();
          var $dropdownParent, $el = $(e.target),
              isDropdownParent = $el.hasClass(classes.dropdownParents),
              isDropdownTrigger = $el.hasClass(classes.dropdownTrigger),
              isDropdownTriggerCollapsible = $el.hasClass(classes.dropdownTriggerCollapsible),
              isDropdownLink = $el.hasClass(classes.dropdownLink),
              isMegamenuLink = $el.hasClass(classes.megamenuLink);
          if (isDropdownParent) $dropdownParent = $(this), hideDropdown($dropdownParent);
          else if (isDropdownTrigger || isDropdownLink || isMegamenuLink) $dropdownParent = $el.parents(selectors.dropdownParents), hideDropdown($dropdownParent);
          else if (isDropdownTriggerCollapsible) {
            var $dropdown = $("#" + $el.attr("aria-controls")),
                isExpanded = $dropdown.hasClass(classes.isExpanded),
                isTransitioning = $dropdown.hasClass(classes.isTransitioning);
            (isExpanded || !isTransitioning) && ($dropdownParent = $el.parents(selectors.dropdownParents), hideDropdown($dropdownParent))
          }
        }
      }).each(function() {
        self2.dropdownFix($(this))
      }), $headerTopLevelLinks.on("focus" + this.namespace, function() {
        var $dropdownSiblings = $(selectors.dropdownActive).not($(this).closest(selectors.dropdownParents));
        hideDropdown($dropdownSiblings)
      });

      function showDropdown($el) {
        var $dropdownParent = $el,
            $dropdownTrigger = $el.children(selectors.dropdownTrigger),
            $dropdown = $dropdownParent.children(selectors.dropdown),
            $megamenu = $dropdownParent.children(selectors.megamenu),
            isMegamenu = $dropdownParent.hasClass(classes.hasMegamenu),
            $activeDropdown = $dropdownParent.siblings(selectors.dropdownActive);
        slate.a11y.state.trigger = $el.children(selectors.navLink), clearTimeout(self2.activeDropdownsClose), $activeDropdown.length && hideDropdown($activeDropdown), $dropdownParent.addClass(classes.navActive), $dropdownTrigger.attr("aria-expanded", !0), $dropdown.addClass(classes.dropdownOpen).attr("aria-hidden", !1), isMegamenu && (self2.$header.addClass(classes.headerMegamenuOpen), $megamenu.addClass(classes.megamenuOpen)), setTimeout(function() {
          $body.on("touchstart" + self2.namespace, function(e) {
            $(e.target).parents(selectors.dropdownParents).length || hideDropdown($el)
          })
        }, 250)
      }

      function hideDropdown($el) {
        var isDropdownOpen = $el.hasClass(classes.navActive);
        if (isDropdownOpen) {
          var $dropdownParent = $el,
              $dropdownTrigger = $el.children(selectors.dropdownTrigger),
              $dropdown = $dropdownParent.children(selectors.dropdown),
              $megamenu = $dropdownParent.children(selectors.megamenu),
              $activeDropdowns = $el.find(selectors.activeDropdowns);
          $dropdownParent.removeClass(classes.navActive), $dropdownTrigger.attr("aria-expanded", !1), $dropdown.removeClass(classes.dropdownOpen).attr("aria-hidden", !0), $megamenu.removeClass(classes.megamenuOpen).attr("aria-hidden", !0), self2.$header.removeClass(classes.headerMegamenuOpen), $body.off("touchstart" + self2.namespace);
          var hasActiveDropdown = !$dropdownParent.parents(selectors.dropdownParents).hasClass(classes.navActive);
          hasActiveDropdown && (hideActiveCollapsibleDropdowns($activeDropdowns), self2.activeDropdownsClose = setTimeout(function() {
            hideActiveCollapsibleDropdowns($activeDropdowns)
          }, 500))
        }
      }

      function hideActiveCollapsibleDropdowns($activeDropdowns) {
        $activeDropdowns.removeClass(classes.isExpanded).filter(selectors.dropdownCollapsible).css("height", 0)
      }
    },
    dropdownFix: function($el) {
      if ($el.hasClass(classes.dropdownParents)) {
        var self2 = this,
            $dropdownMenu = $el.find(selectors.dropdown).removeClass(classes.dropdownRight),
            $dropdownSubmenu = $el.find(selectors.dropdownSubmenu).removeClass(classes.dropdownSubmenuLeft),
            elementOffset = $el.offset().left;
        if ($dropdownMenu.length) {
          var dropdownMenuWidth = $dropdownMenu.outerWidth() + 20,
              dropdownSubmenuWidth = $dropdownSubmenu.length ? $dropdownSubmenu.outerWidth() : 0,
              headerWidth = self2.$header.width() + self2.$headerWrapper.offset().left;
          parseInt(elementOffset + dropdownMenuWidth) > headerWidth && $dropdownMenu.addClass(classes.dropdownRight), parseInt(elementOffset + dropdownMenuWidth + dropdownSubmenuWidth) > headerWidth && $dropdownSubmenu.addClass(classes.dropdownSubmenuLeft)
        }
      }
    },
    initMobileNav: function() {
      theme.settings.mobileMenuBehaviour != "link" && $(selectors.mobileNavLink).on("click", function(e) {
        var hasDropdown = $(this).hasClass(classes.mobileNavDropdownTrigger),
            $dropdownTrigger = $(this).next(selectors.mobileNavDropdownTrigger);
        hasDropdown && (e.preventDefault(), $dropdownTrigger.trigger("click"))
      })
    },
    initDrawers: function() {
      var $openNavDrawer = $(selectors.openNavDrawer, this.$container),
          $openCartDrawer = $(selectors.openCartDrawer, this.$container),
          cartDrawer = document.querySelector(selectors.cartDrawer),
          navDrawer = document.querySelector(selectors.navDrawer);
      PaloAlto.Drawers.initCloseListener(), PaloAlto.Drawers.initOpenListener($openNavDrawer), $body.on("NavDrawer:open" + this.namespace, function() {
        slate.a11y.trapFocus({
          container: navDrawer,
          elementToFocus: navDrawer.querySelector(selectors.closeDrawer)
        })
      }).on("NavDrawer:close" + this.namespace, function() {
        slate.a11y.removeTrapFocus({
          container: navDrawer
        })
      }), theme.settings.cartType == "drawer" && (PaloAlto.Drawers.initOpenListener($openCartDrawer), $body.on("CartDrawer:open" + this.namespace, function() {
        var isCartLoaded = !!$(selectors.cartContainer).html();
        isCartLoaded || ajaxCart.load(), slate.a11y.trapFocus({
          container: cartDrawer,
          elementToFocus: cartDrawer.querySelector(selectors.closeDrawer)
        })
      }).on("CartDrawer:close" + this.namespace, function() {
        slate.a11y.removeTrapFocus({
          container: cartDrawer
        })
      }))
    },
    onUnload: function() {
      PaloAlto.Drawers.close(), $window.off(this.namespace), $body.off(this.namespace).removeClass(classes.jsDrawerOpenAll), ajaxCart.destroy()
    }
  }), Header
}(), PaloAlto.IconsRow = function() {
  var selectors = {
    slider: "[data-slider]"
  };

  function IconsRow(container) {
    this.container = container
  }
  return IconsRow.prototype = $.extend({}, IconsRow.prototype, {
    onBlockSelect: function(evt) {
      var slider = this.container.querySelector(selectors.slider),
          sliderStyle = slider.currentStyle || window.getComputedStyle(slider),
          sliderPadding = parseInt(sliderStyle.paddingLeft),
          blockPositionLeft = evt.target.offsetLeft - sliderPadding;
      slider.scrollTo({
        top: 0,
        left: blockPositionLeft,
        behavior: "smooth"
      })
    }
  }), IconsRow
}(), PaloAlto.ImageColumns = function() {
  function ImageColumns(container) {
    var $container = this.$container = $(container);
    this.init()
  }
  return ImageColumns.prototype = $.extend({}, ImageColumns.prototype, {
    init: function() {
      var $dots = this.$container.find(".image-column__dot");
      $dots.each(function() {
        var $dot = $(this);
        $dot.data("left") < 25 ? $dot.addClass("image-column__dot--end") : $dot.data("left") > 50 && $dot.data("left") <= 75 ? $dot.addClass("image-column__dot--reverse") : $dot.data("left") > 75 && $dot.addClass("image-column__dot--reverse image-column__dot--reverse-end"), $dot.data("top") < 35 && $dot.addClass("image-column__dot--bottom")
      })
    }
  }), ImageColumns
}(), PaloAlto.ListCollections = function() {
  var selectors = {
        slider: "[data-slider]",
        sliderItem: "[data-slider-item]"
      },
      classes = {
        carouselActive: "carousel--active",
        carouselInactive: "carousel--inactive"
      };

  function ListCollections(container) {
    this.$container = $(container), this.$slider = $(selectors.slider, this.$container), this.$slider.length && (this.checkSlidesSizeOnResize = this.checkSlidesSize.bind(this), this.listen())
  }
  return ListCollections.prototype = $.extend({}, ListCollections.prototype, {
    initSlider: function() {
      this.$slider.addClass(classes.carouselActive).removeClass(classes.carouselInactive), this.$slider.flickity({
        pageDots: !1,
        cellAlign: "left",
        groupCells: !0,
        contain: !0
      })
    },
    destroySlider: function() {
      this.$slider.removeClass(classes.carouselActive).addClass(classes.carouselInactive), this.$slider.data("flickity") && this.$slider.flickity("destroy")
    },
    checkSlidesSize: function() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth,
          gutter = $(selectors.sliderItem, this.$container).outerWidth(!0) - $(selectors.sliderItem, this.$container).width(),
          containerWidth = $(window).width() - gutter * 2,
          itemWidth = $(selectors.sliderItem, this.$container).outerWidth(!0),
          itemsCount = $(selectors.sliderItem, this.$container).length,
          itemsOverflowViewport = containerWidth < itemWidth * itemsCount;
      windowWidth >= 768 && itemsOverflowViewport ? this.initSlider() : this.destroySlider()
    },
    listen: function() {
      document.addEventListener("theme:resize", this.checkSlidesSizeOnResize), this.checkSlidesSize()
    },
    onBlockSelect: function(evt) {
      var sliderData = this.$slider.data("flickity");
      if (sliderData) {
        var index = parseInt($(evt.target).index()),
            slidesPerPage = parseInt(sliderData.slides[0].cells.length),
            groupIndex = Math.floor(index / slidesPerPage);
        this.$slider.flickity("select", groupIndex)
      } else if (this.$slider.length) {
        var slider = this.container.querySelector(selectors.slider),
            sliderStyle = slider.currentStyle || window.getComputedStyle(slider),
            sliderPadding = parseInt(sliderStyle.paddingLeft),
            blockPositionLeft = evt.target.offsetLeft - sliderPadding;
        slider.scrollTo({
          top: 0,
          left: blockPositionLeft,
          behavior: "smooth"
        })
      }
    },
    onUnload: function() {
      document.removeEventListener("theme:resize", this.checkSlidesSizeOnResize)
    }
  }), ListCollections
}(), PaloAlto.LogoList = function() {
  var selectors = {
    slider: "[data-slider]",
    sliderItem: "[data-slider-item]"
  };

  function LogoList(container) {
    this.$container = $(container), this.namespace = this.$container.attr("data-section-id"), this.$slider = $(selectors.slider, this.$container), this.checkSlides(), $(window).on("resize." + this.namespace, PaloAlto.debounce(this.checkSlides.bind(this), 250))
  }
  return LogoList.prototype = $.extend({}, LogoList.prototype, {
    checkSlides: function() {
      var containerWidth = this.$slider.width(),
          slidesTotalWidth = this.getSlidesWidth(),
          windowWidth = window.innerWidth || document.documentElement.clientWidth;
      windowWidth >= 768 && slidesTotalWidth > containerWidth ? this.initSlider() : this.destroySlider()
    },
    getSlidesWidth: function() {
      var slidesTotalWidth = 0;
      return this.$slider.find(selectors.sliderItem).each(function() {
        slidesTotalWidth += $(this).outerWidth()
      }), slidesTotalWidth
    },
    initSlider: function() {
      this.$slider.data("flickity") || (this.$slider.flickity({
        contain: !0,
        wrapAround: !0,
        pageDots: !1
      }), PaloAlto.flickitySmoothScrolling(this.$slider))
    },
    destroySlider: function() {
      this.$slider.data("flickity") && this.$slider.flickity("destroy")
    },
    onBlockSelect: function(evt) {
      var index = $(evt.target).index(),
          $slider = $(evt.target).parents(selectors.slider),
          sliderData = $slider.data("flickity");
      if (sliderData) $slider.flickity("select", index);
      else {
        var slider = this.container.querySelector(selectors.slider),
            sliderStyle = slider.currentStyle || window.getComputedStyle(slider),
            sliderPadding = parseInt(sliderStyle.paddingLeft),
            blockPositionLeft = evt.target.offsetLeft - sliderPadding;
        slider.scrollTo({
          top: 0,
          left: blockPositionLeft,
          behavior: "smooth"
        })
      }
    },
    onUnload: function(evt) {
      this.$slider.data("flickity") && this.$slider.flickity("destroy"), $(window).off("resize." + this.namespace)
    }
  }), LogoList
}(), PaloAlto.Locations = function() {
  var selectors = {
    slider: "[data-slider-gallery]",
    sliderNav: "[data-slider-info]"
  };

  function Locations(container) {
    this.$container = $(container), this.$slider = this.$container.find(selectors.slider), this.$sliderNav = this.$container.find(selectors.sliderNav), this.initSlider()
  }
  return Locations.prototype = $.extend({}, Locations.prototype, {
    initSlider: function() {
      var $slider = this.$slider,
          $sliderNav = this.$sliderNav,
          slidesCount = $slider.data("count");
      slidesCount <= 1 || ($slider.flickity({
        wrapAround: !0,
        adaptiveHeight: !0,
        prevNextButtons: !1,
        pageDots: !1
      }), PaloAlto.flickitySmoothScrolling($slider), $sliderNav.flickity({
        wrapAround: !0,
        imagesLoaded: !0,
        lazyLoad: !0,
        asNavFor: $slider[0],
        prevNextButtons: !0,
        pageDots: !1
      }), $sliderNav.on("change.flickity", function(event, pointer) {
        var flkty = $sliderNav.data("flickity"),
            index = flkty.selectedIndex;
        $slider.flickity("selectCell", index)
      }), $slider.on("change.flickity", function(event, pointer) {
        var flkty = $slider.data("flickity"),
            index = flkty.selectedIndex;
        $sliderNav.flickity("selectCell", index)
      }))
    },
    onBlockSelect: function(evt) {
      var $slider = $(evt.target).parents(selectors.slider),
          $sliderNav = $(evt.target).parents(selectors.sliderNav),
          index = $(evt.target).index();
      $slider.data("flickity") && $slider.flickity("select", index), $sliderNav.data("flickity") && $sliderNav.flickity("select", index)
    }
  }), Locations
}(), PaloAlto.Popup = function() {
  var selectors = {
        popup: "#popup",
        popupText: ".popup__text",
        modalContainer: ".jquery-modal"
      },
      classes = {
        popupVisible: "popup--visible"
      };

  function Popup(container) {
    var $container = this.$container = $(container),
        $popup = $(selectors.popup, $container),
        modalDelay = parseInt($popup.data("delay")),
        reappearTime = parseInt($popup.data("reappear-time")),
        testMode = $popup.data("testmode");
    testMode ? showModal(modalDelay) : (Cookies.get("newsletter_delay") === void 0 || reappearTime == 0) && (showModal(modalDelay), createCookie(reappearTime));

    function showModal(modalDelay2) {
      if (this.showModalDelayed != null && clearTimeout(this.showModalDelayed), sessionStorage.name != "popup_shown" && $("html").hasClass("lt-ie9") == !1) {
        if (this.showModalDelayed = setTimeout(function() {
          $popup.modal(), $popup.addClass(classes.popupVisible)
        }, modalDelay2), typeof localStorage == "object") try {
          localStorage.setItem("localStorage", 1), localStorage.removeItem("localStorage"), sessionStorage.name = "popup_shown"
        } catch {
          Storage.prototype._setItem = Storage.prototype.setItem, Storage.prototype.setItem = function() {}
        }
      } else testMode && (this.showModalDelayed = setTimeout(function() {
        $popup.modal(), $popup.addClass(classes.popupVisible)
      }, modalDelay2))
    }

    function createCookie(reappearTime2) {
      reappearTime2 != 0 && Cookies.set("newsletter_delay", "value", {
        expires: reappearTime2
      })
    }
    $(document).on("modal:block", function() {
      $("body").css("overflow", "")
    }), $.modal.defaults = {
      escapeClose: !0,
      clickClose: !1,
      closeText: theme.icons.close,
      closeClass: "",
      showClose: !0,
      modalClass: "modal",
      spinnerHtml: null,
      showSpinner: !0,
      fadeDuration: 250,
      fadeDelay: .5
    }
  }
  return Popup.prototype = $.extend({}, Popup.prototype, {
    onUnload: function() {
      $(selectors.popup).add(selectors.modalContainer).remove(), this.showModalDelayed != null && clearTimeout(this.showModalDelayed)
    }
  }), Popup
}(), PaloAlto.Press = function() {
  var selectors = {
    pressItems: "[data-press-items]",
    logoSlider: "[data-logo-slider]",
    logoSlide: "[data-logo-slide]"
  };

  function Press(container) {
    var self2 = this;
    this.$container = $(container), this.$slider = this.$container.find(selectors.pressItems), this.$sliderNav = this.$container.find(selectors.logoSlider), this.initSlider(), $(window).on("load", self2.resizeSlider.bind(self2))
  }
  return Press.prototype = $.extend({}, Press.prototype, {
    initSlider: function() {
      var $slider = this.$slider,
          $sliderNav = this.$sliderNav,
          slidesCount = $slider.data("count"),
          infiniteLoop = slidesCount > 2,
          contain = slidesCount == 2;
      $slider.flickity({
        wrapAround: !0,
        adaptiveHeight: !0,
        prevNextButtons: !1,
        pageDots: !1
      }), $sliderNav.flickity({
        wrapAround: infiniteLoop,
        contain,
        imagesLoaded: !0,
        lazyLoad: !0,
        asNavFor: $slider[0],
        prevNextButtons: !1,
        pageDots: !1
      }), PaloAlto.flickitySmoothScrolling($slider), PaloAlto.flickitySmoothScrolling($sliderNav), $sliderNav.on("change.flickity", function(event, pointer) {
        var flkty = $sliderNav.data("flickity"),
            index = flkty.selectedIndex;
        $slider.flickity("selectCell", index)
      }), $slider.on("change.flickity", function(event, pointer) {
        var flkty = $slider.data("flickity"),
            index = flkty.selectedIndex;
        $sliderNav.flickity("selectCell", index)
      })
    },
    resizeSlider: function() {
      var hasSlider = this.$slider.data("flickity");
      hasSlider && this.$slider.flickity("resize")
    },
    onBlockSelect: function(evt) {
      var $slider = $(evt.target).parents(selectors.pressItems),
          $sliderNav = $(evt.target).parents(selectors.logoSlider),
          index = $(evt.target).index();
      $slider.data("flickity") && $slider.flickity("select", index), $sliderNav.data("flickity") && $sliderNav.flickity("select", index)
    }
  }), Press
}(), PaloAlto.Product = function() {
  var selectors = {
        addToCart: "[data-add-to-cart]",
        addToCartForm: "#AddToCartForm--",
        addToCartId: "#AddToCart--",
        addToCartText: "[data-add-to-cart-text]",
        ajaxCart: ".ajaxCart",
        cartContainer: "[data-api-cart]",
        colorLabel: "[data-color-label]",
        colorSwatch: "[data-color-swatch]",
        comparePrice: "[data-compare-price]",
        notificationForm: "[data-notification-form]",
        option: "[data-option]",
        originalSelectorId: "[data-product-select]",
        popoutOption: "[data-popout-option]",
        popoutToggleQuantity: "[data-popout-quantity]",
        priceWrapper: "[data-price-wrapper]",
        productBadge: "[data-product-badge]",
        productForm: "[data-product-form]",
        productFormWrapper: "[data-product-form-wrapper]",
        productImageLightbox: "[data-mfp-src]",
        productImageZoom: "[data-zoom]",
        productMediaSlider: "[data-product-single-media-slider]",
        productMediaThumb: "[data-thumbnail-id]",
        productMediaThumbs: "[data-product-single-media-thumbs]",
        productMediaWrapper: "[data-product-single-media-wrapper]",
        productModel: "[data-product-media-type-model]",
        productPrice: "[data-product-price]",
        productSingleMediaImage: ".product-single__media--image",
        productSingleThumbnailLInk: ".product-single__thumbnail-link",
        productVideo: "[data-product-media-type-video]",
        quantityButton: "[data-quantity-button]",
        quantityInput: "[data-quantity-input]",
        quantitySelect: "[data-quantity-select]",
        singleOptionSelector: "[data-single-option-selector]",
        storeAvailabilityContainer: "[data-store-availability-container]",
        unitBase: "[data-unit-base]",
        unitPrice: "[data-unit-price]",
        unitWrapper: "[data-unit-wrapper]"
      },
      classes = {
        disabled: "disabled",
        featuredProduct: "featured-product",
        featuredProductOnboarding: "featured-product--onboarding",
        hasMediaActive: "has-media-active",
        hide: "hide",
        isSelected: "is-selected",
        mediaHidden: "media--hidden",
        noOutline: "no-outline",
        productFormIsLoading: "product__form--is-loading",
        productPriceSale: "product__price--with-sale",
        visuallyHidden: "visually-hidden",
        notificationFormHidden: "product__notification--hidden",
        zoomed: "zoomed",
        quantityButtonIncrease: "quantity__btn--increase"
      };

  function Product(container) {
    this.$container = $(container), this.sectionId = $(container).data("section-id"), this.storeAvailabilityContainer = container.querySelector(selectors.storeAvailabilityContainer), this.isFlickityDragging = !1, this.enableHistoryState = !this.$container.hasClass(classes.featuredProduct), this.storeAvailabilityContainer && (this.storeAvailability = new PaloAlto.StoreAvailability(this.storeAvailabilityContainer));
    var $popoutOptions = $(selectors.popoutOption, this.$container),
        popoutOptions = {},
        popoutDisableSubmit = !0;
    if ($popoutOptions.length && $popoutOptions.each(function() {
      $popoutOption = $(this), popoutOptions = new PaloAlto.Popout($popoutOption, popoutDisableSubmit)
    }), this.initQuantityPicker(), this.initQuantityInput(), $(selectors.colorSwatch, this.$container).on("change", this.updateColorName.bind(this)), !$(container).hasClass(classes.featuredProductOnboarding)) {
        this.product = document.getElementById("ProductJson-" + this.sectionId)?.innerHTML
        this.product = (this.product) ? JSON.parse(this.product) : null;
      var options = {
        $container: this.$container,
        enableHistoryState: this.enableHistoryState,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.product,
        storeAvailability: this.storeAvailability
      };
      this.namespace = ".product--" + this.sectionId, this.variants = new slate.Variants(options), this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this)), this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this)), this.$container.on("variantUnitChange" + this.namespace, this.updateProductUnits.bind(this)), this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this)), this.$container.on("variantChange" + this.namespace, this.updateColorName.bind(this)), ajaxCart.init({
        namespace: selectors.ajaxCart + this.sectionId,
        formSelector: selectors.addToCartForm + this.sectionId,
        cartContainer: selectors.cartContainer,
        addToCartSelector: selectors.addToCartId + this.sectionId,
        moneyFormat: theme.moneyFormat
      }), PaloAlto.initListeners(), PaloAlto.initCollapsible(), PaloAlto.videoLink(), $(selectors.productForm, this.$container).removeClass(classes.productFormIsLoading), this.initProductSlider(), this.initProductImageGallery(), this.initMediaSwitch(), this.initProductVideo(), this.initModelViewerLibraries(), this.initShopifyXrLaunch(), this.$container.hasClass(classes.featuredProduct) && (this.setBadgePosition(), $(window).on("resize." + this.sectionId, PaloAlto.debounce(this.setBadgePosition.bind(this), 250)))
    }
  }
  return Product.prototype = $.extend({}, Product.prototype, {
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      const buttonText = this.product.tags.includes("_preorder") ? theme.strings.preorder : theme.strings.add_to_cart;
      variant ? variant.available ? ($(selectors.addToCart, this.$container).prop("disabled", !1), $(selectors.addToCartText, this.$container).html(buttonText), $(selectors.notificationForm, this.$container).addClass(classes.notificationFormHidden)) : ($(selectors.addToCart, this.$container).prop("disabled", !0), $(selectors.addToCartText, this.$container).html(theme.strings.sold_out), $(selectors.notificationForm, this.$container).removeClass(classes.notificationFormHidden)) : ($(selectors.addToCart, this.$container).prop("disabled", !0), $(selectors.addToCartText, this.$container).html(theme.strings.unavailable), $(selectors.notificationForm, this.$container).removeClass(classes.notificationFormHidden))
    },
    updateProductPrices: function(evt) {
      var variant = evt.variant,
          $comparePrice = $(selectors.comparePrice, this.$container),
          $productPrice = $(selectors.productPrice, this.$container);
      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat)), variant.compare_at_price > variant.price ? ($comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass(classes.hide), $productPrice.addClass(classes.productPriceSale)) : ($comparePrice.html("").addClass(classes.hide), $productPrice.removeClass(classes.productPriceSale))
    },
    updateProductUnits: function(evt) {
      var variant = evt.variant;
      if (typeof variant.unit_price < "u") {
        var price = slate.Currency.formatMoney(variant.unit_price, theme.moneyFormat),
            base = this.getBaseUnit(variant);
        $(selectors.unitPrice, this.$container).html(price), $(selectors.unitBase, this.$container).html(base), $(selectors.unitWrapper, this.$container).show()
      } else $(selectors.unitWrapper, this.$container).hide()
    },
    getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
    },
    updateProductImage: function(evt) {
      var variant = evt.variant,
          variantMediaId = variant.featured_media ? variant.featured_media.id : "",
          $imgSlider = $(selectors.productMediaSlider, this.$container),
          flick = $imgSlider.data("flickity");
      if (flick && flick.isActive) {
        var $variantSlide = $imgSlider.find('[data-id="' + variantMediaId + '"]');
        $variantSlide.index() != -1 && flick.select($variantSlide.index())
      }
    },
    updateColorName: function(evt) {
      $(selectors.colorSwatch, this.$container).filter(":checked").each(function() {
        var colorName = $(this).val(),
            $colorLabel = $(this).closest(selectors.option).find(selectors.colorLabel);
        $colorLabel.text(colorName)
      })
    },
    initProductSlider: function() {
      var self2 = this,
          $slider = $(selectors.productMediaSlider, this.$container),
          $thumbs = $(selectors.productMediaThumbs, this.$container),
          hasSlides = $(selectors.productMediaWrapper, this.$container).length > 1;
      hasSlides && ($slider.on("ready.flickity", function(event, pointer, moveVector) {
        $slider.attr("tabindex", "-1")
      }), $slider.flickity({
        wrapAround: !0,
        pageDots: !1,
        adaptiveHeight: !0
      }), this.sliderInstance = $slider.data("flickity"), $slider.on("dragMove.flickity", function(event, pointer, moveVector) {
        self2.isFlickityDragging = !0
      }).on("staticClick.flickity", function(event, pointer, moveVector) {
        self2.isFlickityDragging = !1
      }).on("settle.flickity", function(event, index) {
        var $currentSlide = $slider.find(selectors.productMediaWrapper).eq(index),
            mediaId = $currentSlide.data("media-id");
        $currentSlide.has(selectors.productSingleMediaImage).attr("tabindex", "0").siblings().attr("tabindex", "-1"), self2.switchMedia(mediaId)
      }), $(selectors.productMediaWrapper, this.$container).on("playModel playVideo playYoutubeVideo", function() {
        var isSelectedSlide = $(this).hasClass(classes.isSelected);
        isSelectedSlide && (self2.sliderInstance.options.draggable = !1, self2.sliderInstance.updateDraggable(), $(this).closest(selectors.productMediaSlider).addClass(classes.hasMediaActive))
      }).on("pauseModel pauseVideo pauseYoutubeVideo", function() {
        var isSelectedSlide = $(this).hasClass(classes.isSelected);
        isSelectedSlide && (self2.sliderInstance.options.draggable = !0, self2.sliderInstance.updateDraggable(), $(this).closest(selectors.productMediaSlider).removeClass(classes.hasMediaActive))
      }), PaloAlto.flickitySmoothScrolling($slider), $thumbs.on("ready.flickity", function() {
        $thumbs.attr("tabindex", "-1")
      }), $thumbs.flickity({
        asNavFor: $slider[0],
        contain: !0,
        pageDots: !1,
        prevNextButtons: !1
      }), $thumbs.on("click", selectors.productSingleThumbnailLInk, function(e) {
        e.preventDefault()
      }))
    },
    handleMediaFocus: function(e) {
      if (!(e.keyCode !== 13 && e.keyCode !== 9)) {
        var mediaId = $(e.currentTarget).data("thumbnail-id"),
            slideIndex = $(selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]', this.$container).index(),
            flick = $(selectors.productMediaSlider, this.$container).data("flickity"),
            flickNav = $(selectors.productMediaThumbs, this.$container).data("flickity");
        flick && flick.isActive && slideIndex > -1 && e.keyCode === 13 && flick.select(slideIndex), flickNav && flickNav.isActive && slideIndex > -1 && flickNav.select(slideIndex)
      }
    },
    switchMedia: function(mediaId) {
      var $currentMedia = $(selectors.productMediaWrapper + ":not(.media--hidden)", this.$container),
          $newMedia = $(selectors.productMediaWrapper + '[data-media-id="' + mediaId + '"]', this.$container),
          $otherMedia = $(selectors.productMediaWrapper + ':not([data-media-id="' + mediaId + '"])', this.$container),
          isFocusEnabled = !$("body").hasClass(classes.noOutline);
      isFocusEnabled && $newMedia.focus(), $currentMedia.trigger("mediaHidden"), $otherMedia.addClass(classes.mediaHidden), $newMedia.removeClass(classes.mediaHidden).trigger("mediaVisible"), $newMedia.find("[data-deferred-media]").length && !$newMedia.find("[data-deferred-media]").attr("loaded") && $newMedia.find("[data-deferred-media-button]").trigger("click")
    },
    initMediaSwitch: function() {
      var self2 = this,
          $productThumbImages = $(selectors.productMediaThumb, this.$container);
      $productThumbImages.length && $productThumbImages.on("click", function(e) {
        e.preventDefault()
      }).on("keyup", self2.handleMediaFocus.bind(self2))
    },
    initProductVideo: function() {
      const sectionId = this.sectionId;
      let $videos = $(selectors.productVideo, this.$container);
      $videos.length && $videos.each(function() {
        let $video = $(this);
        PaloAlto.ProductVideo.init($video, sectionId)
      })
    },
    initModelViewerLibraries: function() {
      const sectionId = this.sectionId;
      let $modelViewerElements = $(selectors.productModel, this.$container);
      $modelViewerElements.length && $modelViewerElements.each(function() {
        var $model = $(this);
        PaloAlto.ProductModel.init($model, sectionId)
      })
    },
    initShopifyXrLaunch: function() {
      var self2 = this;
      $(document).on("shopify_xr_launch", function() {
        var $currentMedia = $(selectors.productMediaWrapper + ":not(.media--hidden)", self2.$container);
        $currentMedia.trigger("xrLaunch")
      })
    },
    initQuantityPicker: function() {
      var self2 = this;
      this.$container.off("click", selectors.quantityButton), this.$container.on("click", selectors.quantityButton, function(e) {
        e.preventDefault();
        var $adjustBtn = $(this),
            $qtySelector = $(this).siblings(selectors.quantityInput);
        qty = validateQty(parseInt($qtySelector.val().replace(/\D/g, ""))), $adjustBtn.hasClass(classes.quantityButtonIncrease) ? qty += 1 : qty > 1 && (qty -= 1), $qtySelector.val(qty)
      }), this.$container.off("focusout", selectors.quantityInput), this.$container.on("focusout", selectors.quantityInput, function(e) {
        var currentValue = $(this).val();
        currentValue || $(this).prop("value", 1)
      }), this.$container.off("keydown", selectors.quantityInput), this.$container.on("keydown", selectors.quantityInput, function(e) {
        var currentValue = $(this).val();
        e.keyCode === slate.utils.keyboardKeys.ENTER && !currentValue && $(this).prop("value", 1)
      });

      function validateQty(qty2) {
        return (parseFloat(qty2) != parseInt(qty2) || isNaN(qty2)) && (qty2 = 1), qty2
      }
    },
    initQuantityInput: function() {
      var self2 = this;
      $(selectors.quantitySelect, this.$container).on("change", function() {
        var quantity = $(this).text();
        if (quantity < 10) $(selectors.quantityInput, self2.$container).val(quantity);
        else {
          var quantityId = this.id;
          $(selectors.popoutToggleQuantity, self2.$container).remove(), $(selectors.quantityButton, self2.$container).removeClass(classes.visuallyHidden), $(selectors.quantityInput, self2.$container).attr({
            id: quantityId,
            type: "number"
          }).val(10).select()
        }
      }), $(selectors.quantityInput, this.$container).on("change", function() {
        var quantity = this.value;
        $(selectors.quantityInput, self2.$container).val(quantity)
      })
    },
    initProductImageGallery: function() {
      var self2 = this;
      $(selectors.productMediaWrapper, this.$container).each(function() {
        var $productImage = $(this),
            $productImageZoom = $(selectors.productImageZoom, $productImage),
            $productImageLightbox = $(selectors.productImageLightbox, $productImage),
            hasZoom = $productImageZoom.length,
            hasLightbox = $productImageLightbox.length;
        hasLightbox ? ($(selectors.productImageLightbox).magnificPopup({
          type: "image",
          image: {
            markup: '<div class="mfp-figure"><div class="mfp-img"></div></div>'
          },
          mainClass: "mfp-fade",
          closeOnBgClick: !0,
          closeBtnInside: !1,
          closeOnContentClick: !1,
          tClose: "Close (Esc)",
          removalDelay: 300,
          closeMarkup: '<button title="%title%" class="mfp-close">' + theme.icons.close + "</button>",
          gallery: {
            enabled: !0,
            navigateByImgClick: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow--%dir%"><span class="icon-css-arrow"></span></button>',
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: ""
          },
          disableOn: function() {
            return !($(window).width() < 768 || self2.isFlickityDragging)
          }
        }), $(window).on("resize.product", PaloAlto.debounce(function() {
          var windowWidth = window.innerWidth || document.documentElement.clientWidth;
          windowWidth < 768 && $.magnificPopup.close()
        }, 250))) : hasZoom && enquire.register("screen and (min-width: 768px)", {
          match: function() {
            $productImageZoom.parent().zoom({
              magnify: 1.5,
              duration: 300,
              url: $productImageZoom.data("zoom"),
              target: $productImageZoom.parent(),
              callback: function() {
                var forceZoomRatio = 1.5,
                    originalImgWidth = this.width,
                    originalImgHeight = this.height,
                    imageAspectRatio = $productImageZoom.data("aspectratio"),
                    containerWidth = $productImageZoom.parent().width(),
                    containerHeight = $productImageZoom.parent().height();
                originalImgWidth < containerWidth ? ($(this).width(containerWidth * forceZoomRatio), $(this).height(containerWidth / imageAspectRatio * forceZoomRatio)) : originalImgHeight < containerHeight && ($(this).width(containerHeight * imageAspectRatio * forceZoomRatio), $(this).height(containerHeight * forceZoomRatio))
              },
              onZoomIn: function() {
                $(this).parent().addClass(classes.zoomed)
              },
              onZoomOut: function() {
                $(this).parent().removeClass(classes.zoomed)
              }
            })
          }
        })
      })
    },
    setBadgePosition: function() {
      $(selectors.productBadge, this.$container).each(function() {
        var $productBadge = $(this),
            $imageContainer = $(this).parent(),
            imageAspectRatio = $imageContainer.data("aspectratio") || 1,
            containerAspectRatio = $imageContainer.width() / $imageContainer.height(),
            productBadgeLeftPosition = 0;
        imageAspectRatio < containerAspectRatio && (productBadgeLeftPosition = parseInt(($imageContainer.width() - $imageContainer.height() * imageAspectRatio) / 2)), $productBadge.css("left", productBadgeLeftPosition)
      })
    },
    onUnload: function() {
      $(window).off("resize." + this.sectionId)
    }
  }), Product
}(), PaloAlto.ProductFeature = function() {
  function ProductFeature(container) {
    PaloAlto.videoLink()
  }
  return ProductFeature
}(), PaloAlto.RelatedProducts = function() {
  var selectors = {
        slider: "[data-collection-slider]",
        sliderItem: "[data-product-slide]",
        productMediaSlider: "[data-product-media-slideshow]",
        productMediaSlide: "[data-product-media-slideshow-slide]",
        productGridItemImage: "[data-product-media-container]",
        sliderArrows: ".flickity-button",
        relatedProducts: "[data-related-products]"
      },
      classes = {
        carouselActive: "carousel--active",
        carouselInactive: "carousel--inactive"
      };

  function RelatedProducts(container) {
    this.$container = $(container), this.$slider = null, this.namespace = this.$container.attr("data-section-id"), this.checkSlidesSizeOnResize = this.checkSlidesSize.bind(this), this.setBadgePositionOnResize = PaloAlto.Badge.setPosition(), this.init(), this.listen()
  }
  return RelatedProducts.prototype = $.extend({}, RelatedProducts.prototype, {
    init: function() {
      var self2 = this,
          $relatedSection = self2.$container,
          $relatedProducts = $(selectors.relatedProducts, this.$container),
          showSection = $relatedSection.data("show-section"),
          productId = $relatedSection.data("product-id"),
          limit = $relatedSection.data("limit"),
          requestUrl = theme.routes.product_recommendations_url + "?section_id=related-products&limit=" + limit + "&product_id=" + productId;
      showSection && $.get(requestUrl).done(function(data2) {
        var inner = $(data2).find(selectors.relatedProducts).html();
        $relatedProducts.hide().html(inner).slideDown("slow"), self2.$slider = self2.$container.find(selectors.slider), PaloAlto.Badge.setPosition(), PaloAlto.initQuickButton(self2.$container), self2.checkSlidesSize()
        document.dispatchEvent(new CustomEvent('related-products:processed'));
      })
    },
    initSlider: function() {
      this.$slider.addClass(classes.carouselActive).removeClass(classes.carouselInactive), this.$slider.data("flickity") || (this.$slider.on("ready.flickity", this.setSliderArrowsPosition.bind(this)), this.$slider.flickity({
        pageDots: !1,
        cellSelector: selectors.sliderItem,
        cellAlign: "left",
        groupCells: !0,
        contain: !0,
        wrapAround: !1,
        adaptiveHeight: !1
      }))
    },
    destroySlider: function() {
      this.$slider && (this.$slider.removeClass(classes.carouselActive).addClass(classes.carouselInactive), this.$slider.data("flickity") && this.$slider.flickity("destroy"))
    },
    checkSlidesSize: function() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth,
          gutter = $(selectors.sliderItem, this.$container).outerWidth(!0) - $(selectors.sliderItem, this.$container).width(),
          containerWidth = $(window).width() - gutter * 2,
          itemWidth = $(selectors.sliderItem, this.$container).outerWidth(!0),
          itemsCount = $(selectors.sliderItem, this.$container).length,
          itemsOverflowViewport = containerWidth < itemWidth * itemsCount;
      windowWidth >= 768 && itemsOverflowViewport ? (this.initSlider(), this.setSliderArrowsPosition()) : this.destroySlider()
    },
    setSliderArrowsPosition: function() {
      var $arrows = this.$slider.find(selectors.sliderArrows),
          imageHeight = this.$slider.find(selectors.productGridItemImage).outerHeight();
      $arrows.css("top", imageHeight / 2)
    },
    listen: function() {
      document.addEventListener("theme:resize", this.checkSlidesSizeOnResize), document.addEventListener("theme:resize", this.setBadgePositionOnResize), this.checkSlidesSize()
    },
    onUnload: function(evt) {
      $(window).off("resize." + this.namespace);
      var $slider = $(evt.target).parents(selectors.slider);
      $slider.data("flickity") && $slider.flickity("destroy")
    }
  }), RelatedProducts
}(), PaloAlto.StoreAvailability = function() {
  var selectors = {
    body: "body",
    storeAvailabilityModal: "[data-store-availability-modal]",
    storeAvailabilityModalOpen: "[data-store-availability-modal-open]",
    storeAvailabilityModalProductTitle: "[data-store-availability-modal-product__title]"
  };

  function StoreAvailability(container) {
    this.container = container
  }
  return StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function(variantId, productTitle) {
      this._fetchStoreAvailabilities(variantId, productTitle)
    },
    clearContent: function() {
      this.container.innerHTML = ""
    },
    _initModal: function() {
      return new PaloAlto.Modals("StoreAvailabilityModal", "store-availability-modal", {
        close: ".js-modal-close-store-availability-modal",
        closeModalOnClick: !0,
        openClass: "store-availabilities-modal--active",
        scrollIntoView: !1
      })
    },
    _fetchStoreAvailabilities: function(variantId, productTitle) {
      var variantSectionUrl = "/variants/" + variantId + "/?section_id=store-availability";
      this.clearContent();
      var self2 = this;
      fetch(variantSectionUrl).then(function(response) {
        return response.text()
      }).then(function(storeAvailabilityHTML) {
        if (storeAvailabilityHTML.trim() !== "") {
          var body = document.querySelector(selectors.body),
              storeAvailabilityModal = body.querySelector(selectors.storeAvailabilityModal);
          storeAvailabilityModal && storeAvailabilityModal.remove(), self2.container.innerHTML = storeAvailabilityHTML, self2.container.innerHTML = self2.container.firstElementChild.innerHTML;
          var storeAvailabilityModalOpen = self2.container.querySelector(selectors.storeAvailabilityModalOpen);
          if (storeAvailabilityModalOpen) {
            self2.modal = self2._initModal(), self2._updateProductTitle(productTitle);
            var storeAvailabilityModal = self2.container.querySelector(selectors.storeAvailabilityModal);
            storeAvailabilityModal && body.appendChild(storeAvailabilityModal)
          }
        }
      })
    },
    _updateProductTitle: function(productTitle) {
      var storeAvailabilityModalProductTitle = this.container.querySelector(selectors.storeAvailabilityModalProductTitle);
      storeAvailabilityModalProductTitle.textContent = productTitle
    }
  }), StoreAvailability
}(), PaloAlto.RichText = function() {
  function RichText(container) {
    PaloAlto.videoLink()
  }
  return RichText
}(), PaloAlto.Slider = function() {
  var selectors = {
        arrowLeft: "[data-arrow-left]",
        arrowRight: "[data-arrow-right]",
        item: ".item",
        slider: ".slider",
        initialSlide: ".initial-slide",
        arrowScrollDown: "[data-scroll-down]",
        header: ".site-header",
        links: "a, button"
      },
      classes = {
        initialSlide: "initial-slide",
        headerFixed: "site-header--fixed"
      };

  function Slider(container) {
    this.$container = $(container), this.initSlider(), this.bindScrollButton(), PaloAlto.videoLink()
  }
  return Slider.prototype = $.extend({}, Slider.prototype, {
    initSlider: function() {
      var $slider = this.$container,
          slidesCount = $slider.find(selectors.item).length,
          autoplay = this.$container.data("autoplay"),
          duration = this.$container.data("duration"),
          pageDots = this.$container.data("page-dots") && slidesCount > 1,
          prevNextButtons = this.$container.data("nav-arrows") && slidesCount > 1;
      autoplay && (autoplay = duration), $slider.on("ready.flickity", function() {
        var currentStyle = $(this).find(selectors.item + '[data-slide-position="1"]').data("style");
        $(this).attr("data-current-style", currentStyle), $(this).find(selectors.initialSlide).removeClass(classes.initialSlide)
      }).on("change.flickity", function(event, index) {
        var $currentSlide = $(this).find(selectors.item + '[data-slide-position="' + parseInt(index + 1) + '"]'),
            currentStyle = $currentSlide.data("style");
        $(this).attr("data-current-style", currentStyle), $currentSlide.find("a, button").removeAttr("tabindex"), $currentSlide.siblings().find(selectors.links).attr("tabindex", "-1")
      }).flickity({
        cellSelector: selectors.item,
        autoPlay: autoplay,
        wrapAround: !0,
        adaptiveHeight: !0,
        setGallerySize: !0,
        imagesLoaded: !0,
        pageDots,
        prevNextButtons: !1
      }), PaloAlto.flickitySmoothScrolling($slider), prevNextButtons && (this.$container.on("click", selectors.arrowLeft, function() {
        $slider.flickity("previous")
      }), this.$container.on("click", selectors.arrowRight, function() {
        $slider.flickity("next")
      }))
    },
    bindScrollButton: function() {
      var $slider = this.$container;
      $slider.on("click", selectors.arrowScrollDown, function(e) {
        e.preventDefault();
        var headerHeight = $(selectors.header).hasClass(classes.headerFixed) ? 60 : 0,
            scrollToPosition = parseInt(Math.ceil($slider.offset().top + $slider.outerHeight() - headerHeight));
        $("html, body").animate({
          scrollTop: scrollToPosition
        }, 500)
      })
    },
    onBlockSelect: function(evt) {
      var $slider = $(evt.target).parents(selectors.slider),
          index = $(evt.target).index(),
          flkty = $slider.data("flickity");
      flkty && ($slider.flickity("select", index), $slider.flickity("pausePlayer"))
    },
    onBlockDeselect: function(evt) {
      var $slider = $(evt.target).parents(".slider"),
          autoplay = this.$container.data("autoplay"),
          flkty = $slider.data("flickity");
      autoplay && flkty && $slider.flickity("playPlayer")
    }
  }), Slider
}(), PaloAlto.Subcollections = function() {
  var selectors = {
    slider: "[data-slider]"
  };

  function Subcollections(container) {
    this.$container = $(container), this.$slider = this.$container.find(selectors.slider), this.flkty = null, this.listenEvent = this.checkForSlider.bind(this), this.init()
  }
  return Subcollections.prototype = $.extend({}, Subcollections.prototype, {
    init: function() {
      this.checkForSlider(), this.listen()
    },
    initSlider: function() {
      this.flkty = this.$slider.flickity({
        prevNextButtons: !0,
        pageDots: !1,
        cellAlign: "left",
        wrapAround: !1,
        groupCells: !0,
        contain: !0
      })
    },
    destroySlider: function() {
      this.flkty && (this.$slider.flickity("destroy"), this.flkty = null)
    },
    checkForSlider: function() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth;
      windowWidth >= 768 ? this.initSlider() : this.destroySlider()
    },
    listen: function() {
      document.addEventListener("theme:resize", this.listenEvent)
    },
    onUnload: function() {
      document.removeEventListener("theme:resize", this.resizeEvent)
    }
  }), Subcollections
}(), PaloAlto.TabbedCollections = function() {
  var selectors = {
        tabButton: "[data-tab-button]",
        tabItem: "[data-tab-item]"
      },
      classes = {
        tabButtonActive: "tabbed-collections__nav__button--active",
        tabItemActive: "tabbed-collections__item--active"
      };

  function TabbedCollections(container) {
    this.$container = $(container), this.$tabButtons = $(selectors.tabButton, this.$container), this.$tabItems = $(selectors.tabItem, this.$container), this.init()
  }
  return TabbedCollections.prototype = $.extend({}, TabbedCollections.prototype, {
    init: function() {
      var self2 = this;
      this.$tabButtons.on("click", function(e) {
        var currentTabAnchor = $(this).attr("href");
        self2.$tabButtons.removeClass(classes.tabButtonActive), self2.$tabItems.removeClass(classes.tabItemActive), $(currentTabAnchor).addClass(classes.tabItemActive), $(this).addClass(classes.tabButtonActive), e.preventDefault()
      })
    },
    onBlockSelect: function(evt) {
      $(evt.target).triggerHandler("click")
    }
  }), TabbedCollections
}(), PaloAlto.Testimonials = function() {
  var selectors = {
        slider: "[data-slider]",
        item: "[data-item]"
      },
      classes = {
        flickityEnabled: "flickity-enabled"
      };

  function Testimonials(container) {
    var self2 = this;
    this.container = container, this.$container = $(container), this.sectionId = this.$container.attr("data-section-id"), this.$slider = $(selectors.slider, this.$container), this.initSlider(), $(window).on("resize." + this.sectionId, PaloAlto.debounce(self2.initSlider.bind(self2), 250))
  }
  return Testimonials.prototype = $.extend({}, Testimonials.prototype, {
    initSlider: function() {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth,
          slidesCount = this.$slider.find(selectors.item).length,
          hasSlider = this.$slider.hasClass(classes.flickityEnabled);
      if (slidesCount == 3 && windowWidth >= 1024 || slidesCount == 2 && windowWidth >= 768 || slidesCount == 1 || windowWidth < 768) {
        hasSlider = this.$slider.hasClass(classes.flickityEnabled), hasSlider && this.$slider.flickity("destroy");
        return
      }
      this.$slider.flickity({
        cellSelector: selectors.item,
        pageDots: !0,
        contain: !0,
        groupCells: !0,
        adaptiveHeight: !1
      })
    },
    onBlockSelect: function(evt) {
      var $slider = $(evt.target).parents(selectors.slider),
          sliderData = $slider.data("flickity");
      if (sliderData) {
        var index = parseInt($(evt.target).index()),
            slidesPerPage = parseInt(sliderData.slides[0].cells.length),
            groupIndex = Math.floor(index / slidesPerPage);
        $slider.flickity("select", groupIndex)
      } else {
        var slider = this.container.querySelector(selectors.slider),
            sliderStyle = slider.currentStyle || window.getComputedStyle(slider),
            sliderPadding = parseInt(sliderStyle.paddingLeft),
            blockPositionLeft = evt.target.offsetLeft - sliderPadding;
        slider.scrollTo({
          top: 0,
          left: blockPositionLeft,
          behavior: "smooth"
        })
      }
    },
    onUnload: function() {
      $(window).off("resize." + this.sectionId)
    }
  }), Testimonials
}(), PaloAlto.Account = function() {
  var addressCountryNew = document.getElementById("AddressCountryNew");
  addressCountryNew && (Shopify && Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
    hideElement: "AddressProvinceContainerNew"
  }), $(".address-country-option").each(function() {
    var formId = $(this).data("form-id"),
        countrySelector = "AddressCountry_" + formId,
        provinceSelector = "AddressProvince_" + formId,
        containerSelector = "AddressProvinceContainer_" + formId;
    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    })
  }), Shopify.CustomerAddress = {
    toggleForm: function(id) {
      var editEl = document.getElementById("EditAddress_" + id);
      return editEl.style.display = editEl.style.display == "none" ? "" : "none", !1
    },
    toggleNewForm: function() {
      var el = document.getElementById("AddAddress");
      return el.style.display = el.style.display == "none" ? "" : "none", !1
    },
    destroy: function(id, confirm_msg) {
      confirm(confirm_msg || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + id, {
        parameters: {
          _method: "delete"
        }
      })
    }
  })
}, PaloAlto.AboutPage = function() {
  function AboutPage(container) {
    PaloAlto.videoLink()
  }
  return AboutPage
}(), PaloAlto.CollectionTemplate = function() {
  function CollectionTemplate(container) {
    new PaloAlto.Filters(container)
  }
  return CollectionTemplate.prototype = $.extend({}, CollectionTemplate.prototype, {
    onDeselect: function() {
      $.magnificPopup.close()
    },
    onUnload: function(evt) {
      $.magnificPopup.close()
    }
  }), CollectionTemplate
}(), PaloAlto.loginForms = function() {
  var selectors = {
    $html: $("html"),
    $body: $("body"),
    $recoverPasswordLink: $("#RecoverPassword"),
    $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
    $recoverPasswordForm: $("#RecoverPasswordForm"),
    $customerLoginForm: $("#CustomerLoginForm")
  };

  function showRecoverPasswordForm() {
    selectors.$recoverPasswordForm.show(), selectors.$customerLoginForm.hide()
  }

  function hideRecoverPasswordForm() {
    selectors.$recoverPasswordForm.hide(), selectors.$customerLoginForm.show()
  }
  selectors.$recoverPasswordLink.on("click", function(evt) {
    evt.preventDefault(), showRecoverPasswordForm()
  }), selectors.$hideRecoverPasswordLink.on("click", function(evt) {
    evt.preventDefault(), hideRecoverPasswordForm()
  }), PaloAlto.getHash() == "#recover" && showRecoverPasswordForm()
}, PaloAlto.PasswordTemplate = function() {
  function PasswordTemplate(container) {
    var self2 = this,
        $container = this.$container = $(container),
        hasLoginErrors = $("#login_form .errors").length;
    $("#AdminLoginToggle", this.$container).on("click", function(e) {
      e.preventDefault(), self2.showRecoverPasswordForm()
    }), $("#NewsletterToggle", this.$container).on("click", function(e) {
      e.preventDefault(), self2.hideRecoverPasswordForm()
    }), window.location.hash == "#login" || hasLoginErrors ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm()
  }
  return PasswordTemplate.prototype = $.extend({}, PasswordTemplate.prototype, {
    showRecoverPasswordForm: function() {
      $("#AdminLogin").show(), $("#login_form .errors").show(), $("#CustomerSignup").hide(), $("#contact_form .errors").hide(), window.location.hash = "#login"
    },
    hideRecoverPasswordForm: function() {
      $("#contact_form .errors").show(), $("#CustomerSignup").show(), $("#AdminLogin").hide(), $("#login_form .errors").hide(), window.location.hash = ""
    }
  }), PasswordTemplate
}(), PaloAlto.SearchTemplate = function() {
  function SearchTemplate(container) {
    this.namespace = ".search-template", new PaloAlto.Filters(container), PaloAlto.Badge.setPosition(), $(window).on("resize" + this.namespace, PaloAlto.debounce(PaloAlto.Badge.setPosition, 150)), theme.settings.enableInfinityScroll && (this.endlessCollection = new Ajaxinate({
      container: "#AjaxinateLoop",
      pagination: "#AjaxinatePagination",
      method: "scroll"
    }))
  }
  return SearchTemplate.prototype = $.extend({}, SearchTemplate.prototype, {
    onDeselect: function(evt) {
      $.magnificPopup.close()
    },
    onUnload: function(evt) {
      $(window).off(this.namespace), theme.settings.enableInfinityScroll && typeof this.endlessCollection == "object" && this.endlessCollection.destroy === "function" && this.endlessBlogPosts.destroy(), $.magnificPopup.close()
    }
  }), SearchTemplate
}(), $.ajaxSetup({
  cache: !1
}), $(document).ready(function() {
  PaloAlto.init(), PaloAlto.initSections(), $(window).on("resize", PaloAlto.debounce(function() {
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
    windowWidth != lastWindowWidth && (PaloAlto.setMainSpacing(), lastWindowWidth = windowWidth)
  }, 250));
  var hash = window.location.hash,
      elementId = hash.substr(1, hash.length),
      element = document.getElementById(elementId);
  element !== null && slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash))
  })
}), PaloAlto.init = function() {
  $("html").removeClass("no-js").addClass("supports-js"), PaloAlto.setScrollbarWidth(), PaloAlto.loginForms(), PaloAlto.initCart(), PaloAlto.Account(), PaloAlto.checkFirstSectionHeight(), $(window).on("resize", PaloAlto.debounce(PaloAlto.checkFirstSectionHeight, 250))
}, PaloAlto.getHash = function() {
  return window.location.hash
}, PaloAlto.updateHash = function(hash) {
  window.location.hash = "#" + hash, $("#" + hash).attr("tabindex", -1).focus()
};

function wasTouched() {
  window.isTouch = !0, document.removeEventListener("touchstart", wasTouched, {
    passive: !0
  }), document.documentElement.className = document.documentElement.className.replace("no-touch", "touch"), document.dispatchEvent(new CustomEvent("theme:touch", {
    bubbles: !0
  }))
}
let originalWidth = window.innerWidth;
const resizePrototype = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  window.innerWidth === originalWidth && window.innerWidth <= 480 || (originalWidth = window.innerWidth, resizePrototype.apply(this, arguments))
}, document.addEventListener("touchstart", wasTouched, {
  passive: !0
}), document.addEventListener("shopify:section:load", function() {
  preventOverflow(document)
}), document.addEventListener("DOMContentLoaded", function() {
  "scrollBehavior" in document.documentElement.style || loadScript({
    url: theme.assets.smoothscroll
  })
}), typeof theme.settings.newHash < "u" && PaloAlto.updateHash(theme.settings.newHash), resizeListener(), window.addEventListener("load", () => {
  setVarsOnResize(), preventOverflow(document)
});
//# sourceMappingURL=/s/files/1/0033/8899/7677/t/60/assets/theme.js.map?v=1735553116